
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("TMgVJ", function(module, exports) {

$parcel$export(module.exports, "readKey", () => Ro);
$parcel$export(module.exports, "readPrivateKey", () => To);
$parcel$export(module.exports, "readMessage", () => _o);
$parcel$export(module.exports, "createMessage", () => jo);
$parcel$export(module.exports, "generateKey", () => Zo);
$parcel$export(module.exports, "decryptKey", () => Xo);
$parcel$export(module.exports, "encrypt", () => tc);
$parcel$export(module.exports, "decrypt", () => rc);
/*! OpenPGP.js v6.1.0 - 2025-01-30 - this is LGPL licensed code, see LICENSE/our website https://openpgpjs.org/ for more information. */ const e = "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function t(e, t) {
    return t.forEach(function(t) {
        t && "string" != typeof t && !Array.isArray(t) && Object.keys(t).forEach(function(r) {
            if ("default" !== r && !(r in e)) {
                var n = Object.getOwnPropertyDescriptor(t, r);
                Object.defineProperty(e, r, n.get ? n : {
                    enumerable: !0,
                    get: function() {
                        return t[r];
                    }
                });
            }
        });
    }), Object.freeze(e);
}
const r = Symbol("doneWritingPromise"), n = Symbol("doneWritingResolve"), i = Symbol("doneWritingReject"), s = Symbol("readingIndex");
class a extends Array {
    constructor(){
        super(), Object.setPrototypeOf(this, a.prototype), this[r] = new Promise((e, t)=>{
            this[n] = e, this[i] = t;
        }), this[r].catch(()=>{});
    }
}
function o(e) {
    return e && e.getReader && Array.isArray(e);
}
function c(e) {
    if (!o(e)) {
        const t = e.getWriter(), r = t.releaseLock;
        return t.releaseLock = ()=>{
            t.closed.catch(function() {}), r.call(t);
        }, t;
    }
    this.stream = e;
}
function h(t) {
    if (o(t)) return "array";
    if (e.ReadableStream && e.ReadableStream.prototype.isPrototypeOf(t)) return "web";
    if (t && !(e.ReadableStream && t instanceof e.ReadableStream) && "function" == typeof t._read && "object" == typeof t._readableState) throw Error("Native Node streams are no longer supported: please manually convert the stream to a WebStream, using e.g. `stream.Readable.toWeb`");
    return !(!t || !t.getReader) && "web-like";
}
function u(e) {
    return Uint8Array.prototype.isPrototypeOf(e);
}
function l(e) {
    if (1 === e.length) return e[0];
    let t = 0;
    for(let r = 0; r < e.length; r++){
        if (!u(e[r])) throw Error("concatUint8Array: Data must be in the form of a Uint8Array");
        t += e[r].length;
    }
    const r = new Uint8Array(t);
    let n = 0;
    return e.forEach(function(e) {
        r.set(e, n), n += e.length;
    }), r;
}
a.prototype.getReader = function() {
    return void 0 === this[s] && (this[s] = 0), {
        read: async ()=>(await this[r], this[s] === this.length ? {
                value: void 0,
                done: !0
            } : {
                value: this[this[s]++],
                done: !1
            })
    };
}, a.prototype.readToEnd = async function(e) {
    await this[r];
    const t = e(this.slice(this[s]));
    return this.length = 0, t;
}, a.prototype.clone = function() {
    const e = new a;
    return e[r] = this[r].then(()=>{
        e.push(...this);
    }), e;
}, c.prototype.write = async function(e) {
    this.stream.push(e);
}, c.prototype.close = async function() {
    this.stream[n]();
}, c.prototype.abort = async function(e) {
    return this.stream[i](e), e;
}, c.prototype.releaseLock = function() {}, "object" == typeof e.process && e.process.versions;
const y = new WeakSet, f = Symbol("externalBuffer");
function g(e) {
    if (this.stream = e, e[f] && (this[f] = e[f].slice()), o(e)) {
        const t = e.getReader();
        return this._read = t.read.bind(t), this._releaseLock = ()=>{}, void (this._cancel = ()=>{});
    }
    if (h(e)) {
        const t = e.getReader();
        return this._read = t.read.bind(t), this._releaseLock = ()=>{
            t.closed.catch(function() {}), t.releaseLock();
        }, void (this._cancel = t.cancel.bind(t));
    }
    let t = !1;
    this._read = async ()=>t || y.has(e) ? {
            value: void 0,
            done: !0
        } : (t = !0, {
            value: e,
            done: !1
        }), this._releaseLock = ()=>{
        if (t) try {
            y.add(e);
        } catch (e) {}
    };
}
function p(e) {
    return h(e) ? e : new ReadableStream({
        start (t) {
            t.enqueue(e), t.close();
        }
    });
}
function d(e) {
    if (h(e)) return e;
    const t = new a;
    return (async ()=>{
        const r = x(t);
        await r.write(e), await r.close();
    })(), t;
}
function A(e) {
    return e.some((e)=>h(e) && !o(e)) ? function(e) {
        e = e.map(p);
        const t = b(async function(e) {
            await Promise.all(n.map((t)=>D(t, e)));
        });
        let r = Promise.resolve();
        const n = e.map((n, i)=>E(n, (n, s)=>(r = r.then(()=>w(n, t.writable, {
                        preventClose: i !== e.length - 1
                    })), r)));
        return t.readable;
    }(e) : e.some((e)=>o(e)) ? function(e) {
        const t = new a;
        let r = Promise.resolve();
        return e.forEach((n, i)=>(r = r.then(()=>w(n, t, {
                    preventClose: i !== e.length - 1
                })), r)), t;
    }(e) : "string" == typeof e[0] ? e.join("") : l(e);
}
async function w(e, t, { preventClose: r = !1, preventAbort: n = !1, preventCancel: i = !1 } = {}) {
    if (h(e) && !o(e)) {
        e = p(e);
        try {
            if (e[f]) {
                const r = x(t);
                for(let t = 0; t < e[f].length; t++)await r.ready, await r.write(e[f][t]);
                r.releaseLock();
            }
            await e.pipeTo(t, {
                preventClose: r,
                preventAbort: n,
                preventCancel: i
            });
        } catch (e) {}
        return;
    }
    const s = P(e = d(e)), a = x(t);
    try {
        for(;;){
            await a.ready;
            const { done: e, value: t } = await s.read();
            if (e) {
                r || await a.close();
                break;
            }
            await a.write(t);
        }
    } catch (e) {
        n || await a.abort(e);
    } finally{
        s.releaseLock(), a.releaseLock();
    }
}
function m(e, t) {
    const r = new TransformStream(t);
    return w(e, r.writable), r.readable;
}
function b(e) {
    let t, r, n, i = !1, s = !1;
    return {
        readable: new ReadableStream({
            start (e) {
                n = e;
            },
            pull () {
                t ? t() : i = !0;
            },
            async cancel (t) {
                s = !0, e && await e(t), r && r(t);
            }
        }, {
            highWaterMark: 0
        }),
        writable: new WritableStream({
            write: async function(e) {
                if (s) throw Error("Stream is cancelled");
                n.enqueue(e), i ? i = !1 : (await new Promise((e, n)=>{
                    t = e, r = n;
                }), t = null, r = null);
            },
            close: n.close.bind(n),
            abort: n.error.bind(n)
        })
    };
}
function k(e, t = ()=>{}, r = ()=>{}) {
    if (o(e)) {
        const n = new a;
        return (async ()=>{
            const i = x(n);
            try {
                const n = await C(e), s = t(n), a = r();
                let o;
                o = void 0 !== s && void 0 !== a ? A([
                    s,
                    a
                ]) : void 0 !== s ? s : a, await i.write(o), await i.close();
            } catch (e) {
                await i.abort(e);
            }
        })(), n;
    }
    if (h(e)) return m(e, {
        async transform (e, r) {
            try {
                const n = await t(e);
                void 0 !== n && r.enqueue(n);
            } catch (e) {
                r.error(e);
            }
        },
        async flush (e) {
            try {
                const t = await r();
                void 0 !== t && e.enqueue(t);
            } catch (t) {
                e.error(t);
            }
        }
    });
    const n = t(e), i = r();
    return void 0 !== n && void 0 !== i ? A([
        n,
        i
    ]) : void 0 !== n ? n : i;
}
function E(e, t) {
    if (h(e) && !o(e)) {
        let r;
        const n = new TransformStream({
            start (e) {
                r = e;
            }
        }), i = w(e, n.writable), s = b(async function(e) {
            r.error(e), await i, await new Promise(setTimeout);
        });
        return t(n.readable, s.writable), s.readable;
    }
    e = d(e);
    const r = new a;
    return t(e, r), r;
}
function v(e, t) {
    let r;
    const n = E(e, (e, i)=>{
        const s = P(e);
        s.remainder = ()=>(s.releaseLock(), w(e, i), n), r = t(s);
    });
    return r;
}
function I(e) {
    if (o(e)) return e.clone();
    if (h(e)) {
        const t = function(e) {
            if (o(e)) throw Error("ArrayStream cannot be tee()d, use clone() instead");
            if (h(e)) {
                const t = p(e).tee();
                return t[0][f] = t[1][f] = e[f], t;
            }
            return [
                K(e),
                K(e)
            ];
        }(e);
        return S(e, t[0]), t[1];
    }
    return K(e);
}
function B(e) {
    return o(e) ? I(e) : h(e) ? new ReadableStream({
        start (t) {
            const r = E(e, async (e, r)=>{
                const n = P(e), i = x(r);
                try {
                    for(;;){
                        await i.ready;
                        const { done: e, value: r } = await n.read();
                        if (e) {
                            try {
                                t.close();
                            } catch (e) {}
                            return void await i.close();
                        }
                        try {
                            t.enqueue(r);
                        } catch (e) {}
                        await i.write(r);
                    }
                } catch (e) {
                    t.error(e), await i.abort(e);
                }
            });
            S(e, r);
        }
    }) : K(e);
}
function S(e, t) {
    Object.entries(Object.getOwnPropertyDescriptors(e.constructor.prototype)).forEach(([r, n])=>{
        "constructor" !== r && (n.value ? n.value = n.value.bind(t) : n.get = n.get.bind(t), Object.defineProperty(e, r, n));
    });
}
function K(e, t = 0, r = 1 / 0) {
    if (o(e)) throw Error("Not implemented");
    if (h(e)) {
        if (t >= 0 && r >= 0) {
            let n = 0;
            return m(e, {
                transform (e, i) {
                    n < r ? (n + e.length >= t && i.enqueue(K(e, Math.max(t - n, 0), r - n)), n += e.length) : i.terminate();
                }
            });
        }
        if (t < 0 && (r < 0 || r === 1 / 0)) {
            let n = [];
            return k(e, (e)=>{
                e.length >= -t ? n = [
                    e
                ] : n.push(e);
            }, ()=>K(A(n), t, r));
        }
        if (0 === t && r < 0) {
            let n;
            return k(e, (e)=>{
                const i = n ? A([
                    n,
                    e
                ]) : e;
                if (i.length >= -r) return n = K(i, r), K(i, t, r);
                n = i;
            });
        }
        return console.warn(`stream.slice(input, ${t}, ${r}) not implemented efficiently.`), U(async ()=>K(await C(e), t, r));
    }
    return e[f] && (e = A(e[f].concat([
        e
    ]))), u(e) ? e.subarray(t, r === 1 / 0 ? e.length : r) : e.slice(t, r);
}
async function C(e, t = A) {
    return o(e) ? e.readToEnd(t) : h(e) ? P(e).readToEnd(t) : e;
}
async function D(e, t) {
    if (h(e)) {
        if (e.cancel) {
            const r = await e.cancel(t);
            return await new Promise(setTimeout), r;
        }
        if (e.destroy) return e.destroy(t), await new Promise(setTimeout), t;
    }
}
function U(e) {
    const t = new a;
    return (async ()=>{
        const r = x(t);
        try {
            await r.write(await e()), await r.close();
        } catch (e) {
            await r.abort(e);
        }
    })(), t;
}
function P(e) {
    return new g(e);
}
function x(e) {
    return new c(e);
}
g.prototype.read = async function() {
    if (this[f] && this[f].length) return {
        done: !1,
        value: this[f].shift()
    };
    return this._read();
}, g.prototype.releaseLock = function() {
    this[f] && (this.stream[f] = this[f]), this._releaseLock();
}, g.prototype.cancel = function(e) {
    return this._cancel(e);
}, g.prototype.readLine = async function() {
    let e, t = [];
    for(; !e;){
        let { done: r, value: n } = await this.read();
        if (n += "", r) return t.length ? A(t) : void 0;
        const i = n.indexOf("\n") + 1;
        i && (e = A(t.concat(n.substr(0, i))), t = []), i !== n.length && t.push(n.substr(i));
    }
    return this.unshift(...t), e;
}, g.prototype.readByte = async function() {
    const { done: e, value: t } = await this.read();
    if (e) return;
    const r = t[0];
    return this.unshift(K(t, 1)), r;
}, g.prototype.readBytes = async function(e) {
    const t = [];
    let r = 0;
    for(;;){
        const { done: n, value: i } = await this.read();
        if (n) return t.length ? A(t) : void 0;
        if (t.push(i), r += i.length, r >= e) {
            const r = A(t);
            return this.unshift(K(r, e)), K(r, 0, e);
        }
    }
}, g.prototype.peekBytes = async function(e) {
    const t = await this.readBytes(e);
    return this.unshift(t), t;
}, g.prototype.unshift = function(...e) {
    this[f] || (this[f] = []), 1 === e.length && u(e[0]) && this[f].length && e[0].length && this[f][0].byteOffset >= e[0].length ? this[f][0] = new Uint8Array(this[f][0].buffer, this[f][0].byteOffset - e[0].length, this[f][0].byteLength + e[0].length) : this[f].unshift(...e.filter((e)=>e && e.length));
}, g.prototype.readToEnd = async function(e = A) {
    const t = [];
    for(;;){
        const { done: e, value: r } = await this.read();
        if (e) break;
        t.push(r);
    }
    return e(t);
};
const Q = Symbol("byValue");
var R = {
    curve: {
        nistP256: "nistP256",
        p256: "nistP256",
        nistP384: "nistP384",
        p384: "nistP384",
        nistP521: "nistP521",
        p521: "nistP521",
        secp256k1: "secp256k1",
        ed25519Legacy: "ed25519Legacy",
        ed25519: "ed25519Legacy",
        curve25519Legacy: "curve25519Legacy",
        curve25519: "curve25519Legacy",
        brainpoolP256r1: "brainpoolP256r1",
        brainpoolP384r1: "brainpoolP384r1",
        brainpoolP512r1: "brainpoolP512r1"
    },
    s2k: {
        simple: 0,
        salted: 1,
        iterated: 3,
        argon2: 4,
        gnu: 101
    },
    publicKey: {
        rsaEncryptSign: 1,
        rsaEncrypt: 2,
        rsaSign: 3,
        elgamal: 16,
        dsa: 17,
        ecdh: 18,
        ecdsa: 19,
        eddsaLegacy: 22,
        aedh: 23,
        aedsa: 24,
        x25519: 25,
        x448: 26,
        ed25519: 27,
        ed448: 28
    },
    symmetric: {
        idea: 1,
        tripledes: 2,
        cast5: 3,
        blowfish: 4,
        aes128: 7,
        aes192: 8,
        aes256: 9,
        twofish: 10
    },
    compression: {
        uncompressed: 0,
        zip: 1,
        zlib: 2,
        bzip2: 3
    },
    hash: {
        md5: 1,
        sha1: 2,
        ripemd: 3,
        sha256: 8,
        sha384: 9,
        sha512: 10,
        sha224: 11,
        sha3_256: 12,
        sha3_512: 14
    },
    webHash: {
        "SHA-1": 2,
        "SHA-256": 8,
        "SHA-384": 9,
        "SHA-512": 10
    },
    aead: {
        eax: 1,
        ocb: 2,
        gcm: 3,
        experimentalGCM: 100
    },
    packet: {
        publicKeyEncryptedSessionKey: 1,
        signature: 2,
        symEncryptedSessionKey: 3,
        onePassSignature: 4,
        secretKey: 5,
        publicKey: 6,
        secretSubkey: 7,
        compressedData: 8,
        symmetricallyEncryptedData: 9,
        marker: 10,
        literalData: 11,
        trust: 12,
        userID: 13,
        publicSubkey: 14,
        userAttribute: 17,
        symEncryptedIntegrityProtectedData: 18,
        modificationDetectionCode: 19,
        aeadEncryptedData: 20,
        padding: 21
    },
    literal: {
        binary: 98,
        text: 116,
        utf8: 117,
        mime: 109
    },
    signature: {
        binary: 0,
        text: 1,
        standalone: 2,
        certGeneric: 16,
        certPersona: 17,
        certCasual: 18,
        certPositive: 19,
        certRevocation: 48,
        subkeyBinding: 24,
        keyBinding: 25,
        key: 31,
        keyRevocation: 32,
        subkeyRevocation: 40,
        timestamp: 64,
        thirdParty: 80
    },
    signatureSubpacket: {
        signatureCreationTime: 2,
        signatureExpirationTime: 3,
        exportableCertification: 4,
        trustSignature: 5,
        regularExpression: 6,
        revocable: 7,
        keyExpirationTime: 9,
        placeholderBackwardsCompatibility: 10,
        preferredSymmetricAlgorithms: 11,
        revocationKey: 12,
        issuerKeyID: 16,
        notationData: 20,
        preferredHashAlgorithms: 21,
        preferredCompressionAlgorithms: 22,
        keyServerPreferences: 23,
        preferredKeyServer: 24,
        primaryUserID: 25,
        policyURI: 26,
        keyFlags: 27,
        signersUserID: 28,
        reasonForRevocation: 29,
        features: 30,
        signatureTarget: 31,
        embeddedSignature: 32,
        issuerFingerprint: 33,
        preferredAEADAlgorithms: 34,
        preferredCipherSuites: 39
    },
    keyFlags: {
        certifyKeys: 1,
        signData: 2,
        encryptCommunication: 4,
        encryptStorage: 8,
        splitPrivateKey: 16,
        authentication: 32,
        sharedPrivateKey: 128
    },
    armor: {
        multipartSection: 0,
        multipartLast: 1,
        signed: 2,
        message: 3,
        publicKey: 4,
        privateKey: 5,
        signature: 6
    },
    reasonForRevocation: {
        noReason: 0,
        keySuperseded: 1,
        keyCompromised: 2,
        keyRetired: 3,
        userIDInvalid: 32
    },
    features: {
        modificationDetection: 1,
        aead: 2,
        v5Keys: 4,
        seipdv2: 8
    },
    write: function(e, t) {
        if ("number" == typeof t && (t = this.read(e, t)), void 0 !== e[t]) return e[t];
        throw Error("Invalid enum value.");
    },
    read: function(e, t) {
        if (e[Q] || (e[Q] = [], Object.entries(e).forEach(([t, r])=>{
            e[Q][r] = t;
        })), void 0 !== e[Q][t]) return e[Q][t];
        throw Error("Invalid enum value.");
    }
}, T = {
    preferredHashAlgorithm: R.hash.sha512,
    preferredSymmetricAlgorithm: R.symmetric.aes256,
    preferredCompressionAlgorithm: R.compression.uncompressed,
    aeadProtect: !1,
    parseAEADEncryptedV4KeysAsLegacy: !1,
    preferredAEADAlgorithm: R.aead.gcm,
    aeadChunkSizeByte: 12,
    v6Keys: !1,
    enableParsingV5Entities: !1,
    s2kType: R.s2k.iterated,
    s2kIterationCountByte: 224,
    s2kArgon2Params: {
        passes: 3,
        parallelism: 4,
        memoryExponent: 16
    },
    allowUnauthenticatedMessages: !1,
    allowUnauthenticatedStream: !1,
    minRSABits: 2047,
    passwordCollisionCheck: !1,
    allowInsecureDecryptionWithSigningKeys: !1,
    allowInsecureVerificationWithReformattedKeys: !1,
    allowMissingKeyFlags: !1,
    constantTimePKCS1Decryption: !1,
    constantTimePKCS1DecryptionSupportedSymmetricAlgorithms: new Set([
        R.symmetric.aes128,
        R.symmetric.aes192,
        R.symmetric.aes256
    ]),
    ignoreUnsupportedPackets: !0,
    ignoreMalformedPackets: !1,
    additionalAllowedPackets: [],
    showVersion: !1,
    showComment: !1,
    versionString: "OpenPGP.js 6.1.0",
    commentString: "https://openpgpjs.org",
    maxUserIDLength: 5120,
    knownNotations: [],
    nonDeterministicSignaturesViaNotation: !0,
    useEllipticFallback: !0,
    rejectHashAlgorithms: new Set([
        R.hash.md5,
        R.hash.ripemd
    ]),
    rejectMessageHashAlgorithms: new Set([
        R.hash.md5,
        R.hash.ripemd,
        R.hash.sha1
    ]),
    rejectPublicKeyAlgorithms: new Set([
        R.publicKey.elgamal,
        R.publicKey.dsa
    ]),
    rejectCurves: new Set([
        R.curve.secp256k1
    ])
};
const L = (()=>{
    try {
        return false;
    } catch (e) {}
    return !1;
})(), M = {
    isString: function(e) {
        return "string" == typeof e || e instanceof String;
    },
    nodeRequire: ()=>{},
    isArray: function(e) {
        return e instanceof Array;
    },
    isUint8Array: u,
    isStream: h,
    getNobleCurve: async (e, t)=>{
        if (!T.useEllipticFallback) throw Error("This curve is only supported in the full build of OpenPGP.js");
        const { nobleCurves: r } = await Promise.resolve().then(function() {
            return Ul;
        });
        switch(e){
            case R.publicKey.ecdh:
            case R.publicKey.ecdsa:
                {
                    const e = r.get(t);
                    if (!e) throw Error("Unsupported curve");
                    return e;
                }
            case R.publicKey.x448:
                return r.get("x448");
            case R.publicKey.ed448:
                return r.get("ed448");
            default:
                throw Error("Unsupported curve");
        }
    },
    readNumber: function(e) {
        let t = 0;
        for(let r = 0; r < e.length; r++)t += 256 ** r * e[e.length - 1 - r];
        return t;
    },
    writeNumber: function(e, t) {
        const r = new Uint8Array(t);
        for(let n = 0; n < t; n++)r[n] = e >> 8 * (t - n - 1) & 255;
        return r;
    },
    readDate: function(e) {
        const t = M.readNumber(e);
        return new Date(1e3 * t);
    },
    writeDate: function(e) {
        const t = Math.floor(e.getTime() / 1e3);
        return M.writeNumber(t, 4);
    },
    normalizeDate: function(e = Date.now()) {
        return null === e || e === 1 / 0 ? e : new Date(1e3 * Math.floor(+e / 1e3));
    },
    readMPI: function(e) {
        const t = (e[0] << 8 | e[1]) + 7 >>> 3;
        return M.readExactSubarray(e, 2, 2 + t);
    },
    readExactSubarray: function(e, t, r) {
        if (e.length < r - t) throw Error("Input array too short");
        return e.subarray(t, r);
    },
    leftPad (e, t) {
        if (e.length > t) throw Error("Input array too long");
        const r = new Uint8Array(t), n = t - e.length;
        return r.set(e, n), r;
    },
    uint8ArrayToMPI: function(e) {
        const t = M.uint8ArrayBitLength(e);
        if (0 === t) throw Error("Zero MPI");
        const r = e.subarray(e.length - Math.ceil(t / 8)), n = new Uint8Array([
            (65280 & t) >> 8,
            255 & t
        ]);
        return M.concatUint8Array([
            n,
            r
        ]);
    },
    uint8ArrayBitLength: function(e) {
        let t;
        for(t = 0; t < e.length && 0 === e[t]; t++);
        if (t === e.length) return 0;
        const r = e.subarray(t);
        return 8 * (r.length - 1) + M.nbits(r[0]);
    },
    hexToUint8Array: function(e) {
        const t = new Uint8Array(e.length >> 1);
        for(let r = 0; r < e.length >> 1; r++)t[r] = parseInt(e.substr(r << 1, 2), 16);
        return t;
    },
    uint8ArrayToHex: function(e) {
        const t = "0123456789abcdef";
        let r = "";
        return e.forEach((e)=>{
            r += t[e >> 4] + t[15 & e];
        }), r;
    },
    stringToUint8Array: function(e) {
        return k(e, (e)=>{
            if (!M.isString(e)) throw Error("stringToUint8Array: Data must be in the form of a string");
            const t = new Uint8Array(e.length);
            for(let r = 0; r < e.length; r++)t[r] = e.charCodeAt(r);
            return t;
        });
    },
    uint8ArrayToString: function(e) {
        const t = [], r = 16384, n = (e = new Uint8Array(e)).length;
        for(let i = 0; i < n; i += r)t.push(String.fromCharCode.apply(String, e.subarray(i, i + r < n ? i + r : n)));
        return t.join("");
    },
    encodeUTF8: function(e) {
        const t = new TextEncoder("utf-8");
        function r(e, r1 = !1) {
            return t.encode(e, {
                stream: !r1
            });
        }
        return k(e, r, ()=>r("", !0));
    },
    decodeUTF8: function(e) {
        const t = new TextDecoder("utf-8");
        function r(e, r1 = !1) {
            return t.decode(e, {
                stream: !r1
            });
        }
        return k(e, r, ()=>r(new Uint8Array, !0));
    },
    concat: A,
    concatUint8Array: l,
    equalsUint8Array: function(e, t) {
        if (!M.isUint8Array(e) || !M.isUint8Array(t)) throw Error("Data must be in the form of a Uint8Array");
        if (e.length !== t.length) return !1;
        for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
        return !0;
    },
    writeChecksum: function(e) {
        let t = 0;
        for(let r = 0; r < e.length; r++)t = t + e[r] & 65535;
        return M.writeNumber(t, 2);
    },
    printDebug: function(e) {
        L && console.log("[OpenPGP.js debug]", e);
    },
    printDebugError: function(e) {
        L && console.error("[OpenPGP.js debug]", e);
    },
    nbits: function(e) {
        let t = 1, r = e >>> 16;
        return 0 !== r && (e = r, t += 16), r = e >> 8, 0 !== r && (e = r, t += 8), r = e >> 4, 0 !== r && (e = r, t += 4), r = e >> 2, 0 !== r && (e = r, t += 2), r = e >> 1, 0 !== r && (e = r, t += 1), t;
    },
    double: function(e) {
        const t = new Uint8Array(e.length), r = e.length - 1;
        for(let n = 0; n < r; n++)t[n] = e[n] << 1 ^ e[n + 1] >> 7;
        return t[r] = e[r] << 1 ^ 135 * (e[0] >> 7), t;
    },
    shiftRight: function(e, t) {
        if (t) for(let r = e.length - 1; r >= 0; r--)e[r] >>= t, r > 0 && (e[r] |= e[r - 1] << 8 - t);
        return e;
    },
    getWebCrypto: function() {
        const t = void 0 !== e && e.crypto && e.crypto.subtle || this.getNodeCrypto()?.webcrypto.subtle;
        if (!t) throw Error("The WebCrypto API is not available");
        return t;
    },
    getNodeCrypto: function() {
        return this.nodeRequire("crypto");
    },
    getNodeZlib: function() {
        return this.nodeRequire("zlib");
    },
    getNodeBuffer: function() {
        return (this.nodeRequire("buffer") || {}).Buffer;
    },
    getHardwareConcurrency: function() {
        if ("undefined" != typeof navigator) return navigator.hardwareConcurrency || 1;
        return this.nodeRequire("os").cpus().length;
    },
    isEmailAddress: function(e) {
        if (!M.isString(e)) return !1;
        return /^[^\p{C}\p{Z}@<>\\]+@[^\p{C}\p{Z}@<>\\]+[^\p{C}\p{Z}\p{P}]$/u.test(e);
    },
    canonicalizeEOL: function(e) {
        let t = !1;
        return k(e, (e)=>{
            let r;
            t && (e = M.concatUint8Array([
                new Uint8Array([
                    13
                ]),
                e
            ])), 13 === e[e.length - 1] ? (t = !0, e = e.subarray(0, -1)) : t = !1;
            const n = [];
            for(let t = 0; r = e.indexOf(10, t) + 1, r; t = r)13 !== e[r - 2] && n.push(r);
            if (!n.length) return e;
            const i = new Uint8Array(e.length + n.length);
            let s = 0;
            for(let t = 0; t < n.length; t++){
                const r = e.subarray(n[t - 1] || 0, n[t]);
                i.set(r, s), s += r.length, i[s - 1] = 13, i[s] = 10, s++;
            }
            return i.set(e.subarray(n[n.length - 1] || 0), s), i;
        }, ()=>t ? new Uint8Array([
                13
            ]) : void 0);
    },
    nativeEOL: function(e) {
        let t = !1;
        return k(e, (e)=>{
            let r;
            13 === (e = t && 10 !== e[0] ? M.concatUint8Array([
                new Uint8Array([
                    13
                ]),
                e
            ]) : new Uint8Array(e))[e.length - 1] ? (t = !0, e = e.subarray(0, -1)) : t = !1;
            let n = 0;
            for(let t = 0; t !== e.length; t = r){
                r = e.indexOf(13, t) + 1, r || (r = e.length);
                const i = r - (10 === e[r] ? 1 : 0);
                t && e.copyWithin(n, t, i), n += i - t;
            }
            return e.subarray(0, n);
        }, ()=>t ? new Uint8Array([
                13
            ]) : void 0);
    },
    removeTrailingSpaces: function(e) {
        return e.split("\n").map((e)=>{
            let t = e.length - 1;
            for(; t >= 0 && (" " === e[t] || "\t" === e[t] || "\r" === e[t]); t--);
            return e.substr(0, t + 1);
        }).join("\n");
    },
    wrapError: function(e, t) {
        if (!t) return Error(e);
        try {
            t.message = e + ": " + t.message;
        } catch (e) {}
        return t;
    },
    constructAllowedPackets: function(e) {
        const t = {};
        return e.forEach((e)=>{
            if (!e.tag) throw Error("Invalid input: expected a packet class");
            t[e.tag] = e;
        }), t;
    },
    anyPromise: function(e) {
        return new Promise(async (t, r)=>{
            let n;
            await Promise.all(e.map(async (e)=>{
                try {
                    t(await e);
                } catch (e) {
                    n = e;
                }
            })), r(n);
        });
    },
    selectUint8Array: function(e, t, r) {
        const n = Math.max(t.length, r.length), i = new Uint8Array(n);
        let s = 0;
        for(let n = 0; n < i.length; n++)i[n] = t[n] & 256 - e | r[n] & 255 + e, s += e & n < t.length | 1 - e & n < r.length;
        return i.subarray(0, s);
    },
    selectUint8: function(e, t, r) {
        return t & 256 - e | r & 255 + e;
    },
    isAES: function(e) {
        return e === R.symmetric.aes128 || e === R.symmetric.aes192 || e === R.symmetric.aes256;
    }
}, N = M.getNodeBuffer();
let F, O;
function H(e) {
    let t = new Uint8Array;
    return k(e, (e)=>{
        t = M.concatUint8Array([
            t,
            e
        ]);
        const r = [], n = Math.floor(t.length / 45), i = 45 * n, s = F(t.subarray(0, i));
        for(let e = 0; e < n; e++)r.push(s.substr(60 * e, 60)), r.push("\n");
        return t = t.subarray(i), r.join("");
    }, ()=>t.length ? F(t) + "\n" : "");
}
function z(e) {
    let t = "";
    return k(e, (e)=>{
        t += e;
        let r = 0;
        const n = [
            " ",
            "\t",
            "\r",
            "\n"
        ];
        for(let e = 0; e < n.length; e++){
            const i = n[e];
            for(let e = t.indexOf(i); -1 !== e; e = t.indexOf(i, e + 1))r++;
        }
        let i = t.length;
        for(; i > 0 && (i - r) % 4 != 0; i--)n.includes(t[i]) && r--;
        const s = O(t.substr(0, i));
        return t = t.substr(i), s;
    }, ()=>O(t));
}
function G(e) {
    return z(e.replace(/-/g, "+").replace(/_/g, "/"));
}
function _(e, t) {
    let r = H(e).replace(/[\r\n]/g, "");
    return r = r.replace(/[+]/g, "-").replace(/[/]/g, "_").replace(/[=]/g, ""), r;
}
function j(e) {
    const t = e.match(/^-----BEGIN PGP (MESSAGE, PART \d+\/\d+|MESSAGE, PART \d+|SIGNED MESSAGE|MESSAGE|PUBLIC KEY BLOCK|PRIVATE KEY BLOCK|SIGNATURE)-----$/m);
    if (!t) throw Error("Unknown ASCII armor type");
    return /MESSAGE, PART \d+\/\d+/.test(t[1]) ? R.armor.multipartSection : /MESSAGE, PART \d+/.test(t[1]) ? R.armor.multipartLast : /SIGNED MESSAGE/.test(t[1]) ? R.armor.signed : /MESSAGE/.test(t[1]) ? R.armor.message : /PUBLIC KEY BLOCK/.test(t[1]) ? R.armor.publicKey : /PRIVATE KEY BLOCK/.test(t[1]) ? R.armor.privateKey : /SIGNATURE/.test(t[1]) ? R.armor.signature : void 0;
}
function q(e, t) {
    let r = "";
    return t.showVersion && (r += "Version: " + t.versionString + "\n"), t.showComment && (r += "Comment: " + t.commentString + "\n"), e && (r += "Comment: " + e + "\n"), r += "\n", r;
}
function V(e) {
    const t = function(e) {
        let t = 13501623;
        return k(e, (e)=>{
            const r = Y ? Math.floor(e.length / 4) : 0, n = new Uint32Array(e.buffer, e.byteOffset, r);
            for(let e = 0; e < r; e++)t ^= n[e], t = J[0][t >> 24 & 255] ^ J[1][t >> 16 & 255] ^ J[2][t >> 8 & 255] ^ J[3][255 & t];
            for(let n = 4 * r; n < e.length; n++)t = t >> 8 ^ J[0][255 & t ^ e[n]];
        }, ()=>new Uint8Array([
                t,
                t >> 8,
                t >> 16
            ]));
    }(e);
    return H(t);
}
N ? (F = (e)=>N.from(e).toString("base64"), O = (e)=>{
    const t = N.from(e, "base64");
    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
}) : (F = (e)=>btoa(M.uint8ArrayToString(e)), O = (e)=>M.stringToUint8Array(atob(e)));
const J = [
    Array(255),
    Array(255),
    Array(255),
    Array(255)
];
for(let e = 0; e <= 255; e++){
    let t = e << 16;
    for(let e = 0; e < 8; e++)t = t << 1 ^ (8388608 & t ? 8801531 : 0);
    J[0][e] = (16711680 & t) >> 16 | 65280 & t | (255 & t) << 16;
}
for(let e = 0; e <= 255; e++)J[1][e] = J[0][e] >> 8 ^ J[0][255 & J[0][e]];
for(let e = 0; e <= 255; e++)J[2][e] = J[1][e] >> 8 ^ J[0][255 & J[1][e]];
for(let e = 0; e <= 255; e++)J[3][e] = J[2][e] >> 8 ^ J[0][255 & J[2][e]];
const Y = function() {
    const e = new ArrayBuffer(2);
    return new DataView(e).setInt16(0, 255, !0), 255 === new Int16Array(e)[0];
}();
function Z(e) {
    for(let t = 0; t < e.length; t++)/^([^\s:]|[^\s:][^:]*[^\s:]): .+$/.test(e[t]) || M.printDebugError(Error("Improperly formatted armor header: " + e[t])), /^(Version|Comment|MessageID|Hash|Charset): .+$/.test(e[t]) || M.printDebugError(Error("Unknown header: " + e[t]));
}
function W(e) {
    let t = e;
    const r = e.lastIndexOf("=");
    return r >= 0 && r !== e.length - 1 && (t = e.slice(0, r)), t;
}
function $(e) {
    return new Promise(async (t, r)=>{
        try {
            const n = /^-----[^-]+-----$/m, i = /^[ \f\r\t\u00a0\u2000-\u200a\u202f\u205f\u3000]*$/;
            let s;
            const a = [];
            let o, c, h = a, u = [];
            const l = z(E(e, async (e, y)=>{
                const f = P(e);
                try {
                    for(;;){
                        let e = await f.readLine();
                        if (void 0 === e) throw Error("Misformed armored text");
                        if (e = M.removeTrailingSpaces(e.replace(/[\r\n]/g, "")), s) {
                            if (o) c || s !== R.armor.signed || (n.test(e) ? (u = u.join("\r\n"), c = !0, Z(h), h = [], o = !1) : u.push(e.replace(/^- /, "")));
                            else if (n.test(e) && r(Error("Mandatory blank line missing between armor headers and armor data")), i.test(e)) {
                                if (Z(h), o = !0, c || s !== R.armor.signed) {
                                    t({
                                        text: u,
                                        data: l,
                                        headers: a,
                                        type: s
                                    });
                                    break;
                                }
                            } else h.push(e);
                        } else n.test(e) && (s = j(e));
                    }
                } catch (e) {
                    return void r(e);
                }
                const g = x(y);
                try {
                    for(;;){
                        await g.ready;
                        const { done: e, value: t } = await f.read();
                        if (e) throw Error("Misformed armored text");
                        const r = t + "";
                        if (-1 !== r.indexOf("=") || -1 !== r.indexOf("-")) {
                            let e = await f.readToEnd();
                            e.length || (e = ""), e = r + e, e = M.removeTrailingSpaces(e.replace(/\r/g, ""));
                            const t = e.split(n);
                            if (1 === t.length) throw Error("Misformed armored text");
                            const i = W(t[0].slice(0, -1));
                            await g.write(i);
                            break;
                        }
                        await g.write(r);
                    }
                    await g.ready, await g.close();
                } catch (e) {
                    await g.abort(e);
                }
            }));
        } catch (e) {
            r(e);
        }
    }).then(async (e)=>(o(e.data) && (e.data = await C(e.data)), e));
}
function X(e, t, r, n, i, s = !1, a = T) {
    let o, c;
    e === R.armor.signed && (o = t.text, c = t.hash, t = t.data);
    const h = s && B(t), u = [];
    switch(e){
        case R.armor.multipartSection:
            u.push("-----BEGIN PGP MESSAGE, PART " + r + "/" + n + "-----\n"), u.push(q(i, a)), u.push(H(t)), h && u.push("=", V(h)), u.push("-----END PGP MESSAGE, PART " + r + "/" + n + "-----\n");
            break;
        case R.armor.multipartLast:
            u.push("-----BEGIN PGP MESSAGE, PART " + r + "-----\n"), u.push(q(i, a)), u.push(H(t)), h && u.push("=", V(h)), u.push("-----END PGP MESSAGE, PART " + r + "-----\n");
            break;
        case R.armor.signed:
            u.push("-----BEGIN PGP SIGNED MESSAGE-----\n"), u.push(c ? `Hash: ${c}\n\n` : "\n"), u.push(o.replace(/^-/gm, "- -")), u.push("\n-----BEGIN PGP SIGNATURE-----\n"), u.push(q(i, a)), u.push(H(t)), h && u.push("=", V(h)), u.push("-----END PGP SIGNATURE-----\n");
            break;
        case R.armor.message:
            u.push("-----BEGIN PGP MESSAGE-----\n"), u.push(q(i, a)), u.push(H(t)), h && u.push("=", V(h)), u.push("-----END PGP MESSAGE-----\n");
            break;
        case R.armor.publicKey:
            u.push("-----BEGIN PGP PUBLIC KEY BLOCK-----\n"), u.push(q(i, a)), u.push(H(t)), h && u.push("=", V(h)), u.push("-----END PGP PUBLIC KEY BLOCK-----\n");
            break;
        case R.armor.privateKey:
            u.push("-----BEGIN PGP PRIVATE KEY BLOCK-----\n"), u.push(q(i, a)), u.push(H(t)), h && u.push("=", V(h)), u.push("-----END PGP PRIVATE KEY BLOCK-----\n");
            break;
        case R.armor.signature:
            u.push("-----BEGIN PGP SIGNATURE-----\n"), u.push(q(i, a)), u.push(H(t)), h && u.push("=", V(h)), u.push("-----END PGP SIGNATURE-----\n");
    }
    return M.concat(u);
}
const ee = BigInt(0), te = BigInt(1);
function re(e) {
    const t = "0123456789ABCDEF";
    let r = "";
    return e.forEach((e)=>{
        r += t[e >> 4] + t[15 & e];
    }), BigInt("0x0" + r);
}
function ne(e, t) {
    const r = e % t;
    return r < ee ? r + t : r;
}
function ie(e, t, r) {
    if (r === ee) throw Error("Modulo cannot be zero");
    if (r === te) return BigInt(0);
    if (t < ee) throw Error("Unsopported negative exponent");
    let n = t, i = e;
    i %= r;
    let s = BigInt(1);
    for(; n > ee;){
        const e = n & te;
        n >>= te;
        s = e ? s * i % r : s, i = i * i % r;
    }
    return s;
}
function se(e) {
    return e >= ee ? e : -e;
}
function ae(e, t) {
    const { gcd: r, x: n } = function(e, t) {
        let r = BigInt(0), n = BigInt(1), i = BigInt(1), s = BigInt(0), a = se(e), o = se(t);
        const c = e < ee, h = t < ee;
        for(; o !== ee;){
            const e = a / o;
            let t = r;
            r = i - e * r, i = t, t = n, n = s - e * n, s = t, t = o, o = a % o, a = t;
        }
        return {
            x: c ? -i : i,
            y: h ? -s : s,
            gcd: a
        };
    }(e, t);
    if (r !== te) throw Error("Inverse does not exist");
    return ne(n + t, t);
}
function oe(e) {
    const t = Number(e);
    if (t > Number.MAX_SAFE_INTEGER) throw Error("Number can only safely store up to 53 bits");
    return t;
}
function ce(e, t) {
    return (e >> BigInt(t) & te) === ee ? 0 : 1;
}
function he(e) {
    const t = e < ee ? BigInt(-1) : ee;
    let r = 1, n = e;
    for(; (n >>= te) !== t;)r++;
    return r;
}
function ue(e) {
    const t = e < ee ? BigInt(-1) : ee, r = BigInt(8);
    let n = 1, i = e;
    for(; (i >>= r) !== t;)n++;
    return n;
}
function le(e, t = "be", r) {
    let n = e.toString(16);
    n.length % 2 == 1 && (n = "0" + n);
    const i = n.length / 2, s = new Uint8Array(r || i), a = r ? r - i : 0;
    let o = 0;
    for(; o < i;)s[o + a] = parseInt(n.slice(2 * o, 2 * o + 2), 16), o++;
    return "be" !== t && s.reverse(), s;
}
const ye = M.getNodeCrypto();
function fe(e) {
    const t = "undefined" != typeof crypto ? crypto : ye?.webcrypto;
    if (t?.getRandomValues) {
        const r = new Uint8Array(e);
        return t.getRandomValues(r);
    }
    throw Error("No secure random number generator available.");
}
function ge(e, t) {
    if (t < e) throw Error("Illegal parameter value: max <= min");
    const r = t - e;
    return ne(re(fe(ue(r) + 8)), r) + e;
}
const pe = BigInt(1);
function de(e, t, r) {
    const n = BigInt(30), i = pe << BigInt(e - 1), s = [
        1,
        6,
        5,
        4,
        3,
        2,
        1,
        4,
        3,
        2,
        1,
        2,
        1,
        4,
        3,
        2,
        1,
        2,
        1,
        4,
        3,
        2,
        1,
        6,
        5,
        4,
        3,
        2,
        1,
        2
    ];
    let a = ge(i, i << pe), o = oe(ne(a, n));
    do a += BigInt(s[o]), o = (o + s[o]) % s.length, he(a) > e && (a = ne(a, i << pe), a += i, o = oe(ne(a, n)));
    while (!Ae(a, t, r));
    return a;
}
function Ae(e, t, r) {
    return (!t || function(e, t) {
        let r = e, n = t;
        for(; n !== ee;){
            const e = n;
            n = r % n, r = e;
        }
        return r;
    }(e - pe, t) === pe) && !!function(e) {
        const t = BigInt(0);
        return we.every((r)=>ne(e, r) !== t);
    }(e) && !!function(e, t = BigInt(2)) {
        return ie(t, e - pe, e) === pe;
    }(e) && !!function(e, t) {
        const r = he(e);
        t || (t = Math.max(1, r / 48 | 0));
        const n = e - pe;
        let i = 0;
        for(; !ce(n, i);)i++;
        const s = e >> BigInt(i);
        for(; t > 0; t--){
            let t, r = ie(ge(BigInt(2), n), s, e);
            if (r !== pe && r !== n) {
                for(t = 1; t < i; t++){
                    if (r = ne(r * r, e), r === pe) return !1;
                    if (r === n) break;
                }
                if (t === i) return !1;
            }
        }
        return !0;
    }(e, r);
}
const we = [
    7,
    11,
    13,
    17,
    19,
    23,
    29,
    31,
    37,
    41,
    43,
    47,
    53,
    59,
    61,
    67,
    71,
    73,
    79,
    83,
    89,
    97,
    101,
    103,
    107,
    109,
    113,
    127,
    131,
    137,
    139,
    149,
    151,
    157,
    163,
    167,
    173,
    179,
    181,
    191,
    193,
    197,
    199,
    211,
    223,
    227,
    229,
    233,
    239,
    241,
    251,
    257,
    263,
    269,
    271,
    277,
    281,
    283,
    293,
    307,
    311,
    313,
    317,
    331,
    337,
    347,
    349,
    353,
    359,
    367,
    373,
    379,
    383,
    389,
    397,
    401,
    409,
    419,
    421,
    431,
    433,
    439,
    443,
    449,
    457,
    461,
    463,
    467,
    479,
    487,
    491,
    499,
    503,
    509,
    521,
    523,
    541,
    547,
    557,
    563,
    569,
    571,
    577,
    587,
    593,
    599,
    601,
    607,
    613,
    617,
    619,
    631,
    641,
    643,
    647,
    653,
    659,
    661,
    673,
    677,
    683,
    691,
    701,
    709,
    719,
    727,
    733,
    739,
    743,
    751,
    757,
    761,
    769,
    773,
    787,
    797,
    809,
    811,
    821,
    823,
    827,
    829,
    839,
    853,
    857,
    859,
    863,
    877,
    881,
    883,
    887,
    907,
    911,
    919,
    929,
    937,
    941,
    947,
    953,
    967,
    971,
    977,
    983,
    991,
    997,
    1009,
    1013,
    1019,
    1021,
    1031,
    1033,
    1039,
    1049,
    1051,
    1061,
    1063,
    1069,
    1087,
    1091,
    1093,
    1097,
    1103,
    1109,
    1117,
    1123,
    1129,
    1151,
    1153,
    1163,
    1171,
    1181,
    1187,
    1193,
    1201,
    1213,
    1217,
    1223,
    1229,
    1231,
    1237,
    1249,
    1259,
    1277,
    1279,
    1283,
    1289,
    1291,
    1297,
    1301,
    1303,
    1307,
    1319,
    1321,
    1327,
    1361,
    1367,
    1373,
    1381,
    1399,
    1409,
    1423,
    1427,
    1429,
    1433,
    1439,
    1447,
    1451,
    1453,
    1459,
    1471,
    1481,
    1483,
    1487,
    1489,
    1493,
    1499,
    1511,
    1523,
    1531,
    1543,
    1549,
    1553,
    1559,
    1567,
    1571,
    1579,
    1583,
    1597,
    1601,
    1607,
    1609,
    1613,
    1619,
    1621,
    1627,
    1637,
    1657,
    1663,
    1667,
    1669,
    1693,
    1697,
    1699,
    1709,
    1721,
    1723,
    1733,
    1741,
    1747,
    1753,
    1759,
    1777,
    1783,
    1787,
    1789,
    1801,
    1811,
    1823,
    1831,
    1847,
    1861,
    1867,
    1871,
    1873,
    1877,
    1879,
    1889,
    1901,
    1907,
    1913,
    1931,
    1933,
    1949,
    1951,
    1973,
    1979,
    1987,
    1993,
    1997,
    1999,
    2003,
    2011,
    2017,
    2027,
    2029,
    2039,
    2053,
    2063,
    2069,
    2081,
    2083,
    2087,
    2089,
    2099,
    2111,
    2113,
    2129,
    2131,
    2137,
    2141,
    2143,
    2153,
    2161,
    2179,
    2203,
    2207,
    2213,
    2221,
    2237,
    2239,
    2243,
    2251,
    2267,
    2269,
    2273,
    2281,
    2287,
    2293,
    2297,
    2309,
    2311,
    2333,
    2339,
    2341,
    2347,
    2351,
    2357,
    2371,
    2377,
    2381,
    2383,
    2389,
    2393,
    2399,
    2411,
    2417,
    2423,
    2437,
    2441,
    2447,
    2459,
    2467,
    2473,
    2477,
    2503,
    2521,
    2531,
    2539,
    2543,
    2549,
    2551,
    2557,
    2579,
    2591,
    2593,
    2609,
    2617,
    2621,
    2633,
    2647,
    2657,
    2659,
    2663,
    2671,
    2677,
    2683,
    2687,
    2689,
    2693,
    2699,
    2707,
    2711,
    2713,
    2719,
    2729,
    2731,
    2741,
    2749,
    2753,
    2767,
    2777,
    2789,
    2791,
    2797,
    2801,
    2803,
    2819,
    2833,
    2837,
    2843,
    2851,
    2857,
    2861,
    2879,
    2887,
    2897,
    2903,
    2909,
    2917,
    2927,
    2939,
    2953,
    2957,
    2963,
    2969,
    2971,
    2999,
    3001,
    3011,
    3019,
    3023,
    3037,
    3041,
    3049,
    3061,
    3067,
    3079,
    3083,
    3089,
    3109,
    3119,
    3121,
    3137,
    3163,
    3167,
    3169,
    3181,
    3187,
    3191,
    3203,
    3209,
    3217,
    3221,
    3229,
    3251,
    3253,
    3257,
    3259,
    3271,
    3299,
    3301,
    3307,
    3313,
    3319,
    3323,
    3329,
    3331,
    3343,
    3347,
    3359,
    3361,
    3371,
    3373,
    3389,
    3391,
    3407,
    3413,
    3433,
    3449,
    3457,
    3461,
    3463,
    3467,
    3469,
    3491,
    3499,
    3511,
    3517,
    3527,
    3529,
    3533,
    3539,
    3541,
    3547,
    3557,
    3559,
    3571,
    3581,
    3583,
    3593,
    3607,
    3613,
    3617,
    3623,
    3631,
    3637,
    3643,
    3659,
    3671,
    3673,
    3677,
    3691,
    3697,
    3701,
    3709,
    3719,
    3727,
    3733,
    3739,
    3761,
    3767,
    3769,
    3779,
    3793,
    3797,
    3803,
    3821,
    3823,
    3833,
    3847,
    3851,
    3853,
    3863,
    3877,
    3881,
    3889,
    3907,
    3911,
    3917,
    3919,
    3923,
    3929,
    3931,
    3943,
    3947,
    3967,
    3989,
    4001,
    4003,
    4007,
    4013,
    4019,
    4021,
    4027,
    4049,
    4051,
    4057,
    4073,
    4079,
    4091,
    4093,
    4099,
    4111,
    4127,
    4129,
    4133,
    4139,
    4153,
    4157,
    4159,
    4177,
    4201,
    4211,
    4217,
    4219,
    4229,
    4231,
    4241,
    4243,
    4253,
    4259,
    4261,
    4271,
    4273,
    4283,
    4289,
    4297,
    4327,
    4337,
    4339,
    4349,
    4357,
    4363,
    4373,
    4391,
    4397,
    4409,
    4421,
    4423,
    4441,
    4447,
    4451,
    4457,
    4463,
    4481,
    4483,
    4493,
    4507,
    4513,
    4517,
    4519,
    4523,
    4547,
    4549,
    4561,
    4567,
    4583,
    4591,
    4597,
    4603,
    4621,
    4637,
    4639,
    4643,
    4649,
    4651,
    4657,
    4663,
    4673,
    4679,
    4691,
    4703,
    4721,
    4723,
    4729,
    4733,
    4751,
    4759,
    4783,
    4787,
    4789,
    4793,
    4799,
    4801,
    4813,
    4817,
    4831,
    4861,
    4871,
    4877,
    4889,
    4903,
    4909,
    4919,
    4931,
    4933,
    4937,
    4943,
    4951,
    4957,
    4967,
    4969,
    4973,
    4987,
    4993,
    4999
].map((e)=>BigInt(e));
const me = M.getWebCrypto(), be = M.getNodeCrypto(), ke = be && be.getHashes();
function Ee(e) {
    if (be && ke.includes(e)) return async function(t) {
        const r = be.createHash(e);
        return k(t, (e)=>{
            r.update(e);
        }, ()=>new Uint8Array(r.digest()));
    };
}
function ve(e, t) {
    const r = async ()=>{
        const { nobleHashes: t } = await Promise.resolve().then(function() {
            return ty;
        }), r = t.get(e);
        if (!r) throw Error("Unsupported hash");
        return r;
    };
    return async function(e) {
        if (o(e) && (e = await C(e)), M.isStream(e)) {
            const t = (await r()).create();
            return k(e, (e)=>{
                t.update(e);
            }, ()=>t.digest());
        }
        if (me && t) return new Uint8Array(await me.digest(t, e));
        return (await r())(e);
    };
}
const Ie = Ee("md5") || ve("md5"), Be = Ee("sha1") || ve("sha1", "SHA-1"), Se = Ee("sha224") || ve("sha224"), Ke = Ee("sha256") || ve("sha256", "SHA-256"), Ce = Ee("sha384") || ve("sha384", "SHA-384"), De = Ee("sha512") || ve("sha512", "SHA-512"), Ue = Ee("ripemd160") || ve("ripemd160"), Pe = Ee("sha3-256") || ve("sha3_256"), xe = Ee("sha3-512") || ve("sha3_512");
function Qe(e, t) {
    switch(e){
        case R.hash.md5:
            return Ie(t);
        case R.hash.sha1:
            return Be(t);
        case R.hash.ripemd:
            return Ue(t);
        case R.hash.sha256:
            return Ke(t);
        case R.hash.sha384:
            return Ce(t);
        case R.hash.sha512:
            return De(t);
        case R.hash.sha224:
            return Se(t);
        case R.hash.sha3_256:
            return Pe(t);
        case R.hash.sha3_512:
            return xe(t);
        default:
            throw Error("Unsupported hash function");
    }
}
function Re(e) {
    switch(e){
        case R.hash.md5:
            return 16;
        case R.hash.sha1:
        case R.hash.ripemd:
            return 20;
        case R.hash.sha256:
            return 32;
        case R.hash.sha384:
            return 48;
        case R.hash.sha512:
            return 64;
        case R.hash.sha224:
            return 28;
        case R.hash.sha3_256:
            return 32;
        case R.hash.sha3_512:
            return 64;
        default:
            throw Error("Invalid hash algorithm.");
    }
}
const Te = [];
function Le(e, t) {
    const r = e.length;
    if (r > t - 11) throw Error("Message too long");
    const n = function(e) {
        const t = new Uint8Array(e);
        let r = 0;
        for(; r < e;){
            const n = fe(e - r);
            for(let e = 0; e < n.length; e++)0 !== n[e] && (t[r++] = n[e]);
        }
        return t;
    }(t - r - 3), i = new Uint8Array(t);
    return i[1] = 2, i.set(n, 2), i.set(e, t - r), i;
}
function Me(e, t) {
    let r = 2, n = 1;
    for(let t = r; t < e.length; t++)n &= 0 !== e[t], r += n;
    const i = r - 2, s = e.subarray(r + 1), a = 0 === e[0] & 2 === e[1] & i >= 8 & !n;
    if (t) return M.selectUint8Array(a, s, t);
    if (a) return s;
    throw Error("Decryption error");
}
function Ne(e, t, r) {
    let n;
    if (t.length !== Re(e)) throw Error("Invalid hash length");
    const i = new Uint8Array(Te[e].length);
    for(n = 0; n < Te[e].length; n++)i[n] = Te[e][n];
    const s = i.length + t.length;
    if (r < s + 11) throw Error("Intended encoded message length too short");
    const a = new Uint8Array(r - s - 3).fill(255), o = new Uint8Array(r);
    return o[1] = 1, o.set(a, 2), o.set(i, r - s), o.set(t, r - t.length), o;
}
Te[1] = [
    48,
    32,
    48,
    12,
    6,
    8,
    42,
    134,
    72,
    134,
    247,
    13,
    2,
    5,
    5,
    0,
    4,
    16
], Te[2] = [
    48,
    33,
    48,
    9,
    6,
    5,
    43,
    14,
    3,
    2,
    26,
    5,
    0,
    4,
    20
], Te[3] = [
    48,
    33,
    48,
    9,
    6,
    5,
    43,
    36,
    3,
    2,
    1,
    5,
    0,
    4,
    20
], Te[8] = [
    48,
    49,
    48,
    13,
    6,
    9,
    96,
    134,
    72,
    1,
    101,
    3,
    4,
    2,
    1,
    5,
    0,
    4,
    32
], Te[9] = [
    48,
    65,
    48,
    13,
    6,
    9,
    96,
    134,
    72,
    1,
    101,
    3,
    4,
    2,
    2,
    5,
    0,
    4,
    48
], Te[10] = [
    48,
    81,
    48,
    13,
    6,
    9,
    96,
    134,
    72,
    1,
    101,
    3,
    4,
    2,
    3,
    5,
    0,
    4,
    64
], Te[11] = [
    48,
    45,
    48,
    13,
    6,
    9,
    96,
    134,
    72,
    1,
    101,
    3,
    4,
    2,
    4,
    5,
    0,
    4,
    28
];
const Fe = M.getWebCrypto(), Oe = M.getNodeCrypto(), He = BigInt(1);
async function ze(e, t, r, n, i, s, a, o, c) {
    if (Re(e) >= r.length) throw Error("Digest size cannot exceed key modulus size");
    if (t && !M.isStream(t)) {
        if (M.getWebCrypto()) try {
            return await async function(e, t, r, n, i, s, a, o) {
                const c = await qe(r, n, i, s, a, o), h = {
                    name: "RSASSA-PKCS1-v1_5",
                    hash: {
                        name: e
                    }
                }, u = await Fe.importKey("jwk", c, h, !1, [
                    "sign"
                ]);
                return new Uint8Array(await Fe.sign("RSASSA-PKCS1-v1_5", u, t));
            }(R.read(R.webHash, e), t, r, n, i, s, a, o);
        } catch (e) {
            M.printDebugError(e);
        }
        else if (M.getNodeCrypto()) return async function(e, t, r, n, i, s, a, o) {
            const c = Oe.createSign(R.read(R.hash, e));
            c.write(t), c.end();
            const h = await qe(r, n, i, s, a, o);
            return new Uint8Array(c.sign({
                key: h,
                format: "jwk",
                type: "pkcs1"
            }));
        }(e, t, r, n, i, s, a, o);
    }
    return async function(e, t, r, n) {
        t = re(t);
        const i = re(Ne(e, n, ue(t)));
        return r = re(r), le(ie(i, r, t), "be", ue(t));
    }(e, r, i, c);
}
async function Ge(e, t, r, n, i, s) {
    if (t && !M.isStream(t)) {
        if (M.getWebCrypto()) try {
            return await async function(e, t, r, n, i) {
                const s = Ve(n, i), a = await Fe.importKey("jwk", s, {
                    name: "RSASSA-PKCS1-v1_5",
                    hash: {
                        name: e
                    }
                }, !1, [
                    "verify"
                ]);
                return Fe.verify("RSASSA-PKCS1-v1_5", a, r, t);
            }(R.read(R.webHash, e), t, r, n, i);
        } catch (e) {
            M.printDebugError(e);
        }
        else if (M.getNodeCrypto()) return async function(e, t, r, n, i) {
            const s = Ve(n, i), a = {
                key: s,
                format: "jwk",
                type: "pkcs1"
            }, o = Oe.createVerify(R.read(R.hash, e));
            o.write(t), o.end();
            try {
                return o.verify(a, r);
            } catch (e) {
                return !1;
            }
        }(e, t, r, n, i);
    }
    return async function(e, t, r, n, i) {
        if (r = re(r), t = re(t), n = re(n), t >= r) throw Error("Signature size cannot exceed modulus size");
        const s = le(ie(t, n, r), "be", ue(r)), a = Ne(e, i, ue(r));
        return M.equalsUint8Array(s, a);
    }(e, r, n, i, s);
}
async function _e(e, t, r) {
    return M.getNodeCrypto() ? async function(e, t, r) {
        const n = Ve(t, r), i = {
            key: n,
            format: "jwk",
            type: "pkcs1",
            padding: Oe.constants.RSA_PKCS1_PADDING
        };
        return new Uint8Array(Oe.publicEncrypt(i, e));
    }(e, t, r) : async function(e, t, r) {
        if (t = re(t), e = re(Le(e, ue(t))), r = re(r), e >= t) throw Error("Message size cannot exceed modulus size");
        return le(ie(e, r, t), "be", ue(t));
    }(e, t, r);
}
async function je(e, t, r, n, i, s, a, o) {
    if (M.getNodeCrypto() && !o) try {
        return await async function(e, t, r, n, i, s, a) {
            const o = await qe(t, r, n, i, s, a), c = {
                key: o,
                format: "jwk",
                type: "pkcs1",
                padding: Oe.constants.RSA_PKCS1_PADDING
            };
            try {
                return new Uint8Array(Oe.privateDecrypt(c, e));
            } catch (e) {
                throw Error("Decryption error");
            }
        }(e, t, r, n, i, s, a);
    } catch (e) {
        M.printDebugError(e);
    }
    return async function(e, t, r, n, i, s, a, o) {
        if (e = re(e), t = re(t), r = re(r), n = re(n), i = re(i), s = re(s), a = re(a), e >= t) throw Error("Data too large.");
        const c = ne(n, s - He), h = ne(n, i - He), u = ge(BigInt(2), t), l = ie(ae(u, t), r, t);
        e = ne(e * l, t);
        const y = ie(e, h, i), f = ie(e, c, s), g = ne(a * (f - y), s);
        let p = g * i + y;
        return p = ne(p * u, t), Me(le(p, "be", ue(t)), o);
    }(e, t, r, n, i, s, a, o);
}
async function qe(e, t, r, n, i, s) {
    const a = re(n), o = re(i), c = re(r);
    let h = ne(c, o - He), u = ne(c, a - He);
    return u = le(u), h = le(h), {
        kty: "RSA",
        n: _(e),
        e: _(t),
        d: _(r),
        p: _(i),
        q: _(n),
        dp: _(h),
        dq: _(u),
        qi: _(s),
        ext: !0
    };
}
function Ve(e, t) {
    return {
        kty: "RSA",
        n: _(e),
        e: _(t),
        ext: !0
    };
}
function Je(e, t) {
    return {
        n: G(e.n),
        e: le(t),
        d: G(e.d),
        p: G(e.q),
        q: G(e.p),
        u: G(e.qi)
    };
}
const Ye = BigInt(1);
const Ze = "object" == typeof e && "crypto" in e ? e.crypto : void 0, We = {};
var $e = function(e) {
    var t, r = new Float64Array(16);
    if (e) for(t = 0; t < e.length; t++)r[t] = e[t];
    return r;
}, Xe = function() {
    throw Error("no PRNG");
}, et = new Uint8Array(32);
et[0] = 9;
var tt = $e(), rt = $e([
    1
]), nt = $e([
    56129,
    1
]), it = $e([
    30883,
    4953,
    19914,
    30187,
    55467,
    16705,
    2637,
    112,
    59544,
    30585,
    16505,
    36039,
    65139,
    11119,
    27886,
    20995
]), st = $e([
    61785,
    9906,
    39828,
    60374,
    45398,
    33411,
    5274,
    224,
    53552,
    61171,
    33010,
    6542,
    64743,
    22239,
    55772,
    9222
]), at = $e([
    54554,
    36645,
    11616,
    51542,
    42930,
    38181,
    51040,
    26924,
    56412,
    64982,
    57905,
    49316,
    21502,
    52590,
    14035,
    8553
]), ot = $e([
    26200,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214
]), ct = $e([
    41136,
    18958,
    6951,
    50414,
    58488,
    44335,
    6150,
    12099,
    55207,
    15867,
    153,
    11085,
    57099,
    20417,
    9344,
    11139
]);
function ht(e, t, r, n) {
    e[t] = r >> 24 & 255, e[t + 1] = r >> 16 & 255, e[t + 2] = r >> 8 & 255, e[t + 3] = 255 & r, e[t + 4] = n >> 24 & 255, e[t + 5] = n >> 16 & 255, e[t + 6] = n >> 8 & 255, e[t + 7] = 255 & n;
}
function ut(e, t, r, n) {
    return function(e, t, r, n, i) {
        var s, a = 0;
        for(s = 0; s < i; s++)a |= e[t + s] ^ r[n + s];
        return (1 & a - 1 >>> 8) - 1;
    }(e, t, r, n, 32);
}
function lt(e, t) {
    var r;
    for(r = 0; r < 16; r++)e[r] = 0 | t[r];
}
function yt(e) {
    var t, r, n = 1;
    for(t = 0; t < 16; t++)r = e[t] + n + 65535, n = Math.floor(r / 65536), e[t] = r - 65536 * n;
    e[0] += n - 1 + 37 * (n - 1);
}
function ft(e, t, r) {
    for(var n, i = ~(r - 1), s = 0; s < 16; s++)n = i & (e[s] ^ t[s]), e[s] ^= n, t[s] ^= n;
}
function gt(e, t) {
    var r, n, i, s = $e(), a = $e();
    for(r = 0; r < 16; r++)a[r] = t[r];
    for(yt(a), yt(a), yt(a), n = 0; n < 2; n++){
        for(s[0] = a[0] - 65517, r = 1; r < 15; r++)s[r] = a[r] - 65535 - (s[r - 1] >> 16 & 1), s[r - 1] &= 65535;
        s[15] = a[15] - 32767 - (s[14] >> 16 & 1), i = s[15] >> 16 & 1, s[14] &= 65535, ft(a, s, 1 - i);
    }
    for(r = 0; r < 16; r++)e[2 * r] = 255 & a[r], e[2 * r + 1] = a[r] >> 8;
}
function pt(e, t) {
    var r = new Uint8Array(32), n = new Uint8Array(32);
    return gt(r, e), gt(n, t), ut(r, 0, n, 0);
}
function dt(e) {
    var t = new Uint8Array(32);
    return gt(t, e), 1 & t[0];
}
function At(e, t) {
    var r;
    for(r = 0; r < 16; r++)e[r] = t[2 * r] + (t[2 * r + 1] << 8);
    e[15] &= 32767;
}
function wt(e, t, r) {
    for(var n = 0; n < 16; n++)e[n] = t[n] + r[n];
}
function mt(e, t, r) {
    for(var n = 0; n < 16; n++)e[n] = t[n] - r[n];
}
function bt(e, t, r) {
    var n, i, s = 0, a = 0, o = 0, c = 0, h = 0, u = 0, l = 0, y = 0, f = 0, g = 0, p = 0, d = 0, A = 0, w = 0, m = 0, b = 0, k = 0, E = 0, v = 0, I = 0, B = 0, S = 0, K = 0, C = 0, D = 0, U = 0, P = 0, x = 0, Q = 0, R = 0, T = 0, L = r[0], M = r[1], N = r[2], F = r[3], O = r[4], H = r[5], z = r[6], G = r[7], _ = r[8], j = r[9], q = r[10], V = r[11], J = r[12], Y = r[13], Z = r[14], W = r[15];
    s += (n = t[0]) * L, a += n * M, o += n * N, c += n * F, h += n * O, u += n * H, l += n * z, y += n * G, f += n * _, g += n * j, p += n * q, d += n * V, A += n * J, w += n * Y, m += n * Z, b += n * W, a += (n = t[1]) * L, o += n * M, c += n * N, h += n * F, u += n * O, l += n * H, y += n * z, f += n * G, g += n * _, p += n * j, d += n * q, A += n * V, w += n * J, m += n * Y, b += n * Z, k += n * W, o += (n = t[2]) * L, c += n * M, h += n * N, u += n * F, l += n * O, y += n * H, f += n * z, g += n * G, p += n * _, d += n * j, A += n * q, w += n * V, m += n * J, b += n * Y, k += n * Z, E += n * W, c += (n = t[3]) * L, h += n * M, u += n * N, l += n * F, y += n * O, f += n * H, g += n * z, p += n * G, d += n * _, A += n * j, w += n * q, m += n * V, b += n * J, k += n * Y, E += n * Z, v += n * W, h += (n = t[4]) * L, u += n * M, l += n * N, y += n * F, f += n * O, g += n * H, p += n * z, d += n * G, A += n * _, w += n * j, m += n * q, b += n * V, k += n * J, E += n * Y, v += n * Z, I += n * W, u += (n = t[5]) * L, l += n * M, y += n * N, f += n * F, g += n * O, p += n * H, d += n * z, A += n * G, w += n * _, m += n * j, b += n * q, k += n * V, E += n * J, v += n * Y, I += n * Z, B += n * W, l += (n = t[6]) * L, y += n * M, f += n * N, g += n * F, p += n * O, d += n * H, A += n * z, w += n * G, m += n * _, b += n * j, k += n * q, E += n * V, v += n * J, I += n * Y, B += n * Z, S += n * W, y += (n = t[7]) * L, f += n * M, g += n * N, p += n * F, d += n * O, A += n * H, w += n * z, m += n * G, b += n * _, k += n * j, E += n * q, v += n * V, I += n * J, B += n * Y, S += n * Z, K += n * W, f += (n = t[8]) * L, g += n * M, p += n * N, d += n * F, A += n * O, w += n * H, m += n * z, b += n * G, k += n * _, E += n * j, v += n * q, I += n * V, B += n * J, S += n * Y, K += n * Z, C += n * W, g += (n = t[9]) * L, p += n * M, d += n * N, A += n * F, w += n * O, m += n * H, b += n * z, k += n * G, E += n * _, v += n * j, I += n * q, B += n * V, S += n * J, K += n * Y, C += n * Z, D += n * W, p += (n = t[10]) * L, d += n * M, A += n * N, w += n * F, m += n * O, b += n * H, k += n * z, E += n * G, v += n * _, I += n * j, B += n * q, S += n * V, K += n * J, C += n * Y, D += n * Z, U += n * W, d += (n = t[11]) * L, A += n * M, w += n * N, m += n * F, b += n * O, k += n * H, E += n * z, v += n * G, I += n * _, B += n * j, S += n * q, K += n * V, C += n * J, D += n * Y, U += n * Z, P += n * W, A += (n = t[12]) * L, w += n * M, m += n * N, b += n * F, k += n * O, E += n * H, v += n * z, I += n * G, B += n * _, S += n * j, K += n * q, C += n * V, D += n * J, U += n * Y, P += n * Z, x += n * W, w += (n = t[13]) * L, m += n * M, b += n * N, k += n * F, E += n * O, v += n * H, I += n * z, B += n * G, S += n * _, K += n * j, C += n * q, D += n * V, U += n * J, P += n * Y, x += n * Z, Q += n * W, m += (n = t[14]) * L, b += n * M, k += n * N, E += n * F, v += n * O, I += n * H, B += n * z, S += n * G, K += n * _, C += n * j, D += n * q, U += n * V, P += n * J, x += n * Y, Q += n * Z, R += n * W, b += (n = t[15]) * L, a += 38 * (E += n * N), o += 38 * (v += n * F), c += 38 * (I += n * O), h += 38 * (B += n * H), u += 38 * (S += n * z), l += 38 * (K += n * G), y += 38 * (C += n * _), f += 38 * (D += n * j), g += 38 * (U += n * q), p += 38 * (P += n * V), d += 38 * (x += n * J), A += 38 * (Q += n * Y), w += 38 * (R += n * Z), m += 38 * (T += n * W), s = (n = (s += 38 * (k += n * M)) + (i = 1) + 65535) - 65536 * (i = Math.floor(n / 65536)), a = (n = a + i + 65535) - 65536 * (i = Math.floor(n / 65536)), o = (n = o + i + 65535) - 65536 * (i = Math.floor(n / 65536)), c = (n = c + i + 65535) - 65536 * (i = Math.floor(n / 65536)), h = (n = h + i + 65535) - 65536 * (i = Math.floor(n / 65536)), u = (n = u + i + 65535) - 65536 * (i = Math.floor(n / 65536)), l = (n = l + i + 65535) - 65536 * (i = Math.floor(n / 65536)), y = (n = y + i + 65535) - 65536 * (i = Math.floor(n / 65536)), f = (n = f + i + 65535) - 65536 * (i = Math.floor(n / 65536)), g = (n = g + i + 65535) - 65536 * (i = Math.floor(n / 65536)), p = (n = p + i + 65535) - 65536 * (i = Math.floor(n / 65536)), d = (n = d + i + 65535) - 65536 * (i = Math.floor(n / 65536)), A = (n = A + i + 65535) - 65536 * (i = Math.floor(n / 65536)), w = (n = w + i + 65535) - 65536 * (i = Math.floor(n / 65536)), m = (n = m + i + 65535) - 65536 * (i = Math.floor(n / 65536)), b = (n = b + i + 65535) - 65536 * (i = Math.floor(n / 65536)), s = (n = (s += i - 1 + 37 * (i - 1)) + (i = 1) + 65535) - 65536 * (i = Math.floor(n / 65536)), a = (n = a + i + 65535) - 65536 * (i = Math.floor(n / 65536)), o = (n = o + i + 65535) - 65536 * (i = Math.floor(n / 65536)), c = (n = c + i + 65535) - 65536 * (i = Math.floor(n / 65536)), h = (n = h + i + 65535) - 65536 * (i = Math.floor(n / 65536)), u = (n = u + i + 65535) - 65536 * (i = Math.floor(n / 65536)), l = (n = l + i + 65535) - 65536 * (i = Math.floor(n / 65536)), y = (n = y + i + 65535) - 65536 * (i = Math.floor(n / 65536)), f = (n = f + i + 65535) - 65536 * (i = Math.floor(n / 65536)), g = (n = g + i + 65535) - 65536 * (i = Math.floor(n / 65536)), p = (n = p + i + 65535) - 65536 * (i = Math.floor(n / 65536)), d = (n = d + i + 65535) - 65536 * (i = Math.floor(n / 65536)), A = (n = A + i + 65535) - 65536 * (i = Math.floor(n / 65536)), w = (n = w + i + 65535) - 65536 * (i = Math.floor(n / 65536)), m = (n = m + i + 65535) - 65536 * (i = Math.floor(n / 65536)), b = (n = b + i + 65535) - 65536 * (i = Math.floor(n / 65536)), s += i - 1 + 37 * (i - 1), e[0] = s, e[1] = a, e[2] = o, e[3] = c, e[4] = h, e[5] = u, e[6] = l, e[7] = y, e[8] = f, e[9] = g, e[10] = p, e[11] = d, e[12] = A, e[13] = w, e[14] = m, e[15] = b;
}
function kt(e, t) {
    bt(e, t, t);
}
function Et(e, t) {
    var r, n = $e();
    for(r = 0; r < 16; r++)n[r] = t[r];
    for(r = 253; r >= 0; r--)kt(n, n), 2 !== r && 4 !== r && bt(n, n, t);
    for(r = 0; r < 16; r++)e[r] = n[r];
}
function vt(e, t, r) {
    var n, i, s = new Uint8Array(32), a = new Float64Array(80), o = $e(), c = $e(), h = $e(), u = $e(), l = $e(), y = $e();
    for(i = 0; i < 31; i++)s[i] = t[i];
    for(s[31] = 127 & t[31] | 64, s[0] &= 248, At(a, r), i = 0; i < 16; i++)c[i] = a[i], u[i] = o[i] = h[i] = 0;
    for(o[0] = u[0] = 1, i = 254; i >= 0; --i)ft(o, c, n = s[i >>> 3] >>> (7 & i) & 1), ft(h, u, n), wt(l, o, h), mt(o, o, h), wt(h, c, u), mt(c, c, u), kt(u, l), kt(y, o), bt(o, h, o), bt(h, c, l), wt(l, o, h), mt(o, o, h), kt(c, o), mt(h, u, y), bt(o, h, nt), wt(o, o, u), bt(h, h, o), bt(o, u, y), bt(u, c, a), kt(c, l), ft(o, c, n), ft(h, u, n);
    for(i = 0; i < 16; i++)a[i + 16] = o[i], a[i + 32] = h[i], a[i + 48] = c[i], a[i + 64] = u[i];
    var f = a.subarray(32), g = a.subarray(16);
    return Et(f, f), bt(g, g, f), gt(e, g), 0;
}
function It(e, t) {
    return vt(e, t, et);
}
var Bt = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
];
function St(e, t, r, n) {
    for(var i, s, a, o, c, h, u, l, y, f, g, p, d, A, w, m, b, k, E, v, I, B, S, K, C, D, U = new Int32Array(16), P = new Int32Array(16), x = e[0], Q = e[1], R = e[2], T = e[3], L = e[4], M = e[5], N = e[6], F = e[7], O = t[0], H = t[1], z = t[2], G = t[3], _ = t[4], j = t[5], q = t[6], V = t[7], J = 0; n >= 128;){
        for(E = 0; E < 16; E++)v = 8 * E + J, U[E] = r[v + 0] << 24 | r[v + 1] << 16 | r[v + 2] << 8 | r[v + 3], P[E] = r[v + 4] << 24 | r[v + 5] << 16 | r[v + 6] << 8 | r[v + 7];
        for(E = 0; E < 80; E++)if (i = x, s = Q, a = R, o = T, c = L, h = M, u = N, F, y = O, f = H, g = z, p = G, d = _, A = j, w = q, V, S = 65535 & (B = V), K = B >>> 16, C = 65535 & (I = F), D = I >>> 16, S += 65535 & (B = (_ >>> 14 | L << 18) ^ (_ >>> 18 | L << 14) ^ (L >>> 9 | _ << 23)), K += B >>> 16, C += 65535 & (I = (L >>> 14 | _ << 18) ^ (L >>> 18 | _ << 14) ^ (_ >>> 9 | L << 23)), D += I >>> 16, S += 65535 & (B = _ & j ^ ~_ & q), K += B >>> 16, C += 65535 & (I = L & M ^ ~L & N), D += I >>> 16, I = Bt[2 * E], S += 65535 & (B = Bt[2 * E + 1]), K += B >>> 16, C += 65535 & I, D += I >>> 16, I = U[E % 16], K += (B = P[E % 16]) >>> 16, C += 65535 & I, D += I >>> 16, C += (K += (S += 65535 & B) >>> 16) >>> 16, S = 65535 & (B = k = 65535 & S | K << 16), K = B >>> 16, C = 65535 & (I = b = 65535 & C | (D += C >>> 16) << 16), D = I >>> 16, S += 65535 & (B = (O >>> 28 | x << 4) ^ (x >>> 2 | O << 30) ^ (x >>> 7 | O << 25)), K += B >>> 16, C += 65535 & (I = (x >>> 28 | O << 4) ^ (O >>> 2 | x << 30) ^ (O >>> 7 | x << 25)), D += I >>> 16, K += (B = O & H ^ O & z ^ H & z) >>> 16, C += 65535 & (I = x & Q ^ x & R ^ Q & R), D += I >>> 16, l = 65535 & (C += (K += (S += 65535 & B) >>> 16) >>> 16) | (D += C >>> 16) << 16, m = 65535 & S | K << 16, S = 65535 & (B = p), K = B >>> 16, C = 65535 & (I = o), D = I >>> 16, K += (B = k) >>> 16, C += 65535 & (I = b), D += I >>> 16, Q = i, R = s, T = a, L = o = 65535 & (C += (K += (S += 65535 & B) >>> 16) >>> 16) | (D += C >>> 16) << 16, M = c, N = h, F = u, x = l, H = y, z = f, G = g, _ = p = 65535 & S | K << 16, j = d, q = A, V = w, O = m, E % 16 == 15) for(v = 0; v < 16; v++)I = U[v], S = 65535 & (B = P[v]), K = B >>> 16, C = 65535 & I, D = I >>> 16, I = U[(v + 9) % 16], S += 65535 & (B = P[(v + 9) % 16]), K += B >>> 16, C += 65535 & I, D += I >>> 16, b = U[(v + 1) % 16], S += 65535 & (B = ((k = P[(v + 1) % 16]) >>> 1 | b << 31) ^ (k >>> 8 | b << 24) ^ (k >>> 7 | b << 25)), K += B >>> 16, C += 65535 & (I = (b >>> 1 | k << 31) ^ (b >>> 8 | k << 24) ^ b >>> 7), D += I >>> 16, b = U[(v + 14) % 16], K += (B = ((k = P[(v + 14) % 16]) >>> 19 | b << 13) ^ (b >>> 29 | k << 3) ^ (k >>> 6 | b << 26)) >>> 16, C += 65535 & (I = (b >>> 19 | k << 13) ^ (k >>> 29 | b << 3) ^ b >>> 6), D += I >>> 16, D += (C += (K += (S += 65535 & B) >>> 16) >>> 16) >>> 16, U[v] = 65535 & C | D << 16, P[v] = 65535 & S | K << 16;
        S = 65535 & (B = O), K = B >>> 16, C = 65535 & (I = x), D = I >>> 16, I = e[0], K += (B = t[0]) >>> 16, C += 65535 & I, D += I >>> 16, D += (C += (K += (S += 65535 & B) >>> 16) >>> 16) >>> 16, e[0] = x = 65535 & C | D << 16, t[0] = O = 65535 & S | K << 16, S = 65535 & (B = H), K = B >>> 16, C = 65535 & (I = Q), D = I >>> 16, I = e[1], K += (B = t[1]) >>> 16, C += 65535 & I, D += I >>> 16, D += (C += (K += (S += 65535 & B) >>> 16) >>> 16) >>> 16, e[1] = Q = 65535 & C | D << 16, t[1] = H = 65535 & S | K << 16, S = 65535 & (B = z), K = B >>> 16, C = 65535 & (I = R), D = I >>> 16, I = e[2], K += (B = t[2]) >>> 16, C += 65535 & I, D += I >>> 16, D += (C += (K += (S += 65535 & B) >>> 16) >>> 16) >>> 16, e[2] = R = 65535 & C | D << 16, t[2] = z = 65535 & S | K << 16, S = 65535 & (B = G), K = B >>> 16, C = 65535 & (I = T), D = I >>> 16, I = e[3], K += (B = t[3]) >>> 16, C += 65535 & I, D += I >>> 16, D += (C += (K += (S += 65535 & B) >>> 16) >>> 16) >>> 16, e[3] = T = 65535 & C | D << 16, t[3] = G = 65535 & S | K << 16, S = 65535 & (B = _), K = B >>> 16, C = 65535 & (I = L), D = I >>> 16, I = e[4], K += (B = t[4]) >>> 16, C += 65535 & I, D += I >>> 16, D += (C += (K += (S += 65535 & B) >>> 16) >>> 16) >>> 16, e[4] = L = 65535 & C | D << 16, t[4] = _ = 65535 & S | K << 16, S = 65535 & (B = j), K = B >>> 16, C = 65535 & (I = M), D = I >>> 16, I = e[5], K += (B = t[5]) >>> 16, C += 65535 & I, D += I >>> 16, D += (C += (K += (S += 65535 & B) >>> 16) >>> 16) >>> 16, e[5] = M = 65535 & C | D << 16, t[5] = j = 65535 & S | K << 16, S = 65535 & (B = q), K = B >>> 16, C = 65535 & (I = N), D = I >>> 16, I = e[6], K += (B = t[6]) >>> 16, C += 65535 & I, D += I >>> 16, D += (C += (K += (S += 65535 & B) >>> 16) >>> 16) >>> 16, e[6] = N = 65535 & C | D << 16, t[6] = q = 65535 & S | K << 16, S = 65535 & (B = V), K = B >>> 16, C = 65535 & (I = F), D = I >>> 16, I = e[7], K += (B = t[7]) >>> 16, C += 65535 & I, D += I >>> 16, D += (C += (K += (S += 65535 & B) >>> 16) >>> 16) >>> 16, e[7] = F = 65535 & C | D << 16, t[7] = V = 65535 & S | K << 16, J += 128, n -= 128;
    }
    return n;
}
function Kt(e, t, r) {
    var n, i = new Int32Array(8), s = new Int32Array(8), a = new Uint8Array(256), o = r;
    for(i[0] = 1779033703, i[1] = 3144134277, i[2] = 1013904242, i[3] = 2773480762, i[4] = 1359893119, i[5] = 2600822924, i[6] = 528734635, i[7] = 1541459225, s[0] = 4089235720, s[1] = 2227873595, s[2] = 4271175723, s[3] = 1595750129, s[4] = 2917565137, s[5] = 725511199, s[6] = 4215389547, s[7] = 327033209, St(i, s, t, r), r %= 128, n = 0; n < r; n++)a[n] = t[o - r + n];
    for(a[r] = 128, a[(r = 256 - 128 * (r < 112 ? 1 : 0)) - 9] = 0, ht(a, r - 8, o / 536870912 | 0, o << 3), St(i, s, a, r), n = 0; n < 8; n++)ht(e, 8 * n, i[n], s[n]);
    return 0;
}
function Ct(e, t) {
    var r = $e(), n = $e(), i = $e(), s = $e(), a = $e(), o = $e(), c = $e(), h = $e(), u = $e();
    mt(r, e[1], e[0]), mt(u, t[1], t[0]), bt(r, r, u), wt(n, e[0], e[1]), wt(u, t[0], t[1]), bt(n, n, u), bt(i, e[3], t[3]), bt(i, i, st), bt(s, e[2], t[2]), wt(s, s, s), mt(a, n, r), mt(o, s, i), wt(c, s, i), wt(h, n, r), bt(e[0], a, o), bt(e[1], h, c), bt(e[2], c, o), bt(e[3], a, h);
}
function Dt(e, t, r) {
    var n;
    for(n = 0; n < 4; n++)ft(e[n], t[n], r);
}
function Ut(e, t) {
    var r = $e(), n = $e(), i = $e();
    Et(i, t[2]), bt(r, t[0], i), bt(n, t[1], i), gt(e, n), e[31] ^= dt(r) << 7;
}
function Pt(e, t, r) {
    var n, i;
    for(lt(e[0], tt), lt(e[1], rt), lt(e[2], rt), lt(e[3], tt), i = 255; i >= 0; --i)Dt(e, t, n = r[i / 8 | 0] >> (7 & i) & 1), Ct(t, e), Ct(e, e), Dt(e, t, n);
}
function xt(e, t) {
    var r = [
        $e(),
        $e(),
        $e(),
        $e()
    ];
    lt(r[0], at), lt(r[1], ot), lt(r[2], rt), bt(r[3], at, ot), Pt(e, r, t);
}
function Qt(e, t, r) {
    var n, i = new Uint8Array(64), s = [
        $e(),
        $e(),
        $e(),
        $e()
    ];
    for(r || Xe(t, 32), Kt(i, t, 32), i[0] &= 248, i[31] &= 127, i[31] |= 64, xt(s, i), Ut(e, s), n = 0; n < 32; n++)t[n + 32] = e[n];
    return 0;
}
var Rt = new Float64Array([
    237,
    211,
    245,
    92,
    26,
    99,
    18,
    88,
    214,
    156,
    247,
    162,
    222,
    249,
    222,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    16
]);
function Tt(e, t) {
    var r, n, i, s;
    for(n = 63; n >= 32; --n){
        for(r = 0, i = n - 32, s = n - 12; i < s; ++i)t[i] += r - 16 * t[n] * Rt[i - (n - 32)], r = Math.floor((t[i] + 128) / 256), t[i] -= 256 * r;
        t[i] += r, t[n] = 0;
    }
    for(r = 0, i = 0; i < 32; i++)t[i] += r - (t[31] >> 4) * Rt[i], r = t[i] >> 8, t[i] &= 255;
    for(i = 0; i < 32; i++)t[i] -= r * Rt[i];
    for(n = 0; n < 32; n++)t[n + 1] += t[n] >> 8, e[n] = 255 & t[n];
}
function Lt(e) {
    var t, r = new Float64Array(64);
    for(t = 0; t < 64; t++)r[t] = e[t];
    for(t = 0; t < 64; t++)e[t] = 0;
    Tt(e, r);
}
function Mt(e, t) {
    var r = $e(), n = $e(), i = $e(), s = $e(), a = $e(), o = $e(), c = $e();
    return lt(e[2], rt), At(e[1], t), kt(i, e[1]), bt(s, i, it), mt(i, i, e[2]), wt(s, e[2], s), kt(a, s), kt(o, a), bt(c, o, a), bt(r, c, i), bt(r, r, s), function(e, t) {
        var r, n = $e();
        for(r = 0; r < 16; r++)n[r] = t[r];
        for(r = 250; r >= 0; r--)kt(n, n), 1 !== r && bt(n, n, t);
        for(r = 0; r < 16; r++)e[r] = n[r];
    }(r, r), bt(r, r, i), bt(r, r, s), bt(r, r, s), bt(e[0], r, s), kt(n, e[0]), bt(n, n, s), pt(n, i) && bt(e[0], e[0], ct), kt(n, e[0]), bt(n, n, s), pt(n, i) ? -1 : (dt(e[0]) === t[31] >> 7 && mt(e[0], tt, e[0]), bt(e[3], e[0], e[1]), 0);
}
var Nt = 64;
function Ft() {
    for(var e = 0; e < arguments.length; e++)if (!(arguments[e] instanceof Uint8Array)) throw new TypeError("unexpected type, use Uint8Array");
}
We.scalarMult = function(e, t) {
    if (Ft(e, t), 32 !== e.length) throw Error("bad n size");
    if (32 !== t.length) throw Error("bad p size");
    var r = new Uint8Array(32);
    return vt(r, e, t), r;
}, We.box = {}, We.box.keyPair = function() {
    var e = new Uint8Array(32), t = new Uint8Array(32);
    return function(e, t) {
        Xe(t, 32), It(e, t);
    }(e, t), {
        publicKey: e,
        secretKey: t
    };
}, We.box.keyPair.fromSecretKey = function(e) {
    if (Ft(e), 32 !== e.length) throw Error("bad secret key size");
    var t = new Uint8Array(32);
    return It(t, e), {
        publicKey: t,
        secretKey: new Uint8Array(e)
    };
}, We.sign = function(e, t) {
    if (Ft(e, t), 64 !== t.length) throw Error("bad secret key size");
    var r = new Uint8Array(Nt + e.length);
    return function(e, t, r, n) {
        var i, s, a = new Uint8Array(64), o = new Uint8Array(64), c = new Uint8Array(64), h = new Float64Array(64), u = [
            $e(),
            $e(),
            $e(),
            $e()
        ];
        Kt(a, n, 32), a[0] &= 248, a[31] &= 127, a[31] |= 64;
        var l = r + 64;
        for(i = 0; i < r; i++)e[64 + i] = t[i];
        for(i = 0; i < 32; i++)e[32 + i] = a[32 + i];
        for(Kt(c, e.subarray(32), r + 32), Lt(c), xt(u, c), Ut(e, u), i = 32; i < 64; i++)e[i] = n[i];
        for(Kt(o, e, r + 64), Lt(o), i = 0; i < 64; i++)h[i] = 0;
        for(i = 0; i < 32; i++)h[i] = c[i];
        for(i = 0; i < 32; i++)for(s = 0; s < 32; s++)h[i + s] += o[i] * a[s];
        Tt(e.subarray(32), h);
    }(r, e, e.length, t), r;
}, We.sign.detached = function(e, t) {
    for(var r = We.sign(e, t), n = new Uint8Array(Nt), i = 0; i < n.length; i++)n[i] = r[i];
    return n;
}, We.sign.detached.verify = function(e, t, r) {
    if (Ft(e, t, r), t.length !== Nt) throw Error("bad signature size");
    if (32 !== r.length) throw Error("bad public key size");
    var n, i = new Uint8Array(Nt + e.length), s = new Uint8Array(Nt + e.length);
    for(n = 0; n < Nt; n++)i[n] = t[n];
    for(n = 0; n < e.length; n++)i[n + Nt] = e[n];
    return function(e, t, r, n) {
        var i, s = new Uint8Array(32), a = new Uint8Array(64), o = [
            $e(),
            $e(),
            $e(),
            $e()
        ], c = [
            $e(),
            $e(),
            $e(),
            $e()
        ];
        if (r < 64) return -1;
        if (Mt(c, n)) return -1;
        for(i = 0; i < r; i++)e[i] = t[i];
        for(i = 0; i < 32; i++)e[i + 32] = n[i];
        if (Kt(a, e, r), Lt(a), Pt(o, c, a), xt(c, t.subarray(32)), Ct(o, c), Ut(s, o), r -= 64, ut(t, 0, s, 0)) {
            for(i = 0; i < r; i++)e[i] = 0;
            return -1;
        }
        for(i = 0; i < r; i++)e[i] = t[i + 64];
        return r;
    }(s, i, i.length, r) >= 0;
}, We.sign.keyPair = function() {
    var e = new Uint8Array(32), t = new Uint8Array(64);
    return Qt(e, t), {
        publicKey: e,
        secretKey: t
    };
}, We.sign.keyPair.fromSecretKey = function(e) {
    if (Ft(e), 64 !== e.length) throw Error("bad secret key size");
    for(var t = new Uint8Array(32), r = 0; r < t.length; r++)t[r] = e[32 + r];
    return {
        publicKey: t,
        secretKey: new Uint8Array(e)
    };
}, We.sign.keyPair.fromSeed = function(e) {
    if (Ft(e), 32 !== e.length) throw Error("bad seed size");
    for(var t = new Uint8Array(32), r = new Uint8Array(64), n = 0; n < 32; n++)r[n] = e[n];
    return Qt(t, r, !0), {
        publicKey: t,
        secretKey: r
    };
}, We.setPRNG = function(e) {
    Xe = e;
}, function() {
    if (Ze && Ze.getRandomValues) We.setPRNG(function(e, t) {
        var r, n = new Uint8Array(t);
        for(r = 0; r < t; r += 65536)Ze.getRandomValues(n.subarray(r, r + Math.min(t - r, 65536)));
        for(r = 0; r < t; r++)e[r] = n[r];
        !function(e) {
            for(var t = 0; t < e.length; t++)e[t] = 0;
        }(n);
    });
}();
const Ot = {
    "2a8648ce3d030107": R.curve.nistP256,
    "2b81040022": R.curve.nistP384,
    "2b81040023": R.curve.nistP521,
    "2b8104000a": R.curve.secp256k1,
    "2b06010401da470f01": R.curve.ed25519Legacy,
    "2b060104019755010501": R.curve.curve25519Legacy,
    "2b2403030208010107": R.curve.brainpoolP256r1,
    "2b240303020801010b": R.curve.brainpoolP384r1,
    "2b240303020801010d": R.curve.brainpoolP512r1
};
class Ht {
    constructor(e){
        if (e instanceof Ht) this.oid = e.oid;
        else if (M.isArray(e) || M.isUint8Array(e)) {
            if (6 === (e = new Uint8Array(e))[0]) {
                if (e[1] !== e.length - 2) throw Error("Length mismatch in DER encoded oid");
                e = e.subarray(2);
            }
            this.oid = e;
        } else this.oid = "";
    }
    read(e) {
        if (e.length >= 1) {
            const t = e[0];
            if (e.length >= 1 + t) return this.oid = e.subarray(1, 1 + t), 1 + this.oid.length;
        }
        throw Error("Invalid oid");
    }
    write() {
        return M.concatUint8Array([
            new Uint8Array([
                this.oid.length
            ]),
            this.oid
        ]);
    }
    toHex() {
        return M.uint8ArrayToHex(this.oid);
    }
    getName() {
        const e = Ot[this.toHex()];
        if (!e) throw Error("Unknown curve object identifier.");
        return e;
    }
}
function zt(e) {
    let t, r = 0;
    const n = e[0];
    return n < 192 ? ([r] = e, t = 1) : n < 255 ? (r = (e[0] - 192 << 8) + e[1] + 192, t = 2) : 255 === n && (r = M.readNumber(e.subarray(1, 5)), t = 5), {
        len: r,
        offset: t
    };
}
function Gt(e) {
    return e < 192 ? new Uint8Array([
        e
    ]) : e > 191 && e < 8384 ? new Uint8Array([
        192 + (e - 192 >> 8),
        e - 192 & 255
    ]) : M.concatUint8Array([
        new Uint8Array([
            255
        ]),
        M.writeNumber(e, 4)
    ]);
}
function _t(e) {
    if (e < 0 || e > 30) throw Error("Partial Length power must be between 1 and 30");
    return new Uint8Array([
        224 + e
    ]);
}
function jt(e) {
    return new Uint8Array([
        192 | e
    ]);
}
function qt(e, t) {
    return M.concatUint8Array([
        jt(e),
        Gt(t)
    ]);
}
function Vt(e) {
    return [
        R.packet.literalData,
        R.packet.compressedData,
        R.packet.symmetricallyEncryptedData,
        R.packet.symEncryptedIntegrityProtectedData,
        R.packet.aeadEncryptedData
    ].includes(e);
}
async function Jt(e, t) {
    const r = P(e);
    let n, i;
    try {
        const s = await r.peekBytes(2);
        if (!s || s.length < 2 || !(128 & s[0])) throw Error("Error during parsing. This message / key probably does not conform to a valid OpenPGP format.");
        const o = await r.readByte();
        let c, h, u = -1, l = -1;
        l = 0, 64 & o && (l = 1), l ? u = 63 & o : (u = (63 & o) >> 2, h = 3 & o);
        const y = Vt(u);
        let f, g = null;
        if (y) {
            if ("array" === M.isStream(e)) {
                const e = new a;
                n = x(e), g = e;
            } else {
                const e = new TransformStream;
                n = x(e.writable), g = e.readable;
            }
            i = t({
                tag: u,
                packet: g
            });
        } else g = [];
        do {
            if (l) {
                const e = await r.readByte();
                if (f = !1, e < 192) c = e;
                else if (e >= 192 && e < 224) c = (e - 192 << 8) + await r.readByte() + 192;
                else if (e > 223 && e < 255) {
                    if (c = 1 << (31 & e), f = !0, !y) throw new TypeError("This packet type does not support partial lengths.");
                } else c = await r.readByte() << 24 | await r.readByte() << 16 | await r.readByte() << 8 | await r.readByte();
            } else switch(h){
                case 0:
                    c = await r.readByte();
                    break;
                case 1:
                    c = await r.readByte() << 8 | await r.readByte();
                    break;
                case 2:
                    c = await r.readByte() << 24 | await r.readByte() << 16 | await r.readByte() << 8 | await r.readByte();
                    break;
                default:
                    c = 1 / 0;
            }
            if (c > 0) {
                let e = 0;
                for(;;){
                    n && await n.ready;
                    const { done: t, value: i } = await r.read();
                    if (t) {
                        if (c === 1 / 0) break;
                        throw Error("Unexpected end of packet");
                    }
                    const s = c === 1 / 0 ? i : i.subarray(0, c - e);
                    if (n ? await n.write(s) : g.push(s), e += i.length, e >= c) {
                        r.unshift(i.subarray(c - e + i.length));
                        break;
                    }
                }
            }
        }while (f);
        const p = await r.peekBytes(y ? 1 / 0 : 2);
        return n ? (await n.ready, await n.close()) : (g = M.concatUint8Array(g), await t({
            tag: u,
            packet: g
        })), !p || !p.length;
    } catch (e) {
        if (n) return await n.abort(e), !0;
        throw e;
    } finally{
        n && await i, r.releaseLock();
    }
}
class Yt extends Error {
    constructor(...e){
        super(...e), Error.captureStackTrace && Error.captureStackTrace(this, Yt), this.name = "UnsupportedError";
    }
}
class Zt extends Yt {
    constructor(...e){
        super(...e), Error.captureStackTrace && Error.captureStackTrace(this, Yt), this.name = "UnknownPacketError";
    }
}
class Wt {
    constructor(e, t){
        this.tag = e, this.rawContent = t;
    }
    write() {
        return this.rawContent;
    }
}
async function $t(e) {
    switch(e){
        case R.publicKey.ed25519:
            try {
                const e = M.getWebCrypto(), t = await e.generateKey("Ed25519", !0, [
                    "sign",
                    "verify"
                ]), r = await e.exportKey("jwk", t.privateKey), n = await e.exportKey("jwk", t.publicKey);
                return {
                    A: new Uint8Array(G(n.x)),
                    seed: G(r.d)
                };
            } catch (t) {
                if ("NotSupportedError" !== t.name && "OperationError" !== t.name) throw t;
                const r = fe(rr(e)), { publicKey: n } = We.sign.keyPair.fromSeed(r);
                return {
                    A: n,
                    seed: r
                };
            }
        case R.publicKey.ed448:
            {
                const e = await M.getNobleCurve(R.publicKey.ed448), t = e.utils.randomPrivateKey();
                return {
                    A: e.getPublicKey(t),
                    seed: t
                };
            }
        default:
            throw Error("Unsupported EdDSA algorithm");
    }
}
async function Xt(e, t, r, n, i, s) {
    if (Re(t) < Re(nr(e))) throw Error("Hash algorithm too weak for EdDSA.");
    switch(e){
        case R.publicKey.ed25519:
            try {
                const t = M.getWebCrypto(), r = sr(e, n, i), a = await t.importKey("jwk", r, "Ed25519", !1, [
                    "sign"
                ]);
                return {
                    RS: new Uint8Array(await t.sign("Ed25519", a, s))
                };
            } catch (e) {
                if ("NotSupportedError" !== e.name) throw e;
                const t = M.concatUint8Array([
                    i,
                    n
                ]);
                return {
                    RS: We.sign.detached(s, t)
                };
            }
        case R.publicKey.ed448:
            return {
                RS: (await M.getNobleCurve(R.publicKey.ed448)).sign(s, i)
            };
        default:
            throw Error("Unsupported EdDSA algorithm");
    }
}
async function er(e, t, { RS: r }, n, i, s) {
    if (Re(t) < Re(nr(e))) throw Error("Hash algorithm too weak for EdDSA.");
    switch(e){
        case R.publicKey.ed25519:
            try {
                const t = M.getWebCrypto(), n = ir(e, i), a = await t.importKey("jwk", n, "Ed25519", !1, [
                    "verify"
                ]);
                return await t.verify("Ed25519", a, r, s);
            } catch (e) {
                if ("NotSupportedError" !== e.name) throw e;
                return We.sign.detached.verify(s, r, i);
            }
        case R.publicKey.ed448:
            return (await M.getNobleCurve(R.publicKey.ed448)).verify(r, s, i);
        default:
            throw Error("Unsupported EdDSA algorithm");
    }
}
async function tr(e, t, r) {
    switch(e){
        case R.publicKey.ed25519:
            {
                const { publicKey: e } = We.sign.keyPair.fromSeed(r);
                return M.equalsUint8Array(t, e);
            }
        case R.publicKey.ed448:
            {
                const e = (await M.getNobleCurve(R.publicKey.ed448)).getPublicKey(r);
                return M.equalsUint8Array(t, e);
            }
        default:
            return !1;
    }
}
function rr(e) {
    switch(e){
        case R.publicKey.ed25519:
            return 32;
        case R.publicKey.ed448:
            return 57;
        default:
            throw Error("Unsupported EdDSA algorithm");
    }
}
function nr(e) {
    switch(e){
        case R.publicKey.ed25519:
            return R.hash.sha256;
        case R.publicKey.ed448:
            return R.hash.sha512;
        default:
            throw Error("Unknown EdDSA algo");
    }
}
const ir = (e, t)=>{
    if (e === R.publicKey.ed25519) return {
        kty: "OKP",
        crv: "Ed25519",
        x: _(t),
        ext: !0
    };
    throw Error("Unsupported EdDSA algorithm");
}, sr = (e, t, r)=>{
    if (e === R.publicKey.ed25519) {
        const n = ir(e, t);
        return n.d = _(r), n;
    }
    throw Error("Unsupported EdDSA algorithm");
};
var ar = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    generate: $t,
    getPayloadSize: rr,
    getPreferredHashAlgo: nr,
    sign: Xt,
    validateParams: tr,
    verify: er
});
function or(e) {
    return e instanceof Uint8Array || null != e && "object" == typeof e && "Uint8Array" === e.constructor.name;
}
function cr(e, ...t) {
    if (!or(e)) throw Error("Uint8Array expected");
    if (t.length > 0 && !t.includes(e.length)) throw Error(`Uint8Array expected of length ${t}, not of length=${e.length}`);
}
function hr(e, t = !0) {
    if (e.destroyed) throw Error("Hash instance has been destroyed");
    if (t && e.finished) throw Error("Hash#digest() has already been called");
}
function ur(e, t) {
    cr(e);
    const r = t.outputLen;
    if (e.length < r) throw Error("digestInto() expects output buffer of length at least " + r);
}
/*! noble-ciphers - MIT License (c) 2023 Paul Miller (paulmillr.com) */ const lr = (e)=>new Uint8Array(e.buffer, e.byteOffset, e.byteLength), yr = (e)=>new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), fr = (e)=>new DataView(e.buffer, e.byteOffset, e.byteLength);
if (!(68 === new Uint8Array(new Uint32Array([
    287454020
]).buffer)[0])) throw Error("Non little-endian hardware is not supported");
function gr(e) {
    if ("string" == typeof e) e = function(e) {
        if ("string" != typeof e) throw Error("string expected, got " + typeof e);
        return new Uint8Array((new TextEncoder).encode(e));
    }(e);
    else {
        if (!or(e)) throw Error("Uint8Array expected, got " + typeof e);
        e = mr(e);
    }
    return e;
}
function pr(e, t) {
    if (e.length !== t.length) return !1;
    let r = 0;
    for(let n = 0; n < e.length; n++)r |= e[n] ^ t[n];
    return 0 === r;
}
const dr = (e, t)=>(Object.assign(t, e), t);
function Ar(e, t, r, n) {
    if ("function" == typeof e.setBigUint64) return e.setBigUint64(t, r, n);
    const i = BigInt(32), s = BigInt(4294967295), a = Number(r >> i & s), o = Number(r & s);
    e.setUint32(t + 0, a, n), e.setUint32(t + 4, o, n);
}
function wr(e) {
    return e.byteOffset % 4 == 0;
}
function mr(e) {
    return Uint8Array.from(e);
}
function br(...e) {
    for(let t = 0; t < e.length; t++)e[t].fill(0);
}
const kr = 16, Er = /* @__PURE__ */ new Uint8Array(16), vr = yr(Er), Ir = (e)=>(e >>> 0 & 255) << 24 | (e >>> 8 & 255) << 16 | (e >>> 16 & 255) << 8 | e >>> 24 & 255;
class Br {
    constructor(e, t){
        this.blockLen = kr, this.outputLen = kr, this.s0 = 0, this.s1 = 0, this.s2 = 0, this.s3 = 0, this.finished = !1, cr(e = gr(e), 16);
        const r = fr(e);
        let n = r.getUint32(0, !1), i = r.getUint32(4, !1), s = r.getUint32(8, !1), a = r.getUint32(12, !1);
        const o = [];
        for(let e = 0; e < 128; e++)o.push({
            s0: Ir(n),
            s1: Ir(i),
            s2: Ir(s),
            s3: Ir(a)
        }), { s0: n, s1: i, s2: s, s3: a } = {
            s3: (u = s) << 31 | (l = a) >>> 1,
            s2: (h = i) << 31 | u >>> 1,
            s1: (c = n) << 31 | h >>> 1,
            s0: c >>> 1 ^ -520093696 & -(1 & l)
        };
        var c, h, u, l;
        const y = ((e)=>e > 65536 ? 8 : e > 1024 ? 4 : 2)(t || 1024);
        if (![
            1,
            2,
            4,
            8
        ].includes(y)) throw Error(`ghash: wrong window size=${y}, should be 2, 4 or 8`);
        this.W = y;
        const f = 128 / y, g = this.windowSize = 2 ** y, p = [];
        for(let e = 0; e < f; e++)for(let t = 0; t < g; t++){
            let r = 0, n = 0, i = 0, s = 0;
            for(let a = 0; a < y; a++){
                if (!(t >>> y - a - 1 & 1)) continue;
                const { s0: c, s1: h, s2: u, s3: l } = o[y * e + a];
                r ^= c, n ^= h, i ^= u, s ^= l;
            }
            p.push({
                s0: r,
                s1: n,
                s2: i,
                s3: s
            });
        }
        this.t = p;
    }
    _updateBlock(e, t, r, n) {
        e ^= this.s0, t ^= this.s1, r ^= this.s2, n ^= this.s3;
        const { W: i, t: s, windowSize: a } = this;
        let o = 0, c = 0, h = 0, u = 0;
        const l = (1 << i) - 1;
        let y = 0;
        for (const f of [
            e,
            t,
            r,
            n
        ])for(let e = 0; e < 4; e++){
            const t = f >>> 8 * e & 255;
            for(let e = 8 / i - 1; e >= 0; e--){
                const r = t >>> i * e & l, { s0: n, s1: f, s2: g, s3: p } = s[y * a + r];
                o ^= n, c ^= f, h ^= g, u ^= p, y += 1;
            }
        }
        this.s0 = o, this.s1 = c, this.s2 = h, this.s3 = u;
    }
    update(e) {
        e = gr(e), hr(this);
        const t = yr(e), r = Math.floor(e.length / kr), n = e.length % kr;
        for(let e = 0; e < r; e++)this._updateBlock(t[4 * e + 0], t[4 * e + 1], t[4 * e + 2], t[4 * e + 3]);
        return n && (Er.set(e.subarray(r * kr)), this._updateBlock(vr[0], vr[1], vr[2], vr[3]), br(vr)), this;
    }
    destroy() {
        const { t: e } = this;
        for (const t of e)t.s0 = 0, t.s1 = 0, t.s2 = 0, t.s3 = 0;
    }
    digestInto(e) {
        hr(this), ur(e, this), this.finished = !0;
        const { s0: t, s1: r, s2: n, s3: i } = this, s = yr(e);
        return s[0] = t, s[1] = r, s[2] = n, s[3] = i, e;
    }
    digest() {
        const e = new Uint8Array(kr);
        return this.digestInto(e), this.destroy(), e;
    }
}
class Sr extends Br {
    constructor(e, t){
        const r = function(e) {
            e.reverse();
            const t = 1 & e[15];
            let r = 0;
            for(let t = 0; t < e.length; t++){
                const n = e[t];
                e[t] = n >>> 1 | r, r = (1 & n) << 7;
            }
            return e[0] ^= 225 & -t, e;
        }(mr(e = gr(e)));
        super(r, t), br(r);
    }
    update(e) {
        e = gr(e), hr(this);
        const t = yr(e), r = e.length % kr, n = Math.floor(e.length / kr);
        for(let e = 0; e < n; e++)this._updateBlock(Ir(t[4 * e + 3]), Ir(t[4 * e + 2]), Ir(t[4 * e + 1]), Ir(t[4 * e + 0]));
        return r && (Er.set(e.subarray(n * kr)), this._updateBlock(Ir(vr[3]), Ir(vr[2]), Ir(vr[1]), Ir(vr[0])), br(vr)), this;
    }
    digestInto(e) {
        hr(this), ur(e, this), this.finished = !0;
        const { s0: t, s1: r, s2: n, s3: i } = this, s = yr(e);
        return s[0] = t, s[1] = r, s[2] = n, s[3] = i, e.reverse();
    }
}
function Kr(e) {
    const t = (t, r)=>e(r, t.length).update(gr(t)).digest(), r = e(new Uint8Array(16), 0);
    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = (t, r)=>e(t, r), t;
}
const Cr = Kr((e, t)=>new Br(e, t));
Kr((e, t)=>new Sr(e, t));
const Dr = 16, Ur = new Uint8Array(Dr), Pr = 283;
function xr(e) {
    return e << 1 ^ Pr & -(e >> 7);
}
function Qr(e, t) {
    let r = 0;
    for(; t > 0; t >>= 1)r ^= e & -(1 & t), e = xr(e);
    return r;
}
const Rr = /* @__PURE__ */ (()=>{
    const e = new Uint8Array(256);
    for(let t = 0, r = 1; t < 256; t++, r ^= xr(r))e[t] = r;
    const t = new Uint8Array(256);
    t[0] = 99;
    for(let r = 0; r < 255; r++){
        let n = e[255 - r];
        n |= n << 8, t[e[r]] = 255 & (n ^ n >> 4 ^ n >> 5 ^ n >> 6 ^ n >> 7 ^ 99);
    }
    return br(e), t;
})(), Tr = /* @__PURE__ */ Rr.map((e, t)=>Rr.indexOf(t)), Lr = (e)=>e << 24 | e >>> 8, Mr = (e)=>e << 8 | e >>> 24, Nr = (e)=>e << 24 & 4278190080 | e << 8 & 16711680 | e >>> 8 & 65280 | e >>> 24 & 255;
function Fr(e, t) {
    if (256 !== e.length) throw Error("Wrong sbox length");
    const r = new Uint32Array(256).map((r, n)=>t(e[n])), n = r.map(Mr), i = n.map(Mr), s = i.map(Mr), a = new Uint32Array(65536), o = new Uint32Array(65536), c = new Uint16Array(65536);
    for(let t = 0; t < 256; t++)for(let h = 0; h < 256; h++){
        const u = 256 * t + h;
        a[u] = r[t] ^ n[h], o[u] = i[t] ^ s[h], c[u] = e[t] << 8 | e[h];
    }
    return {
        sbox: e,
        sbox2: c,
        T0: r,
        T1: n,
        T2: i,
        T3: s,
        T01: a,
        T23: o
    };
}
const Or = /* @__PURE__ */ Fr(Rr, (e)=>Qr(e, 3) << 24 | e << 16 | e << 8 | Qr(e, 2)), Hr = /* @__PURE__ */ Fr(Tr, (e)=>Qr(e, 11) << 24 | Qr(e, 13) << 16 | Qr(e, 9) << 8 | Qr(e, 14)), zr = /* @__PURE__ */ (()=>{
    const e = new Uint8Array(16);
    for(let t = 0, r = 1; t < 16; t++, r = xr(r))e[t] = r;
    return e;
})();
function Gr(e) {
    cr(e);
    const t = e.length;
    if (![
        16,
        24,
        32
    ].includes(t)) throw Error("aes: wrong key size: should be 16, 24 or 32, got: " + t);
    const { sbox2: r } = Or, n = [];
    wr(e) || n.push(e = mr(e));
    const i = yr(e), s = i.length, a = (e)=>qr(r, e, e, e, e), o = new Uint32Array(t + 28);
    o.set(i);
    for(let e = s; e < o.length; e++){
        let t = o[e - 1];
        e % s == 0 ? t = a(Lr(t)) ^ zr[e / s - 1] : s > 6 && e % s == 4 && (t = a(t)), o[e] = o[e - s] ^ t;
    }
    return br(...n), o;
}
function _r(e) {
    const t = Gr(e), r = t.slice(), n = t.length, { sbox2: i } = Or, { T0: s, T1: a, T2: o, T3: c } = Hr;
    for(let e = 0; e < n; e += 4)for(let i = 0; i < 4; i++)r[e + i] = t[n - e - 4 + i];
    br(t);
    for(let e = 4; e < n - 4; e++){
        const t = r[e], n = qr(i, t, t, t, t);
        r[e] = s[255 & n] ^ a[n >>> 8 & 255] ^ o[n >>> 16 & 255] ^ c[n >>> 24];
    }
    return r;
}
function jr(e, t, r, n, i, s) {
    return e[r << 8 & 65280 | n >>> 8 & 255] ^ t[i >>> 8 & 65280 | s >>> 24 & 255];
}
function qr(e, t, r, n, i) {
    return e[255 & t | 65280 & r] | e[n >>> 16 & 255 | i >>> 16 & 65280] << 16;
}
function Vr(e, t, r, n, i) {
    const { sbox2: s, T01: a, T23: o } = Or;
    let c = 0;
    t ^= e[c++], r ^= e[c++], n ^= e[c++], i ^= e[c++];
    const h = e.length / 4 - 2;
    for(let s = 0; s < h; s++){
        const s = e[c++] ^ jr(a, o, t, r, n, i), h = e[c++] ^ jr(a, o, r, n, i, t), u = e[c++] ^ jr(a, o, n, i, t, r), l = e[c++] ^ jr(a, o, i, t, r, n);
        t = s, r = h, n = u, i = l;
    }
    return {
        s0: e[c++] ^ qr(s, t, r, n, i),
        s1: e[c++] ^ qr(s, r, n, i, t),
        s2: e[c++] ^ qr(s, n, i, t, r),
        s3: e[c++] ^ qr(s, i, t, r, n)
    };
}
function Jr(e, t, r, n, i) {
    const { sbox2: s, T01: a, T23: o } = Hr;
    let c = 0;
    t ^= e[c++], r ^= e[c++], n ^= e[c++], i ^= e[c++];
    const h = e.length / 4 - 2;
    for(let s = 0; s < h; s++){
        const s = e[c++] ^ jr(a, o, t, i, n, r), h = e[c++] ^ jr(a, o, r, t, i, n), u = e[c++] ^ jr(a, o, n, r, t, i), l = e[c++] ^ jr(a, o, i, n, r, t);
        t = s, r = h, n = u, i = l;
    }
    return {
        s0: e[c++] ^ qr(s, t, i, n, r),
        s1: e[c++] ^ qr(s, r, t, i, n),
        s2: e[c++] ^ qr(s, n, r, t, i),
        s3: e[c++] ^ qr(s, i, n, r, t)
    };
}
function Yr(e, t) {
    if (void 0 === t) return new Uint8Array(e);
    if (cr(t), t.length < e) throw Error(`aes: wrong destination length, expected at least ${e}, got: ${t.length}`);
    if (!wr(t)) throw Error("unaligned dst");
    return t;
}
function Zr(e, t, r, n) {
    cr(t, Dr), cr(r);
    const i = r.length;
    n = Yr(i, n);
    const s = t, a = yr(s);
    let { s0: o, s1: c, s2: h, s3: u } = Vr(e, a[0], a[1], a[2], a[3]);
    const l = yr(r), y = yr(n);
    for(let t = 0; t + 4 <= l.length; t += 4){
        y[t + 0] = l[t + 0] ^ o, y[t + 1] = l[t + 1] ^ c, y[t + 2] = l[t + 2] ^ h, y[t + 3] = l[t + 3] ^ u;
        let r = 1;
        for(let e = s.length - 1; e >= 0; e--)r = r + (255 & s[e]) | 0, s[e] = 255 & r, r >>>= 8;
        ({ s0: o, s1: c, s2: h, s3: u } = Vr(e, a[0], a[1], a[2], a[3]));
    }
    const f = Dr * Math.floor(l.length / 4);
    if (f < i) {
        const e = new Uint32Array([
            o,
            c,
            h,
            u
        ]), t = lr(e);
        for(let e = f, s = 0; e < i; e++, s++)n[e] = r[e] ^ t[s];
        br(e);
    }
    return n;
}
function Wr(e, t, r, n, i) {
    cr(r, Dr), cr(n), i = Yr(n.length, i);
    const s = r, a = yr(s), o = fr(s), c = yr(n), h = yr(i), u = t ? 0 : 12, l = n.length;
    let y = o.getUint32(u, t), { s0: f, s1: g, s2: p, s3: d } = Vr(e, a[0], a[1], a[2], a[3]);
    for(let r = 0; r + 4 <= c.length; r += 4)h[r + 0] = c[r + 0] ^ f, h[r + 1] = c[r + 1] ^ g, h[r + 2] = c[r + 2] ^ p, h[r + 3] = c[r + 3] ^ d, y = y + 1 >>> 0, o.setUint32(u, y, t), { s0: f, s1: g, s2: p, s3: d } = Vr(e, a[0], a[1], a[2], a[3]);
    const A = Dr * Math.floor(c.length / 4);
    if (A < l) {
        const e = new Uint32Array([
            f,
            g,
            p,
            d
        ]), t = lr(e);
        for(let e = A, r = 0; e < l; e++, r++)i[e] = n[e] ^ t[r];
        br(e);
    }
    return i;
}
const $r = dr({
    blockSize: 16,
    nonceLength: 16
}, function(e, t) {
    function r(r, n) {
        if (cr(r), void 0 !== n && (cr(n), !wr(n))) throw Error("unaligned destination");
        const i = Gr(e), s = mr(t), a = [
            i,
            s
        ];
        wr(r) || a.push(r = mr(r));
        const o = Zr(i, s, r, n);
        return br(...a), o;
    }
    return cr(e), cr(t, Dr), {
        encrypt: (e, t)=>r(e, t),
        decrypt: (e, t)=>r(e, t)
    };
});
const Xr = dr({
    blockSize: 16,
    nonceLength: 16
}, function(e, t, r = {}) {
    cr(e), cr(t, 16);
    const n = !r.disablePadding;
    return {
        encrypt (r, i) {
            const s = Gr(e), { b: a, o, out: c } = function(e, t, r) {
                cr(e);
                let n = e.length;
                const i = n % Dr;
                if (!t && 0 !== i) throw Error("aec/(cbc-ecb): unpadded plaintext with disabled padding");
                wr(e) || (e = mr(e));
                const s = yr(e);
                if (t) {
                    let e = Dr - i;
                    e || (e = Dr), n += e;
                }
                const a = Yr(n, r);
                return {
                    b: s,
                    o: yr(a),
                    out: a
                };
            }(r, n, i);
            let h = t;
            const u = [
                s
            ];
            wr(h) || u.push(h = mr(h));
            const l = yr(h);
            let y = l[0], f = l[1], g = l[2], p = l[3], d = 0;
            for(; d + 4 <= a.length;)y ^= a[d + 0], f ^= a[d + 1], g ^= a[d + 2], p ^= a[d + 3], ({ s0: y, s1: f, s2: g, s3: p } = Vr(s, y, f, g, p)), o[d++] = y, o[d++] = f, o[d++] = g, o[d++] = p;
            if (n) {
                const e = function(e) {
                    const t = new Uint8Array(16), r = yr(t);
                    t.set(e);
                    const n = Dr - e.length;
                    for(let e = Dr - n; e < Dr; e++)t[e] = n;
                    return r;
                }(r.subarray(4 * d));
                y ^= e[0], f ^= e[1], g ^= e[2], p ^= e[3], ({ s0: y, s1: f, s2: g, s3: p } = Vr(s, y, f, g, p)), o[d++] = y, o[d++] = f, o[d++] = g, o[d++] = p;
            }
            return br(...u), c;
        },
        decrypt (r, i) {
            !function(e) {
                if (cr(e), e.length % Dr != 0) throw Error("aes/(cbc-ecb).decrypt ciphertext should consist of blocks with size 16");
            }(r);
            const s = _r(e);
            let a = t;
            const o = [
                s
            ];
            wr(a) || o.push(a = mr(a));
            const c = yr(a), h = Yr(r.length, i);
            wr(r) || o.push(r = mr(r));
            const u = yr(r), l = yr(h);
            let y = c[0], f = c[1], g = c[2], p = c[3];
            for(let e = 0; e + 4 <= u.length;){
                const t = y, r = f, n = g, i = p;
                y = u[e + 0], f = u[e + 1], g = u[e + 2], p = u[e + 3];
                const { s0: a, s1: o, s2: c, s3: h } = Jr(s, y, f, g, p);
                l[e++] = a ^ t, l[e++] = o ^ r, l[e++] = c ^ n, l[e++] = h ^ i;
            }
            return br(...o), function(e, t) {
                if (!t) return e;
                const r = e.length;
                if (!r) throw Error("aes/pcks5: empty ciphertext not allowed");
                const n = e[r - 1];
                if (n <= 0 || n > 16) throw Error("aes/pcks5: wrong padding");
                const i = e.subarray(0, -n);
                for(let t = 0; t < n; t++)if (e[r - t - 1] !== n) throw Error("aes/pcks5: wrong padding");
                return i;
            }(h, n);
        }
    };
}), en = dr({
    blockSize: 16,
    nonceLength: 16
}, function(e, t) {
    function r(r, n, i) {
        cr(r);
        const s = r.length;
        i = Yr(s, i);
        const a = Gr(e);
        let o = t;
        const c = [
            a
        ];
        wr(o) || c.push(o = mr(o)), wr(r) || c.push(r = mr(r));
        const h = yr(r), u = yr(i), l = n ? u : h, y = yr(o);
        let f = y[0], g = y[1], p = y[2], d = y[3];
        for(let e = 0; e + 4 <= h.length;){
            const { s0: t, s1: r, s2: n, s3: i } = Vr(a, f, g, p, d);
            u[e + 0] = h[e + 0] ^ t, u[e + 1] = h[e + 1] ^ r, u[e + 2] = h[e + 2] ^ n, u[e + 3] = h[e + 3] ^ i, f = l[e++], g = l[e++], p = l[e++], d = l[e++];
        }
        const A = Dr * Math.floor(h.length / 4);
        if (A < s) {
            ({ s0: f, s1: g, s2: p, s3: d } = Vr(a, f, g, p, d));
            const e = lr(new Uint32Array([
                f,
                g,
                p,
                d
            ]));
            for(let t = A, n = 0; t < s; t++, n++)i[t] = r[t] ^ e[n];
            br(e);
        }
        return br(...c), i;
    }
    return cr(e), cr(t, 16), {
        encrypt: (e, t)=>r(e, !0, t),
        decrypt: (e, t)=>r(e, !1, t)
    };
});
const tn = dr({
    blockSize: 16,
    nonceLength: 12,
    tagLength: 16
}, function(e, t, r) {
    if (cr(e), cr(t), void 0 !== r && cr(r), t.length < 8) throw Error("aes/gcm: invalid nonce length");
    const n = 16;
    function i(e, t, n) {
        const i = function(e, t, r, n, i) {
            const s = null == i ? 0 : i.length, a = e.create(r, n.length + s);
            i && a.update(i), a.update(n);
            const o = new Uint8Array(16), c = fr(o);
            i && Ar(c, 0, BigInt(8 * s), t), Ar(c, 8, BigInt(8 * n.length), t), a.update(o);
            const h = a.digest();
            return br(o), h;
        }(Cr, !1, e, n, r);
        for(let e = 0; e < t.length; e++)i[e] ^= t[e];
        return i;
    }
    function s() {
        const r = Gr(e), n = Ur.slice(), i = Ur.slice();
        if (Wr(r, !1, i, i, n), 12 === t.length) i.set(t);
        else {
            const e = Ur.slice();
            Ar(fr(e), 8, BigInt(8 * t.length), !1);
            const r = Cr.create(n).update(t).update(e);
            r.digestInto(i), r.destroy();
        }
        return {
            xk: r,
            authKey: n,
            counter: i,
            tagMask: Wr(r, !1, i, Ur)
        };
    }
    return {
        encrypt (e) {
            cr(e);
            const { xk: t, authKey: r, counter: a, tagMask: o } = s(), c = new Uint8Array(e.length + n), h = [
                t,
                r,
                a,
                o
            ];
            wr(e) || h.push(e = mr(e)), Wr(t, !1, a, e, c);
            const u = i(r, o, c.subarray(0, c.length - n));
            return h.push(u), c.set(u, e.length), br(...h), c;
        },
        decrypt (e) {
            if (cr(e), e.length < n) throw Error("aes/gcm: ciphertext less than tagLen (16)");
            const { xk: t, authKey: r, counter: a, tagMask: o } = s(), c = [
                t,
                r,
                o,
                a
            ];
            wr(e) || c.push(e = mr(e));
            const h = e.subarray(0, -16), u = e.subarray(-16), l = i(r, o, h);
            if (c.push(l), !pr(l, u)) throw Error("aes/gcm: invalid ghash tag");
            const y = Wr(t, !1, a, h);
            return br(...c), y;
        }
    };
});
function rn(e) {
    return null != e && "object" == typeof e && (e instanceof Uint32Array || "Uint32Array" === e.constructor.name);
}
function nn(e, t) {
    if (cr(t, 16), !rn(e)) throw Error("_encryptBlock accepts result of expandKeyLE");
    const r = yr(t);
    let { s0: n, s1: i, s2: s, s3: a } = Vr(e, r[0], r[1], r[2], r[3]);
    return r[0] = n, r[1] = i, r[2] = s, r[3] = a, t;
}
function sn(e, t) {
    if (cr(t, 16), !rn(e)) throw Error("_decryptBlock accepts result of expandKeyLE");
    const r = yr(t);
    let { s0: n, s1: i, s2: s, s3: a } = Jr(e, r[0], r[1], r[2], r[3]);
    return r[0] = n, r[1] = i, r[2] = s, r[3] = a, t;
}
const an = {
    encrypt (e, t) {
        if (t.length >= 2 ** 32) throw Error("plaintext should be less than 4gb");
        const r = Gr(e);
        if (16 === t.length) nn(r, t);
        else {
            const e = yr(t);
            let n = e[0], i = e[1];
            for(let t = 0, s = 1; t < 6; t++)for(let t = 2; t < e.length; t += 2, s++){
                const { s0: a, s1: o, s2: c, s3: h } = Vr(r, n, i, e[t], e[t + 1]);
                n = a, i = o ^ Nr(s), e[t] = c, e[t + 1] = h;
            }
            e[0] = n, e[1] = i;
        }
        r.fill(0);
    },
    decrypt (e, t) {
        if (t.length - 8 >= 2 ** 32) throw Error("ciphertext should be less than 4gb");
        const r = _r(e), n = t.length / 8 - 1;
        if (1 === n) sn(r, t);
        else {
            const e = yr(t);
            let i = e[0], s = e[1];
            for(let t = 0, a = 6 * n; t < 6; t++)for(let t = 2 * n; t >= 1; t -= 2, a--){
                s ^= Nr(a);
                const { s0: n, s1: o, s2: c, s3: h } = Jr(r, i, s, e[t], e[t + 1]);
                i = n, s = o, e[t] = c, e[t + 1] = h;
            }
            e[0] = i, e[1] = s;
        }
        r.fill(0);
    }
}, on = new Uint8Array(8).fill(166), cn = dr({
    blockSize: 8
}, (e)=>({
        encrypt (t) {
            if (cr(t), !t.length || t.length % 8 != 0) throw Error("invalid plaintext length");
            if (8 === t.length) throw Error("8-byte keys not allowed in AESKW, use AESKWP instead");
            const r = function(...e) {
                let t = 0;
                for(let r = 0; r < e.length; r++){
                    const n = e[r];
                    cr(n), t += n.length;
                }
                const r = new Uint8Array(t);
                for(let t = 0, n = 0; t < e.length; t++){
                    const i = e[t];
                    r.set(i, n), n += i.length;
                }
                return r;
            }(on, t);
            return an.encrypt(e, r), r;
        },
        decrypt (t) {
            if (cr(t), t.length % 8 != 0 || t.length < 24) throw Error("invalid ciphertext length");
            const r = mr(t);
            if (an.decrypt(e, r), !pr(r.subarray(0, 8), on)) throw Error("integrity check failed");
            return r.subarray(0, 8).fill(0), r.subarray(8);
        }
    })), hn = {
    expandKeyLE: Gr,
    expandKeyDecLE: _r,
    encrypt: Vr,
    decrypt: Jr,
    encryptBlock: nn,
    decryptBlock: sn,
    ctrCounter: Zr,
    ctr32: Wr
};
async function un(e) {
    switch(e){
        case R.symmetric.aes128:
        case R.symmetric.aes192:
        case R.symmetric.aes256:
            throw Error("Not a legacy cipher");
        case R.symmetric.cast5:
        case R.symmetric.blowfish:
        case R.symmetric.twofish:
        case R.symmetric.tripledes:
            {
                const { legacyCiphers: t } = await Promise.resolve().then(function() {
                    return dy;
                }), r = R.read(R.symmetric, e), n = t.get(r);
                if (!n) throw Error("Unsupported cipher algorithm");
                return n;
            }
        default:
            throw Error("Unsupported cipher algorithm");
    }
}
function ln(e) {
    switch(e){
        case R.symmetric.aes128:
        case R.symmetric.aes192:
        case R.symmetric.aes256:
        case R.symmetric.twofish:
            return 16;
        case R.symmetric.blowfish:
        case R.symmetric.cast5:
        case R.symmetric.tripledes:
            return 8;
        default:
            throw Error("Unsupported cipher");
    }
}
function yn(e) {
    switch(e){
        case R.symmetric.aes128:
        case R.symmetric.blowfish:
        case R.symmetric.cast5:
            return 16;
        case R.symmetric.aes192:
        case R.symmetric.tripledes:
            return 24;
        case R.symmetric.aes256:
        case R.symmetric.twofish:
            return 32;
        default:
            throw Error("Unsupported cipher");
    }
}
function fn(e) {
    return {
        keySize: yn(e),
        blockSize: ln(e)
    };
}
const gn = M.getWebCrypto();
async function pn(e, t, r) {
    const { keySize: n } = fn(e);
    if (!M.isAES(e) || t.length !== n) throw Error("Unexpected algorithm or key size");
    try {
        const e = await gn.importKey("raw", t, {
            name: "AES-KW"
        }, !1, [
            "wrapKey"
        ]), n = await gn.importKey("raw", r, {
            name: "HMAC",
            hash: "SHA-256"
        }, !0, [
            "sign"
        ]), i = await gn.wrapKey("raw", n, e, {
            name: "AES-KW"
        });
        return new Uint8Array(i);
    } catch (e) {
        if ("NotSupportedError" !== e.name && (24 !== t.length || "OperationError" !== e.name)) throw e;
        M.printDebugError("Browser did not support operation: " + e.message);
    }
    return cn(t).encrypt(r);
}
async function dn(e, t, r) {
    const { keySize: n } = fn(e);
    if (!M.isAES(e) || t.length !== n) throw Error("Unexpected algorithm or key size");
    let i;
    try {
        i = await gn.importKey("raw", t, {
            name: "AES-KW"
        }, !1, [
            "unwrapKey"
        ]);
    } catch (e) {
        if ("NotSupportedError" !== e.name && (24 !== t.length || "OperationError" !== e.name)) throw e;
        return M.printDebugError("Browser did not support operation: " + e.message), cn(t).decrypt(r);
    }
    try {
        const e = await gn.unwrapKey("raw", r, i, {
            name: "AES-KW"
        }, {
            name: "HMAC",
            hash: "SHA-256"
        }, !0, [
            "sign"
        ]);
        return new Uint8Array(await gn.exportKey("raw", e));
    } catch (e) {
        if ("OperationError" === e.name) throw Error("Key Data Integrity failed");
        throw e;
    }
}
const An = M.getWebCrypto();
async function wn(e, t, r, n, i) {
    const s = R.read(R.webHash, e);
    if (!s) throw Error("Hash algo not supported with HKDF");
    const a = await An.importKey("raw", t, "HKDF", !1, [
        "deriveBits"
    ]), o = await An.deriveBits({
        name: "HKDF",
        hash: s,
        salt: r,
        info: n
    }, a, 8 * i);
    return new Uint8Array(o);
}
const mn = {
    x25519: M.encodeUTF8("OpenPGP X25519"),
    x448: M.encodeUTF8("OpenPGP X448")
};
async function bn(e) {
    switch(e){
        case R.publicKey.x25519:
            {
                const e = fe(32), { publicKey: t } = We.box.keyPair.fromSecretKey(e);
                return {
                    A: t,
                    k: e
                };
            }
        case R.publicKey.x448:
            {
                const e = await M.getNobleCurve(R.publicKey.x448), t = e.utils.randomPrivateKey();
                return {
                    A: e.getPublicKey(t),
                    k: t
                };
            }
        default:
            throw Error("Unsupported ECDH algorithm");
    }
}
async function kn(e, t, r) {
    switch(e){
        case R.publicKey.x25519:
            {
                const { publicKey: e } = We.box.keyPair.fromSecretKey(r);
                return M.equalsUint8Array(t, e);
            }
        case R.publicKey.x448:
            {
                const e = (await M.getNobleCurve(R.publicKey.x448)).getPublicKey(r);
                return M.equalsUint8Array(t, e);
            }
        default:
            return !1;
    }
}
async function En(e, t, r) {
    const { ephemeralPublicKey: n, sharedSecret: i } = await Bn(e, r), s = M.concatUint8Array([
        n,
        r,
        i
    ]);
    switch(e){
        case R.publicKey.x25519:
            {
                const e = R.symmetric.aes128, { keySize: r } = fn(e), i = await wn(R.hash.sha256, s, new Uint8Array, mn.x25519, r);
                return {
                    ephemeralPublicKey: n,
                    wrappedKey: await pn(e, i, t)
                };
            }
        case R.publicKey.x448:
            {
                const e = R.symmetric.aes256, { keySize: r } = fn(R.symmetric.aes256), i = await wn(R.hash.sha512, s, new Uint8Array, mn.x448, r);
                return {
                    ephemeralPublicKey: n,
                    wrappedKey: await pn(e, i, t)
                };
            }
        default:
            throw Error("Unsupported ECDH algorithm");
    }
}
async function vn(e, t, r, n, i) {
    const s = await Sn(e, t, n, i), a = M.concatUint8Array([
        t,
        n,
        s
    ]);
    switch(e){
        case R.publicKey.x25519:
            {
                const e = R.symmetric.aes128, { keySize: t } = fn(e);
                return dn(e, await wn(R.hash.sha256, a, new Uint8Array, mn.x25519, t), r);
            }
        case R.publicKey.x448:
            {
                const e = R.symmetric.aes256, { keySize: t } = fn(R.symmetric.aes256);
                return dn(e, await wn(R.hash.sha512, a, new Uint8Array, mn.x448, t), r);
            }
        default:
            throw Error("Unsupported ECDH algorithm");
    }
}
function In(e) {
    switch(e){
        case R.publicKey.x25519:
            return 32;
        case R.publicKey.x448:
            return 56;
        default:
            throw Error("Unsupported ECDH algorithm");
    }
}
async function Bn(e, t) {
    switch(e){
        case R.publicKey.x25519:
            {
                const r = fe(In(e)), n = We.scalarMult(r, t);
                Kn(n);
                const { publicKey: i } = We.box.keyPair.fromSecretKey(r);
                return {
                    ephemeralPublicKey: i,
                    sharedSecret: n
                };
            }
        case R.publicKey.x448:
            {
                const e = await M.getNobleCurve(R.publicKey.x448), r = e.utils.randomPrivateKey(), n = e.getSharedSecret(r, t);
                Kn(n);
                return {
                    ephemeralPublicKey: e.getPublicKey(r),
                    sharedSecret: n
                };
            }
        default:
            throw Error("Unsupported ECDH algorithm");
    }
}
async function Sn(e, t, r, n) {
    switch(e){
        case R.publicKey.x25519:
            {
                const e = We.scalarMult(n, t);
                return Kn(e), e;
            }
        case R.publicKey.x448:
            {
                const e = (await M.getNobleCurve(R.publicKey.x448)).getSharedSecret(n, t);
                return Kn(e), e;
            }
        default:
            throw Error("Unsupported ECDH algorithm");
    }
}
function Kn(e) {
    let t = 0;
    for(let r = 0; r < e.length; r++)t |= e[r];
    if (0 === t) throw Error("Unexpected low order point");
}
var Cn = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    decrypt: vn,
    encrypt: En,
    generate: bn,
    generateEphemeralEncryptionMaterial: Bn,
    getPayloadSize: In,
    recomputeSharedSecret: Sn,
    validateParams: kn
});
const Dn = M.getWebCrypto(), Un = M.getNodeCrypto(), Pn = {
    [R.curve.nistP256]: "P-256",
    [R.curve.nistP384]: "P-384",
    [R.curve.nistP521]: "P-521"
}, xn = Un ? Un.getCurves() : [], Qn = Un ? {
    [R.curve.secp256k1]: xn.includes("secp256k1") ? "secp256k1" : void 0,
    [R.curve.nistP256]: xn.includes("prime256v1") ? "prime256v1" : void 0,
    [R.curve.nistP384]: xn.includes("secp384r1") ? "secp384r1" : void 0,
    [R.curve.nistP521]: xn.includes("secp521r1") ? "secp521r1" : void 0,
    [R.curve.ed25519Legacy]: xn.includes("ED25519") ? "ED25519" : void 0,
    [R.curve.curve25519Legacy]: xn.includes("X25519") ? "X25519" : void 0,
    [R.curve.brainpoolP256r1]: xn.includes("brainpoolP256r1") ? "brainpoolP256r1" : void 0,
    [R.curve.brainpoolP384r1]: xn.includes("brainpoolP384r1") ? "brainpoolP384r1" : void 0,
    [R.curve.brainpoolP512r1]: xn.includes("brainpoolP512r1") ? "brainpoolP512r1" : void 0
} : {}, Rn = {
    [R.curve.nistP256]: {
        oid: [
            6,
            8,
            42,
            134,
            72,
            206,
            61,
            3,
            1,
            7
        ],
        keyType: R.publicKey.ecdsa,
        hash: R.hash.sha256,
        cipher: R.symmetric.aes128,
        node: Qn[R.curve.nistP256],
        web: Pn[R.curve.nistP256],
        payloadSize: 32,
        sharedSize: 256,
        wireFormatLeadingByte: 4
    },
    [R.curve.nistP384]: {
        oid: [
            6,
            5,
            43,
            129,
            4,
            0,
            34
        ],
        keyType: R.publicKey.ecdsa,
        hash: R.hash.sha384,
        cipher: R.symmetric.aes192,
        node: Qn[R.curve.nistP384],
        web: Pn[R.curve.nistP384],
        payloadSize: 48,
        sharedSize: 384,
        wireFormatLeadingByte: 4
    },
    [R.curve.nistP521]: {
        oid: [
            6,
            5,
            43,
            129,
            4,
            0,
            35
        ],
        keyType: R.publicKey.ecdsa,
        hash: R.hash.sha512,
        cipher: R.symmetric.aes256,
        node: Qn[R.curve.nistP521],
        web: Pn[R.curve.nistP521],
        payloadSize: 66,
        sharedSize: 528,
        wireFormatLeadingByte: 4
    },
    [R.curve.secp256k1]: {
        oid: [
            6,
            5,
            43,
            129,
            4,
            0,
            10
        ],
        keyType: R.publicKey.ecdsa,
        hash: R.hash.sha256,
        cipher: R.symmetric.aes128,
        node: Qn[R.curve.secp256k1],
        payloadSize: 32,
        wireFormatLeadingByte: 4
    },
    [R.curve.ed25519Legacy]: {
        oid: [
            6,
            9,
            43,
            6,
            1,
            4,
            1,
            218,
            71,
            15,
            1
        ],
        keyType: R.publicKey.eddsaLegacy,
        hash: R.hash.sha512,
        node: !1,
        payloadSize: 32,
        wireFormatLeadingByte: 64
    },
    [R.curve.curve25519Legacy]: {
        oid: [
            6,
            10,
            43,
            6,
            1,
            4,
            1,
            151,
            85,
            1,
            5,
            1
        ],
        keyType: R.publicKey.ecdh,
        hash: R.hash.sha256,
        cipher: R.symmetric.aes128,
        node: !1,
        payloadSize: 32,
        wireFormatLeadingByte: 64
    },
    [R.curve.brainpoolP256r1]: {
        oid: [
            6,
            9,
            43,
            36,
            3,
            3,
            2,
            8,
            1,
            1,
            7
        ],
        keyType: R.publicKey.ecdsa,
        hash: R.hash.sha256,
        cipher: R.symmetric.aes128,
        node: Qn[R.curve.brainpoolP256r1],
        payloadSize: 32,
        wireFormatLeadingByte: 4
    },
    [R.curve.brainpoolP384r1]: {
        oid: [
            6,
            9,
            43,
            36,
            3,
            3,
            2,
            8,
            1,
            1,
            11
        ],
        keyType: R.publicKey.ecdsa,
        hash: R.hash.sha384,
        cipher: R.symmetric.aes192,
        node: Qn[R.curve.brainpoolP384r1],
        payloadSize: 48,
        wireFormatLeadingByte: 4
    },
    [R.curve.brainpoolP512r1]: {
        oid: [
            6,
            9,
            43,
            36,
            3,
            3,
            2,
            8,
            1,
            1,
            13
        ],
        keyType: R.publicKey.ecdsa,
        hash: R.hash.sha512,
        cipher: R.symmetric.aes256,
        node: Qn[R.curve.brainpoolP512r1],
        payloadSize: 64,
        wireFormatLeadingByte: 4
    }
};
class Tn {
    constructor(e){
        try {
            this.name = e instanceof Ht ? e.getName() : R.write(R.curve, e);
        } catch (e) {
            throw new Yt("Unknown curve");
        }
        const t = Rn[this.name];
        this.keyType = t.keyType, this.oid = t.oid, this.hash = t.hash, this.cipher = t.cipher, this.node = t.node, this.web = t.web, this.payloadSize = t.payloadSize, this.sharedSize = t.sharedSize, this.wireFormatLeadingByte = t.wireFormatLeadingByte, this.web && M.getWebCrypto() ? this.type = "web" : this.node && M.getNodeCrypto() ? this.type = "node" : this.name === R.curve.curve25519Legacy ? this.type = "curve25519Legacy" : this.name === R.curve.ed25519Legacy && (this.type = "ed25519Legacy");
    }
    async genKeyPair() {
        switch(this.type){
            case "web":
                try {
                    return await async function(e, t) {
                        const r = await Dn.generateKey({
                            name: "ECDSA",
                            namedCurve: Pn[e]
                        }, !0, [
                            "sign",
                            "verify"
                        ]), n = await Dn.exportKey("jwk", r.privateKey);
                        return {
                            publicKey: Hn(await Dn.exportKey("jwk", r.publicKey), t),
                            privateKey: G(n.d)
                        };
                    }(this.name, this.wireFormatLeadingByte);
                } catch (e) {
                    return M.printDebugError("Browser did not support generating ec key " + e.message), On(this.name);
                }
            case "node":
                return async function(e) {
                    const t = Un.createECDH(Qn[e]);
                    return await t.generateKeys(), {
                        publicKey: new Uint8Array(t.getPublicKey()),
                        privateKey: new Uint8Array(t.getPrivateKey())
                    };
                }(this.name);
            case "curve25519Legacy":
                {
                    const { k: e, A: t } = await bn(R.publicKey.x25519), r = e.slice().reverse();
                    r[0] = 127 & r[0] | 64, r[31] &= 248;
                    return {
                        publicKey: M.concatUint8Array([
                            new Uint8Array([
                                this.wireFormatLeadingByte
                            ]),
                            t
                        ]),
                        privateKey: r
                    };
                }
            case "ed25519Legacy":
                {
                    const { seed: e, A: t } = await $t(R.publicKey.ed25519);
                    return {
                        publicKey: M.concatUint8Array([
                            new Uint8Array([
                                this.wireFormatLeadingByte
                            ]),
                            t
                        ]),
                        privateKey: e
                    };
                }
            default:
                return On(this.name);
        }
    }
}
async function Ln(e) {
    const t = new Tn(e), { oid: r, hash: n, cipher: i } = t, s = await t.genKeyPair();
    return {
        oid: r,
        Q: s.publicKey,
        secret: M.leftPad(s.privateKey, t.payloadSize),
        hash: n,
        cipher: i
    };
}
function Mn(e) {
    return Rn[e.getName()].hash;
}
async function Nn(e, t, r, n) {
    const i = {
        [R.curve.nistP256]: !0,
        [R.curve.nistP384]: !0,
        [R.curve.nistP521]: !0,
        [R.curve.secp256k1]: !0,
        [R.curve.curve25519Legacy]: e === R.publicKey.ecdh,
        [R.curve.brainpoolP256r1]: !0,
        [R.curve.brainpoolP384r1]: !0,
        [R.curve.brainpoolP512r1]: !0
    }, s = t.getName();
    if (!i[s]) return !1;
    if (s === R.curve.curve25519Legacy) {
        n = n.slice().reverse();
        const { publicKey: e } = We.box.keyPair.fromSecretKey(n);
        r = new Uint8Array(r);
        const t = new Uint8Array([
            64,
            ...e
        ]);
        return !!M.equalsUint8Array(t, r);
    }
    const a = (await M.getNobleCurve(R.publicKey.ecdsa, s)).getPublicKey(n, !1);
    return !!M.equalsUint8Array(a, r);
}
function Fn(e, t) {
    const { payloadSize: r, wireFormatLeadingByte: n, name: i } = e, s = i === R.curve.curve25519Legacy || i === R.curve.ed25519Legacy ? r : 2 * r;
    if (t[0] !== n || t.length !== s + 1) throw Error("Invalid point encoding");
}
async function On(e) {
    const t = await M.getNobleCurve(R.publicKey.ecdsa, e), r = t.utils.randomPrivateKey();
    return {
        publicKey: t.getPublicKey(r, !1),
        privateKey: r
    };
}
function Hn(e, t) {
    const r = G(e.x), n = G(e.y), i = new Uint8Array(r.length + n.length + 1);
    return i[0] = t, i.set(r, 1), i.set(n, r.length + 1), i;
}
function zn(e, t, r) {
    const n = e, i = r.slice(1, n + 1), s = r.slice(n + 1, 2 * n + 1);
    return {
        kty: "EC",
        crv: t,
        x: _(i),
        y: _(s),
        ext: !0
    };
}
function Gn(e, t, r, n) {
    const i = zn(e, t, r);
    return i.d = _(n), i;
}
const _n = M.getWebCrypto(), jn = M.getNodeCrypto();
async function qn(e, t, r, n, i, s) {
    const a = new Tn(e);
    if (Fn(a, n), r && !M.isStream(r)) {
        const e = {
            publicKey: n,
            privateKey: i
        };
        switch(a.type){
            case "web":
                try {
                    return await async function(e, t, r, n) {
                        const i = e.payloadSize, s = Gn(e.payloadSize, Pn[e.name], n.publicKey, n.privateKey), a = await _n.importKey("jwk", s, {
                            name: "ECDSA",
                            namedCurve: Pn[e.name],
                            hash: {
                                name: R.read(R.webHash, e.hash)
                            }
                        }, !1, [
                            "sign"
                        ]), o = new Uint8Array(await _n.sign({
                            name: "ECDSA",
                            namedCurve: Pn[e.name],
                            hash: {
                                name: R.read(R.webHash, t)
                            }
                        }, a, r));
                        return {
                            r: o.slice(0, i),
                            s: o.slice(i, i << 1)
                        };
                    }(a, t, r, e);
                } catch (e) {
                    if ("nistP521" !== a.name && ("DataError" === e.name || "OperationError" === e.name)) throw e;
                    M.printDebugError("Browser did not support signing: " + e.message);
                }
                break;
            case "node":
                return async function(e, t, r, n) {
                    const i = M.nodeRequire("eckey-utils"), s = M.getNodeBuffer(), { privateKey: a } = i.generateDer({
                        curveName: Qn[e.name],
                        privateKey: s.from(n)
                    }), o = jn.createSign(R.read(R.hash, t));
                    o.write(r), o.end();
                    const c = new Uint8Array(o.sign({
                        key: a,
                        format: "der",
                        type: "sec1",
                        dsaEncoding: "ieee-p1363"
                    })), h = e.payloadSize;
                    return {
                        r: c.subarray(0, h),
                        s: c.subarray(h, h << 1)
                    };
                }(a, t, r, i);
        }
    }
    const o = (await M.getNobleCurve(R.publicKey.ecdsa, a.name)).sign(s, i, {
        lowS: !1
    });
    return {
        r: le(o.r, "be", a.payloadSize),
        s: le(o.s, "be", a.payloadSize)
    };
}
async function Vn(e, t, r, n, i, s) {
    const a = new Tn(e);
    Fn(a, i);
    const o = async ()=>0 === s[0] && Jn(a, r, s.subarray(1), i);
    if (n && !M.isStream(n)) switch(a.type){
        case "web":
            try {
                const e = await async function(e, t, { r, s: n }, i, s) {
                    const a = zn(e.payloadSize, Pn[e.name], s), o = await _n.importKey("jwk", a, {
                        name: "ECDSA",
                        namedCurve: Pn[e.name],
                        hash: {
                            name: R.read(R.webHash, e.hash)
                        }
                    }, !1, [
                        "verify"
                    ]), c = M.concatUint8Array([
                        r,
                        n
                    ]).buffer;
                    return _n.verify({
                        name: "ECDSA",
                        namedCurve: Pn[e.name],
                        hash: {
                            name: R.read(R.webHash, t)
                        }
                    }, o, c, i);
                }(a, t, r, n, i);
                return e || o();
            } catch (e) {
                if ("nistP521" !== a.name && ("DataError" === e.name || "OperationError" === e.name)) throw e;
                M.printDebugError("Browser did not support verifying: " + e.message);
            }
            break;
        case "node":
            {
                const e = await async function(e, t, { r, s: n }, i, s) {
                    const a = M.nodeRequire("eckey-utils"), o = M.getNodeBuffer(), { publicKey: c } = a.generateDer({
                        curveName: Qn[e.name],
                        publicKey: o.from(s)
                    }), h = jn.createVerify(R.read(R.hash, t));
                    h.write(i), h.end();
                    const u = M.concatUint8Array([
                        r,
                        n
                    ]);
                    try {
                        return h.verify({
                            key: c,
                            format: "der",
                            type: "spki",
                            dsaEncoding: "ieee-p1363"
                        }, u);
                    } catch (e) {
                        return !1;
                    }
                }(a, t, r, n, i);
                return e || o();
            }
    }
    return await Jn(a, r, s, i) || o();
}
async function Jn(e, t, r, n) {
    return (await M.getNobleCurve(R.publicKey.ecdsa, e.name)).verify(M.concatUint8Array([
        t.r,
        t.s
    ]), r, n, {
        lowS: !1
    });
}
var Yn = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    sign: qn,
    validateParams: async function(e, t, r) {
        const n = new Tn(e);
        if (n.keyType !== R.publicKey.ecdsa) return !1;
        switch(n.type){
            case "web":
            case "node":
                {
                    const n = fe(8), i = R.hash.sha256, s = await Qe(i, n);
                    try {
                        const a = await qn(e, i, n, t, r, s);
                        return await Vn(e, i, a, n, t, s);
                    } catch (e) {
                        return !1;
                    }
                }
            default:
                return Nn(R.publicKey.ecdsa, e, t, r);
        }
    },
    verify: Vn
});
async function Zn(e, t, r, n, i, s) {
    if (Fn(new Tn(e), n), Re(t) < Re(R.hash.sha256)) throw Error("Hash algorithm too weak for EdDSA.");
    const { RS: a } = await Xt(R.publicKey.ed25519, t, 0, n.subarray(1), i, s);
    return {
        r: a.subarray(0, 32),
        s: a.subarray(32)
    };
}
async function Wn(e, t, { r, s: n }, i, s, a) {
    if (Fn(new Tn(e), s), Re(t) < Re(R.hash.sha256)) throw Error("Hash algorithm too weak for EdDSA.");
    const o = M.concatUint8Array([
        r,
        n
    ]);
    return er(R.publicKey.ed25519, t, {
        RS: o
    }, 0, s.subarray(1), a);
}
async function $n(e, t, r) {
    if (e.getName() !== R.curve.ed25519Legacy) return !1;
    const { publicKey: n } = We.sign.keyPair.fromSeed(r), i = new Uint8Array([
        64,
        ...n
    ]);
    return M.equalsUint8Array(t, i);
}
var Xn = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    sign: Zn,
    validateParams: $n,
    verify: Wn
});
function ei(e) {
    const t = e.length;
    if (t > 0) {
        const r = e[t - 1];
        if (r >= 1) {
            const n = e.subarray(t - r), i = new Uint8Array(r).fill(r);
            if (M.equalsUint8Array(n, i)) return e.subarray(0, t - r);
        }
    }
    throw Error("Invalid padding");
}
const ti = M.getWebCrypto(), ri = M.getNodeCrypto();
function ni(e, t, r, n) {
    return M.concatUint8Array([
        t.write(),
        new Uint8Array([
            e
        ]),
        r.write(),
        M.stringToUint8Array("Anonymous Sender    "),
        n
    ]);
}
async function ii(e, t, r, n, i = !1, s = !1) {
    let a;
    if (i) {
        for(a = 0; a < t.length && 0 === t[a]; a++);
        t = t.subarray(a);
    }
    if (s) {
        for(a = t.length - 1; a >= 0 && 0 === t[a]; a--);
        t = t.subarray(0, a + 1);
    }
    return (await Qe(e, M.concatUint8Array([
        new Uint8Array([
            0,
            0,
            0,
            1
        ]),
        t,
        n
    ]))).subarray(0, r);
}
async function si(e, t) {
    switch(e.type){
        case "curve25519Legacy":
            {
                const { sharedSecret: r, ephemeralPublicKey: n } = await Bn(R.publicKey.x25519, t.subarray(1));
                return {
                    publicKey: M.concatUint8Array([
                        new Uint8Array([
                            e.wireFormatLeadingByte
                        ]),
                        n
                    ]),
                    sharedKey: r
                };
            }
        case "web":
            if (e.web && M.getWebCrypto()) try {
                return await async function(e, t) {
                    const r = zn(e.payloadSize, e.web, t);
                    let n = ti.generateKey({
                        name: "ECDH",
                        namedCurve: e.web
                    }, !0, [
                        "deriveKey",
                        "deriveBits"
                    ]), i = ti.importKey("jwk", r, {
                        name: "ECDH",
                        namedCurve: e.web
                    }, !1, []);
                    [n, i] = await Promise.all([
                        n,
                        i
                    ]);
                    let s = ti.deriveBits({
                        name: "ECDH",
                        namedCurve: e.web,
                        public: i
                    }, n.privateKey, e.sharedSize), a = ti.exportKey("jwk", n.publicKey);
                    [s, a] = await Promise.all([
                        s,
                        a
                    ]);
                    const o = new Uint8Array(s), c = new Uint8Array(Hn(a, e.wireFormatLeadingByte));
                    return {
                        publicKey: c,
                        sharedKey: o
                    };
                }(e, t);
            } catch (r) {
                return M.printDebugError(r), ui(e, t);
            }
            break;
        case "node":
            return async function(e, t) {
                const r = ri.createECDH(e.node);
                r.generateKeys();
                const n = new Uint8Array(r.computeSecret(t));
                return {
                    publicKey: new Uint8Array(r.getPublicKey()),
                    sharedKey: n
                };
            }(e, t);
        default:
            return ui(e, t);
    }
}
async function ai(e, t, r, n, i) {
    const s = function(e) {
        const t = 8 - e.length % 8, r = new Uint8Array(e.length + t).fill(t);
        return r.set(e), r;
    }(r), a = new Tn(e);
    Fn(a, n);
    const { publicKey: o, sharedKey: c } = await si(a, n), h = ni(R.publicKey.ecdh, e, t, i), { keySize: u } = fn(t.cipher), l = await ii(t.hash, c, u, h);
    return {
        publicKey: o,
        wrappedKey: await pn(t.cipher, l, s)
    };
}
async function oi(e, t, r, n) {
    if (n.length !== e.payloadSize) {
        const t = new Uint8Array(e.payloadSize);
        t.set(n, e.payloadSize - n.length), n = t;
    }
    switch(e.type){
        case "curve25519Legacy":
            {
                const e = n.slice().reverse();
                return {
                    secretKey: e,
                    sharedKey: await Sn(R.publicKey.x25519, t.subarray(1), r.subarray(1), e)
                };
            }
        case "web":
            if (e.web && M.getWebCrypto()) try {
                return await async function(e, t, r, n) {
                    const i = Gn(e.payloadSize, e.web, r, n);
                    let s = ti.importKey("jwk", i, {
                        name: "ECDH",
                        namedCurve: e.web
                    }, !0, [
                        "deriveKey",
                        "deriveBits"
                    ]);
                    const a = zn(e.payloadSize, e.web, t);
                    let o = ti.importKey("jwk", a, {
                        name: "ECDH",
                        namedCurve: e.web
                    }, !0, []);
                    [s, o] = await Promise.all([
                        s,
                        o
                    ]);
                    let c = ti.deriveBits({
                        name: "ECDH",
                        namedCurve: e.web,
                        public: o
                    }, s, e.sharedSize), h = ti.exportKey("jwk", s);
                    [c, h] = await Promise.all([
                        c,
                        h
                    ]);
                    const u = new Uint8Array(c);
                    return {
                        secretKey: G(h.d),
                        sharedKey: u
                    };
                }(e, t, r, n);
            } catch (r) {
                return M.printDebugError(r), hi(e, t, n);
            }
            break;
        case "node":
            return async function(e, t, r) {
                const n = ri.createECDH(e.node);
                n.setPrivateKey(r);
                const i = new Uint8Array(n.computeSecret(t));
                return {
                    secretKey: new Uint8Array(n.getPrivateKey()),
                    sharedKey: i
                };
            }(e, t, n);
        default:
            return hi(e, t, n);
    }
}
async function ci(e, t, r, n, i, s, a) {
    const o = new Tn(e);
    Fn(o, i), Fn(o, r);
    const { sharedKey: c } = await oi(o, r, i, s), h = ni(R.publicKey.ecdh, e, t, a), { keySize: u } = fn(t.cipher);
    let l;
    for(let e = 0; e < 3; e++)try {
        const r = await ii(t.hash, c, u, h, 1 === e, 2 === e);
        return ei(await dn(t.cipher, r, n));
    } catch (e) {
        l = e;
    }
    throw l;
}
async function hi(e, t, r) {
    return {
        secretKey: r,
        sharedKey: (await M.getNobleCurve(R.publicKey.ecdh, e.name)).getSharedSecret(r, t).subarray(1)
    };
}
async function ui(e, t) {
    const r = await M.getNobleCurve(R.publicKey.ecdh, e.name), { publicKey: n, privateKey: i } = await e.genKeyPair();
    return {
        publicKey: n,
        sharedKey: r.getSharedSecret(i, t).subarray(1)
    };
}
var li = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CurveWithOID: Tn,
    ecdh: /*#__PURE__*/ Object.freeze({
        __proto__: null,
        decrypt: ci,
        encrypt: ai,
        validateParams: async function(e, t, r) {
            return Nn(R.publicKey.ecdh, e, t, r);
        }
    }),
    ecdhX: Cn,
    ecdsa: Yn,
    eddsa: ar,
    eddsaLegacy: Xn,
    generate: Ln,
    getPreferredHashAlgo: Mn
});
const yi = BigInt(0), fi = BigInt(1);
class gi {
    constructor(e){
        e && (this.data = e);
    }
    read(e) {
        if (e.length >= 1) {
            const t = e[0];
            if (e.length >= 1 + t) return this.data = e.subarray(1, 1 + t), 1 + this.data.length;
        }
        throw Error("Invalid symmetric key");
    }
    write() {
        return M.concatUint8Array([
            new Uint8Array([
                this.data.length
            ]),
            this.data
        ]);
    }
}
class pi {
    constructor(e){
        if (e) {
            const { hash: t, cipher: r } = e;
            this.hash = t, this.cipher = r;
        } else this.hash = null, this.cipher = null;
    }
    read(e) {
        if (e.length < 4 || 3 !== e[0] || 1 !== e[1]) throw new Yt("Cannot read KDFParams");
        return this.hash = e[2], this.cipher = e[3], 4;
    }
    write() {
        return new Uint8Array([
            3,
            1,
            this.hash,
            this.cipher
        ]);
    }
}
class di {
    static fromObject({ wrappedKey: e, algorithm: t }) {
        const r = new di;
        return r.wrappedKey = e, r.algorithm = t, r;
    }
    read(e) {
        let t = 0, r = e[t++];
        this.algorithm = r % 2 ? e[t++] : null, r -= r % 2, this.wrappedKey = M.readExactSubarray(e, t, t + r), t += r;
    }
    write() {
        return M.concatUint8Array([
            this.algorithm ? new Uint8Array([
                this.wrappedKey.length + 1,
                this.algorithm
            ]) : new Uint8Array([
                this.wrappedKey.length
            ]),
            this.wrappedKey
        ]);
    }
}
async function Ai(e, t, r, n, i) {
    switch(e){
        case R.publicKey.rsaEncrypt:
        case R.publicKey.rsaEncryptSign:
            {
                const { n: e, e: t } = r;
                return {
                    c: await _e(n, e, t)
                };
            }
        case R.publicKey.elgamal:
            {
                const { p: e, g: t, y: i } = r;
                return async function(e, t, r, n) {
                    t = re(t), r = re(r), n = re(n);
                    const i = re(Le(e, ue(t))), s = ge(Ye, t - Ye);
                    return {
                        c1: le(ie(r, s, t)),
                        c2: le(ne(ie(n, s, t) * i, t))
                    };
                }(n, e, t, i);
            }
        case R.publicKey.ecdh:
            {
                const { oid: e, Q: t, kdfParams: s } = r, { publicKey: a, wrappedKey: o } = await ai(e, s, n, t, i);
                return {
                    V: a,
                    C: new gi(o)
                };
            }
        case R.publicKey.x25519:
        case R.publicKey.x448:
            {
                if (t && !M.isAES(t)) throw Error("X25519 and X448 keys can only encrypt AES session keys");
                const { A: i } = r, { ephemeralPublicKey: s, wrappedKey: a } = await En(e, n, i);
                return {
                    ephemeralPublicKey: s,
                    C: di.fromObject({
                        algorithm: t,
                        wrappedKey: a
                    })
                };
            }
        default:
            return [];
    }
}
async function wi(e, t, r, n, i, s) {
    switch(e){
        case R.publicKey.rsaEncryptSign:
        case R.publicKey.rsaEncrypt:
            {
                const { c: e } = n, { n: i, e: a } = t, { d: o, p: c, q: h, u } = r;
                return je(e, i, a, o, c, h, u, s);
            }
        case R.publicKey.elgamal:
            {
                const { c1: e, c2: i } = n;
                return async function(e, t, r, n, i) {
                    return e = re(e), t = re(t), r = re(r), Me(le(ne(ae(ie(e, n = re(n), r), r) * t, r), "be", ue(r)), i);
                }(e, i, t.p, r.x, s);
            }
        case R.publicKey.ecdh:
            {
                const { oid: e, Q: s, kdfParams: a } = t, { d: o } = r, { V: c, C: h } = n;
                return ci(e, a, c, h.data, s, o, i);
            }
        case R.publicKey.x25519:
        case R.publicKey.x448:
            {
                const { A: i } = t, { k: s } = r, { ephemeralPublicKey: a, C: o } = n;
                if (null !== o.algorithm && !M.isAES(o.algorithm)) throw Error("AES session key expected");
                return vn(e, a, o.wrappedKey, i, s);
            }
        default:
            throw Error("Unknown public key encryption algorithm.");
    }
}
function mi(e, t, r) {
    let n = 0;
    switch(e){
        case R.publicKey.rsaEncrypt:
        case R.publicKey.rsaEncryptSign:
        case R.publicKey.rsaSign:
            {
                const e = M.readMPI(t.subarray(n));
                n += e.length + 2;
                const r = M.readMPI(t.subarray(n));
                n += r.length + 2;
                const i = M.readMPI(t.subarray(n));
                n += i.length + 2;
                const s = M.readMPI(t.subarray(n));
                return n += s.length + 2, {
                    read: n,
                    privateParams: {
                        d: e,
                        p: r,
                        q: i,
                        u: s
                    }
                };
            }
        case R.publicKey.dsa:
        case R.publicKey.elgamal:
            {
                const e = M.readMPI(t.subarray(n));
                return n += e.length + 2, {
                    read: n,
                    privateParams: {
                        x: e
                    }
                };
            }
        case R.publicKey.ecdsa:
        case R.publicKey.ecdh:
            {
                const i = Bi(e, r.oid);
                let s = M.readMPI(t.subarray(n));
                return n += s.length + 2, s = M.leftPad(s, i), {
                    read: n,
                    privateParams: {
                        d: s
                    }
                };
            }
        case R.publicKey.eddsaLegacy:
            {
                const i = Bi(e, r.oid);
                if (r.oid.getName() !== R.curve.ed25519Legacy) throw Error("Unexpected OID for eddsaLegacy");
                let s = M.readMPI(t.subarray(n));
                return n += s.length + 2, s = M.leftPad(s, i), {
                    read: n,
                    privateParams: {
                        seed: s
                    }
                };
            }
        case R.publicKey.ed25519:
        case R.publicKey.ed448:
            {
                const r = Bi(e), i = M.readExactSubarray(t, n, n + r);
                return n += i.length, {
                    read: n,
                    privateParams: {
                        seed: i
                    }
                };
            }
        case R.publicKey.x25519:
        case R.publicKey.x448:
            {
                const r = Bi(e), i = M.readExactSubarray(t, n, n + r);
                return n += i.length, {
                    read: n,
                    privateParams: {
                        k: i
                    }
                };
            }
        default:
            throw new Yt("Unknown public key encryption algorithm.");
    }
}
function bi(e, t) {
    const r = new Set([
        R.publicKey.ed25519,
        R.publicKey.x25519,
        R.publicKey.ed448,
        R.publicKey.x448
    ]), n = Object.keys(t).map((n)=>{
        const i = t[n];
        return M.isUint8Array(i) ? r.has(e) ? i : M.uint8ArrayToMPI(i) : i.write();
    });
    return M.concatUint8Array(n);
}
function ki(e, t, r) {
    switch(e){
        case R.publicKey.rsaEncrypt:
        case R.publicKey.rsaEncryptSign:
        case R.publicKey.rsaSign:
            return (async function(e, t) {
                if (t = BigInt(t), M.getWebCrypto()) {
                    const r = {
                        name: "RSASSA-PKCS1-v1_5",
                        modulusLength: e,
                        publicExponent: le(t),
                        hash: {
                            name: "SHA-1"
                        }
                    }, n = await Fe.generateKey(r, !0, [
                        "sign",
                        "verify"
                    ]);
                    return Je(await Fe.exportKey("jwk", n.privateKey), t);
                }
                if (M.getNodeCrypto()) {
                    const r = {
                        modulusLength: e,
                        publicExponent: oe(t),
                        publicKeyEncoding: {
                            type: "pkcs1",
                            format: "jwk"
                        },
                        privateKeyEncoding: {
                            type: "pkcs1",
                            format: "jwk"
                        }
                    }, n = await new Promise((e, t)=>{
                        Oe.generateKeyPair("rsa", r, (r, n, i)=>{
                            r ? t(r) : e(i);
                        });
                    });
                    return Je(n, t);
                }
                let r, n, i;
                do n = de(e - (e >> 1), t, 40), r = de(e >> 1, t, 40), i = r * n;
                while (he(i) !== e);
                const s = (r - He) * (n - He);
                return n < r && ([r, n] = [
                    n,
                    r
                ]), {
                    n: le(i),
                    e: le(t),
                    d: le(ae(t, s)),
                    p: le(r),
                    q: le(n),
                    u: le(ae(r, n))
                };
            })(t, 65537).then(({ n: e, e: t, d: r, p: n, q: i, u: s })=>({
                    privateParams: {
                        d: r,
                        p: n,
                        q: i,
                        u: s
                    },
                    publicParams: {
                        n: e,
                        e: t
                    }
                }));
        case R.publicKey.ecdsa:
            return Ln(r).then(({ oid: e, Q: t, secret: r })=>({
                    privateParams: {
                        d: r
                    },
                    publicParams: {
                        oid: new Ht(e),
                        Q: t
                    }
                }));
        case R.publicKey.eddsaLegacy:
            return Ln(r).then(({ oid: e, Q: t, secret: r })=>({
                    privateParams: {
                        seed: r
                    },
                    publicParams: {
                        oid: new Ht(e),
                        Q: t
                    }
                }));
        case R.publicKey.ecdh:
            return Ln(r).then(({ oid: e, Q: t, secret: r, hash: n, cipher: i })=>({
                    privateParams: {
                        d: r
                    },
                    publicParams: {
                        oid: new Ht(e),
                        Q: t,
                        kdfParams: new pi({
                            hash: n,
                            cipher: i
                        })
                    }
                }));
        case R.publicKey.ed25519:
        case R.publicKey.ed448:
            return $t(e).then(({ A: e, seed: t })=>({
                    privateParams: {
                        seed: t
                    },
                    publicParams: {
                        A: e
                    }
                }));
        case R.publicKey.x25519:
        case R.publicKey.x448:
            return bn(e).then(({ A: e, k: t })=>({
                    privateParams: {
                        k: t
                    },
                    publicParams: {
                        A: e
                    }
                }));
        case R.publicKey.dsa:
        case R.publicKey.elgamal:
            throw Error("Unsupported algorithm for key generation.");
        default:
            throw Error("Unknown public key algorithm.");
    }
}
async function Ei(e, t, r) {
    if (!t || !r) throw Error("Missing key parameters");
    switch(e){
        case R.publicKey.rsaEncrypt:
        case R.publicKey.rsaEncryptSign:
        case R.publicKey.rsaSign:
            {
                const { n: e, e: n } = t, { d: i, p: s, q: a, u: o } = r;
                return async function(e, t, r, n, i, s) {
                    if (e = re(e), (n = re(n)) * (i = re(i)) !== e) return !1;
                    const a = BigInt(2);
                    if (ne(n * (s = re(s)), i) !== BigInt(1)) return !1;
                    t = re(t), r = re(r);
                    const o = ge(a, a << BigInt(Math.floor(he(e) / 3))), c = o * r * t;
                    return !(ne(c, n - He) !== o || ne(c, i - He) !== o);
                }(e, n, i, s, a, o);
            }
        case R.publicKey.dsa:
            {
                const { p: e, q: n, g: i, y: s } = t, { x: a } = r;
                return async function(e, t, r, n, i) {
                    if (e = re(e), t = re(t), r = re(r), n = re(n), r <= fi || r >= e) return !1;
                    if (ne(e - fi, t) !== yi) return !1;
                    if (ie(r, t, e) !== fi) return !1;
                    const s = BigInt(he(t));
                    if (s < BigInt(150) || !Ae(t, null, 32)) return !1;
                    i = re(i);
                    const a = BigInt(2);
                    return n === ie(r, t * ge(a << s - fi, a << s) + i, e);
                }(e, n, i, s, a);
            }
        case R.publicKey.elgamal:
            {
                const { p: e, g: n, y: i } = t, { x: s } = r;
                return async function(e, t, r, n) {
                    if (e = re(e), t = re(t), r = re(r), t <= Ye || t >= e) return !1;
                    const i = BigInt(he(e));
                    if (i < BigInt(1023)) return !1;
                    if (ie(t, e - Ye, e) !== Ye) return !1;
                    let s = t, a = BigInt(1);
                    const o = BigInt(2), c = o << BigInt(17);
                    for(; a < c;){
                        if (s = ne(s * t, e), s === Ye) return !1;
                        a++;
                    }
                    n = re(n);
                    const h = ge(o << i - Ye, o << i);
                    return r === ie(t, (e - Ye) * h + n, e);
                }(e, n, i, s);
            }
        case R.publicKey.ecdsa:
        case R.publicKey.ecdh:
            {
                const n = li[R.read(R.publicKey, e)], { oid: i, Q: s } = t, { d: a } = r;
                return n.validateParams(i, s, a);
            }
        case R.publicKey.eddsaLegacy:
            {
                const { Q: e, oid: n } = t, { seed: i } = r;
                return $n(n, e, i);
            }
        case R.publicKey.ed25519:
        case R.publicKey.ed448:
            {
                const { A: n } = t, { seed: i } = r;
                return tr(e, n, i);
            }
        case R.publicKey.x25519:
        case R.publicKey.x448:
            {
                const { A: n } = t, { k: i } = r;
                return kn(e, n, i);
            }
        default:
            throw Error("Unknown public key algorithm.");
    }
}
function vi(e) {
    const { keySize: t } = fn(e);
    return fe(t);
}
function Ii(e) {
    try {
        e.getName();
    } catch (e) {
        throw new Yt("Unknown curve OID");
    }
}
function Bi(e, t) {
    switch(e){
        case R.publicKey.ecdsa:
        case R.publicKey.ecdh:
        case R.publicKey.eddsaLegacy:
            return new Tn(t).payloadSize;
        case R.publicKey.ed25519:
        case R.publicKey.ed448:
            return rr(e);
        case R.publicKey.x25519:
        case R.publicKey.x448:
            return In(e);
        default:
            throw Error("Unknown elliptic algo");
    }
}
const Si = M.getWebCrypto(), Ki = M.getNodeCrypto(), Ci = Ki ? Ki.getCiphers() : [], Di = {
    idea: Ci.includes("idea-cfb") ? "idea-cfb" : void 0,
    tripledes: Ci.includes("des-ede3-cfb") ? "des-ede3-cfb" : void 0,
    cast5: Ci.includes("cast5-cfb") ? "cast5-cfb" : void 0,
    blowfish: Ci.includes("bf-cfb") ? "bf-cfb" : void 0,
    aes128: Ci.includes("aes-128-cfb") ? "aes-128-cfb" : void 0,
    aes192: Ci.includes("aes-192-cfb") ? "aes-192-cfb" : void 0,
    aes256: Ci.includes("aes-256-cfb") ? "aes-256-cfb" : void 0
};
async function Ui(e) {
    const { blockSize: t } = fn(e), r = await fe(t), n = new Uint8Array([
        r[r.length - 2],
        r[r.length - 1]
    ]);
    return M.concat([
        r,
        n
    ]);
}
async function Pi(e, t, r, n, i) {
    const s = R.read(R.symmetric, e);
    if (M.getNodeCrypto() && Di[s]) return function(e, t, r, n) {
        const i = R.read(R.symmetric, e), s = new Ki.createCipheriv(Di[i], t, n);
        return k(r, (e)=>new Uint8Array(s.update(e)));
    }(e, t, r, n);
    if (M.isAES(e)) return async function(e, t, r, n) {
        if (Si && await Qi.isSupported(e)) {
            const i = new Qi(e, t, n);
            return M.isStream(r) ? k(r, (e)=>i.encryptChunk(e), ()=>i.finish()) : i.encrypt(r);
        }
        if (M.isStream(r)) {
            const i = new Ri(!0, e, t, n);
            return k(r, (e)=>i.processChunk(e), ()=>i.finish());
        }
        return en(t, n).encrypt(r);
    }(e, t, r, n);
    const a = new (await un(e))(t), o = a.blockSize, c = n.slice();
    let h = new Uint8Array;
    const u = (e)=>{
        e && (h = M.concatUint8Array([
            h,
            e
        ]));
        const t = new Uint8Array(h.length);
        let r, n = 0;
        for(; e ? h.length >= o : h.length;){
            const e = a.encrypt(c);
            for(r = 0; r < o; r++)c[r] = h[r] ^ e[r], t[n++] = c[r];
            h = h.subarray(o);
        }
        return t.subarray(0, n);
    };
    return k(r, u, u);
}
async function xi(e, t, r, n) {
    const i = R.read(R.symmetric, e);
    if (Ki && Di[i]) return function(e, t, r, n) {
        const i = R.read(R.symmetric, e), s = new Ki.createDecipheriv(Di[i], t, n);
        return k(r, (e)=>new Uint8Array(s.update(e)));
    }(e, t, r, n);
    if (M.isAES(e)) return async function(e, t, r, n) {
        if (M.isStream(r)) {
            const i = new Ri(!1, e, t, n);
            return k(r, (e)=>i.processChunk(e), ()=>i.finish());
        }
        return en(t, n).decrypt(r);
    }(e, t, r, n);
    const s = new (await un(e))(t), a = s.blockSize;
    let o = n, c = new Uint8Array;
    const h = (e)=>{
        e && (c = M.concatUint8Array([
            c,
            e
        ]));
        const t = new Uint8Array(c.length);
        let r, n = 0;
        for(; e ? c.length >= a : c.length;){
            const e = s.encrypt(o);
            for(o = c.subarray(0, a), r = 0; r < a; r++)t[n++] = o[r] ^ e[r];
            c = c.subarray(a);
        }
        return t.subarray(0, n);
    };
    return k(r, h, h);
}
class Qi {
    constructor(e, t, r){
        const { blockSize: n } = fn(e);
        this.key = t, this.prevBlock = r, this.nextBlock = new Uint8Array(n), this.i = 0, this.blockSize = n, this.zeroBlock = new Uint8Array(this.blockSize);
    }
    static async isSupported(e) {
        const { keySize: t } = fn(e);
        return Si.importKey("raw", new Uint8Array(t), "aes-cbc", !1, [
            "encrypt"
        ]).then(()=>!0, ()=>!1);
    }
    async _runCBC(e, t) {
        const r = "AES-CBC";
        this.keyRef = this.keyRef || await Si.importKey("raw", this.key, r, !1, [
            "encrypt"
        ]);
        const n = await Si.encrypt({
            name: r,
            iv: t || this.zeroBlock
        }, this.keyRef, e);
        return new Uint8Array(n).subarray(0, e.length);
    }
    async encryptChunk(e) {
        const t = this.nextBlock.length - this.i, r = e.subarray(0, t);
        if (this.nextBlock.set(r, this.i), this.i + e.length >= 2 * this.blockSize) {
            const r = (e.length - t) % this.blockSize, n = M.concatUint8Array([
                this.nextBlock,
                e.subarray(t, e.length - r)
            ]), i = M.concatUint8Array([
                this.prevBlock,
                n.subarray(0, n.length - this.blockSize)
            ]), s = await this._runCBC(i);
            return Ti(s, n), this.prevBlock = s.slice(-this.blockSize), r > 0 && this.nextBlock.set(e.subarray(-r)), this.i = r, s;
        }
        let n;
        if (this.i += r.length, this.i === this.nextBlock.length) {
            const t = this.nextBlock;
            n = await this._runCBC(this.prevBlock), Ti(n, t), this.prevBlock = n.slice(), this.i = 0;
            const i = e.subarray(r.length);
            this.nextBlock.set(i, this.i), this.i += i.length;
        } else n = new Uint8Array;
        return n;
    }
    async finish() {
        let e;
        if (0 === this.i) e = new Uint8Array;
        else {
            this.nextBlock = this.nextBlock.subarray(0, this.i);
            const t = this.nextBlock, r = await this._runCBC(this.prevBlock);
            Ti(r, t), e = r.subarray(0, t.length);
        }
        return this.clearSensitiveData(), e;
    }
    clearSensitiveData() {
        this.nextBlock.fill(0), this.prevBlock.fill(0), this.keyRef = null, this.key = null;
    }
    async encrypt(e) {
        const t = (await this._runCBC(M.concatUint8Array([
            new Uint8Array(this.blockSize),
            e
        ]), this.iv)).subarray(0, e.length);
        return Ti(t, e), this.clearSensitiveData(), t;
    }
}
class Ri {
    constructor(e, t, r, n){
        this.forEncryption = e;
        const { blockSize: i } = fn(t);
        this.key = hn.expandKeyLE(r), n.byteOffset % 4 != 0 && (n = n.slice()), this.prevBlock = Li(n), this.nextBlock = new Uint8Array(i), this.i = 0, this.blockSize = i;
    }
    _runCFB(e) {
        const t = Li(e), r = new Uint8Array(e.length), n = Li(r);
        for(let e = 0; e + 4 <= n.length; e += 4){
            const { s0: r, s1: i, s2: s, s3: a } = hn.encrypt(this.key, this.prevBlock[0], this.prevBlock[1], this.prevBlock[2], this.prevBlock[3]);
            n[e + 0] = t[e + 0] ^ r, n[e + 1] = t[e + 1] ^ i, n[e + 2] = t[e + 2] ^ s, n[e + 3] = t[e + 3] ^ a, this.prevBlock = (this.forEncryption ? n : t).slice(e, e + 4);
        }
        return r;
    }
    async processChunk(e) {
        const t = this.nextBlock.length - this.i, r = e.subarray(0, t);
        if (this.nextBlock.set(r, this.i), this.i + e.length >= 2 * this.blockSize) {
            const r = (e.length - t) % this.blockSize, n = M.concatUint8Array([
                this.nextBlock,
                e.subarray(t, e.length - r)
            ]), i = this._runCFB(n);
            return r > 0 && this.nextBlock.set(e.subarray(-r)), this.i = r, i;
        }
        let n;
        if (this.i += r.length, this.i === this.nextBlock.length) {
            n = this._runCFB(this.nextBlock), this.i = 0;
            const t = e.subarray(r.length);
            this.nextBlock.set(t, this.i), this.i += t.length;
        } else n = new Uint8Array;
        return n;
    }
    async finish() {
        let e;
        if (0 === this.i) e = new Uint8Array;
        else e = this._runCFB(this.nextBlock).subarray(0, this.i);
        return this.clearSensitiveData(), e;
    }
    clearSensitiveData() {
        this.nextBlock.fill(0), this.prevBlock.fill(0), this.key.fill(0);
    }
}
function Ti(e, t) {
    const r = Math.min(e.length, t.length);
    for(let n = 0; n < r; n++)e[n] = e[n] ^ t[n];
}
const Li = (e)=>new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4));
const Mi = M.getWebCrypto(), Ni = M.getNodeCrypto(), Fi = 16;
function Oi(e, t) {
    const r = e.length - Fi;
    for(let n = 0; n < Fi; n++)e[n + r] ^= t[n];
    return e;
}
const Hi = new Uint8Array(Fi);
async function zi(e) {
    const t = await Gi(e), r = M.double(await t(Hi)), n = M.double(r);
    return async function(e) {
        return (await t(function(e, t, r) {
            if (e.length && e.length % Fi == 0) return Oi(e, t);
            const n = new Uint8Array(e.length + (Fi - e.length % Fi));
            return n.set(e), n[e.length] = 128, Oi(n, r);
        }(e, r, n))).subarray(-Fi);
    };
}
async function Gi(e) {
    if (M.getNodeCrypto()) return async function(t) {
        const r = new Ni.createCipheriv("aes-" + 8 * e.length + "-cbc", e, Hi).update(t);
        return new Uint8Array(r);
    };
    if (M.getWebCrypto()) try {
        return e = await Mi.importKey("raw", e, {
            name: "AES-CBC",
            length: 8 * e.length
        }, !1, [
            "encrypt"
        ]), async function(t) {
            const r = await Mi.encrypt({
                name: "AES-CBC",
                iv: Hi,
                length: 8 * Fi
            }, e, t);
            return new Uint8Array(r).subarray(0, r.byteLength - Fi);
        };
    } catch (t) {
        if ("NotSupportedError" !== t.name && (24 !== e.length || "OperationError" !== t.name)) throw t;
        M.printDebugError("Browser did not support operation: " + t.message);
    }
    return async function(t) {
        return Xr(e, Hi, {
            disablePadding: !0
        }).encrypt(t);
    };
}
const _i = M.getWebCrypto(), ji = M.getNodeCrypto(), qi = M.getNodeBuffer(), Vi = 16, Ji = Vi, Yi = Vi, Zi = new Uint8Array(Vi), Wi = new Uint8Array(Vi);
Wi[Vi - 1] = 1;
const $i = new Uint8Array(Vi);
async function Xi(e) {
    const t = await zi(e);
    return function(e, r) {
        return t(M.concatUint8Array([
            e,
            r
        ]));
    };
}
async function es(e) {
    if (M.getNodeCrypto()) return async function(t, r) {
        const n = new ji.createCipheriv("aes-" + 8 * e.length + "-ctr", e, r), i = qi.concat([
            n.update(t),
            n.final()
        ]);
        return new Uint8Array(i);
    };
    if (M.getWebCrypto()) try {
        const t = await _i.importKey("raw", e, {
            name: "AES-CTR",
            length: 8 * e.length
        }, !1, [
            "encrypt"
        ]);
        return async function(e, r) {
            const n = await _i.encrypt({
                name: "AES-CTR",
                counter: r,
                length: 8 * Vi
            }, t, e);
            return new Uint8Array(n);
        };
    } catch (t) {
        if ("NotSupportedError" !== t.name && (24 !== e.length || "OperationError" !== t.name)) throw t;
        M.printDebugError("Browser did not support operation: " + t.message);
    }
    return async function(t, r) {
        return $r(e, r).encrypt(t);
    };
}
async function ts(e, t) {
    if (e !== R.symmetric.aes128 && e !== R.symmetric.aes192 && e !== R.symmetric.aes256) throw Error("EAX mode supports only AES cipher");
    const [r, n] = await Promise.all([
        Xi(t),
        es(t)
    ]);
    return {
        encrypt: async function(e, t, i) {
            const [s, a] = await Promise.all([
                r(Zi, t),
                r(Wi, i)
            ]), o = await n(e, s), c = await r($i, o);
            for(let e = 0; e < Yi; e++)c[e] ^= a[e] ^ s[e];
            return M.concatUint8Array([
                o,
                c
            ]);
        },
        decrypt: async function(e, t, i) {
            if (e.length < Yi) throw Error("Invalid EAX ciphertext");
            const s = e.subarray(0, -Yi), a = e.subarray(-Yi), [o, c, h] = await Promise.all([
                r(Zi, t),
                r(Wi, i),
                r($i, s)
            ]), u = h;
            for(let e = 0; e < Yi; e++)u[e] ^= c[e] ^ o[e];
            if (!M.equalsUint8Array(a, u)) throw Error("Authentication tag mismatch");
            return await n(s, o);
        }
    };
}
$i[Vi - 1] = 2, ts.getNonce = function(e, t) {
    const r = e.slice();
    for(let e = 0; e < t.length; e++)r[8 + e] ^= t[e];
    return r;
}, ts.blockLength = Vi, ts.ivLength = Ji, ts.tagLength = Yi;
const rs = 16, ns = 15, is = 16;
function ss(e) {
    let t = 0;
    for(let r = 1; !(e & r); r <<= 1)t++;
    return t;
}
function as(e, t) {
    for(let r = 0; r < e.length; r++)e[r] ^= t[r];
    return e;
}
function os(e, t) {
    return as(e.slice(), t);
}
const cs = new Uint8Array(rs), hs = new Uint8Array([
    1
]);
async function us(e, t) {
    const { keySize: r } = fn(e);
    if (!M.isAES(e) || t.length !== r) throw Error("Unexpected algorithm or key size");
    let n = 0;
    const i = Xr(t, cs, {
        disablePadding: !0
    }), s = (e)=>i.encrypt(e), a = (e)=>i.decrypt(e);
    let o;
    function c(e, t, r, i) {
        const a = t.length / rs | 0;
        !function(e, t) {
            const r = M.nbits(Math.max(e.length, t.length) / rs | 0) - 1;
            for(let e = n + 1; e <= r; e++)o[e] = M.double(o[e - 1]);
            n = r;
        }(t, i);
        const c = M.concatUint8Array([
            cs.subarray(0, ns - r.length),
            hs,
            r
        ]), h = 63 & c[rs - 1];
        c[rs - 1] &= 192;
        const u = s(c), l = M.concatUint8Array([
            u,
            os(u.subarray(0, 8), u.subarray(1, 9))
        ]), y = M.shiftRight(l.subarray(0 + (h >> 3), 17 + (h >> 3)), 8 - (7 & h)).subarray(1), f = new Uint8Array(rs), g = new Uint8Array(t.length + is);
        let p, d = 0;
        for(p = 0; p < a; p++)as(y, o[ss(p + 1)]), g.set(as(e(os(y, t)), y), d), as(f, e === s ? t : g.subarray(d)), t = t.subarray(rs), d += rs;
        if (t.length) {
            as(y, o.x);
            const r = s(y);
            g.set(os(t, r), d);
            const n = new Uint8Array(rs);
            n.set(e === s ? t : g.subarray(d, -is), 0), n[t.length] = 128, as(f, n), d += t.length;
        }
        const A = as(s(as(as(f, y), o.$)), function(e) {
            if (!e.length) return cs;
            const t = e.length / rs | 0, r = new Uint8Array(rs), n = new Uint8Array(rs);
            for(let i = 0; i < t; i++)as(r, o[ss(i + 1)]), as(n, s(os(r, e))), e = e.subarray(rs);
            if (e.length) {
                as(r, o.x);
                const t = new Uint8Array(rs);
                t.set(e, 0), t[e.length] = 128, as(t, r), as(n, s(t));
            }
            return n;
        }(i));
        return g.set(A, d), g;
    }
    return function() {
        const e = s(cs), t = M.double(e);
        o = [], o[0] = M.double(t), o.x = e, o.$ = t;
    }(), {
        encrypt: async function(e, t, r) {
            return c(s, e, t, r);
        },
        decrypt: async function(e, t, r) {
            if (e.length < is) throw Error("Invalid OCB ciphertext");
            const n = e.subarray(-is);
            e = e.subarray(0, -is);
            const i = c(a, e, t, r);
            if (M.equalsUint8Array(n, i.subarray(-is))) return i.subarray(0, -is);
            throw Error("Authentication tag mismatch");
        }
    };
}
us.getNonce = function(e, t) {
    const r = e.slice();
    for(let e = 0; e < t.length; e++)r[7 + e] ^= t[e];
    return r;
}, us.blockLength = rs, us.ivLength = ns, us.tagLength = is;
const ls = M.getWebCrypto(), ys = M.getNodeCrypto(), fs = M.getNodeBuffer(), gs = 16, ps = "AES-GCM";
async function ds(e, t) {
    if (e !== R.symmetric.aes128 && e !== R.symmetric.aes192 && e !== R.symmetric.aes256) throw Error("GCM mode supports only AES cipher");
    if (M.getNodeCrypto()) return {
        encrypt: async function(e, r, n = new Uint8Array) {
            const i = new ys.createCipheriv("aes-" + 8 * t.length + "-gcm", t, r);
            i.setAAD(n);
            const s = fs.concat([
                i.update(e),
                i.final(),
                i.getAuthTag()
            ]);
            return new Uint8Array(s);
        },
        decrypt: async function(e, r, n = new Uint8Array) {
            const i = new ys.createDecipheriv("aes-" + 8 * t.length + "-gcm", t, r);
            i.setAAD(n), i.setAuthTag(e.slice(e.length - gs, e.length));
            const s = fs.concat([
                i.update(e.slice(0, e.length - gs)),
                i.final()
            ]);
            return new Uint8Array(s);
        }
    };
    if (M.getWebCrypto()) try {
        const e = await ls.importKey("raw", t, {
            name: ps
        }, !1, [
            "encrypt",
            "decrypt"
        ]), r = navigator.userAgent.match(/Version\/13\.\d(\.\d)* Safari/) || navigator.userAgent.match(/Version\/(13|14)\.\d(\.\d)* Mobile\/\S* Safari/);
        return {
            encrypt: async function(n, i, s = new Uint8Array) {
                if (r && !n.length) return tn(t, i, s).encrypt(n);
                const a = await ls.encrypt({
                    name: ps,
                    iv: i,
                    additionalData: s,
                    tagLength: 8 * gs
                }, e, n);
                return new Uint8Array(a);
            },
            decrypt: async function(n, i, s = new Uint8Array) {
                if (r && n.length === gs) return tn(t, i, s).decrypt(n);
                try {
                    const t = await ls.decrypt({
                        name: ps,
                        iv: i,
                        additionalData: s,
                        tagLength: 8 * gs
                    }, e, n);
                    return new Uint8Array(t);
                } catch (e) {
                    if ("OperationError" === e.name) throw Error("Authentication tag mismatch");
                }
            }
        };
    } catch (e) {
        if ("NotSupportedError" !== e.name && (24 !== t.length || "OperationError" !== e.name)) throw e;
        M.printDebugError("Browser did not support operation: " + e.message);
    }
    return {
        encrypt: async function(e, r, n) {
            return tn(t, r, n).encrypt(e);
        },
        decrypt: async function(e, r, n) {
            return tn(t, r, n).decrypt(e);
        }
    };
}
function As(e, t = !1) {
    switch(e){
        case R.aead.eax:
            return ts;
        case R.aead.ocb:
            return us;
        case R.aead.gcm:
            return ds;
        case R.aead.experimentalGCM:
            if (!t) throw Error("Unexpected non-standard `experimentalGCM` AEAD algorithm provided in `config.preferredAEADAlgorithm`: use `gcm` instead");
            return ds;
        default:
            throw Error("Unsupported AEAD mode");
    }
}
async function ws(e, t, r, n, i, s) {
    switch(e){
        case R.publicKey.rsaEncryptSign:
        case R.publicKey.rsaEncrypt:
        case R.publicKey.rsaSign:
            {
                const { n: e, e: a } = n;
                return Ge(t, i, M.leftPad(r.s, e.length), e, a, s);
            }
        case R.publicKey.dsa:
            {
                const { g: e, p: t, q: i, y: a } = n, { r: o, s: c } = r;
                return async function(e, t, r, n, i, s, a, o) {
                    if (t = re(t), r = re(r), s = re(s), a = re(a), i = re(i), o = re(o), t <= yi || t >= a || r <= yi || r >= a) return M.printDebug("invalid DSA Signature"), !1;
                    const c = ne(re(n.subarray(0, ue(a))), a), h = ae(r, a);
                    if (h === yi) return M.printDebug("invalid DSA Signature"), !1;
                    i = ne(i, s), o = ne(o, s);
                    const u = ne(c * h, a), l = ne(t * h, a);
                    return ne(ne(ie(i, u, s) * ie(o, l, s), s), a) === t;
                }(0, o, c, s, e, t, i, a);
            }
        case R.publicKey.ecdsa:
            {
                const { oid: e, Q: a } = n, o = new Tn(e).payloadSize;
                return Vn(e, t, {
                    r: M.leftPad(r.r, o),
                    s: M.leftPad(r.s, o)
                }, i, a, s);
            }
        case R.publicKey.eddsaLegacy:
            {
                const { oid: e, Q: i } = n, a = new Tn(e).payloadSize;
                return Wn(e, t, {
                    r: M.leftPad(r.r, a),
                    s: M.leftPad(r.s, a)
                }, 0, i, s);
            }
        case R.publicKey.ed25519:
        case R.publicKey.ed448:
            {
                const { A: i } = n;
                return er(e, t, r, 0, i, s);
            }
        default:
            throw Error("Unknown signature algorithm.");
    }
}
async function ms(e, t, r, n, i, s) {
    if (!r || !n) throw Error("Missing key parameters");
    switch(e){
        case R.publicKey.rsaEncryptSign:
        case R.publicKey.rsaEncrypt:
        case R.publicKey.rsaSign:
            {
                const { n: e, e: a } = r, { d: o, p: c, q: h, u } = n;
                return {
                    s: await ze(t, i, e, a, o, c, h, u, s)
                };
            }
        case R.publicKey.dsa:
            {
                const { g: e, p: t, q: i } = r, { x: a } = n;
                return async function(e, t, r, n, i, s) {
                    const a = BigInt(0);
                    let o, c, h, u;
                    n = re(n), i = re(i), r = re(r), s = re(s), r = ne(r, n), s = ne(s, i);
                    const l = ne(re(t.subarray(0, ue(i))), i);
                    for(;;){
                        if (o = ge(fi, i), c = ne(ie(r, o, n), i), c === a) continue;
                        const e = ne(s * c, i);
                        if (u = ne(l + e, i), h = ne(ae(o, i) * u, i), h !== a) break;
                    }
                    return {
                        r: le(c, "be", ue(n)),
                        s: le(h, "be", ue(n))
                    };
                }(0, s, e, t, i, a);
            }
        case R.publicKey.elgamal:
            throw Error("Signing with Elgamal is not defined in the OpenPGP standard.");
        case R.publicKey.ecdsa:
            {
                const { oid: e, Q: a } = r, { d: o } = n;
                return qn(e, t, i, a, o, s);
            }
        case R.publicKey.eddsaLegacy:
            {
                const { oid: e, Q: i } = r, { seed: a } = n;
                return Zn(e, t, 0, i, a, s);
            }
        case R.publicKey.ed25519:
        case R.publicKey.ed448:
            {
                const { A: i } = r, { seed: a } = n;
                return Xt(e, t, 0, i, a, s);
            }
        default:
            throw Error("Unknown signature algorithm.");
    }
}
ds.getNonce = function(e, t) {
    const r = e.slice();
    for(let e = 0; e < t.length; e++)r[4 + e] ^= t[e];
    return r;
}, ds.blockLength = 16, ds.ivLength = 12, ds.tagLength = gs;
class bs extends Error {
    constructor(...e){
        super(...e), Error.captureStackTrace && Error.captureStackTrace(this, bs), this.name = "Argon2OutOfMemoryError";
    }
}
let ks, Es;
class vs {
    constructor(e = T){
        const { passes: t, parallelism: r, memoryExponent: n } = e.s2kArgon2Params;
        this.type = "argon2", this.salt = null, this.t = t, this.p = r, this.encodedM = n;
    }
    generateSalt() {
        this.salt = fe(16);
    }
    read(e) {
        let t = 0;
        return this.salt = e.subarray(t, t + 16), t += 16, this.t = e[t++], this.p = e[t++], this.encodedM = e[t++], t;
    }
    write() {
        const e = [
            new Uint8Array([
                R.write(R.s2k, this.type)
            ]),
            this.salt,
            new Uint8Array([
                this.t,
                this.p,
                this.encodedM
            ])
        ];
        return M.concatUint8Array(e);
    }
    async produceKey(e, t) {
        const r = 2 << this.encodedM - 1;
        try {
            ks = ks || (await Promise.resolve().then(function() {
                return ef;
            })).default, Es = Es || ks();
            const n = await Es, i = n({
                version: 19,
                type: 2,
                password: M.encodeUTF8(e),
                salt: this.salt,
                tagLength: t,
                memorySize: r,
                parallelism: this.p,
                passes: this.t
            });
            return r > 1048576 && (Es = ks(), Es.catch(()=>{})), i;
        } catch (e) {
            throw e.message && (e.message.includes("Unable to grow instance memory") || e.message.includes("failed to grow memory") || e.message.includes("WebAssembly.Memory.grow") || e.message.includes("Out of memory")) ? new bs("Could not allocate required memory for Argon2") : e;
        }
    }
}
class Is {
    constructor(e, t = T){
        this.algorithm = R.hash.sha256, this.type = R.read(R.s2k, e), this.c = t.s2kIterationCountByte, this.salt = null;
    }
    generateSalt() {
        switch(this.type){
            case "salted":
            case "iterated":
                this.salt = fe(8);
        }
    }
    getCount() {
        return 16 + (15 & this.c) << 6 + (this.c >> 4);
    }
    read(e) {
        let t = 0;
        switch(this.algorithm = e[t++], this.type){
            case "simple":
                break;
            case "salted":
                this.salt = e.subarray(t, t + 8), t += 8;
                break;
            case "iterated":
                this.salt = e.subarray(t, t + 8), t += 8, this.c = e[t++];
                break;
            case "gnu":
                if ("GNU" !== M.uint8ArrayToString(e.subarray(t, t + 3))) throw new Yt("Unknown s2k type.");
                t += 3;
                if (1001 !== 1e3 + e[t++]) throw new Yt("Unknown s2k gnu protection mode.");
                this.type = "gnu-dummy";
                break;
            default:
                throw new Yt("Unknown s2k type.");
        }
        return t;
    }
    write() {
        if ("gnu-dummy" === this.type) return new Uint8Array([
            101,
            0,
            ...M.stringToUint8Array("GNU"),
            1
        ]);
        const e = [
            new Uint8Array([
                R.write(R.s2k, this.type),
                this.algorithm
            ])
        ];
        switch(this.type){
            case "simple":
                break;
            case "salted":
                e.push(this.salt);
                break;
            case "iterated":
                e.push(this.salt), e.push(new Uint8Array([
                    this.c
                ]));
                break;
            case "gnu":
                throw Error("GNU s2k type not supported.");
            default:
                throw Error("Unknown s2k type.");
        }
        return M.concatUint8Array(e);
    }
    async produceKey(e, t) {
        e = M.encodeUTF8(e);
        const r = [];
        let n = 0, i = 0;
        for(; n < t;){
            let t;
            switch(this.type){
                case "simple":
                    t = M.concatUint8Array([
                        new Uint8Array(i),
                        e
                    ]);
                    break;
                case "salted":
                    t = M.concatUint8Array([
                        new Uint8Array(i),
                        this.salt,
                        e
                    ]);
                    break;
                case "iterated":
                    {
                        const r = M.concatUint8Array([
                            this.salt,
                            e
                        ]);
                        let n = r.length;
                        const s = Math.max(this.getCount(), n);
                        t = new Uint8Array(i + s), t.set(r, i);
                        for(let e = i + n; e < s; e += n, n *= 2)t.copyWithin(e, i, e);
                        break;
                    }
                case "gnu":
                    throw Error("GNU s2k type not supported.");
                default:
                    throw Error("Unknown s2k type.");
            }
            const s = await Qe(this.algorithm, t);
            r.push(s), n += s.length, i++;
        }
        return M.concatUint8Array(r).subarray(0, t);
    }
}
const Bs = new Set([
    R.s2k.argon2,
    R.s2k.iterated
]);
function Ss(e, t = T) {
    switch(e){
        case R.s2k.argon2:
            return new vs(t);
        case R.s2k.iterated:
        case R.s2k.gnu:
        case R.s2k.salted:
        case R.s2k.simple:
            return new Is(e, t);
        default:
            throw new Yt("Unsupported S2K type");
    }
}
function Ks(e) {
    const { s2kType: t } = e;
    if (!Bs.has(t)) throw Error("The provided `config.s2kType` value is not allowed");
    return Ss(t, e);
}
var Cs = Uint8Array, Ds = Uint16Array, Us = Uint32Array, Ps = new Cs([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), xs = new Cs([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), Qs = new Cs([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), Rs = function(e, t) {
    for(var r = new Ds(31), n = 0; n < 31; ++n)r[n] = t += 1 << e[n - 1];
    var i = new Us(r[30]);
    for(n = 1; n < 30; ++n)for(var s = r[n]; s < r[n + 1]; ++s)i[s] = s - r[n] << 5 | n;
    return [
        r,
        i
    ];
}, Ts = Rs(Ps, 2), Ls = Ts[0], Ms = Ts[1];
Ls[28] = 258, Ms[258] = 28;
for(var Ns = Rs(xs, 0), Fs = Ns[0], Os = Ns[1], Hs = new Ds(32768), zs = 0; zs < 32768; ++zs){
    var Gs = (43690 & zs) >>> 1 | (21845 & zs) << 1;
    Gs = (61680 & (Gs = (52428 & Gs) >>> 2 | (13107 & Gs) << 2)) >>> 4 | (3855 & Gs) << 4, Hs[zs] = ((65280 & Gs) >>> 8 | (255 & Gs) << 8) >>> 1;
}
var _s = function(e, t, r) {
    for(var n = e.length, i = 0, s = new Ds(t); i < n; ++i)e[i] && ++s[e[i] - 1];
    var a, o = new Ds(t);
    for(i = 0; i < t; ++i)o[i] = o[i - 1] + s[i - 1] << 1;
    if (r) {
        a = new Ds(1 << t);
        var c = 15 - t;
        for(i = 0; i < n; ++i)if (e[i]) for(var h = i << 4 | e[i], u = t - e[i], l = o[e[i] - 1]++ << u, y = l | (1 << u) - 1; l <= y; ++l)a[Hs[l] >>> c] = h;
    } else for(a = new Ds(n), i = 0; i < n; ++i)e[i] && (a[i] = Hs[o[e[i] - 1]++] >>> 15 - e[i]);
    return a;
}, js = new Cs(288);
for(zs = 0; zs < 144; ++zs)js[zs] = 8;
for(zs = 144; zs < 256; ++zs)js[zs] = 9;
for(zs = 256; zs < 280; ++zs)js[zs] = 7;
for(zs = 280; zs < 288; ++zs)js[zs] = 8;
var qs = new Cs(32);
for(zs = 0; zs < 32; ++zs)qs[zs] = 5;
var Vs = /*#__PURE__*/ _s(js, 9, 0), Js = /*#__PURE__*/ _s(js, 9, 1), Ys = /*#__PURE__*/ _s(qs, 5, 0), Zs = /*#__PURE__*/ _s(qs, 5, 1), Ws = function(e) {
    for(var t = e[0], r = 1; r < e.length; ++r)e[r] > t && (t = e[r]);
    return t;
}, $s = function(e, t, r) {
    var n = t / 8 | 0;
    return (e[n] | e[n + 1] << 8) >> (7 & t) & r;
}, Xs = function(e, t) {
    var r = t / 8 | 0;
    return (e[r] | e[r + 1] << 8 | e[r + 2] << 16) >> (7 & t);
}, ea = function(e) {
    return (e + 7) / 8 | 0;
}, ta = function(e, t, r) {
    (null == t || t < 0) && (t = 0), (null == r || r > e.length) && (r = e.length);
    var n = new (2 == e.BYTES_PER_ELEMENT ? Ds : 4 == e.BYTES_PER_ELEMENT ? Us : Cs)(r - t);
    return n.set(e.subarray(t, r)), n;
}, ra = [
    "unexpected EOF",
    "invalid block type",
    "invalid length/literal",
    "invalid distance",
    "stream finished",
    "no stream handler",
    ,
    "no callback",
    "invalid UTF-8 data",
    "extra field too long",
    "date not in range 1980-2099",
    "filename too long",
    "stream finishing",
    "invalid zip data"
], na = function(e, t, r) {
    var n = Error(t || ra[e]);
    if (n.code = e, Error.captureStackTrace && Error.captureStackTrace(n, na), !r) throw n;
    return n;
}, ia = function(e, t, r) {
    r <<= 7 & t;
    var n = t / 8 | 0;
    e[n] |= r, e[n + 1] |= r >>> 8;
}, sa = function(e, t, r) {
    r <<= 7 & t;
    var n = t / 8 | 0;
    e[n] |= r, e[n + 1] |= r >>> 8, e[n + 2] |= r >>> 16;
}, aa = function(e, t) {
    for(var r = [], n = 0; n < e.length; ++n)e[n] && r.push({
        s: n,
        f: e[n]
    });
    var i = r.length, s = r.slice();
    if (!i) return [
        fa,
        0
    ];
    if (1 == i) {
        var a = new Cs(r[0].s + 1);
        return a[r[0].s] = 1, [
            a,
            1
        ];
    }
    r.sort(function(e, t) {
        return e.f - t.f;
    }), r.push({
        s: -1,
        f: 25001
    });
    var o = r[0], c = r[1], h = 0, u = 1, l = 2;
    for(r[0] = {
        s: -1,
        f: o.f + c.f,
        l: o,
        r: c
    }; u != i - 1;)o = r[r[h].f < r[l].f ? h++ : l++], c = r[h != u && r[h].f < r[l].f ? h++ : l++], r[u++] = {
        s: -1,
        f: o.f + c.f,
        l: o,
        r: c
    };
    var y = s[0].s;
    for(n = 1; n < i; ++n)s[n].s > y && (y = s[n].s);
    var f = new Ds(y + 1), g = oa(r[u - 1], f, 0);
    if (g > t) {
        n = 0;
        var p = 0, d = g - t, A = 1 << d;
        for(s.sort(function(e, t) {
            return f[t.s] - f[e.s] || e.f - t.f;
        }); n < i; ++n){
            var w = s[n].s;
            if (!(f[w] > t)) break;
            p += A - (1 << g - f[w]), f[w] = t;
        }
        for(p >>>= d; p > 0;){
            var m = s[n].s;
            f[m] < t ? p -= 1 << t - f[m]++ - 1 : ++n;
        }
        for(; n >= 0 && p; --n){
            var b = s[n].s;
            f[b] == t && (--f[b], ++p);
        }
        g = t;
    }
    return [
        new Cs(f),
        g
    ];
}, oa = function(e, t, r) {
    return -1 == e.s ? Math.max(oa(e.l, t, r + 1), oa(e.r, t, r + 1)) : t[e.s] = r;
}, ca = function(e) {
    for(var t = e.length; t && !e[--t];);
    for(var r = new Ds(++t), n = 0, i = e[0], s = 1, a = function(e) {
        r[n++] = e;
    }, o = 1; o <= t; ++o)if (e[o] == i && o != t) ++s;
    else {
        if (!i && s > 2) {
            for(; s > 138; s -= 138)a(32754);
            s > 2 && (a(s > 10 ? s - 11 << 5 | 28690 : s - 3 << 5 | 12305), s = 0);
        } else if (s > 3) {
            for(a(i), --s; s > 6; s -= 6)a(8304);
            s > 2 && (a(s - 3 << 5 | 8208), s = 0);
        }
        for(; s--;)a(i);
        s = 1, i = e[o];
    }
    return [
        r.subarray(0, n),
        t
    ];
}, ha = function(e, t) {
    for(var r = 0, n = 0; n < t.length; ++n)r += e[n] * t[n];
    return r;
}, ua = function(e, t, r) {
    var n = r.length, i = ea(t + 2);
    e[i] = 255 & n, e[i + 1] = n >>> 8, e[i + 2] = 255 ^ e[i], e[i + 3] = 255 ^ e[i + 1];
    for(var s = 0; s < n; ++s)e[i + s + 4] = r[s];
    return 8 * (i + 4 + n);
}, la = function(e, t, r, n, i, s, a, o, c, h, u) {
    ia(t, u++, r), ++i[256];
    for(var l = aa(i, 15), y = l[0], f = l[1], g = aa(s, 15), p = g[0], d = g[1], A = ca(y), w = A[0], m = A[1], b = ca(p), k = b[0], E = b[1], v = new Ds(19), I = 0; I < w.length; ++I)v[31 & w[I]]++;
    for(I = 0; I < k.length; ++I)v[31 & k[I]]++;
    for(var B = aa(v, 7), S = B[0], K = B[1], C = 19; C > 4 && !S[Qs[C - 1]]; --C);
    var D, U, P, x, Q = h + 5 << 3, R = ha(i, js) + ha(s, qs) + a, T = ha(i, y) + ha(s, p) + a + 14 + 3 * C + ha(v, S) + (2 * v[16] + 3 * v[17] + 7 * v[18]);
    if (Q <= R && Q <= T) return ua(t, u, e.subarray(c, c + h));
    if (ia(t, u, 1 + (T < R)), u += 2, T < R) {
        D = _s(y, f, 0), U = y, P = _s(p, d, 0), x = p;
        var L = _s(S, K, 0);
        ia(t, u, m - 257), ia(t, u + 5, E - 1), ia(t, u + 10, C - 4), u += 14;
        for(I = 0; I < C; ++I)ia(t, u + 3 * I, S[Qs[I]]);
        u += 3 * C;
        for(var M = [
            w,
            k
        ], N = 0; N < 2; ++N){
            var F = M[N];
            for(I = 0; I < F.length; ++I){
                var O = 31 & F[I];
                ia(t, u, L[O]), u += S[O], O > 15 && (ia(t, u, F[I] >>> 5 & 127), u += F[I] >>> 12);
            }
        }
    } else D = Vs, U = js, P = Ys, x = qs;
    for(I = 0; I < o; ++I)if (n[I] > 255) {
        O = n[I] >>> 18 & 31;
        sa(t, u, D[O + 257]), u += U[O + 257], O > 7 && (ia(t, u, n[I] >>> 23 & 31), u += Ps[O]);
        var H = 31 & n[I];
        sa(t, u, P[H]), u += x[H], H > 3 && (sa(t, u, n[I] >>> 5 & 8191), u += xs[H]);
    } else sa(t, u, D[n[I]]), u += U[n[I]];
    return sa(t, u, D[256]), u + U[256];
}, ya = /*#__PURE__*/ new Us([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), fa = /*#__PURE__*/ new Cs(0), ga = function(e, t, r, n, i) {
    return function(e, t, r, n, i, s) {
        var a = e.length, o = new Cs(n + a + 5 * (1 + Math.ceil(a / 7e3)) + i), c = o.subarray(n, o.length - i), h = 0;
        if (!t || a < 8) for(var u = 0; u <= a; u += 65535){
            var l = u + 65535;
            l >= a && (c[h >> 3] = s), h = ua(c, h + 1, e.subarray(u, l));
        }
        else {
            for(var y = ya[t - 1], f = y >>> 13, g = 8191 & y, p = (1 << r) - 1, d = new Ds(32768), A = new Ds(p + 1), w = Math.ceil(r / 3), m = 2 * w, b = function(t) {
                return (e[t] ^ e[t + 1] << w ^ e[t + 2] << m) & p;
            }, k = new Us(25e3), E = new Ds(288), v = new Ds(32), I = 0, B = 0, S = (u = 0, 0), K = 0, C = 0; u < a; ++u){
                var D = b(u), U = 32767 & u, P = A[D];
                if (d[U] = P, A[D] = U, K <= u) {
                    var x = a - u;
                    if ((I > 7e3 || S > 24576) && x > 423) {
                        h = la(e, c, 0, k, E, v, B, S, C, u - C, h), S = I = B = 0, C = u;
                        for(var Q = 0; Q < 286; ++Q)E[Q] = 0;
                        for(Q = 0; Q < 30; ++Q)v[Q] = 0;
                    }
                    var R = 2, T = 0, L = g, M = U - P & 32767;
                    if (x > 2 && D == b(u - M)) for(var N = Math.min(f, x) - 1, F = Math.min(32767, u), O = Math.min(258, x); M <= F && --L && U != P;){
                        if (e[u + R] == e[u + R - M]) {
                            for(var H = 0; H < O && e[u + H] == e[u + H - M]; ++H);
                            if (H > R) {
                                if (R = H, T = M, H > N) break;
                                var z = Math.min(M, H - 2), G = 0;
                                for(Q = 0; Q < z; ++Q){
                                    var _ = u - M + Q + 32768 & 32767, j = _ - d[_] + 32768 & 32767;
                                    j > G && (G = j, P = _);
                                }
                            }
                        }
                        M += (U = P) - (P = d[U]) + 32768 & 32767;
                    }
                    if (T) {
                        k[S++] = 268435456 | Ms[R] << 18 | Os[T];
                        var q = 31 & Ms[R], V = 31 & Os[T];
                        B += Ps[q] + xs[V], ++E[257 + q], ++v[V], K = u + R, ++I;
                    } else k[S++] = e[u], ++E[e[u]];
                }
            }
            h = la(e, c, s, k, E, v, B, S, C, u - C, h), !s && 7 & h && (h = ua(c, h + 1, fa));
        }
        return ta(o, 0, n + ea(h) + i);
    }(e, null == t.level ? 6 : t.level, null == t.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(e.length)))) : 12 + t.mem, r, n, !i);
}, pa = /*#__PURE__*/ function() {
    function e(e, t) {
        t || "function" != typeof e || (t = e, e = {}), this.ondata = t, this.o = e || {};
    }
    return e.prototype.p = function(e, t) {
        this.ondata(ga(e, this.o, 0, 0, !t), t);
    }, e.prototype.push = function(e, t) {
        this.ondata || na(5), this.d && na(4), this.d = t, this.p(e, t || !1);
    }, e;
}(), da = /*#__PURE__*/ function() {
    function e(e) {
        this.s = {}, this.p = new Cs(0), this.ondata = e;
    }
    return e.prototype.e = function(e) {
        this.ondata || na(5), this.d && na(4);
        var t = this.p.length, r = new Cs(t + e.length);
        r.set(this.p), r.set(e, t), this.p = r;
    }, e.prototype.c = function(e) {
        this.d = this.s.i = e || !1;
        var t = this.s.b, r = function(e, t, r) {
            var n = e.length;
            if (!n || r && r.f && !r.l) return t || new Cs(0);
            var i = !t || r, s = !r || r.i;
            r || (r = {}), t || (t = new Cs(3 * n));
            var a = function(e) {
                var r = t.length;
                if (e > r) {
                    var n = new Cs(Math.max(2 * r, e));
                    n.set(t), t = n;
                }
            }, o = r.f || 0, c = r.p || 0, h = r.b || 0, u = r.l, l = r.d, y = r.m, f = r.n, g = 8 * n;
            do {
                if (!u) {
                    o = $s(e, c, 1);
                    var p = $s(e, c + 1, 3);
                    if (c += 3, !p) {
                        var d = e[(K = ea(c) + 4) - 4] | e[K - 3] << 8, A = K + d;
                        if (A > n) {
                            s && na(0);
                            break;
                        }
                        i && a(h + d), t.set(e.subarray(K, A), h), r.b = h += d, r.p = c = 8 * A, r.f = o;
                        continue;
                    }
                    if (1 == p) u = Js, l = Zs, y = 9, f = 5;
                    else if (2 == p) {
                        var w = $s(e, c, 31) + 257, m = $s(e, c + 10, 15) + 4, b = w + $s(e, c + 5, 31) + 1;
                        c += 14;
                        for(var k = new Cs(b), E = new Cs(19), v = 0; v < m; ++v)E[Qs[v]] = $s(e, c + 3 * v, 7);
                        c += 3 * m;
                        var I = Ws(E), B = (1 << I) - 1, S = _s(E, I, 1);
                        for(v = 0; v < b;){
                            var K, C = S[$s(e, c, B)];
                            if (c += 15 & C, (K = C >>> 4) < 16) k[v++] = K;
                            else {
                                var D = 0, U = 0;
                                for(16 == K ? (U = 3 + $s(e, c, 3), c += 2, D = k[v - 1]) : 17 == K ? (U = 3 + $s(e, c, 7), c += 3) : 18 == K && (U = 11 + $s(e, c, 127), c += 7); U--;)k[v++] = D;
                            }
                        }
                        var P = k.subarray(0, w), x = k.subarray(w);
                        y = Ws(P), f = Ws(x), u = _s(P, y, 1), l = _s(x, f, 1);
                    } else na(1);
                    if (c > g) {
                        s && na(0);
                        break;
                    }
                }
                i && a(h + 131072);
                for(var Q = (1 << y) - 1, R = (1 << f) - 1, T = c;; T = c){
                    var L = (D = u[Xs(e, c) & Q]) >>> 4;
                    if ((c += 15 & D) > g) {
                        s && na(0);
                        break;
                    }
                    if (D || na(2), L < 256) t[h++] = L;
                    else {
                        if (256 == L) {
                            T = c, u = null;
                            break;
                        }
                        var M = L - 254;
                        if (L > 264) {
                            var N = Ps[v = L - 257];
                            M = $s(e, c, (1 << N) - 1) + Ls[v], c += N;
                        }
                        var F = l[Xs(e, c) & R], O = F >>> 4;
                        if (F || na(3), c += 15 & F, x = Fs[O], O > 3 && (N = xs[O], x += Xs(e, c) & (1 << N) - 1, c += N), c > g) {
                            s && na(0);
                            break;
                        }
                        i && a(h + 131072);
                        for(var H = h + M; h < H; h += 4)t[h] = t[h - x], t[h + 1] = t[h + 1 - x], t[h + 2] = t[h + 2 - x], t[h + 3] = t[h + 3 - x];
                        h = H;
                    }
                }
                r.l = u, r.p = T, r.b = h, r.f = o, u && (o = 1, r.m = y, r.d = l, r.n = f);
            }while (!o);
            return h == t.length ? t : ta(t, 0, h);
        }(this.p, this.o, this.s);
        this.ondata(ta(r, t, this.s.b), this.d), this.o = ta(r, this.s.b - 32768), this.s.b = this.o.length, this.p = ta(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    }, e.prototype.push = function(e, t) {
        this.e(e), this.c(t);
    }, e;
}(), Aa = /*#__PURE__*/ function() {
    function e(e, t) {
        var r, n;
        this.c = (r = 1, n = 0, {
            p: function(e) {
                for(var t = r, i = n, s = 0 | e.length, a = 0; a != s;){
                    for(var o = Math.min(a + 2655, s); a < o; ++a)i += t += e[a];
                    t = (65535 & t) + 15 * (t >> 16), i = (65535 & i) + 15 * (i >> 16);
                }
                r = t, n = i;
            },
            d: function() {
                return (255 & (r %= 65521)) << 24 | r >>> 8 << 16 | (255 & (n %= 65521)) << 8 | n >>> 8;
            }
        }), this.v = 1, pa.call(this, e, t);
    }
    return e.prototype.push = function(e, t) {
        pa.prototype.push.call(this, e, t);
    }, e.prototype.p = function(e, t) {
        this.c.p(e);
        var r = ga(e, this.o, this.v && 2, t && 4, !t);
        this.v && (function(e, t) {
            var r = t.level, n = 0 == r ? 0 : r < 6 ? 1 : 9 == r ? 3 : 2;
            e[0] = 120, e[1] = n << 6 | (n ? 32 - 2 * n : 1);
        }(r, this.o), this.v = 0), t && function(e, t, r) {
            for(; r; ++t)e[t] = r, r >>>= 8;
        }(r, r.length - 4, this.c.d()), this.ondata(r, t);
    }, e;
}(), wa = /*#__PURE__*/ function() {
    function e(e) {
        this.v = 1, da.call(this, e);
    }
    return e.prototype.push = function(e, t) {
        if (da.prototype.e.call(this, e), this.v) {
            if (this.p.length < 2 && !t) return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        t && (this.p.length < 4 && na(6, "invalid zlib data"), this.p = this.p.subarray(0, -4)), da.prototype.c.call(this, t);
    }, e;
}(), ma = "undefined" != typeof TextDecoder && /*#__PURE__*/ new TextDecoder;
try {
    ma.decode(fa, {
        stream: !0
    });
} catch (e) {}
class ba {
    static get tag() {
        return R.packet.literalData;
    }
    constructor(e = new Date){
        this.format = R.literal.utf8, this.date = M.normalizeDate(e), this.text = null, this.data = null, this.filename = "";
    }
    setText(e, t = R.literal.utf8) {
        this.format = t, this.text = e, this.data = null;
    }
    getText(e = !1) {
        return (null === this.text || M.isStream(this.text)) && (this.text = M.decodeUTF8(M.nativeEOL(this.getBytes(e)))), this.text;
    }
    setBytes(e, t) {
        this.format = t, this.data = e, this.text = null;
    }
    getBytes(e = !1) {
        return null === this.data && (this.data = M.canonicalizeEOL(M.encodeUTF8(this.text))), e ? B(this.data) : this.data;
    }
    setFilename(e) {
        this.filename = e;
    }
    getFilename() {
        return this.filename;
    }
    async read(e) {
        await v(e, async (e)=>{
            const t = await e.readByte(), r = await e.readByte();
            this.filename = M.decodeUTF8(await e.readBytes(r)), this.date = M.readDate(await e.readBytes(4));
            let n = e.remainder();
            o(n) && (n = await C(n)), this.setBytes(n, t);
        });
    }
    writeHeader() {
        const e = M.encodeUTF8(this.filename), t = new Uint8Array([
            e.length
        ]), r = new Uint8Array([
            this.format
        ]), n = M.writeDate(this.date);
        return M.concatUint8Array([
            r,
            t,
            e,
            n
        ]);
    }
    write() {
        const e = this.writeHeader(), t = this.getBytes();
        return M.concat([
            e,
            t
        ]);
    }
}
class ka {
    constructor(){
        this.bytes = "";
    }
    read(e) {
        return this.bytes = M.uint8ArrayToString(e.subarray(0, 8)), this.bytes.length;
    }
    write() {
        return M.stringToUint8Array(this.bytes);
    }
    toHex() {
        return M.uint8ArrayToHex(M.stringToUint8Array(this.bytes));
    }
    equals(e, t = !1) {
        return t && (e.isWildcard() || this.isWildcard()) || this.bytes === e.bytes;
    }
    isNull() {
        return "" === this.bytes;
    }
    isWildcard() {
        return /^0+$/.test(this.toHex());
    }
    static mapToHex(e) {
        return e.toHex();
    }
    static fromID(e) {
        const t = new ka;
        return t.read(M.hexToUint8Array(e)), t;
    }
    static wildcard() {
        const e = new ka;
        return e.read(new Uint8Array(8)), e;
    }
}
const Ea = Symbol("verified"), va = "salt@notations.openpgpjs.org", Ia = new Set([
    R.signatureSubpacket.issuerKeyID,
    R.signatureSubpacket.issuerFingerprint,
    R.signatureSubpacket.embeddedSignature
]);
class Ba {
    static get tag() {
        return R.packet.signature;
    }
    constructor(){
        this.version = null, this.signatureType = null, this.hashAlgorithm = null, this.publicKeyAlgorithm = null, this.signatureData = null, this.unhashedSubpackets = [], this.unknownSubpackets = [], this.signedHashValue = null, this.salt = null, this.created = null, this.signatureExpirationTime = null, this.signatureNeverExpires = !0, this.exportable = null, this.trustLevel = null, this.trustAmount = null, this.regularExpression = null, this.revocable = null, this.keyExpirationTime = null, this.keyNeverExpires = null, this.preferredSymmetricAlgorithms = null, this.revocationKeyClass = null, this.revocationKeyAlgorithm = null, this.revocationKeyFingerprint = null, this.issuerKeyID = new ka, this.rawNotations = [], this.notations = {}, this.preferredHashAlgorithms = null, this.preferredCompressionAlgorithms = null, this.keyServerPreferences = null, this.preferredKeyServer = null, this.isPrimaryUserID = null, this.policyURI = null, this.keyFlags = null, this.signersUserID = null, this.reasonForRevocationFlag = null, this.reasonForRevocationString = null, this.features = null, this.signatureTargetPublicKeyAlgorithm = null, this.signatureTargetHashAlgorithm = null, this.signatureTargetHash = null, this.embeddedSignature = null, this.issuerKeyVersion = null, this.issuerFingerprint = null, this.preferredAEADAlgorithms = null, this.preferredCipherSuites = null, this.revoked = null, this[Ea] = null;
    }
    read(e, t = T) {
        let r = 0;
        if (this.version = e[r++], 5 === this.version && !t.enableParsingV5Entities) throw new Yt("Support for v5 entities is disabled; turn on `config.enableParsingV5Entities` if needed");
        if (4 !== this.version && 5 !== this.version && 6 !== this.version) throw new Yt(`Version ${this.version} of the signature packet is unsupported.`);
        if (this.signatureType = e[r++], this.publicKeyAlgorithm = e[r++], this.hashAlgorithm = e[r++], r += this.readSubPackets(e.subarray(r, e.length), !0), !this.created) throw Error("Missing signature creation time subpacket.");
        if (this.signatureData = e.subarray(0, r), r += this.readSubPackets(e.subarray(r, e.length), !1), this.signedHashValue = e.subarray(r, r + 2), r += 2, 6 === this.version) {
            const t = e[r++];
            this.salt = e.subarray(r, r + t), r += t;
        }
        const n = e.subarray(r, e.length), { read: i, signatureParams: s } = function(e, t) {
            let r = 0;
            switch(e){
                case R.publicKey.rsaEncryptSign:
                case R.publicKey.rsaEncrypt:
                case R.publicKey.rsaSign:
                    {
                        const e = M.readMPI(t.subarray(r));
                        return r += e.length + 2, {
                            read: r,
                            signatureParams: {
                                s: e
                            }
                        };
                    }
                case R.publicKey.dsa:
                case R.publicKey.ecdsa:
                    {
                        const e = M.readMPI(t.subarray(r));
                        r += e.length + 2;
                        const n = M.readMPI(t.subarray(r));
                        return r += n.length + 2, {
                            read: r,
                            signatureParams: {
                                r: e,
                                s: n
                            }
                        };
                    }
                case R.publicKey.eddsaLegacy:
                    {
                        const e = M.readMPI(t.subarray(r));
                        r += e.length + 2;
                        const n = M.readMPI(t.subarray(r));
                        return r += n.length + 2, {
                            read: r,
                            signatureParams: {
                                r: e,
                                s: n
                            }
                        };
                    }
                case R.publicKey.ed25519:
                case R.publicKey.ed448:
                    {
                        const n = 2 * rr(e), i = M.readExactSubarray(t, r, r + n);
                        return r += i.length, {
                            read: r,
                            signatureParams: {
                                RS: i
                            }
                        };
                    }
                default:
                    throw new Yt("Unknown signature algorithm.");
            }
        }(this.publicKeyAlgorithm, n);
        if (i < n.length) throw Error("Error reading MPIs");
        this.params = s;
    }
    writeParams() {
        return this.params instanceof Promise ? U(async ()=>bi(this.publicKeyAlgorithm, await this.params)) : bi(this.publicKeyAlgorithm, this.params);
    }
    write() {
        const e = [];
        return e.push(this.signatureData), e.push(this.writeUnhashedSubPackets()), e.push(this.signedHashValue), 6 === this.version && (e.push(new Uint8Array([
            this.salt.length
        ])), e.push(this.salt)), e.push(this.writeParams()), M.concat(e);
    }
    async sign(e, t, r = new Date, n = !1, i) {
        this.version = e.version, this.created = M.normalizeDate(r), this.issuerKeyVersion = e.version, this.issuerFingerprint = e.getFingerprintBytes(), this.issuerKeyID = e.getKeyID();
        const s = [
            new Uint8Array([
                this.version,
                this.signatureType,
                this.publicKeyAlgorithm,
                this.hashAlgorithm
            ])
        ];
        if (6 === this.version) {
            const e = Ka(this.hashAlgorithm);
            if (null === this.salt) this.salt = fe(e);
            else if (e !== this.salt.length) throw Error("Provided salt does not have the required length");
        } else if (i.nonDeterministicSignaturesViaNotation) {
            if (0 !== this.rawNotations.filter(({ name: e })=>e === va).length) throw Error("Unexpected existing salt notation");
            {
                const e = fe(Ka(this.hashAlgorithm));
                this.rawNotations.push({
                    name: va,
                    value: e,
                    humanReadable: !1,
                    critical: !1
                });
            }
        }
        s.push(this.writeHashedSubPackets()), this.unhashedSubpackets = [], this.signatureData = M.concat(s);
        const a = this.toHash(this.signatureType, t, n), o = await this.hash(this.signatureType, t, a, n);
        this.signedHashValue = K(I(o), 0, 2);
        const c = async ()=>ms(this.publicKeyAlgorithm, this.hashAlgorithm, e.publicParams, e.privateParams, a, await C(o));
        M.isStream(o) ? this.params = c() : (this.params = await c(), this[Ea] = !0);
    }
    writeHashedSubPackets() {
        const e = R.signatureSubpacket, t = [];
        let r;
        if (null === this.created) throw Error("Missing signature creation time");
        t.push(Sa(e.signatureCreationTime, !0, M.writeDate(this.created))), null !== this.signatureExpirationTime && t.push(Sa(e.signatureExpirationTime, !0, M.writeNumber(this.signatureExpirationTime, 4))), null !== this.exportable && t.push(Sa(e.exportableCertification, !0, new Uint8Array([
            this.exportable ? 1 : 0
        ]))), null !== this.trustLevel && (r = new Uint8Array([
            this.trustLevel,
            this.trustAmount
        ]), t.push(Sa(e.trustSignature, !0, r))), null !== this.regularExpression && t.push(Sa(e.regularExpression, !0, this.regularExpression)), null !== this.revocable && t.push(Sa(e.revocable, !0, new Uint8Array([
            this.revocable ? 1 : 0
        ]))), null !== this.keyExpirationTime && t.push(Sa(e.keyExpirationTime, !0, M.writeNumber(this.keyExpirationTime, 4))), null !== this.preferredSymmetricAlgorithms && (r = M.stringToUint8Array(M.uint8ArrayToString(this.preferredSymmetricAlgorithms)), t.push(Sa(e.preferredSymmetricAlgorithms, !1, r))), null !== this.revocationKeyClass && (r = new Uint8Array([
            this.revocationKeyClass,
            this.revocationKeyAlgorithm
        ]), r = M.concat([
            r,
            this.revocationKeyFingerprint
        ]), t.push(Sa(e.revocationKey, !1, r))), !this.issuerKeyID.isNull() && this.issuerKeyVersion < 5 && t.push(Sa(e.issuerKeyID, !0, this.issuerKeyID.write())), this.rawNotations.forEach(({ name: n, value: i, humanReadable: s, critical: a })=>{
            r = [
                new Uint8Array([
                    s ? 128 : 0,
                    0,
                    0,
                    0
                ])
            ];
            const o = M.encodeUTF8(n);
            r.push(M.writeNumber(o.length, 2)), r.push(M.writeNumber(i.length, 2)), r.push(o), r.push(i), r = M.concat(r), t.push(Sa(e.notationData, a, r));
        }), null !== this.preferredHashAlgorithms && (r = M.stringToUint8Array(M.uint8ArrayToString(this.preferredHashAlgorithms)), t.push(Sa(e.preferredHashAlgorithms, !1, r))), null !== this.preferredCompressionAlgorithms && (r = M.stringToUint8Array(M.uint8ArrayToString(this.preferredCompressionAlgorithms)), t.push(Sa(e.preferredCompressionAlgorithms, !1, r))), null !== this.keyServerPreferences && (r = M.stringToUint8Array(M.uint8ArrayToString(this.keyServerPreferences)), t.push(Sa(e.keyServerPreferences, !1, r))), null !== this.preferredKeyServer && t.push(Sa(e.preferredKeyServer, !1, M.encodeUTF8(this.preferredKeyServer))), null !== this.isPrimaryUserID && t.push(Sa(e.primaryUserID, !1, new Uint8Array([
            this.isPrimaryUserID ? 1 : 0
        ]))), null !== this.policyURI && t.push(Sa(e.policyURI, !1, M.encodeUTF8(this.policyURI))), null !== this.keyFlags && (r = M.stringToUint8Array(M.uint8ArrayToString(this.keyFlags)), t.push(Sa(e.keyFlags, !0, r))), null !== this.signersUserID && t.push(Sa(e.signersUserID, !1, M.encodeUTF8(this.signersUserID))), null !== this.reasonForRevocationFlag && (r = M.stringToUint8Array(String.fromCharCode(this.reasonForRevocationFlag) + this.reasonForRevocationString), t.push(Sa(e.reasonForRevocation, !0, r))), null !== this.features && (r = M.stringToUint8Array(M.uint8ArrayToString(this.features)), t.push(Sa(e.features, !1, r))), null !== this.signatureTargetPublicKeyAlgorithm && (r = [
            new Uint8Array([
                this.signatureTargetPublicKeyAlgorithm,
                this.signatureTargetHashAlgorithm
            ])
        ], r.push(M.stringToUint8Array(this.signatureTargetHash)), r = M.concat(r), t.push(Sa(e.signatureTarget, !0, r))), null !== this.embeddedSignature && t.push(Sa(e.embeddedSignature, !0, this.embeddedSignature.write())), null !== this.issuerFingerprint && (r = [
            new Uint8Array([
                this.issuerKeyVersion
            ]),
            this.issuerFingerprint
        ], r = M.concat(r), t.push(Sa(e.issuerFingerprint, this.version >= 5, r))), null !== this.preferredAEADAlgorithms && (r = M.stringToUint8Array(M.uint8ArrayToString(this.preferredAEADAlgorithms)), t.push(Sa(e.preferredAEADAlgorithms, !1, r))), null !== this.preferredCipherSuites && (r = new Uint8Array([].concat(...this.preferredCipherSuites)), t.push(Sa(e.preferredCipherSuites, !1, r)));
        const n = M.concat(t), i = M.writeNumber(n.length, 6 === this.version ? 4 : 2);
        return M.concat([
            i,
            n
        ]);
    }
    writeUnhashedSubPackets() {
        const e = this.unhashedSubpackets.map(({ type: e, critical: t, body: r })=>Sa(e, t, r)), t = M.concat(e), r = M.writeNumber(t.length, 6 === this.version ? 4 : 2);
        return M.concat([
            r,
            t
        ]);
    }
    readSubPacket(e, t = !0) {
        let r = 0;
        const n = !!(128 & e[r]), i = 127 & e[r];
        if (r++, t || (this.unhashedSubpackets.push({
            type: i,
            critical: n,
            body: e.subarray(r, e.length)
        }), Ia.has(i))) switch(i){
            case R.signatureSubpacket.signatureCreationTime:
                this.created = M.readDate(e.subarray(r, e.length));
                break;
            case R.signatureSubpacket.signatureExpirationTime:
                {
                    const t = M.readNumber(e.subarray(r, e.length));
                    this.signatureNeverExpires = 0 === t, this.signatureExpirationTime = t;
                    break;
                }
            case R.signatureSubpacket.exportableCertification:
                this.exportable = 1 === e[r++];
                break;
            case R.signatureSubpacket.trustSignature:
                this.trustLevel = e[r++], this.trustAmount = e[r++];
                break;
            case R.signatureSubpacket.regularExpression:
                this.regularExpression = e[r];
                break;
            case R.signatureSubpacket.revocable:
                this.revocable = 1 === e[r++];
                break;
            case R.signatureSubpacket.keyExpirationTime:
                {
                    const t = M.readNumber(e.subarray(r, e.length));
                    this.keyExpirationTime = t, this.keyNeverExpires = 0 === t;
                    break;
                }
            case R.signatureSubpacket.preferredSymmetricAlgorithms:
                this.preferredSymmetricAlgorithms = [
                    ...e.subarray(r, e.length)
                ];
                break;
            case R.signatureSubpacket.revocationKey:
                this.revocationKeyClass = e[r++], this.revocationKeyAlgorithm = e[r++], this.revocationKeyFingerprint = e.subarray(r, r + 20);
                break;
            case R.signatureSubpacket.issuerKeyID:
                if (4 === this.version) this.issuerKeyID.read(e.subarray(r, e.length));
                else if (t) throw Error("Unexpected Issuer Key ID subpacket");
                break;
            case R.signatureSubpacket.notationData:
                {
                    const t = !!(128 & e[r]);
                    r += 4;
                    const i = M.readNumber(e.subarray(r, r + 2));
                    r += 2;
                    const s = M.readNumber(e.subarray(r, r + 2));
                    r += 2;
                    const a = M.decodeUTF8(e.subarray(r, r + i)), o = e.subarray(r + i, r + i + s);
                    this.rawNotations.push({
                        name: a,
                        humanReadable: t,
                        value: o,
                        critical: n
                    }), t && (this.notations[a] = M.decodeUTF8(o));
                    break;
                }
            case R.signatureSubpacket.preferredHashAlgorithms:
                this.preferredHashAlgorithms = [
                    ...e.subarray(r, e.length)
                ];
                break;
            case R.signatureSubpacket.preferredCompressionAlgorithms:
                this.preferredCompressionAlgorithms = [
                    ...e.subarray(r, e.length)
                ];
                break;
            case R.signatureSubpacket.keyServerPreferences:
                this.keyServerPreferences = [
                    ...e.subarray(r, e.length)
                ];
                break;
            case R.signatureSubpacket.preferredKeyServer:
                this.preferredKeyServer = M.decodeUTF8(e.subarray(r, e.length));
                break;
            case R.signatureSubpacket.primaryUserID:
                this.isPrimaryUserID = 0 !== e[r++];
                break;
            case R.signatureSubpacket.policyURI:
                this.policyURI = M.decodeUTF8(e.subarray(r, e.length));
                break;
            case R.signatureSubpacket.keyFlags:
                this.keyFlags = [
                    ...e.subarray(r, e.length)
                ];
                break;
            case R.signatureSubpacket.signersUserID:
                this.signersUserID = M.decodeUTF8(e.subarray(r, e.length));
                break;
            case R.signatureSubpacket.reasonForRevocation:
                this.reasonForRevocationFlag = e[r++], this.reasonForRevocationString = M.decodeUTF8(e.subarray(r, e.length));
                break;
            case R.signatureSubpacket.features:
                this.features = [
                    ...e.subarray(r, e.length)
                ];
                break;
            case R.signatureSubpacket.signatureTarget:
                {
                    this.signatureTargetPublicKeyAlgorithm = e[r++], this.signatureTargetHashAlgorithm = e[r++];
                    const t = Re(this.signatureTargetHashAlgorithm);
                    this.signatureTargetHash = M.uint8ArrayToString(e.subarray(r, r + t));
                    break;
                }
            case R.signatureSubpacket.embeddedSignature:
                this.embeddedSignature = new Ba, this.embeddedSignature.read(e.subarray(r, e.length));
                break;
            case R.signatureSubpacket.issuerFingerprint:
                this.issuerKeyVersion = e[r++], this.issuerFingerprint = e.subarray(r, e.length), this.issuerKeyVersion >= 5 ? this.issuerKeyID.read(this.issuerFingerprint) : this.issuerKeyID.read(this.issuerFingerprint.subarray(-8));
                break;
            case R.signatureSubpacket.preferredAEADAlgorithms:
                this.preferredAEADAlgorithms = [
                    ...e.subarray(r, e.length)
                ];
                break;
            case R.signatureSubpacket.preferredCipherSuites:
                this.preferredCipherSuites = [];
                for(let t = r; t < e.length; t += 2)this.preferredCipherSuites.push([
                    e[t],
                    e[t + 1]
                ]);
                break;
            default:
                this.unknownSubpackets.push({
                    type: i,
                    critical: n,
                    body: e.subarray(r, e.length)
                });
        }
    }
    readSubPackets(e, t = !0, r) {
        const n = 6 === this.version ? 4 : 2, i = M.readNumber(e.subarray(0, n));
        let s = n;
        for(; s < 2 + i;){
            const n = zt(e.subarray(s, e.length));
            s += n.offset, this.readSubPacket(e.subarray(s, s + n.len), t, r), s += n.len;
        }
        return s;
    }
    toSign(e, t) {
        const r = R.signature;
        switch(e){
            case r.binary:
                return null !== t.text ? M.encodeUTF8(t.getText(!0)) : t.getBytes(!0);
            case r.text:
                {
                    const e = t.getBytes(!0);
                    return M.canonicalizeEOL(e);
                }
            case r.standalone:
                return new Uint8Array(0);
            case r.certGeneric:
            case r.certPersona:
            case r.certCasual:
            case r.certPositive:
            case r.certRevocation:
                {
                    let e, n;
                    if (t.userID) n = 180, e = t.userID;
                    else {
                        if (!t.userAttribute) throw Error("Either a userID or userAttribute packet needs to be supplied for certification.");
                        n = 209, e = t.userAttribute;
                    }
                    const i = e.write();
                    return M.concat([
                        this.toSign(r.key, t),
                        new Uint8Array([
                            n
                        ]),
                        M.writeNumber(i.length, 4),
                        i
                    ]);
                }
            case r.subkeyBinding:
            case r.subkeyRevocation:
            case r.keyBinding:
                return M.concat([
                    this.toSign(r.key, t),
                    this.toSign(r.key, {
                        key: t.bind
                    })
                ]);
            case r.key:
                if (void 0 === t.key) throw Error("Key packet is required for this signature.");
                return t.key.writeForHash(this.version);
            case r.keyRevocation:
                return this.toSign(r.key, t);
            case r.timestamp:
                return new Uint8Array(0);
            case r.thirdParty:
                throw Error("Not implemented");
            default:
                throw Error("Unknown signature type.");
        }
    }
    calculateTrailer(e, t) {
        let r = 0;
        return k(I(this.signatureData), (e)=>{
            r += e.length;
        }, ()=>{
            const n = [];
            return 5 !== this.version || this.signatureType !== R.signature.binary && this.signatureType !== R.signature.text || (t ? n.push(new Uint8Array(6)) : n.push(e.writeHeader())), n.push(new Uint8Array([
                this.version,
                255
            ])), 5 === this.version && n.push(new Uint8Array(4)), n.push(M.writeNumber(r, 4)), M.concat(n);
        });
    }
    toHash(e, t, r = !1) {
        const n = this.toSign(e, t);
        return M.concat([
            this.salt || new Uint8Array,
            n,
            this.signatureData,
            this.calculateTrailer(t, r)
        ]);
    }
    async hash(e, t, r, n = !1) {
        if (6 === this.version && this.salt.length !== Ka(this.hashAlgorithm)) throw Error("Signature salt does not have the expected length");
        return r || (r = this.toHash(e, t, n)), Qe(this.hashAlgorithm, r);
    }
    async verify(e, t, r, n = new Date, i = !1, s = T) {
        if (!this.issuerKeyID.equals(e.getKeyID())) throw Error("Signature was not issued by the given public key");
        if (this.publicKeyAlgorithm !== e.algorithm) throw Error("Public key algorithm used to sign signature does not match issuer key algorithm.");
        const a = t === R.signature.binary || t === R.signature.text;
        if (!(this[Ea] && !a)) {
            let n, s;
            if (this.hashed ? s = await this.hashed : (n = this.toHash(t, r, i), s = await this.hash(t, r, n)), s = await C(s), this.signedHashValue[0] !== s[0] || this.signedHashValue[1] !== s[1]) throw Error("Signed digest did not match");
            if (this.params = await this.params, this[Ea] = await ws(this.publicKeyAlgorithm, this.hashAlgorithm, this.params, e.publicParams, n, s), !this[Ea]) throw Error("Signature verification failed");
        }
        const o = M.normalizeDate(n);
        if (o && this.created > o) throw Error("Signature creation time is in the future");
        if (o && o >= this.getExpirationTime()) throw Error("Signature is expired");
        if (s.rejectHashAlgorithms.has(this.hashAlgorithm)) throw Error("Insecure hash algorithm: " + R.read(R.hash, this.hashAlgorithm).toUpperCase());
        if (s.rejectMessageHashAlgorithms.has(this.hashAlgorithm) && [
            R.signature.binary,
            R.signature.text
        ].includes(this.signatureType)) throw Error("Insecure message hash algorithm: " + R.read(R.hash, this.hashAlgorithm).toUpperCase());
        if (this.unknownSubpackets.forEach(({ type: e, critical: t })=>{
            if (t) throw Error("Unknown critical signature subpacket type " + e);
        }), this.rawNotations.forEach(({ name: e, critical: t })=>{
            if (t && s.knownNotations.indexOf(e) < 0) throw Error("Unknown critical notation: " + e);
        }), null !== this.revocationKeyClass) throw Error("This key is intended to be revoked with an authorized key, which OpenPGP.js does not support.");
    }
    isExpired(e = new Date) {
        const t = M.normalizeDate(e);
        return null !== t && !(this.created <= t && t < this.getExpirationTime());
    }
    getExpirationTime() {
        return this.signatureNeverExpires ? 1 / 0 : new Date(this.created.getTime() + 1e3 * this.signatureExpirationTime);
    }
}
function Sa(e, t, r) {
    const n = [];
    return n.push(Gt(r.length + 1)), n.push(new Uint8Array([
        (t ? 128 : 0) | e
    ])), n.push(r), M.concat(n);
}
function Ka(e) {
    switch(e){
        case R.hash.sha256:
            return 16;
        case R.hash.sha384:
            return 24;
        case R.hash.sha512:
            return 32;
        case R.hash.sha224:
        case R.hash.sha3_256:
            return 16;
        case R.hash.sha3_512:
            return 32;
        default:
            throw Error("Unsupported hash function");
    }
}
class Ca {
    static get tag() {
        return R.packet.onePassSignature;
    }
    static fromSignaturePacket(e, t) {
        const r = new Ca;
        return r.version = 6 === e.version ? 6 : 3, r.signatureType = e.signatureType, r.hashAlgorithm = e.hashAlgorithm, r.publicKeyAlgorithm = e.publicKeyAlgorithm, r.issuerKeyID = e.issuerKeyID, r.salt = e.salt, r.issuerFingerprint = e.issuerFingerprint, r.flags = t ? 1 : 0, r;
    }
    constructor(){
        this.version = null, this.signatureType = null, this.hashAlgorithm = null, this.publicKeyAlgorithm = null, this.salt = null, this.issuerKeyID = null, this.issuerFingerprint = null, this.flags = null;
    }
    read(e) {
        let t = 0;
        if (this.version = e[t++], 3 !== this.version && 6 !== this.version) throw new Yt(`Version ${this.version} of the one-pass signature packet is unsupported.`);
        if (this.signatureType = e[t++], this.hashAlgorithm = e[t++], this.publicKeyAlgorithm = e[t++], 6 === this.version) {
            const r = e[t++];
            this.salt = e.subarray(t, t + r), t += r, this.issuerFingerprint = e.subarray(t, t + 32), t += 32, this.issuerKeyID = new ka, this.issuerKeyID.read(this.issuerFingerprint);
        } else this.issuerKeyID = new ka, this.issuerKeyID.read(e.subarray(t, t + 8)), t += 8;
        return this.flags = e[t++], this;
    }
    write() {
        const e = [
            new Uint8Array([
                this.version,
                this.signatureType,
                this.hashAlgorithm,
                this.publicKeyAlgorithm
            ])
        ];
        return 6 === this.version ? e.push(new Uint8Array([
            this.salt.length
        ]), this.salt, this.issuerFingerprint) : e.push(this.issuerKeyID.write()), e.push(new Uint8Array([
            this.flags
        ])), M.concatUint8Array(e);
    }
    calculateTrailer(...e) {
        return U(async ()=>Ba.prototype.calculateTrailer.apply(await this.correspondingSig, e));
    }
    async verify() {
        const e = await this.correspondingSig;
        if (!e || e.constructor.tag !== R.packet.signature) throw Error("Corresponding signature packet missing");
        if (e.signatureType !== this.signatureType || e.hashAlgorithm !== this.hashAlgorithm || e.publicKeyAlgorithm !== this.publicKeyAlgorithm || !e.issuerKeyID.equals(this.issuerKeyID) || 3 === this.version && 6 === e.version || 6 === this.version && 6 !== e.version || 6 === this.version && !M.equalsUint8Array(e.issuerFingerprint, this.issuerFingerprint) || 6 === this.version && !M.equalsUint8Array(e.salt, this.salt)) throw Error("Corresponding signature packet does not match one-pass signature packet");
        return e.hashed = this.hashed, e.verify.apply(e, arguments);
    }
}
function Da(e, t) {
    if (!t[e]) {
        let t;
        try {
            t = R.read(R.packet, e);
        } catch (t) {
            throw new Zt("Unknown packet type with tag: " + e);
        }
        throw Error("Packet not allowed in this context: " + t);
    }
    return new t[e];
}
Ca.prototype.hash = Ba.prototype.hash, Ca.prototype.toHash = Ba.prototype.toHash, Ca.prototype.toSign = Ba.prototype.toSign;
class Ua extends Array {
    static async fromBinary(e, t, r = T) {
        const n = new Ua;
        return await n.read(e, t, r), n;
    }
    async read(e, t, r = T) {
        r.additionalAllowedPackets.length && (t = {
            ...t,
            ...M.constructAllowedPackets(r.additionalAllowedPackets)
        }), this.stream = E(e, async (e, n)=>{
            const i = x(n);
            try {
                for(;;){
                    await i.ready;
                    if (await Jt(e, async (e)=>{
                        try {
                            if (e.tag === R.packet.marker || e.tag === R.packet.trust || e.tag === R.packet.padding) return;
                            const n = Da(e.tag, t);
                            n.packets = new Ua, n.fromStream = M.isStream(e.packet), await n.read(e.packet, r), await i.write(n);
                        } catch (t) {
                            if (t instanceof Zt) {
                                if (!(e.tag <= 39)) return;
                                await i.abort(t);
                            }
                            const n = !r.ignoreUnsupportedPackets && t instanceof Yt, s = !(r.ignoreMalformedPackets || t instanceof Yt);
                            if (n || s || Vt(e.tag)) await i.abort(t);
                            else {
                                const t = new Wt(e.tag, e.packet);
                                await i.write(t);
                            }
                            M.printDebugError(t);
                        }
                    })) return await i.ready, void await i.close();
                }
            } catch (e) {
                await i.abort(e);
            }
        });
        const n = P(this.stream);
        for(;;){
            const { done: e, value: t } = await n.read();
            if (e ? this.stream = null : this.push(t), e || Vt(t.constructor.tag)) break;
        }
        n.releaseLock();
    }
    write() {
        const e = [];
        for(let t = 0; t < this.length; t++){
            const r = this[t] instanceof Wt ? this[t].tag : this[t].constructor.tag, n = this[t].write();
            if (M.isStream(n) && Vt(this[t].constructor.tag)) {
                let t = [], i = 0;
                const s = 512;
                e.push(jt(r)), e.push(k(n, (e)=>{
                    if (t.push(e), i += e.length, i >= s) {
                        const e = Math.min(Math.log(i) / Math.LN2 | 0, 30), r = 2 ** e, n = M.concat([
                            _t(e)
                        ].concat(t));
                        return t = [
                            n.subarray(1 + r)
                        ], i = t[0].length, n.subarray(0, 1 + r);
                    }
                }, ()=>M.concat([
                        Gt(i)
                    ].concat(t))));
            } else {
                if (M.isStream(n)) {
                    let t = 0;
                    e.push(k(I(n), (e)=>{
                        t += e.length;
                    }, ()=>qt(r, t)));
                } else e.push(qt(r, n.length));
                e.push(n);
            }
        }
        return M.concat(e);
    }
    filterByTag(...e) {
        const t = new Ua, r = (e)=>(t)=>e === t;
        for(let n = 0; n < this.length; n++)e.some(r(this[n].constructor.tag)) && t.push(this[n]);
        return t;
    }
    findPacket(e) {
        return this.find((t)=>t.constructor.tag === e);
    }
    indexOfTag(...e) {
        const t = [], r = this, n = (e)=>(t)=>e === t;
        for(let i = 0; i < this.length; i++)e.some(n(r[i].constructor.tag)) && t.push(i);
        return t;
    }
}
const Pa = /*#__PURE__*/ M.constructAllowedPackets([
    ba,
    Ca,
    Ba
]);
class xa {
    static get tag() {
        return R.packet.compressedData;
    }
    constructor(e = T){
        this.packets = null, this.algorithm = e.preferredCompressionAlgorithm, this.compressed = null;
    }
    async read(e, t = T) {
        await v(e, async (e)=>{
            this.algorithm = await e.readByte(), this.compressed = e.remainder(), await this.decompress(t);
        });
    }
    write() {
        return null === this.compressed && this.compress(), M.concat([
            new Uint8Array([
                this.algorithm
            ]),
            this.compressed
        ]);
    }
    async decompress(e = T) {
        const t = R.read(R.compression, this.algorithm), r = Ma[t];
        if (!r) throw Error(t + " decompression not supported");
        this.packets = await Ua.fromBinary(await r(this.compressed), Pa, e);
    }
    compress() {
        const e = R.read(R.compression, this.algorithm), t = La[e];
        if (!t) throw Error(e + " compression not supported");
        this.compressed = t(this.packets.write());
    }
}
function Qa(e, t) {
    return (r)=>{
        if (!M.isStream(r) || o(r)) return U(()=>C(r).then((e)=>new Promise((r, n)=>{
                    const i = new t;
                    i.ondata = (e)=>{
                        r(e);
                    };
                    try {
                        i.push(e, !0);
                    } catch (e) {
                        n(e);
                    }
                })));
        if (e) try {
            const t = e();
            return r.pipeThrough(t);
        } catch (e) {
            if ("TypeError" !== e.name) throw e;
        }
        const n = r.getReader(), i = new t;
        return new ReadableStream({
            async start (e) {
                for(i.ondata = async (t, r)=>{
                    e.enqueue(t), r && e.close();
                };;){
                    const { done: e, value: t } = await n.read();
                    if (e) return void i.push(new Uint8Array, !0);
                    t.length && i.push(t);
                }
            }
        });
    };
}
function Ra() {
    return async function(e) {
        const { decode: t } = await Promise.resolve().then(function() {
            return bf;
        });
        return U(async ()=>t(await C(e)));
    };
}
const Ta = (e)=>({
        compressor: "undefined" != typeof CompressionStream && (()=>new CompressionStream(e)),
        decompressor: "undefined" != typeof DecompressionStream && (()=>new DecompressionStream(e))
    }), La = {
    zip: /*#__PURE__*/ Qa(Ta("deflate-raw").compressor, pa),
    zlib: /*#__PURE__*/ Qa(Ta("deflate").compressor, Aa)
}, Ma = {
    uncompressed: (e)=>e,
    zip: /*#__PURE__*/ Qa(Ta("deflate-raw").decompressor, da),
    zlib: /*#__PURE__*/ Qa(Ta("deflate").decompressor, wa),
    bzip2: /*#__PURE__*/ Ra()
}, Na = /*#__PURE__*/ M.constructAllowedPackets([
    ba,
    xa,
    Ca,
    Ba
]);
class Fa {
    static get tag() {
        return R.packet.symEncryptedIntegrityProtectedData;
    }
    static fromObject({ version: e, aeadAlgorithm: t }) {
        if (1 !== e && 2 !== e) throw Error("Unsupported SEIPD version");
        const r = new Fa;
        return r.version = e, 2 === e && (r.aeadAlgorithm = t), r;
    }
    constructor(){
        this.version = null, this.cipherAlgorithm = null, this.aeadAlgorithm = null, this.chunkSizeByte = null, this.salt = null, this.encrypted = null, this.packets = null;
    }
    async read(e) {
        await v(e, async (e)=>{
            if (this.version = await e.readByte(), 1 !== this.version && 2 !== this.version) throw new Yt(`Version ${this.version} of the SEIP packet is unsupported.`);
            2 === this.version && (this.cipherAlgorithm = await e.readByte(), this.aeadAlgorithm = await e.readByte(), this.chunkSizeByte = await e.readByte(), this.salt = await e.readBytes(32)), this.encrypted = e.remainder();
        });
    }
    write() {
        return 2 === this.version ? M.concat([
            new Uint8Array([
                this.version,
                this.cipherAlgorithm,
                this.aeadAlgorithm,
                this.chunkSizeByte
            ]),
            this.salt,
            this.encrypted
        ]) : M.concat([
            new Uint8Array([
                this.version
            ]),
            this.encrypted
        ]);
    }
    async encrypt(e, t, r = T) {
        const { blockSize: n, keySize: i } = fn(e);
        if (t.length !== i) throw Error("Unexpected session key size");
        let s = this.packets.write();
        if (o(s) && (s = await C(s)), 2 === this.version) this.cipherAlgorithm = e, this.salt = fe(32), this.chunkSizeByte = r.aeadChunkSizeByte, this.encrypted = await Oa(this, "encrypt", t, s);
        else {
            const r = await Ui(e), i = new Uint8Array([
                211,
                20
            ]), a = M.concat([
                r,
                s,
                i
            ]), o = await Qe(R.hash.sha1, B(a)), c = M.concat([
                a,
                o
            ]);
            this.encrypted = await Pi(e, t, c, new Uint8Array(n));
        }
        return !0;
    }
    async decrypt(e, t, r = T) {
        if (t.length !== fn(e).keySize) throw Error("Unexpected session key size");
        let n, i = I(this.encrypted);
        if (o(i) && (i = await C(i)), 2 === this.version) {
            if (this.cipherAlgorithm !== e) throw Error("Unexpected session key algorithm");
            n = await Oa(this, "decrypt", t, i);
        } else {
            const { blockSize: s } = fn(e), a = await xi(e, t, i, new Uint8Array(s)), o = K(B(a), -20), c = K(a, 0, -20), h = Promise.all([
                C(await Qe(R.hash.sha1, B(c))),
                C(o)
            ]).then(([e, t])=>{
                if (!M.equalsUint8Array(e, t)) throw Error("Modification detected.");
                return new Uint8Array;
            }), u = K(c, s + 2);
            n = K(u, 0, -2), n = A([
                n,
                U(()=>h)
            ]), M.isStream(i) && r.allowUnauthenticatedStream || (n = await C(n));
        }
        return this.packets = await Ua.fromBinary(n, Na, r), !0;
    }
}
async function Oa(e, t, r, n) {
    const i = e instanceof Fa && 2 === e.version, s = !i && e.constructor.tag === R.packet.aeadEncryptedData;
    if (!i && !s) throw Error("Unexpected packet type");
    const a = As(e.aeadAlgorithm, s), o = "decrypt" === t ? a.tagLength : 0, c = "encrypt" === t ? a.tagLength : 0, h = 2 ** (e.chunkSizeByte + 6) + o, u = s ? 8 : 0, l = new ArrayBuffer(13 + u), y = new Uint8Array(l, 0, 5 + u), f = new Uint8Array(l), g = new DataView(l), p = new Uint8Array(l, 5, 8);
    y.set([
        192 | e.constructor.tag,
        e.version,
        e.cipherAlgorithm,
        e.aeadAlgorithm,
        e.chunkSizeByte
    ], 0);
    let d, A, m = 0, b = Promise.resolve(), k = 0, v = 0;
    if (i) {
        const { keySize: t } = fn(e.cipherAlgorithm), { ivLength: n } = a, i = new Uint8Array(l, 0, 5), s = await wn(R.hash.sha256, r, e.salt, i, t + n);
        r = s.subarray(0, t), d = s.subarray(t), d.fill(0, d.length - 8), A = new DataView(d.buffer, d.byteOffset, d.byteLength);
    } else d = e.iv;
    const I = await a(e.cipherAlgorithm, r);
    return E(n, async (r, n)=>{
        if ("array" !== M.isStream(r)) {
            const t = new TransformStream({}, {
                highWaterMark: M.getHardwareConcurrency() * 2 ** (e.chunkSizeByte + 6),
                size: (e)=>e.length
            });
            w(t.readable, n), n = t.writable;
        }
        const s = P(r), a = x(n);
        try {
            for(;;){
                let e = await s.readBytes(h + o) || new Uint8Array;
                const r = e.subarray(e.length - o);
                let n, l, w;
                if (e = e.subarray(0, e.length - o), i) w = d;
                else {
                    w = d.slice();
                    for(let e = 0; e < 8; e++)w[d.length - 8 + e] ^= p[e];
                }
                if (!m || e.length ? (s.unshift(r), n = I[t](e, w, y), n.catch(()=>{}), v += e.length - o + c) : (g.setInt32(5 + u + 4, k), n = I[t](r, w, f), n.catch(()=>{}), v += c, l = !0), k += e.length - o, b = b.then(()=>n).then(async (e)=>{
                    await a.ready, await a.write(e), v -= e.length;
                }).catch((e)=>a.abort(e)), (l || v > a.desiredSize) && await b, l) {
                    await a.close();
                    break;
                }
                i ? A.setInt32(d.length - 4, ++m) : g.setInt32(9, ++m);
            }
        } catch (e) {
            await a.ready.catch(()=>{}), await a.abort(e);
        }
    });
}
const Ha = /*#__PURE__*/ M.constructAllowedPackets([
    ba,
    xa,
    Ca,
    Ba
]);
class za {
    static get tag() {
        return R.packet.aeadEncryptedData;
    }
    constructor(){
        this.version = 1, this.cipherAlgorithm = null, this.aeadAlgorithm = R.aead.eax, this.chunkSizeByte = null, this.iv = null, this.encrypted = null, this.packets = null;
    }
    async read(e) {
        await v(e, async (e)=>{
            const t = await e.readByte();
            if (1 !== t) throw new Yt(`Version ${t} of the AEAD-encrypted data packet is not supported.`);
            this.cipherAlgorithm = await e.readByte(), this.aeadAlgorithm = await e.readByte(), this.chunkSizeByte = await e.readByte();
            const r = As(this.aeadAlgorithm, !0);
            this.iv = await e.readBytes(r.ivLength), this.encrypted = e.remainder();
        });
    }
    write() {
        return M.concat([
            new Uint8Array([
                this.version,
                this.cipherAlgorithm,
                this.aeadAlgorithm,
                this.chunkSizeByte
            ]),
            this.iv,
            this.encrypted
        ]);
    }
    async decrypt(e, t, r = T) {
        this.packets = await Ua.fromBinary(await Oa(this, "decrypt", t, I(this.encrypted)), Ha, r);
    }
    async encrypt(e, t, r = T) {
        this.cipherAlgorithm = e;
        const { ivLength: n } = As(this.aeadAlgorithm, !0);
        this.iv = fe(n), this.chunkSizeByte = r.aeadChunkSizeByte;
        const i = this.packets.write();
        this.encrypted = await Oa(this, "encrypt", t, i);
    }
}
class Ga {
    static get tag() {
        return R.packet.publicKeyEncryptedSessionKey;
    }
    constructor(){
        this.version = null, this.publicKeyID = new ka, this.publicKeyVersion = null, this.publicKeyFingerprint = null, this.publicKeyAlgorithm = null, this.sessionKey = null, this.sessionKeyAlgorithm = null, this.encrypted = {};
    }
    static fromObject({ version: e, encryptionKeyPacket: t, anonymousRecipient: r, sessionKey: n, sessionKeyAlgorithm: i }) {
        const s = new Ga;
        if (3 !== e && 6 !== e) throw Error("Unsupported PKESK version");
        return s.version = e, 6 === e && (s.publicKeyVersion = r ? null : t.version, s.publicKeyFingerprint = r ? null : t.getFingerprintBytes()), s.publicKeyID = r ? ka.wildcard() : t.getKeyID(), s.publicKeyAlgorithm = t.algorithm, s.sessionKey = n, s.sessionKeyAlgorithm = i, s;
    }
    read(e) {
        let t = 0;
        if (this.version = e[t++], 3 !== this.version && 6 !== this.version) throw new Yt(`Version ${this.version} of the PKESK packet is unsupported.`);
        if (6 === this.version) {
            const r = e[t++];
            if (r) {
                this.publicKeyVersion = e[t++];
                const n = r - 1;
                this.publicKeyFingerprint = e.subarray(t, t + n), t += n, this.publicKeyVersion >= 5 ? this.publicKeyID.read(this.publicKeyFingerprint) : this.publicKeyID.read(this.publicKeyFingerprint.subarray(-8));
            } else this.publicKeyID = ka.wildcard();
        } else t += this.publicKeyID.read(e.subarray(t, t + 8));
        if (this.publicKeyAlgorithm = e[t++], this.encrypted = function(e, t) {
            let r = 0;
            switch(e){
                case R.publicKey.rsaEncrypt:
                case R.publicKey.rsaEncryptSign:
                    return {
                        c: M.readMPI(t.subarray(r))
                    };
                case R.publicKey.elgamal:
                    {
                        const e = M.readMPI(t.subarray(r));
                        return r += e.length + 2, {
                            c1: e,
                            c2: M.readMPI(t.subarray(r))
                        };
                    }
                case R.publicKey.ecdh:
                    {
                        const e = M.readMPI(t.subarray(r));
                        r += e.length + 2;
                        const n = new gi;
                        return n.read(t.subarray(r)), {
                            V: e,
                            C: n
                        };
                    }
                case R.publicKey.x25519:
                case R.publicKey.x448:
                    {
                        const n = Bi(e), i = M.readExactSubarray(t, r, r + n);
                        r += i.length;
                        const s = new di;
                        return s.read(t.subarray(r)), {
                            ephemeralPublicKey: i,
                            C: s
                        };
                    }
                default:
                    throw new Yt("Unknown public key encryption algorithm.");
            }
        }(this.publicKeyAlgorithm, e.subarray(t)), this.publicKeyAlgorithm === R.publicKey.x25519 || this.publicKeyAlgorithm === R.publicKey.x448) {
            if (3 === this.version) this.sessionKeyAlgorithm = R.write(R.symmetric, this.encrypted.C.algorithm);
            else if (null !== this.encrypted.C.algorithm) throw Error("Unexpected cleartext symmetric algorithm");
        }
    }
    write() {
        const e = [
            new Uint8Array([
                this.version
            ])
        ];
        return 6 === this.version ? null !== this.publicKeyFingerprint ? (e.push(new Uint8Array([
            this.publicKeyFingerprint.length + 1,
            this.publicKeyVersion
        ])), e.push(this.publicKeyFingerprint)) : e.push(new Uint8Array([
            0
        ])) : e.push(this.publicKeyID.write()), e.push(new Uint8Array([
            this.publicKeyAlgorithm
        ]), bi(this.publicKeyAlgorithm, this.encrypted)), M.concatUint8Array(e);
    }
    async encrypt(e) {
        const t = R.write(R.publicKey, this.publicKeyAlgorithm), r = 3 === this.version ? this.sessionKeyAlgorithm : null, n = 5 === e.version ? e.getFingerprintBytes().subarray(0, 20) : e.getFingerprintBytes(), i = _a(this.version, t, r, this.sessionKey);
        this.encrypted = await Ai(t, r, e.publicParams, i, n);
    }
    async decrypt(e, t) {
        if (this.publicKeyAlgorithm !== e.algorithm) throw Error("Decryption error");
        const r = t ? _a(this.version, this.publicKeyAlgorithm, t.sessionKeyAlgorithm, t.sessionKey) : null, n = 5 === e.version ? e.getFingerprintBytes().subarray(0, 20) : e.getFingerprintBytes(), i = await wi(this.publicKeyAlgorithm, e.publicParams, e.privateParams, this.encrypted, n, r), { sessionKey: s, sessionKeyAlgorithm: a } = function(e, t, r, n) {
            switch(t){
                case R.publicKey.rsaEncrypt:
                case R.publicKey.rsaEncryptSign:
                case R.publicKey.elgamal:
                case R.publicKey.ecdh:
                    {
                        const t = r.subarray(0, r.length - 2), i = r.subarray(r.length - 2), s = M.writeChecksum(t.subarray(t.length % 8)), a = s[0] === i[0] & s[1] === i[1], o = 6 === e ? {
                            sessionKeyAlgorithm: null,
                            sessionKey: t
                        } : {
                            sessionKeyAlgorithm: t[0],
                            sessionKey: t.subarray(1)
                        };
                        if (n) {
                            const t = a & o.sessionKeyAlgorithm === n.sessionKeyAlgorithm & o.sessionKey.length === n.sessionKey.length;
                            return {
                                sessionKey: M.selectUint8Array(t, o.sessionKey, n.sessionKey),
                                sessionKeyAlgorithm: 6 === e ? null : M.selectUint8(t, o.sessionKeyAlgorithm, n.sessionKeyAlgorithm)
                            };
                        }
                        if (a && (6 === e || R.read(R.symmetric, o.sessionKeyAlgorithm))) return o;
                        throw Error("Decryption error");
                    }
                case R.publicKey.x25519:
                case R.publicKey.x448:
                    return {
                        sessionKeyAlgorithm: null,
                        sessionKey: r
                    };
                default:
                    throw Error("Unsupported public key algorithm");
            }
        }(this.version, this.publicKeyAlgorithm, i, t);
        if (3 === this.version) {
            const e = this.publicKeyAlgorithm !== R.publicKey.x25519 && this.publicKeyAlgorithm !== R.publicKey.x448;
            if (this.sessionKeyAlgorithm = e ? a : this.sessionKeyAlgorithm, s.length !== fn(this.sessionKeyAlgorithm).keySize) throw Error("Unexpected session key size");
        }
        this.sessionKey = s;
    }
}
function _a(e, t, r, n) {
    switch(t){
        case R.publicKey.rsaEncrypt:
        case R.publicKey.rsaEncryptSign:
        case R.publicKey.elgamal:
        case R.publicKey.ecdh:
            return M.concatUint8Array([
                new Uint8Array(6 === e ? [] : [
                    r
                ]),
                n,
                M.writeChecksum(n.subarray(n.length % 8))
            ]);
        case R.publicKey.x25519:
        case R.publicKey.x448:
            return n;
        default:
            throw Error("Unsupported public key algorithm");
    }
}
class ja {
    static get tag() {
        return R.packet.symEncryptedSessionKey;
    }
    constructor(e = T){
        this.version = e.aeadProtect ? 6 : 4, this.sessionKey = null, this.sessionKeyEncryptionAlgorithm = null, this.sessionKeyAlgorithm = null, this.aeadAlgorithm = R.write(R.aead, e.preferredAEADAlgorithm), this.encrypted = null, this.s2k = null, this.iv = null;
    }
    read(e) {
        let t = 0;
        if (this.version = e[t++], 4 !== this.version && 5 !== this.version && 6 !== this.version) throw new Yt(`Version ${this.version} of the SKESK packet is unsupported.`);
        6 === this.version && t++;
        const r = e[t++];
        this.version >= 5 && (this.aeadAlgorithm = e[t++], 6 === this.version && t++);
        const n = e[t++];
        if (this.s2k = Ss(n), t += this.s2k.read(e.subarray(t, e.length)), this.version >= 5) {
            const r = As(this.aeadAlgorithm, !0);
            this.iv = e.subarray(t, t += r.ivLength);
        }
        this.version >= 5 || t < e.length ? (this.encrypted = e.subarray(t, e.length), this.sessionKeyEncryptionAlgorithm = r) : this.sessionKeyAlgorithm = r;
    }
    write() {
        const e = null === this.encrypted ? this.sessionKeyAlgorithm : this.sessionKeyEncryptionAlgorithm;
        let t;
        const r = this.s2k.write();
        if (6 === this.version) {
            const n = r.length, i = 3 + n + this.iv.length;
            t = M.concatUint8Array([
                new Uint8Array([
                    this.version,
                    i,
                    e,
                    this.aeadAlgorithm,
                    n
                ]),
                r,
                this.iv,
                this.encrypted
            ]);
        } else 5 === this.version ? t = M.concatUint8Array([
            new Uint8Array([
                this.version,
                e,
                this.aeadAlgorithm
            ]),
            r,
            this.iv,
            this.encrypted
        ]) : (t = M.concatUint8Array([
            new Uint8Array([
                this.version,
                e
            ]),
            r
        ]), null !== this.encrypted && (t = M.concatUint8Array([
            t,
            this.encrypted
        ])));
        return t;
    }
    async decrypt(e) {
        const t = null !== this.sessionKeyEncryptionAlgorithm ? this.sessionKeyEncryptionAlgorithm : this.sessionKeyAlgorithm, { blockSize: r, keySize: n } = fn(t), i = await this.s2k.produceKey(e, n);
        if (this.version >= 5) {
            const e = As(this.aeadAlgorithm, !0), r = new Uint8Array([
                192 | ja.tag,
                this.version,
                this.sessionKeyEncryptionAlgorithm,
                this.aeadAlgorithm
            ]), s = 6 === this.version ? await wn(R.hash.sha256, i, new Uint8Array, r, n) : i, a = await e(t, s);
            this.sessionKey = await a.decrypt(this.encrypted, this.iv, r);
        } else if (null !== this.encrypted) {
            const e = await xi(t, i, this.encrypted, new Uint8Array(r));
            if (this.sessionKeyAlgorithm = R.write(R.symmetric, e[0]), this.sessionKey = e.subarray(1, e.length), this.sessionKey.length !== fn(this.sessionKeyAlgorithm).keySize) throw Error("Unexpected session key size");
        } else this.sessionKey = i;
    }
    async encrypt(e, t = T) {
        const r = null !== this.sessionKeyEncryptionAlgorithm ? this.sessionKeyEncryptionAlgorithm : this.sessionKeyAlgorithm;
        this.sessionKeyEncryptionAlgorithm = r, this.s2k = Ks(t), this.s2k.generateSalt();
        const { blockSize: n, keySize: i } = fn(r), s = await this.s2k.produceKey(e, i);
        if (null === this.sessionKey && (this.sessionKey = vi(this.sessionKeyAlgorithm)), this.version >= 5) {
            const e = As(this.aeadAlgorithm);
            this.iv = fe(e.ivLength);
            const t = new Uint8Array([
                192 | ja.tag,
                this.version,
                this.sessionKeyEncryptionAlgorithm,
                this.aeadAlgorithm
            ]), n = 6 === this.version ? await wn(R.hash.sha256, s, new Uint8Array, t, i) : s, a = await e(r, n);
            this.encrypted = await a.encrypt(this.sessionKey, this.iv, t);
        } else {
            const e = M.concatUint8Array([
                new Uint8Array([
                    this.sessionKeyAlgorithm
                ]),
                this.sessionKey
            ]);
            this.encrypted = await Pi(r, s, e, new Uint8Array(n));
        }
    }
}
class qa {
    static get tag() {
        return R.packet.publicKey;
    }
    constructor(e = new Date, t = T){
        this.version = t.v6Keys ? 6 : 4, this.created = M.normalizeDate(e), this.algorithm = null, this.publicParams = null, this.expirationTimeV3 = 0, this.fingerprint = null, this.keyID = null;
    }
    static fromSecretKeyPacket(e) {
        const t = new qa, { version: r, created: n, algorithm: i, publicParams: s, keyID: a, fingerprint: o } = e;
        return t.version = r, t.created = n, t.algorithm = i, t.publicParams = s, t.keyID = a, t.fingerprint = o, t;
    }
    async read(e, t = T) {
        let r = 0;
        if (this.version = e[r++], 5 === this.version && !t.enableParsingV5Entities) throw new Yt("Support for parsing v5 entities is disabled; turn on `config.enableParsingV5Entities` if needed");
        if (4 === this.version || 5 === this.version || 6 === this.version) {
            this.created = M.readDate(e.subarray(r, r + 4)), r += 4, this.algorithm = e[r++], this.version >= 5 && (r += 4);
            const { read: t, publicParams: n } = function(e, t) {
                let r = 0;
                switch(e){
                    case R.publicKey.rsaEncrypt:
                    case R.publicKey.rsaEncryptSign:
                    case R.publicKey.rsaSign:
                        {
                            const e = M.readMPI(t.subarray(r));
                            r += e.length + 2;
                            const n = M.readMPI(t.subarray(r));
                            return r += n.length + 2, {
                                read: r,
                                publicParams: {
                                    n: e,
                                    e: n
                                }
                            };
                        }
                    case R.publicKey.dsa:
                        {
                            const e = M.readMPI(t.subarray(r));
                            r += e.length + 2;
                            const n = M.readMPI(t.subarray(r));
                            r += n.length + 2;
                            const i = M.readMPI(t.subarray(r));
                            r += i.length + 2;
                            const s = M.readMPI(t.subarray(r));
                            return r += s.length + 2, {
                                read: r,
                                publicParams: {
                                    p: e,
                                    q: n,
                                    g: i,
                                    y: s
                                }
                            };
                        }
                    case R.publicKey.elgamal:
                        {
                            const e = M.readMPI(t.subarray(r));
                            r += e.length + 2;
                            const n = M.readMPI(t.subarray(r));
                            r += n.length + 2;
                            const i = M.readMPI(t.subarray(r));
                            return r += i.length + 2, {
                                read: r,
                                publicParams: {
                                    p: e,
                                    g: n,
                                    y: i
                                }
                            };
                        }
                    case R.publicKey.ecdsa:
                        {
                            const e = new Ht;
                            r += e.read(t), Ii(e);
                            const n = M.readMPI(t.subarray(r));
                            return r += n.length + 2, {
                                read: r,
                                publicParams: {
                                    oid: e,
                                    Q: n
                                }
                            };
                        }
                    case R.publicKey.eddsaLegacy:
                        {
                            const e = new Ht;
                            if (r += e.read(t), Ii(e), e.getName() !== R.curve.ed25519Legacy) throw Error("Unexpected OID for eddsaLegacy");
                            let n = M.readMPI(t.subarray(r));
                            return r += n.length + 2, n = M.leftPad(n, 33), {
                                read: r,
                                publicParams: {
                                    oid: e,
                                    Q: n
                                }
                            };
                        }
                    case R.publicKey.ecdh:
                        {
                            const e = new Ht;
                            r += e.read(t), Ii(e);
                            const n = M.readMPI(t.subarray(r));
                            r += n.length + 2;
                            const i = new pi;
                            return r += i.read(t.subarray(r)), {
                                read: r,
                                publicParams: {
                                    oid: e,
                                    Q: n,
                                    kdfParams: i
                                }
                            };
                        }
                    case R.publicKey.ed25519:
                    case R.publicKey.ed448:
                    case R.publicKey.x25519:
                    case R.publicKey.x448:
                        {
                            const n = M.readExactSubarray(t, r, r + Bi(e));
                            return r += n.length, {
                                read: r,
                                publicParams: {
                                    A: n
                                }
                            };
                        }
                    default:
                        throw new Yt("Unknown public key encryption algorithm.");
                }
            }(this.algorithm, e.subarray(r));
            if (6 === this.version && n.oid && (n.oid.getName() === R.curve.curve25519Legacy || n.oid.getName() === R.curve.ed25519Legacy)) throw Error("Legacy curve25519 cannot be used with v6 keys");
            return this.publicParams = n, r += t, await this.computeFingerprintAndKeyID(), r;
        }
        throw new Yt(`Version ${this.version} of the key packet is unsupported.`);
    }
    write() {
        const e = [];
        e.push(new Uint8Array([
            this.version
        ])), e.push(M.writeDate(this.created)), e.push(new Uint8Array([
            this.algorithm
        ]));
        const t = bi(this.algorithm, this.publicParams);
        return this.version >= 5 && e.push(M.writeNumber(t.length, 4)), e.push(t), M.concatUint8Array(e);
    }
    writeForHash(e) {
        const t = this.writePublicKey(), r = 149 + e, n = e >= 5 ? 4 : 2;
        return M.concatUint8Array([
            new Uint8Array([
                r
            ]),
            M.writeNumber(t.length, n),
            t
        ]);
    }
    isDecrypted() {
        return null;
    }
    getCreationTime() {
        return this.created;
    }
    getKeyID() {
        return this.keyID;
    }
    async computeFingerprintAndKeyID() {
        if (await this.computeFingerprint(), this.keyID = new ka, this.version >= 5) this.keyID.read(this.fingerprint.subarray(0, 8));
        else {
            if (4 !== this.version) throw Error("Unsupported key version");
            this.keyID.read(this.fingerprint.subarray(12, 20));
        }
    }
    async computeFingerprint() {
        const e = this.writeForHash(this.version);
        if (this.version >= 5) this.fingerprint = await Qe(R.hash.sha256, e);
        else {
            if (4 !== this.version) throw Error("Unsupported key version");
            this.fingerprint = await Qe(R.hash.sha1, e);
        }
    }
    getFingerprintBytes() {
        return this.fingerprint;
    }
    getFingerprint() {
        return M.uint8ArrayToHex(this.getFingerprintBytes());
    }
    hasSameFingerprintAs(e) {
        return this.version === e.version && M.equalsUint8Array(this.writePublicKey(), e.writePublicKey());
    }
    getAlgorithmInfo() {
        const e = {};
        e.algorithm = R.read(R.publicKey, this.algorithm);
        const t = this.publicParams.n || this.publicParams.p;
        return t ? e.bits = M.uint8ArrayBitLength(t) : this.publicParams.oid && (e.curve = this.publicParams.oid.getName()), e;
    }
}
qa.prototype.readPublicKey = qa.prototype.read, qa.prototype.writePublicKey = qa.prototype.write;
const Va = /*#__PURE__*/ M.constructAllowedPackets([
    ba,
    xa,
    Ca,
    Ba
]);
class Ja {
    static get tag() {
        return R.packet.symmetricallyEncryptedData;
    }
    constructor(){
        this.encrypted = null, this.packets = null;
    }
    read(e) {
        this.encrypted = e;
    }
    write() {
        return this.encrypted;
    }
    async decrypt(e, t, r = T) {
        if (!r.allowUnauthenticatedMessages) throw Error("Message is not authenticated.");
        const { blockSize: n } = fn(e), i = await C(I(this.encrypted)), s = await xi(e, t, i.subarray(n + 2), i.subarray(2, n + 2));
        this.packets = await Ua.fromBinary(s, Va, r);
    }
    async encrypt(e, t, r = T) {
        const n = this.packets.write(), { blockSize: i } = fn(e), s = await Ui(e), a = await Pi(e, t, s, new Uint8Array(i)), o = await Pi(e, t, n, a.subarray(2));
        this.encrypted = M.concat([
            a,
            o
        ]);
    }
}
class Ya {
    static get tag() {
        return R.packet.marker;
    }
    read(e) {
        return 80 === e[0] && 71 === e[1] && 80 === e[2];
    }
    write() {
        return new Uint8Array([
            80,
            71,
            80
        ]);
    }
}
class Za extends qa {
    static get tag() {
        return R.packet.publicSubkey;
    }
    constructor(e, t){
        super(e, t);
    }
    static fromSecretSubkeyPacket(e) {
        const t = new Za, { version: r, created: n, algorithm: i, publicParams: s, keyID: a, fingerprint: o } = e;
        return t.version = r, t.created = n, t.algorithm = i, t.publicParams = s, t.keyID = a, t.fingerprint = o, t;
    }
}
class Wa {
    static get tag() {
        return R.packet.userAttribute;
    }
    constructor(){
        this.attributes = [];
    }
    read(e) {
        let t = 0;
        for(; t < e.length;){
            const r = zt(e.subarray(t, e.length));
            t += r.offset, this.attributes.push(M.uint8ArrayToString(e.subarray(t, t + r.len))), t += r.len;
        }
    }
    write() {
        const e = [];
        for(let t = 0; t < this.attributes.length; t++)e.push(Gt(this.attributes[t].length)), e.push(M.stringToUint8Array(this.attributes[t]));
        return M.concatUint8Array(e);
    }
    equals(e) {
        return !!(e && e instanceof Wa) && this.attributes.every(function(t, r) {
            return t === e.attributes[r];
        });
    }
}
class $a extends qa {
    static get tag() {
        return R.packet.secretKey;
    }
    constructor(e = new Date, t = T){
        super(e, t), this.keyMaterial = null, this.isEncrypted = null, this.s2kUsage = 0, this.s2k = null, this.symmetric = null, this.aead = null, this.isLegacyAEAD = null, this.privateParams = null, this.usedModernAEAD = null;
    }
    async read(e, t = T) {
        let r = await this.readPublicKey(e, t);
        const n = r;
        this.s2kUsage = e[r++], 5 === this.version && r++, 6 === this.version && this.s2kUsage && r++;
        try {
            if (255 === this.s2kUsage || 254 === this.s2kUsage || 253 === this.s2kUsage) {
                this.symmetric = e[r++], 253 === this.s2kUsage && (this.aead = e[r++]), 6 === this.version && r++;
                const t = e[r++];
                if (this.s2k = Ss(t), r += this.s2k.read(e.subarray(r, e.length)), "gnu-dummy" === this.s2k.type) return;
            } else this.s2kUsage && (this.symmetric = this.s2kUsage);
            this.s2kUsage && (this.isLegacyAEAD = 253 === this.s2kUsage && (5 === this.version || 4 === this.version && t.parseAEADEncryptedV4KeysAsLegacy), 253 !== this.s2kUsage || this.isLegacyAEAD ? (this.iv = e.subarray(r, r + fn(this.symmetric).blockSize), this.usedModernAEAD = !1) : (this.iv = e.subarray(r, r + As(this.aead).ivLength), this.usedModernAEAD = !0), r += this.iv.length);
        } catch (t) {
            if (!this.s2kUsage) throw t;
            this.unparseableKeyMaterial = e.subarray(n), this.isEncrypted = !0;
        }
        if (5 === this.version && (r += 4), this.keyMaterial = e.subarray(r), this.isEncrypted = !!this.s2kUsage, !this.isEncrypted) {
            let e;
            if (6 === this.version) e = this.keyMaterial;
            else if (e = this.keyMaterial.subarray(0, -2), !M.equalsUint8Array(M.writeChecksum(e), this.keyMaterial.subarray(-2))) throw Error("Key checksum mismatch");
            try {
                const { read: t, privateParams: r } = mi(this.algorithm, e, this.publicParams);
                if (t < e.length) throw Error("Error reading MPIs");
                this.privateParams = r;
            } catch (e) {
                if (e instanceof Yt) throw e;
                throw Error("Error reading MPIs");
            }
        }
    }
    write() {
        const e = this.writePublicKey();
        if (this.unparseableKeyMaterial) return M.concatUint8Array([
            e,
            this.unparseableKeyMaterial
        ]);
        const t = [
            e
        ];
        t.push(new Uint8Array([
            this.s2kUsage
        ]));
        const r = [];
        if (255 === this.s2kUsage || 254 === this.s2kUsage || 253 === this.s2kUsage) {
            r.push(this.symmetric), 253 === this.s2kUsage && r.push(this.aead);
            const e = this.s2k.write();
            6 === this.version && r.push(e.length), r.push(...e);
        }
        return this.s2kUsage && "gnu-dummy" !== this.s2k.type && r.push(...this.iv), (5 === this.version || 6 === this.version && this.s2kUsage) && t.push(new Uint8Array([
            r.length
        ])), t.push(new Uint8Array(r)), this.isDummy() || (this.s2kUsage || (this.keyMaterial = bi(this.algorithm, this.privateParams)), 5 === this.version && t.push(M.writeNumber(this.keyMaterial.length, 4)), t.push(this.keyMaterial), this.s2kUsage || 6 === this.version || t.push(M.writeChecksum(this.keyMaterial))), M.concatUint8Array(t);
    }
    isDecrypted() {
        return !1 === this.isEncrypted;
    }
    isMissingSecretKeyMaterial() {
        return void 0 !== this.unparseableKeyMaterial || this.isDummy();
    }
    isDummy() {
        return !(!this.s2k || "gnu-dummy" !== this.s2k.type);
    }
    makeDummy(e = T) {
        this.isDummy() || (this.isDecrypted() && this.clearPrivateParams(), delete this.unparseableKeyMaterial, this.isEncrypted = null, this.keyMaterial = null, this.s2k = Ss(R.s2k.gnu, e), this.s2k.algorithm = 0, this.s2k.c = 0, this.s2k.type = "gnu-dummy", this.s2kUsage = 254, this.symmetric = R.symmetric.aes256, this.isLegacyAEAD = null, this.usedModernAEAD = null);
    }
    async encrypt(e, t = T) {
        if (this.isDummy()) return;
        if (!this.isDecrypted()) throw Error("Key packet is already encrypted");
        if (!e) throw Error("A non-empty passphrase is required for key encryption.");
        this.s2k = Ks(t), this.s2k.generateSalt();
        const r = bi(this.algorithm, this.privateParams);
        this.symmetric = R.symmetric.aes256;
        const { blockSize: n } = fn(this.symmetric);
        if (t.aeadProtect) {
            this.s2kUsage = 253, this.aead = t.preferredAEADAlgorithm;
            const i = As(this.aead);
            this.isLegacyAEAD = 5 === this.version, this.usedModernAEAD = !this.isLegacyAEAD;
            const s = jt(this.constructor.tag), a = await Xa(this.version, this.s2k, e, this.symmetric, this.aead, s, this.isLegacyAEAD), o = await i(this.symmetric, a);
            this.iv = this.isLegacyAEAD ? fe(n) : fe(i.ivLength);
            const c = this.isLegacyAEAD ? new Uint8Array : M.concatUint8Array([
                s,
                this.writePublicKey()
            ]);
            this.keyMaterial = await o.encrypt(r, this.iv.subarray(0, i.ivLength), c);
        } else {
            this.s2kUsage = 254, this.usedModernAEAD = !1;
            const t = await Xa(this.version, this.s2k, e, this.symmetric);
            this.iv = fe(n), this.keyMaterial = await Pi(this.symmetric, t, M.concatUint8Array([
                r,
                await Qe(R.hash.sha1, r)
            ]), this.iv);
        }
    }
    async decrypt(e) {
        if (this.isDummy()) return !1;
        if (this.unparseableKeyMaterial) throw Error("Key packet cannot be decrypted: unsupported S2K or cipher algo");
        if (this.isDecrypted()) throw Error("Key packet is already decrypted.");
        let t;
        const r = jt(this.constructor.tag);
        if (254 !== this.s2kUsage && 253 !== this.s2kUsage) throw 255 === this.s2kUsage ? Error("Encrypted private key is authenticated using an insecure two-byte hash") : Error("Private key is encrypted using an insecure S2K function: unsalted MD5");
        let n;
        if (t = await Xa(this.version, this.s2k, e, this.symmetric, this.aead, r, this.isLegacyAEAD), 253 === this.s2kUsage) {
            const e = As(this.aead, !0), i = await e(this.symmetric, t);
            try {
                const t = this.isLegacyAEAD ? new Uint8Array : M.concatUint8Array([
                    r,
                    this.writePublicKey()
                ]);
                n = await i.decrypt(this.keyMaterial, this.iv.subarray(0, e.ivLength), t);
            } catch (e) {
                if ("Authentication tag mismatch" === e.message) throw Error("Incorrect key passphrase: " + e.message);
                throw e;
            }
        } else {
            const e = await xi(this.symmetric, t, this.keyMaterial, this.iv);
            n = e.subarray(0, -20);
            const r = await Qe(R.hash.sha1, n);
            if (!M.equalsUint8Array(r, e.subarray(-20))) throw Error("Incorrect key passphrase");
        }
        try {
            const { privateParams: e } = mi(this.algorithm, n, this.publicParams);
            this.privateParams = e;
        } catch (e) {
            throw Error("Error reading MPIs");
        }
        this.isEncrypted = !1, this.keyMaterial = null, this.s2kUsage = 0, this.aead = null, this.symmetric = null, this.isLegacyAEAD = null;
    }
    async validate() {
        if (this.isDummy()) return;
        if (!this.isDecrypted()) throw Error("Key is not decrypted");
        if (this.usedModernAEAD) return;
        let e;
        try {
            e = await Ei(this.algorithm, this.publicParams, this.privateParams);
        } catch (t) {
            e = !1;
        }
        if (!e) throw Error("Key is invalid");
    }
    async generate(e, t) {
        if (6 === this.version && (this.algorithm === R.publicKey.ecdh && t === R.curve.curve25519Legacy || this.algorithm === R.publicKey.eddsaLegacy)) throw Error(`Cannot generate v6 keys of type 'ecc' with curve ${t}. Generate a key of type 'curve25519' instead`);
        const { privateParams: r, publicParams: n } = await ki(this.algorithm, e, t);
        this.privateParams = r, this.publicParams = n, this.isEncrypted = !1;
    }
    clearPrivateParams() {
        this.isMissingSecretKeyMaterial() || (Object.keys(this.privateParams).forEach((e)=>{
            this.privateParams[e].fill(0), delete this.privateParams[e];
        }), this.privateParams = null, this.isEncrypted = !0);
    }
}
async function Xa(e, t, r, n, i, s, a) {
    if ("argon2" === t.type && !i) throw Error("Using Argon2 S2K without AEAD is not allowed");
    if ("simple" === t.type && 6 === e) throw Error("Using Simple S2K with version 6 keys is not allowed");
    const { keySize: o } = fn(n), c = await t.produceKey(r, o);
    if (!i || 5 === e || a) return c;
    const h = M.concatUint8Array([
        s,
        new Uint8Array([
            e,
            n,
            i
        ])
    ]);
    return wn(R.hash.sha256, c, new Uint8Array, h, o);
}
class eo {
    static get tag() {
        return R.packet.userID;
    }
    constructor(){
        this.userID = "", this.name = "", this.email = "", this.comment = "";
    }
    static fromObject(e) {
        if (M.isString(e) || e.name && !M.isString(e.name) || e.email && !M.isEmailAddress(e.email) || e.comment && !M.isString(e.comment)) throw Error("Invalid user ID format");
        const t = new eo;
        Object.assign(t, e);
        const r = [];
        return t.name && r.push(t.name), t.comment && r.push(`(${t.comment})`), t.email && r.push(`<${t.email}>`), t.userID = r.join(" "), t;
    }
    read(e, t = T) {
        const r = M.decodeUTF8(e);
        if (r.length > t.maxUserIDLength) throw Error("User ID string is too long");
        const n = /^(?<name>[^()]+\s+)?(?<comment>\([^()]+\)\s+)?(?<email><\S+@\S+>)$/.exec(r);
        if (null !== n) {
            const { name: e, comment: t, email: r } = n.groups;
            this.comment = t?.replace(/^\(|\)|\s$/g, "").trim() || "", this.name = e?.trim() || "", this.email = r.substring(1, r.length - 1);
        } else /^[^\s@]+@[^\s@]+$/.test(r) && (this.email = r);
        this.userID = r;
    }
    write() {
        return M.encodeUTF8(this.userID);
    }
    equals(e) {
        return e && e.userID === this.userID;
    }
}
class to extends $a {
    static get tag() {
        return R.packet.secretSubkey;
    }
    constructor(e = new Date, t = T){
        super(e, t);
    }
}
class ro {
    static get tag() {
        return R.packet.trust;
    }
    read() {
        throw new Yt("Trust packets are not supported");
    }
    write() {
        throw new Yt("Trust packets are not supported");
    }
}
class no {
    static get tag() {
        return R.packet.padding;
    }
    constructor(){
        this.padding = null;
    }
    read(e) {}
    write() {
        return this.padding;
    }
    async createPadding(e) {
        this.padding = await fe(e);
    }
}
const io = /*#__PURE__*/ M.constructAllowedPackets([
    Ba
]);
class so {
    constructor(e){
        this.packets = e || new Ua;
    }
    write() {
        return this.packets.write();
    }
    armor(e = T) {
        const t = this.packets.some((e)=>e.constructor.tag === Ba.tag && 6 !== e.version);
        return X(R.armor.signature, this.write(), void 0, void 0, void 0, t, e);
    }
    getSigningKeyIDs() {
        return this.packets.map((e)=>e.issuerKeyID);
    }
}
async function ao({ armoredSignature: e, binarySignature: t, config: r, ...n }) {
    r = {
        ...T,
        ...r
    };
    let i = e || t;
    if (!i) throw Error("readSignature: must pass options object containing `armoredSignature` or `binarySignature`");
    if (e && !M.isString(e)) throw Error("readSignature: options.armoredSignature must be a string");
    if (t && !M.isUint8Array(t)) throw Error("readSignature: options.binarySignature must be a Uint8Array");
    const s = Object.keys(n);
    if (s.length > 0) throw Error("Unknown option: " + s.join(", "));
    if (e) {
        const { type: e, data: t } = await $(i);
        if (e !== R.armor.signature) throw Error("Armored text not of type signature");
        i = t;
    }
    const a = await Ua.fromBinary(i, io, r);
    return new so(a);
}
async function oo(e, t) {
    const r = new to(e.date, t);
    return r.packets = null, r.algorithm = R.write(R.publicKey, e.algorithm), await r.generate(e.rsaBits, e.curve), await r.computeFingerprintAndKeyID(), r;
}
async function co(e, t) {
    const r = new $a(e.date, t);
    return r.packets = null, r.algorithm = R.write(R.publicKey, e.algorithm), await r.generate(e.rsaBits, e.curve, e.config), await r.computeFingerprintAndKeyID(), r;
}
async function ho(e, t, r, n, i = new Date, s) {
    let a, o;
    for(let c = e.length - 1; c >= 0; c--)try {
        (!a || e[c].created >= a.created) && (await e[c].verify(t, r, n, i, void 0, s), a = e[c]);
    } catch (e) {
        o = e;
    }
    if (!a) throw M.wrapError(`Could not find valid ${R.read(R.signature, r)} signature in key ${t.getKeyID().toHex()}`.replace("certGeneric ", "self-").replace(/([a-z])([A-Z])/g, (e, t, r)=>t + " " + r.toLowerCase()), o);
    return a;
}
function uo(e, t, r = new Date) {
    const n = M.normalizeDate(r);
    if (null !== n) {
        const r = Ao(e, t);
        return !(e.created <= n && n < r);
    }
    return !1;
}
async function lo(e, t, r, n) {
    const i = {};
    i.key = t, i.bind = e;
    const s = {
        signatureType: R.signature.subkeyBinding
    };
    r.sign ? (s.keyFlags = [
        R.keyFlags.signData
    ], s.embeddedSignature = await fo(i, [], e, {
        signatureType: R.signature.keyBinding
    }, r.date, void 0, void 0, void 0, n)) : s.keyFlags = [
        R.keyFlags.encryptCommunication | R.keyFlags.encryptStorage
    ], r.keyExpirationTime > 0 && (s.keyExpirationTime = r.keyExpirationTime, s.keyNeverExpires = !1);
    return await fo(i, [], t, s, r.date, void 0, void 0, void 0, n);
}
async function yo(e, t, r = new Date, n = [], i) {
    const s = R.hash.sha256, a = i.preferredHashAlgorithm, o = await Promise.all(e.map(async (e, t)=>(await e.getPrimarySelfSignature(r, n[t], i)).preferredHashAlgorithms || [])), c = new Map;
    for (const e of o)for (const t of e)try {
        const e = R.write(R.hash, t);
        c.set(e, c.has(e) ? c.get(e) + 1 : 1);
    } catch  {}
    const h = (t)=>0 === e.length || c.get(t) === e.length || t === s, u = ()=>{
        if (0 === c.size) return s;
        const e = Array.from(c.keys()).filter((e)=>h(e)).sort((e, t)=>Re(e) - Re(t))[0];
        return Re(e) >= Re(s) ? e : s;
    };
    if (new Set([
        R.publicKey.ecdsa,
        R.publicKey.eddsaLegacy,
        R.publicKey.ed25519,
        R.publicKey.ed448
    ]).has(t.algorithm)) {
        const e = function(e, t) {
            switch(e){
                case R.publicKey.ecdsa:
                case R.publicKey.eddsaLegacy:
                    return Mn(t);
                case R.publicKey.ed25519:
                case R.publicKey.ed448:
                    return nr(e);
                default:
                    throw Error("Unknown elliptic signing algo");
            }
        }(t.algorithm, t.publicParams.oid), r = h(a), n = Re(a) >= Re(e);
        if (r && n) return a;
        {
            const t = u();
            return Re(t) >= Re(e) ? t : e;
        }
    }
    return h(a) ? a : u();
}
async function fo(e, t, r, n, i, s, a = [], o = !1, c) {
    if (r.isDummy()) throw Error("Cannot sign with a gnu-dummy key.");
    if (!r.isDecrypted()) throw Error("Signing key is not decrypted.");
    const h = new Ba;
    return Object.assign(h, n), h.publicKeyAlgorithm = r.algorithm, h.hashAlgorithm = await yo(t, r, i, s, c), h.rawNotations = [
        ...a
    ], await h.sign(r, e, i, o, c), h;
}
async function go(e, t, r, n = new Date, i) {
    (e = e[r]) && (t[r].length ? await Promise.all(e.map(async function(e) {
        e.isExpired(n) || i && !await i(e) || t[r].some(function(t) {
            return M.equalsUint8Array(t.writeParams(), e.writeParams());
        }) || t[r].push(e);
    })) : t[r] = e);
}
async function po(e, t, r, n, i, s, a = new Date, o) {
    s = s || e;
    const c = [];
    return await Promise.all(n.map(async function(e) {
        try {
            if (!i || e.issuerKeyID.equals(i.issuerKeyID)) {
                const n = ![
                    R.reasonForRevocation.keyRetired,
                    R.reasonForRevocation.keySuperseded,
                    R.reasonForRevocation.userIDInvalid
                ].includes(e.reasonForRevocationFlag);
                await e.verify(s, t, r, n ? null : a, !1, o), c.push(e.issuerKeyID);
            }
        } catch (e) {}
    })), i ? (i.revoked = !!c.some((e)=>e.equals(i.issuerKeyID)) || i.revoked || !1, i.revoked) : c.length > 0;
}
function Ao(e, t) {
    let r;
    return !1 === t.keyNeverExpires && (r = e.created.getTime() + 1e3 * t.keyExpirationTime), r ? new Date(r) : 1 / 0;
}
function wo(e, t = {}) {
    switch(e.type = e.type || t.type, e.curve = e.curve || t.curve, e.rsaBits = e.rsaBits || t.rsaBits, e.keyExpirationTime = void 0 !== e.keyExpirationTime ? e.keyExpirationTime : t.keyExpirationTime, e.passphrase = M.isString(e.passphrase) ? e.passphrase : t.passphrase, e.date = e.date || t.date, e.sign = e.sign || !1, e.type){
        case "ecc":
            try {
                e.curve = R.write(R.curve, e.curve);
            } catch (e) {
                throw Error("Unknown curve");
            }
            e.curve !== R.curve.ed25519Legacy && e.curve !== R.curve.curve25519Legacy && "ed25519" !== e.curve && "curve25519" !== e.curve || (e.curve = e.sign ? R.curve.ed25519Legacy : R.curve.curve25519Legacy), e.sign ? e.algorithm = e.curve === R.curve.ed25519Legacy ? R.publicKey.eddsaLegacy : R.publicKey.ecdsa : e.algorithm = R.publicKey.ecdh;
            break;
        case "curve25519":
            e.algorithm = e.sign ? R.publicKey.ed25519 : R.publicKey.x25519;
            break;
        case "curve448":
            e.algorithm = e.sign ? R.publicKey.ed448 : R.publicKey.x448;
            break;
        case "rsa":
            e.algorithm = R.publicKey.rsaEncryptSign;
            break;
        default:
            throw Error("Unsupported key type " + e.type);
    }
    return e;
}
function mo(e, t, r) {
    switch(e.algorithm){
        case R.publicKey.rsaEncryptSign:
        case R.publicKey.rsaSign:
        case R.publicKey.dsa:
        case R.publicKey.ecdsa:
        case R.publicKey.eddsaLegacy:
        case R.publicKey.ed25519:
        case R.publicKey.ed448:
            if (!t.keyFlags && !r.allowMissingKeyFlags) throw Error("None of the key flags is set: consider passing `config.allowMissingKeyFlags`");
            return !t.keyFlags || !!(t.keyFlags[0] & R.keyFlags.signData);
        default:
            return !1;
    }
}
function bo(e, t, r) {
    switch(e.algorithm){
        case R.publicKey.rsaEncryptSign:
        case R.publicKey.rsaEncrypt:
        case R.publicKey.elgamal:
        case R.publicKey.ecdh:
        case R.publicKey.x25519:
        case R.publicKey.x448:
            if (!t.keyFlags && !r.allowMissingKeyFlags) throw Error("None of the key flags is set: consider passing `config.allowMissingKeyFlags`");
            return !t.keyFlags || !!(t.keyFlags[0] & R.keyFlags.encryptCommunication) || !!(t.keyFlags[0] & R.keyFlags.encryptStorage);
        default:
            return !1;
    }
}
function ko(e, t, r) {
    if (!t.keyFlags && !r.allowMissingKeyFlags) throw Error("None of the key flags is set: consider passing `config.allowMissingKeyFlags`");
    switch(e.algorithm){
        case R.publicKey.rsaEncryptSign:
        case R.publicKey.rsaEncrypt:
        case R.publicKey.elgamal:
        case R.publicKey.ecdh:
        case R.publicKey.x25519:
        case R.publicKey.x448:
            return !(!(!t.keyFlags || !!(t.keyFlags[0] & R.keyFlags.signData)) || !r.allowInsecureDecryptionWithSigningKeys) || !t.keyFlags || !!(t.keyFlags[0] & R.keyFlags.encryptCommunication) || !!(t.keyFlags[0] & R.keyFlags.encryptStorage);
        default:
            return !1;
    }
}
function Eo(e, t) {
    const r = R.write(R.publicKey, e.algorithm), n = e.getAlgorithmInfo();
    if (t.rejectPublicKeyAlgorithms.has(r)) throw Error(n.algorithm + " keys are considered too weak.");
    switch(r){
        case R.publicKey.rsaEncryptSign:
        case R.publicKey.rsaSign:
        case R.publicKey.rsaEncrypt:
            if (n.bits < t.minRSABits) throw Error(`RSA keys shorter than ${t.minRSABits} bits are considered too weak.`);
            break;
        case R.publicKey.ecdsa:
        case R.publicKey.eddsaLegacy:
        case R.publicKey.ecdh:
            if (t.rejectCurves.has(n.curve)) throw Error(`Support for ${n.algorithm} keys using curve ${n.curve} is disabled.`);
    }
}
class vo {
    constructor(e, t){
        this.userID = e.constructor.tag === R.packet.userID ? e : null, this.userAttribute = e.constructor.tag === R.packet.userAttribute ? e : null, this.selfCertifications = [], this.otherCertifications = [], this.revocationSignatures = [], this.mainKey = t;
    }
    toPacketList() {
        const e = new Ua;
        return e.push(this.userID || this.userAttribute), e.push(...this.revocationSignatures), e.push(...this.selfCertifications), e.push(...this.otherCertifications), e;
    }
    clone() {
        const e = new vo(this.userID || this.userAttribute, this.mainKey);
        return e.selfCertifications = [
            ...this.selfCertifications
        ], e.otherCertifications = [
            ...this.otherCertifications
        ], e.revocationSignatures = [
            ...this.revocationSignatures
        ], e;
    }
    async certify(e, t, r) {
        const n = this.mainKey.keyPacket, i = {
            userID: this.userID,
            userAttribute: this.userAttribute,
            key: n
        }, s = new vo(i.userID || i.userAttribute, this.mainKey);
        return s.otherCertifications = await Promise.all(e.map(async function(e) {
            if (!e.isPrivate()) throw Error("Need private key for signing");
            if (e.hasSameFingerprintAs(n)) throw Error("The user's own key can only be used for self-certifications");
            const s = await e.getSigningKey(void 0, t, void 0, r);
            return fo(i, [
                e
            ], s.keyPacket, {
                signatureType: R.signature.certGeneric,
                keyFlags: [
                    R.keyFlags.certifyKeys | R.keyFlags.signData
                ]
            }, t, void 0, void 0, void 0, r);
        })), await s.update(this, t, r), s;
    }
    async isRevoked(e, t, r = new Date, n = T) {
        const i = this.mainKey.keyPacket;
        return po(i, R.signature.certRevocation, {
            key: i,
            userID: this.userID,
            userAttribute: this.userAttribute
        }, this.revocationSignatures, e, t, r, n);
    }
    async verifyCertificate(e, t, r = new Date, n) {
        const i = this, s = this.mainKey.keyPacket, a = {
            userID: this.userID,
            userAttribute: this.userAttribute,
            key: s
        }, { issuerKeyID: o } = e, c = t.filter((e)=>e.getKeys(o).length > 0);
        return 0 === c.length ? null : (await Promise.all(c.map(async (t)=>{
            const s = await t.getSigningKey(o, e.created, void 0, n);
            if (e.revoked || await i.isRevoked(e, s.keyPacket, r, n)) throw Error("User certificate is revoked");
            try {
                await e.verify(s.keyPacket, R.signature.certGeneric, a, r, void 0, n);
            } catch (e) {
                throw M.wrapError("User certificate is invalid", e);
            }
        })), !0);
    }
    async verifyAllCertifications(e, t = new Date, r) {
        const n = this, i = this.selfCertifications.concat(this.otherCertifications);
        return Promise.all(i.map(async (i)=>({
                keyID: i.issuerKeyID,
                valid: await n.verifyCertificate(i, e, t, r).catch(()=>!1)
            })));
    }
    async verify(e = new Date, t) {
        if (!this.selfCertifications.length) throw Error("No self-certifications found");
        const r = this, n = this.mainKey.keyPacket, i = {
            userID: this.userID,
            userAttribute: this.userAttribute,
            key: n
        };
        let s;
        for(let a = this.selfCertifications.length - 1; a >= 0; a--)try {
            const s = this.selfCertifications[a];
            if (s.revoked || await r.isRevoked(s, void 0, e, t)) throw Error("Self-certification is revoked");
            try {
                await s.verify(n, R.signature.certGeneric, i, e, void 0, t);
            } catch (e) {
                throw M.wrapError("Self-certification is invalid", e);
            }
            return !0;
        } catch (e) {
            s = e;
        }
        throw s;
    }
    async update(e, t, r) {
        const n = this.mainKey.keyPacket, i = {
            userID: this.userID,
            userAttribute: this.userAttribute,
            key: n
        };
        await go(e, this, "selfCertifications", t, async function(e) {
            try {
                return await e.verify(n, R.signature.certGeneric, i, t, !1, r), !0;
            } catch (e) {
                return !1;
            }
        }), await go(e, this, "otherCertifications", t), await go(e, this, "revocationSignatures", t, function(e) {
            return po(n, R.signature.certRevocation, i, [
                e
            ], void 0, void 0, t, r);
        });
    }
    async revoke(e, { flag: t = R.reasonForRevocation.noReason, string: r = "" } = {}, n = new Date, i = T) {
        const s = {
            userID: this.userID,
            userAttribute: this.userAttribute,
            key: e
        }, a = new vo(s.userID || s.userAttribute, this.mainKey);
        return a.revocationSignatures.push(await fo(s, [], e, {
            signatureType: R.signature.certRevocation,
            reasonForRevocationFlag: R.write(R.reasonForRevocation, t),
            reasonForRevocationString: r
        }, n, void 0, void 0, !1, i)), await a.update(this), a;
    }
}
class Io {
    constructor(e, t){
        this.keyPacket = e, this.bindingSignatures = [], this.revocationSignatures = [], this.mainKey = t;
    }
    toPacketList() {
        const e = new Ua;
        return e.push(this.keyPacket), e.push(...this.revocationSignatures), e.push(...this.bindingSignatures), e;
    }
    clone() {
        const e = new Io(this.keyPacket, this.mainKey);
        return e.bindingSignatures = [
            ...this.bindingSignatures
        ], e.revocationSignatures = [
            ...this.revocationSignatures
        ], e;
    }
    async isRevoked(e, t, r = new Date, n = T) {
        const i = this.mainKey.keyPacket;
        return po(i, R.signature.subkeyRevocation, {
            key: i,
            bind: this.keyPacket
        }, this.revocationSignatures, e, t, r, n);
    }
    async verify(e = new Date, t = T) {
        const r = this.mainKey.keyPacket, n = {
            key: r,
            bind: this.keyPacket
        }, i = await ho(this.bindingSignatures, r, R.signature.subkeyBinding, n, e, t);
        if (i.revoked || await this.isRevoked(i, null, e, t)) throw Error("Subkey is revoked");
        if (uo(this.keyPacket, i, e)) throw Error("Subkey is expired");
        return i;
    }
    async getExpirationTime(e = new Date, t = T) {
        const r = this.mainKey.keyPacket, n = {
            key: r,
            bind: this.keyPacket
        };
        let i;
        try {
            i = await ho(this.bindingSignatures, r, R.signature.subkeyBinding, n, e, t);
        } catch (e) {
            return null;
        }
        const s = Ao(this.keyPacket, i), a = i.getExpirationTime();
        return s < a ? s : a;
    }
    async update(e, t = new Date, r = T) {
        const n = this.mainKey.keyPacket;
        if (!this.hasSameFingerprintAs(e)) throw Error("Subkey update method: fingerprints of subkeys not equal");
        this.keyPacket.constructor.tag === R.packet.publicSubkey && e.keyPacket.constructor.tag === R.packet.secretSubkey && (this.keyPacket = e.keyPacket);
        const i = this, s = {
            key: n,
            bind: i.keyPacket
        };
        await go(e, this, "bindingSignatures", t, async function(e) {
            for(let t = 0; t < i.bindingSignatures.length; t++)if (i.bindingSignatures[t].issuerKeyID.equals(e.issuerKeyID)) return e.created > i.bindingSignatures[t].created && (i.bindingSignatures[t] = e), !1;
            try {
                return await e.verify(n, R.signature.subkeyBinding, s, t, void 0, r), !0;
            } catch (e) {
                return !1;
            }
        }), await go(e, this, "revocationSignatures", t, function(e) {
            return po(n, R.signature.subkeyRevocation, s, [
                e
            ], void 0, void 0, t, r);
        });
    }
    async revoke(e, { flag: t = R.reasonForRevocation.noReason, string: r = "" } = {}, n = new Date, i = T) {
        const s = {
            key: e,
            bind: this.keyPacket
        }, a = new Io(this.keyPacket, this.mainKey);
        return a.revocationSignatures.push(await fo(s, [], e, {
            signatureType: R.signature.subkeyRevocation,
            reasonForRevocationFlag: R.write(R.reasonForRevocation, t),
            reasonForRevocationString: r
        }, n, void 0, void 0, !1, i)), await a.update(this), a;
    }
    hasSameFingerprintAs(e) {
        return this.keyPacket.hasSameFingerprintAs(e.keyPacket || e);
    }
}
[
    "getKeyID",
    "getFingerprint",
    "getAlgorithmInfo",
    "getCreationTime",
    "isDecrypted"
].forEach((e)=>{
    Io.prototype[e] = function() {
        return this.keyPacket[e]();
    };
});
const Bo = /*#__PURE__*/ M.constructAllowedPackets([
    Ba
]), So = new Set([
    R.packet.publicKey,
    R.packet.privateKey
]), Ko = new Set([
    R.packet.publicKey,
    R.packet.privateKey,
    R.packet.publicSubkey,
    R.packet.privateSubkey
]);
class Co {
    packetListToStructure(e, t = new Set) {
        let r, n, i, s;
        for (const a of e){
            if (a instanceof Wt) {
                Ko.has(a.tag) && !s && (s = So.has(a.tag) ? So : Ko);
                continue;
            }
            const e = a.constructor.tag;
            if (s) {
                if (!s.has(e)) continue;
                s = null;
            }
            if (t.has(e)) throw Error("Unexpected packet type: " + e);
            switch(e){
                case R.packet.publicKey:
                case R.packet.secretKey:
                    if (this.keyPacket) throw Error("Key block contains multiple keys");
                    if (this.keyPacket = a, n = this.getKeyID(), !n) throw Error("Missing Key ID");
                    break;
                case R.packet.userID:
                case R.packet.userAttribute:
                    r = new vo(a, this), this.users.push(r);
                    break;
                case R.packet.publicSubkey:
                case R.packet.secretSubkey:
                    r = null, i = new Io(a, this), this.subkeys.push(i);
                    break;
                case R.packet.signature:
                    switch(a.signatureType){
                        case R.signature.certGeneric:
                        case R.signature.certPersona:
                        case R.signature.certCasual:
                        case R.signature.certPositive:
                            if (!r) {
                                M.printDebug("Dropping certification signatures without preceding user packet");
                                continue;
                            }
                            a.issuerKeyID.equals(n) ? r.selfCertifications.push(a) : r.otherCertifications.push(a);
                            break;
                        case R.signature.certRevocation:
                            r ? r.revocationSignatures.push(a) : this.directSignatures.push(a);
                            break;
                        case R.signature.key:
                            this.directSignatures.push(a);
                            break;
                        case R.signature.subkeyBinding:
                            if (!i) {
                                M.printDebug("Dropping subkey binding signature without preceding subkey packet");
                                continue;
                            }
                            i.bindingSignatures.push(a);
                            break;
                        case R.signature.keyRevocation:
                            this.revocationSignatures.push(a);
                            break;
                        case R.signature.subkeyRevocation:
                            if (!i) {
                                M.printDebug("Dropping subkey revocation signature without preceding subkey packet");
                                continue;
                            }
                            i.revocationSignatures.push(a);
                    }
            }
        }
    }
    toPacketList() {
        const e = new Ua;
        return e.push(this.keyPacket), e.push(...this.revocationSignatures), e.push(...this.directSignatures), this.users.map((t)=>e.push(...t.toPacketList())), this.subkeys.map((t)=>e.push(...t.toPacketList())), e;
    }
    clone(e = !1) {
        const t = new this.constructor(this.toPacketList());
        return e && t.getKeys().forEach((e)=>{
            if (e.keyPacket = Object.create(Object.getPrototypeOf(e.keyPacket), Object.getOwnPropertyDescriptors(e.keyPacket)), !e.keyPacket.isDecrypted()) return;
            const t = {};
            Object.keys(e.keyPacket.privateParams).forEach((r)=>{
                t[r] = new Uint8Array(e.keyPacket.privateParams[r]);
            }), e.keyPacket.privateParams = t;
        }), t;
    }
    getSubkeys(e = null) {
        return this.subkeys.filter((t)=>!e || t.getKeyID().equals(e, !0));
    }
    getKeys(e = null) {
        const t = [];
        return e && !this.getKeyID().equals(e, !0) || t.push(this), t.concat(this.getSubkeys(e));
    }
    getKeyIDs() {
        return this.getKeys().map((e)=>e.getKeyID());
    }
    getUserIDs() {
        return this.users.map((e)=>e.userID ? e.userID.userID : null).filter((e)=>null !== e);
    }
    write() {
        return this.toPacketList().write();
    }
    async getSigningKey(e = null, t = new Date, r = {}, n = T) {
        await this.verifyPrimaryKey(t, r, n);
        const i = this.keyPacket;
        try {
            Eo(i, n);
        } catch (e) {
            throw M.wrapError("Could not verify primary key", e);
        }
        const s = this.subkeys.slice().sort((e, t)=>t.keyPacket.created - e.keyPacket.created);
        let a;
        for (const r of s)if (!e || r.getKeyID().equals(e)) try {
            await r.verify(t, n);
            const e = {
                key: i,
                bind: r.keyPacket
            }, s = await ho(r.bindingSignatures, i, R.signature.subkeyBinding, e, t, n);
            if (!mo(r.keyPacket, s, n)) continue;
            if (!s.embeddedSignature) throw Error("Missing embedded signature");
            return await ho([
                s.embeddedSignature
            ], r.keyPacket, R.signature.keyBinding, e, t, n), Eo(r.keyPacket, n), r;
        } catch (e) {
            a = e;
        }
        try {
            const s = await this.getPrimarySelfSignature(t, r, n);
            if ((!e || i.getKeyID().equals(e)) && mo(i, s, n)) return Eo(i, n), this;
        } catch (e) {
            a = e;
        }
        throw M.wrapError("Could not find valid signing key packet in key " + this.getKeyID().toHex(), a);
    }
    async getEncryptionKey(e, t = new Date, r = {}, n = T) {
        await this.verifyPrimaryKey(t, r, n);
        const i = this.keyPacket;
        try {
            Eo(i, n);
        } catch (e) {
            throw M.wrapError("Could not verify primary key", e);
        }
        const s = this.subkeys.slice().sort((e, t)=>t.keyPacket.created - e.keyPacket.created);
        let a;
        for (const r of s)if (!e || r.getKeyID().equals(e)) try {
            await r.verify(t, n);
            const e = {
                key: i,
                bind: r.keyPacket
            }, s = await ho(r.bindingSignatures, i, R.signature.subkeyBinding, e, t, n);
            if (bo(r.keyPacket, s, n)) return Eo(r.keyPacket, n), r;
        } catch (e) {
            a = e;
        }
        try {
            const s = await this.getPrimarySelfSignature(t, r, n);
            if ((!e || i.getKeyID().equals(e)) && bo(i, s, n)) return Eo(i, n), this;
        } catch (e) {
            a = e;
        }
        throw M.wrapError("Could not find valid encryption key packet in key " + this.getKeyID().toHex(), a);
    }
    async isRevoked(e, t, r = new Date, n = T) {
        return po(this.keyPacket, R.signature.keyRevocation, {
            key: this.keyPacket
        }, this.revocationSignatures, e, t, r, n);
    }
    async verifyPrimaryKey(e = new Date, t = {}, r = T) {
        const n = this.keyPacket;
        if (await this.isRevoked(null, null, e, r)) throw Error("Primary key is revoked");
        if (uo(n, await this.getPrimarySelfSignature(e, t, r), e)) throw Error("Primary key is expired");
        if (6 !== n.version) {
            const t = await ho(this.directSignatures, n, R.signature.key, {
                key: n
            }, e, r).catch(()=>{});
            if (t && uo(n, t, e)) throw Error("Primary key is expired");
        }
    }
    async getExpirationTime(e, t = T) {
        let r;
        try {
            const n = await this.getPrimarySelfSignature(null, e, t), i = Ao(this.keyPacket, n), s = n.getExpirationTime(), a = 6 !== this.keyPacket.version && await ho(this.directSignatures, this.keyPacket, R.signature.key, {
                key: this.keyPacket
            }, null, t).catch(()=>{});
            if (a) {
                const e = Ao(this.keyPacket, a);
                r = Math.min(i, s, e);
            } else r = i < s ? i : s;
        } catch (e) {
            r = null;
        }
        return M.normalizeDate(r);
    }
    async getPrimarySelfSignature(e = new Date, t = {}, r = T) {
        const n = this.keyPacket;
        if (6 === n.version) return ho(this.directSignatures, n, R.signature.key, {
            key: n
        }, e, r);
        const { selfCertification: i } = await this.getPrimaryUser(e, t, r);
        return i;
    }
    async getPrimaryUser(e = new Date, t = {}, r = T) {
        const n = this.keyPacket, i = [];
        let s;
        for(let a = 0; a < this.users.length; a++)try {
            const s = this.users[a];
            if (!s.userID) continue;
            if (void 0 !== t.name && s.userID.name !== t.name || void 0 !== t.email && s.userID.email !== t.email || void 0 !== t.comment && s.userID.comment !== t.comment) throw Error("Could not find user that matches that user ID");
            const o = {
                userID: s.userID,
                key: n
            }, c = await ho(s.selfCertifications, n, R.signature.certGeneric, o, e, r);
            i.push({
                index: a,
                user: s,
                selfCertification: c
            });
        } catch (e) {
            s = e;
        }
        if (!i.length) throw s || Error("Could not find primary user");
        await Promise.all(i.map(async function(t) {
            return t.selfCertification.revoked || t.user.isRevoked(t.selfCertification, null, e, r);
        }));
        const a = i.sort(function(e, t) {
            const r = e.selfCertification, n = t.selfCertification;
            return n.revoked - r.revoked || r.isPrimaryUserID - n.isPrimaryUserID || r.created - n.created;
        }).pop(), { user: o, selfCertification: c } = a;
        if (c.revoked || await o.isRevoked(c, null, e, r)) throw Error("Primary user is revoked");
        return a;
    }
    async update(e, t = new Date, r = T) {
        if (!this.hasSameFingerprintAs(e)) throw Error("Primary key fingerprints must be equal to update the key");
        if (!this.isPrivate() && e.isPrivate()) {
            if (!(this.subkeys.length === e.subkeys.length && this.subkeys.every((t)=>e.subkeys.some((e)=>t.hasSameFingerprintAs(e))))) throw Error("Cannot update public key with private key if subkeys mismatch");
            return e.update(this, r);
        }
        const n = this.clone();
        return await go(e, n, "revocationSignatures", t, (i)=>po(n.keyPacket, R.signature.keyRevocation, n, [
                i
            ], null, e.keyPacket, t, r)), await go(e, n, "directSignatures", t), await Promise.all(e.users.map(async (e)=>{
            const i = n.users.filter((t)=>e.userID && e.userID.equals(t.userID) || e.userAttribute && e.userAttribute.equals(t.userAttribute));
            if (i.length > 0) await Promise.all(i.map((n)=>n.update(e, t, r)));
            else {
                const t = e.clone();
                t.mainKey = n, n.users.push(t);
            }
        })), await Promise.all(e.subkeys.map(async (e)=>{
            const i = n.subkeys.filter((t)=>t.hasSameFingerprintAs(e));
            if (i.length > 0) await Promise.all(i.map((n)=>n.update(e, t, r)));
            else {
                const t = e.clone();
                t.mainKey = n, n.subkeys.push(t);
            }
        })), n;
    }
    async getRevocationCertificate(e = new Date, t = T) {
        const r = {
            key: this.keyPacket
        }, n = await ho(this.revocationSignatures, this.keyPacket, R.signature.keyRevocation, r, e, t), i = new Ua;
        i.push(n);
        const s = 6 !== this.keyPacket.version;
        return X(R.armor.publicKey, i.write(), null, null, "This is a revocation certificate", s, t);
    }
    async applyRevocationCertificate(e, t = new Date, r = T) {
        const n = await $(e), i = (await Ua.fromBinary(n.data, Bo, r)).findPacket(R.packet.signature);
        if (!i || i.signatureType !== R.signature.keyRevocation) throw Error("Could not find revocation signature packet");
        if (!i.issuerKeyID.equals(this.getKeyID())) throw Error("Revocation signature does not match key");
        try {
            await i.verify(this.keyPacket, R.signature.keyRevocation, {
                key: this.keyPacket
            }, t, void 0, r);
        } catch (e) {
            throw M.wrapError("Could not verify revocation signature", e);
        }
        const s = this.clone();
        return s.revocationSignatures.push(i), s;
    }
    async signPrimaryUser(e, t, r, n = T) {
        const { index: i, user: s } = await this.getPrimaryUser(t, r, n), a = await s.certify(e, t, n), o = this.clone();
        return o.users[i] = a, o;
    }
    async signAllUsers(e, t = new Date, r = T) {
        const n = this.clone();
        return n.users = await Promise.all(this.users.map(function(n) {
            return n.certify(e, t, r);
        })), n;
    }
    async verifyPrimaryUser(e, t = new Date, r, n = T) {
        const i = this.keyPacket, { user: s } = await this.getPrimaryUser(t, r, n);
        return e ? await s.verifyAllCertifications(e, t, n) : [
            {
                keyID: i.getKeyID(),
                valid: await s.verify(t, n).catch(()=>!1)
            }
        ];
    }
    async verifyAllUsers(e, t = new Date, r = T) {
        const n = this.keyPacket, i = [];
        return await Promise.all(this.users.map(async (s)=>{
            const a = e ? await s.verifyAllCertifications(e, t, r) : [
                {
                    keyID: n.getKeyID(),
                    valid: await s.verify(t, r).catch(()=>!1)
                }
            ];
            i.push(...a.map((e)=>({
                    userID: s.userID ? s.userID.userID : null,
                    userAttribute: s.userAttribute,
                    keyID: e.keyID,
                    valid: e.valid
                })));
        })), i;
    }
}
[
    "getKeyID",
    "getFingerprint",
    "getAlgorithmInfo",
    "getCreationTime",
    "hasSameFingerprintAs"
].forEach((e)=>{
    Co.prototype[e] = Io.prototype[e];
});
class Do extends Co {
    constructor(e){
        if (super(), this.keyPacket = null, this.revocationSignatures = [], this.directSignatures = [], this.users = [], this.subkeys = [], e && (this.packetListToStructure(e, new Set([
            R.packet.secretKey,
            R.packet.secretSubkey
        ])), !this.keyPacket)) throw Error("Invalid key: missing public-key packet");
    }
    isPrivate() {
        return !1;
    }
    toPublic() {
        return this;
    }
    armor(e = T) {
        const t = 6 !== this.keyPacket.version;
        return X(R.armor.publicKey, this.toPacketList().write(), void 0, void 0, void 0, t, e);
    }
}
class Uo extends Do {
    constructor(e){
        if (super(), this.packetListToStructure(e, new Set([
            R.packet.publicKey,
            R.packet.publicSubkey
        ])), !this.keyPacket) throw Error("Invalid key: missing private-key packet");
    }
    isPrivate() {
        return !0;
    }
    toPublic() {
        const e = new Ua, t = this.toPacketList();
        for (const r of t)switch(r.constructor.tag){
            case R.packet.secretKey:
                {
                    const t = qa.fromSecretKeyPacket(r);
                    e.push(t);
                    break;
                }
            case R.packet.secretSubkey:
                {
                    const t = Za.fromSecretSubkeyPacket(r);
                    e.push(t);
                    break;
                }
            default:
                e.push(r);
        }
        return new Do(e);
    }
    armor(e = T) {
        const t = 6 !== this.keyPacket.version;
        return X(R.armor.privateKey, this.toPacketList().write(), void 0, void 0, void 0, t, e);
    }
    async getDecryptionKeys(e, t = new Date, r = {}, n = T) {
        const i = this.keyPacket, s = [];
        let a = null;
        for(let r = 0; r < this.subkeys.length; r++)if (!e || this.subkeys[r].getKeyID().equals(e, !0)) {
            if (this.subkeys[r].keyPacket.isDummy()) {
                a = a || Error("Gnu-dummy key packets cannot be used for decryption");
                continue;
            }
            try {
                const e = {
                    key: i,
                    bind: this.subkeys[r].keyPacket
                }, a = await ho(this.subkeys[r].bindingSignatures, i, R.signature.subkeyBinding, e, t, n);
                ko(this.subkeys[r].keyPacket, a, n) && s.push(this.subkeys[r]);
            } catch (e) {
                a = e;
            }
        }
        const o = await this.getPrimarySelfSignature(t, r, n);
        if (e && !i.getKeyID().equals(e, !0) || !ko(i, o, n) || (i.isDummy() ? a = a || Error("Gnu-dummy key packets cannot be used for decryption") : s.push(this)), 0 === s.length) throw a || Error("No decryption key packets found");
        return s;
    }
    isDecrypted() {
        return this.getKeys().some(({ keyPacket: e })=>e.isDecrypted());
    }
    async validate(e = T) {
        if (!this.isPrivate()) throw Error("Cannot validate a public key");
        let t;
        if (this.keyPacket.isDummy()) {
            const r = await this.getSigningKey(null, null, void 0, {
                ...e,
                rejectPublicKeyAlgorithms: new Set,
                minRSABits: 0
            });
            r && !r.keyPacket.isDummy() && (t = r.keyPacket);
        } else t = this.keyPacket;
        if (t) return t.validate();
        {
            const e = this.getKeys();
            if (e.map((e)=>e.keyPacket.isDummy()).every(Boolean)) throw Error("Cannot validate an all-gnu-dummy key");
            return Promise.all(e.map(async (e)=>e.keyPacket.validate()));
        }
    }
    clearPrivateParams() {
        this.getKeys().forEach(({ keyPacket: e })=>{
            e.isDecrypted() && e.clearPrivateParams();
        });
    }
    async revoke({ flag: e = R.reasonForRevocation.noReason, string: t = "" } = {}, r = new Date, n = T) {
        if (!this.isPrivate()) throw Error("Need private key for revoking");
        const i = {
            key: this.keyPacket
        }, s = this.clone();
        return s.revocationSignatures.push(await fo(i, [], this.keyPacket, {
            signatureType: R.signature.keyRevocation,
            reasonForRevocationFlag: R.write(R.reasonForRevocation, e),
            reasonForRevocationString: t
        }, r, void 0, void 0, void 0, n)), s;
    }
    async addSubkey(e = {}) {
        const t = {
            ...T,
            ...e.config
        };
        if (e.passphrase) throw Error("Subkey could not be encrypted here, please encrypt whole key");
        if (e.rsaBits < t.minRSABits) throw Error(`rsaBits should be at least ${t.minRSABits}, got: ${e.rsaBits}`);
        const r = this.keyPacket;
        if (r.isDummy()) throw Error("Cannot add subkey to gnu-dummy primary key");
        if (!r.isDecrypted()) throw Error("Key is not decrypted");
        const n = r.getAlgorithmInfo();
        n.type = function(e) {
            switch(R.write(R.publicKey, e)){
                case R.publicKey.rsaEncrypt:
                case R.publicKey.rsaEncryptSign:
                case R.publicKey.rsaSign:
                case R.publicKey.dsa:
                    return "rsa";
                case R.publicKey.ecdsa:
                case R.publicKey.eddsaLegacy:
                    return "ecc";
                case R.publicKey.ed25519:
                    return "curve25519";
                case R.publicKey.ed448:
                    return "curve448";
                default:
                    throw Error("Unsupported algorithm");
            }
        }(n.algorithm), n.rsaBits = n.bits || 4096, n.curve = n.curve || "curve25519Legacy", e = wo(e, n);
        const i = await oo(e, {
            ...t,
            v6Keys: 6 === this.keyPacket.version
        });
        Eo(i, t);
        const s = await lo(i, r, e, t), a = this.toPacketList();
        return a.push(i, s), new Uo(a);
    }
}
const Po = /*#__PURE__*/ M.constructAllowedPackets([
    qa,
    Za,
    $a,
    to,
    eo,
    Wa,
    Ba
]);
function xo(e) {
    for (const t of e)switch(t.constructor.tag){
        case R.packet.secretKey:
            return new Uo(e);
        case R.packet.publicKey:
            return new Do(e);
    }
    throw Error("No key packet found");
}
async function Qo(e, t, r, n) {
    r.passphrase && await e.encrypt(r.passphrase, n), await Promise.all(t.map(async function(e, t) {
        const i = r.subkeys[t].passphrase;
        i && await e.encrypt(i, n);
    }));
    const i = new Ua;
    function s(e, t) {
        return [
            t,
            ...e.filter((e)=>e !== t)
        ];
    }
    function a() {
        const e = {};
        e.keyFlags = [
            R.keyFlags.certifyKeys | R.keyFlags.signData
        ];
        const t = s([
            R.symmetric.aes256,
            R.symmetric.aes128
        ], n.preferredSymmetricAlgorithm);
        if (e.preferredSymmetricAlgorithms = t, n.aeadProtect) {
            const r = s([
                R.aead.gcm,
                R.aead.eax,
                R.aead.ocb
            ], n.preferredAEADAlgorithm);
            e.preferredCipherSuites = r.flatMap((e)=>t.map((t)=>[
                        t,
                        e
                    ]));
        }
        return e.preferredHashAlgorithms = s([
            R.hash.sha512,
            R.hash.sha256,
            R.hash.sha3_512,
            R.hash.sha3_256
        ], n.preferredHashAlgorithm), e.preferredCompressionAlgorithms = s([
            R.compression.uncompressed,
            R.compression.zlib,
            R.compression.zip
        ], n.preferredCompressionAlgorithm), e.features = [
            0
        ], e.features[0] |= R.features.modificationDetection, n.aeadProtect && (e.features[0] |= R.features.seipdv2), r.keyExpirationTime > 0 && (e.keyExpirationTime = r.keyExpirationTime, e.keyNeverExpires = !1), e;
    }
    if (i.push(e), 6 === e.version) {
        const t = {
            key: e
        }, s = a();
        s.signatureType = R.signature.key;
        const o = await fo(t, [], e, s, r.date, void 0, void 0, void 0, n);
        i.push(o);
    }
    await Promise.all(r.userIDs.map(async function(t, i) {
        const s = eo.fromObject(t), o = {
            userID: s,
            key: e
        }, c = 6 !== e.version ? a() : {};
        c.signatureType = R.signature.certPositive, 0 === i && (c.isPrimaryUserID = !0);
        return {
            userIDPacket: s,
            signaturePacket: await fo(o, [], e, c, r.date, void 0, void 0, void 0, n)
        };
    })).then((e)=>{
        e.forEach(({ userIDPacket: e, signaturePacket: t })=>{
            i.push(e), i.push(t);
        });
    }), await Promise.all(t.map(async function(t, i) {
        const s = r.subkeys[i];
        return {
            secretSubkeyPacket: t,
            subkeySignaturePacket: await lo(t, e, s, n)
        };
    })).then((e)=>{
        e.forEach(({ secretSubkeyPacket: e, subkeySignaturePacket: t })=>{
            i.push(e), i.push(t);
        });
    });
    const o = {
        key: e
    };
    return i.push(await fo(o, [], e, {
        signatureType: R.signature.keyRevocation,
        reasonForRevocationFlag: R.reasonForRevocation.noReason,
        reasonForRevocationString: ""
    }, r.date, void 0, void 0, void 0, n)), r.passphrase && e.clearPrivateParams(), await Promise.all(t.map(async function(e, t) {
        r.subkeys[t].passphrase && e.clearPrivateParams();
    })), new Uo(i);
}
async function Ro({ armoredKey: e, binaryKey: t, config: r, ...n }) {
    if (r = {
        ...T,
        ...r
    }, !e && !t) throw Error("readKey: must pass options object containing `armoredKey` or `binaryKey`");
    if (e && !M.isString(e)) throw Error("readKey: options.armoredKey must be a string");
    if (t && !M.isUint8Array(t)) throw Error("readKey: options.binaryKey must be a Uint8Array");
    const i = Object.keys(n);
    if (i.length > 0) throw Error("Unknown option: " + i.join(", "));
    let s;
    if (e) {
        const { type: t, data: r } = await $(e);
        if (t !== R.armor.publicKey && t !== R.armor.privateKey) throw Error("Armored text not of type key");
        s = r;
    } else s = t;
    const a = await Ua.fromBinary(s, Po, r), o = a.indexOfTag(R.packet.publicKey, R.packet.secretKey);
    if (0 === o.length) throw Error("No key packet found");
    return xo(a.slice(o[0], o[1]));
}
async function To({ armoredKey: e, binaryKey: t, config: r, ...n }) {
    if (r = {
        ...T,
        ...r
    }, !e && !t) throw Error("readPrivateKey: must pass options object containing `armoredKey` or `binaryKey`");
    if (e && !M.isString(e)) throw Error("readPrivateKey: options.armoredKey must be a string");
    if (t && !M.isUint8Array(t)) throw Error("readPrivateKey: options.binaryKey must be a Uint8Array");
    const i = Object.keys(n);
    if (i.length > 0) throw Error("Unknown option: " + i.join(", "));
    let s;
    if (e) {
        const { type: t, data: r } = await $(e);
        if (t !== R.armor.privateKey) throw Error("Armored text not of type private key");
        s = r;
    } else s = t;
    const a = await Ua.fromBinary(s, Po, r), o = a.indexOfTag(R.packet.publicKey, R.packet.secretKey);
    for(let e = 0; e < o.length; e++){
        if (a[o[e]].constructor.tag === R.packet.publicKey) continue;
        const t = a.slice(o[e], o[e + 1]);
        return new Uo(t);
    }
    throw Error("No secret key packet found");
}
async function Lo({ armoredKeys: e, binaryKeys: t, config: r, ...n }) {
    r = {
        ...T,
        ...r
    };
    let i = e || t;
    if (!i) throw Error("readKeys: must pass options object containing `armoredKeys` or `binaryKeys`");
    if (e && !M.isString(e)) throw Error("readKeys: options.armoredKeys must be a string");
    if (t && !M.isUint8Array(t)) throw Error("readKeys: options.binaryKeys must be a Uint8Array");
    const s = Object.keys(n);
    if (s.length > 0) throw Error("Unknown option: " + s.join(", "));
    if (e) {
        const { type: t, data: r } = await $(e);
        if (t !== R.armor.publicKey && t !== R.armor.privateKey) throw Error("Armored text not of type key");
        i = r;
    }
    const a = [], o = await Ua.fromBinary(i, Po, r), c = o.indexOfTag(R.packet.publicKey, R.packet.secretKey);
    if (0 === c.length) throw Error("No key packet found");
    for(let e = 0; e < c.length; e++){
        const t = xo(o.slice(c[e], c[e + 1]));
        a.push(t);
    }
    return a;
}
async function Mo({ armoredKeys: e, binaryKeys: t, config: r }) {
    r = {
        ...T,
        ...r
    };
    let n = e || t;
    if (!n) throw Error("readPrivateKeys: must pass options object containing `armoredKeys` or `binaryKeys`");
    if (e && !M.isString(e)) throw Error("readPrivateKeys: options.armoredKeys must be a string");
    if (t && !M.isUint8Array(t)) throw Error("readPrivateKeys: options.binaryKeys must be a Uint8Array");
    if (e) {
        const { type: t, data: r } = await $(e);
        if (t !== R.armor.privateKey) throw Error("Armored text not of type private key");
        n = r;
    }
    const i = [], s = await Ua.fromBinary(n, Po, r), a = s.indexOfTag(R.packet.publicKey, R.packet.secretKey);
    for(let e = 0; e < a.length; e++){
        if (s[a[e]].constructor.tag === R.packet.publicKey) continue;
        const t = s.slice(a[e], a[e + 1]), r = new Uo(t);
        i.push(r);
    }
    if (0 === i.length) throw Error("No secret key packet found");
    return i;
}
const No = /*#__PURE__*/ M.constructAllowedPackets([
    ba,
    xa,
    za,
    Fa,
    Ja,
    Ga,
    ja,
    Ca,
    Ba
]), Fo = /*#__PURE__*/ M.constructAllowedPackets([
    ja
]), Oo = /*#__PURE__*/ M.constructAllowedPackets([
    Ba
]);
class Ho {
    constructor(e){
        this.packets = e || new Ua;
    }
    getEncryptionKeyIDs() {
        const e = [];
        return this.packets.filterByTag(R.packet.publicKeyEncryptedSessionKey).forEach(function(t) {
            e.push(t.publicKeyID);
        }), e;
    }
    getSigningKeyIDs() {
        const e = this.unwrapCompressed(), t = e.packets.filterByTag(R.packet.onePassSignature);
        if (t.length > 0) return t.map((e)=>e.issuerKeyID);
        return e.packets.filterByTag(R.packet.signature).map((e)=>e.issuerKeyID);
    }
    async decrypt(e, t, r, n = new Date, i = T) {
        const s = this.packets.filterByTag(R.packet.symmetricallyEncryptedData, R.packet.symEncryptedIntegrityProtectedData, R.packet.aeadEncryptedData);
        if (0 === s.length) throw Error("No encrypted data found");
        const a = s[0], o = a.cipherAlgorithm, c = r || await this.decryptSessionKeys(e, t, o, n, i);
        let h = null;
        const u = Promise.all(c.map(async ({ algorithm: e, data: t })=>{
            if (!M.isUint8Array(t) || !a.cipherAlgorithm && !M.isString(e)) throw Error("Invalid session key for decryption.");
            try {
                const r = a.cipherAlgorithm || R.write(R.symmetric, e);
                await a.decrypt(r, t, i);
            } catch (e) {
                M.printDebugError(e), h = e;
            }
        }));
        if (D(a.encrypted), a.encrypted = null, await u, !a.packets || !a.packets.length) throw h || Error("Decryption failed.");
        const l = new Ho(a.packets);
        return a.packets = new Ua, l;
    }
    async decryptSessionKeys(e, t, r, n = new Date, i = T) {
        let s, a = [];
        if (t) {
            const e = this.packets.filterByTag(R.packet.symEncryptedSessionKey);
            if (0 === e.length) throw Error("No symmetrically encrypted session key packet found.");
            await Promise.all(t.map(async function(t, r) {
                let n;
                n = r ? await Ua.fromBinary(e.write(), Fo, i) : e, await Promise.all(n.map(async function(e) {
                    try {
                        await e.decrypt(t), a.push(e);
                    } catch (e) {
                        M.printDebugError(e), e instanceof bs && (s = e);
                    }
                }));
            }));
        } else {
            if (!e) throw Error("No key or password specified.");
            {
                const t = this.packets.filterByTag(R.packet.publicKeyEncryptedSessionKey);
                if (0 === t.length) throw Error("No public key encrypted session key packet found.");
                await Promise.all(t.map(async function(t) {
                    await Promise.all(e.map(async function(e) {
                        let o;
                        try {
                            o = (await e.getDecryptionKeys(t.publicKeyID, null, void 0, i)).map((e)=>e.keyPacket);
                        } catch (e) {
                            return void (s = e);
                        }
                        let c = [
                            R.symmetric.aes256,
                            R.symmetric.aes128,
                            R.symmetric.tripledes,
                            R.symmetric.cast5
                        ];
                        try {
                            const t = await e.getPrimarySelfSignature(n, void 0, i);
                            t.preferredSymmetricAlgorithms && (c = c.concat(t.preferredSymmetricAlgorithms));
                        } catch (e) {}
                        await Promise.all(o.map(async function(e) {
                            if (!e.isDecrypted()) throw Error("Decryption key is not decrypted.");
                            if (i.constantTimePKCS1Decryption && (t.publicKeyAlgorithm === R.publicKey.rsaEncrypt || t.publicKeyAlgorithm === R.publicKey.rsaEncryptSign || t.publicKeyAlgorithm === R.publicKey.rsaSign || t.publicKeyAlgorithm === R.publicKey.elgamal)) {
                                const n = t.write();
                                await Promise.all((r ? [
                                    r
                                ] : Array.from(i.constantTimePKCS1DecryptionSupportedSymmetricAlgorithms)).map(async (t)=>{
                                    const r = new Ga;
                                    r.read(n);
                                    const i = {
                                        sessionKeyAlgorithm: t,
                                        sessionKey: vi(t)
                                    };
                                    try {
                                        await r.decrypt(e, i), a.push(r);
                                    } catch (e) {
                                        M.printDebugError(e), s = e;
                                    }
                                }));
                            } else try {
                                await t.decrypt(e);
                                const n = r || t.sessionKeyAlgorithm;
                                if (n && !c.includes(R.write(R.symmetric, n))) throw Error("A non-preferred symmetric algorithm was used.");
                                a.push(t);
                            } catch (e) {
                                M.printDebugError(e), s = e;
                            }
                        }));
                    })), D(t.encrypted), t.encrypted = null;
                }));
            }
        }
        if (a.length > 0) {
            if (a.length > 1) {
                const e = new Set;
                a = a.filter((t)=>{
                    const r = t.sessionKeyAlgorithm + M.uint8ArrayToString(t.sessionKey);
                    return !e.has(r) && (e.add(r), !0);
                });
            }
            return a.map((e)=>({
                    data: e.sessionKey,
                    algorithm: e.sessionKeyAlgorithm && R.read(R.symmetric, e.sessionKeyAlgorithm)
                }));
        }
        throw s || Error("Session key decryption failed.");
    }
    getLiteralData() {
        const e = this.unwrapCompressed().packets.findPacket(R.packet.literalData);
        return e && e.getBytes() || null;
    }
    getFilename() {
        const e = this.unwrapCompressed().packets.findPacket(R.packet.literalData);
        return e && e.getFilename() || null;
    }
    getText() {
        const e = this.unwrapCompressed().packets.findPacket(R.packet.literalData);
        return e ? e.getText() : null;
    }
    static async generateSessionKey(e = [], t = new Date, r = [], n = T) {
        const { symmetricAlgo: i, aeadAlgo: s } = await async function(e = [], t = new Date, r = [], n = T) {
            const i = await Promise.all(e.map((e, i)=>e.getPrimarySelfSignature(t, r[i], n)));
            if (e.length ? i.every((e)=>e.features && e.features[0] & R.features.seipdv2) : n.aeadProtect) {
                const e = {
                    symmetricAlgo: R.symmetric.aes128,
                    aeadAlgo: R.aead.ocb
                }, t = [
                    {
                        symmetricAlgo: n.preferredSymmetricAlgorithm,
                        aeadAlgo: n.preferredAEADAlgorithm
                    },
                    {
                        symmetricAlgo: n.preferredSymmetricAlgorithm,
                        aeadAlgo: R.aead.ocb
                    },
                    {
                        symmetricAlgo: R.symmetric.aes128,
                        aeadAlgo: n.preferredAEADAlgorithm
                    }
                ];
                for (const e of t)if (i.every((t)=>t.preferredCipherSuites && t.preferredCipherSuites.some((t)=>t[0] === e.symmetricAlgo && t[1] === e.aeadAlgo))) return e;
                return e;
            }
            const s = R.symmetric.aes128, a = n.preferredSymmetricAlgorithm;
            return {
                symmetricAlgo: i.every((e)=>e.preferredSymmetricAlgorithms && e.preferredSymmetricAlgorithms.includes(a)) ? a : s,
                aeadAlgo: void 0
            };
        }(e, t, r, n), a = R.read(R.symmetric, i), o = s ? R.read(R.aead, s) : void 0;
        await Promise.all(e.map((e)=>e.getEncryptionKey().catch(()=>null).then((e)=>{
                if (e && (e.keyPacket.algorithm === R.publicKey.x25519 || e.keyPacket.algorithm === R.publicKey.x448) && !o && !M.isAES(i)) throw Error("Could not generate a session key compatible with the given `encryptionKeys`: X22519 and X448 keys can only be used to encrypt AES session keys; change `config.preferredSymmetricAlgorithm` accordingly.");
            })));
        return {
            data: vi(i),
            algorithm: a,
            aeadAlgorithm: o
        };
    }
    async encrypt(e, t, r, n = !1, i = [], s = new Date, a = [], o = T) {
        if (r) {
            if (!M.isUint8Array(r.data) || !M.isString(r.algorithm)) throw Error("Invalid session key for encryption.");
        } else if (e && e.length) r = await Ho.generateSessionKey(e, s, a, o);
        else {
            if (!t || !t.length) throw Error("No keys, passwords, or session key provided.");
            r = await Ho.generateSessionKey(void 0, void 0, void 0, o);
        }
        const { data: c, algorithm: h, aeadAlgorithm: u } = r, l = await Ho.encryptSessionKey(c, h, u, e, t, n, i, s, a, o), y = Fa.fromObject({
            version: u ? 2 : 1,
            aeadAlgorithm: u ? R.write(R.aead, u) : null
        });
        y.packets = this.packets;
        const f = R.write(R.symmetric, h);
        return await y.encrypt(f, c, o), l.packets.push(y), y.packets = new Ua, l;
    }
    static async encryptSessionKey(e, t, r, n, i, s = !1, a = [], o = new Date, c = [], h = T) {
        const u = new Ua, l = R.write(R.symmetric, t), y = r && R.write(R.aead, r);
        if (n) {
            const t = await Promise.all(n.map(async function(t, r) {
                const n = await t.getEncryptionKey(a[r], o, c, h), i = Ga.fromObject({
                    version: y ? 6 : 3,
                    encryptionKeyPacket: n.keyPacket,
                    anonymousRecipient: s,
                    sessionKey: e,
                    sessionKeyAlgorithm: l
                });
                return await i.encrypt(n.keyPacket), delete i.sessionKey, i;
            }));
            u.push(...t);
        }
        if (i) {
            const t = async function(e, t) {
                try {
                    return await e.decrypt(t), 1;
                } catch (e) {
                    return 0;
                }
            }, r = (e, t)=>e + t, n = async function(e, s, a, o) {
                const c = new ja(h);
                if (c.sessionKey = e, c.sessionKeyAlgorithm = s, a && (c.aeadAlgorithm = a), await c.encrypt(o, h), h.passwordCollisionCheck) {
                    if (1 !== (await Promise.all(i.map((e)=>t(c, e)))).reduce(r)) return n(e, s, o);
                }
                return delete c.sessionKey, c;
            }, s = await Promise.all(i.map((t)=>n(e, l, y, t)));
            u.push(...s);
        }
        return new Ho(u);
    }
    async sign(e = [], t = [], r = null, n = [], i = new Date, s = [], a = [], o = [], c = T) {
        const h = new Ua, u = this.packets.findPacket(R.packet.literalData);
        if (!u) throw Error("No literal data packet to sign.");
        const l = await zo(u, e, t, r, n, i, s, a, o, !1, c), y = l.map((e, t)=>Ca.fromSignaturePacket(e, 0 === t)).reverse();
        return h.push(...y), h.push(u), h.push(...l), new Ho(h);
    }
    compress(e, t = T) {
        if (e === R.compression.uncompressed) return this;
        const r = new xa(t);
        r.algorithm = e, r.packets = this.packets;
        const n = new Ua;
        return n.push(r), new Ho(n);
    }
    async signDetached(e = [], t = [], r = null, n = [], i = [], s = new Date, a = [], o = [], c = T) {
        const h = this.packets.findPacket(R.packet.literalData);
        if (!h) throw Error("No literal data packet to sign.");
        return new so(await zo(h, e, t, r, n, i, s, a, o, !0, c));
    }
    async verify(e, t = new Date, r = T) {
        const n = this.unwrapCompressed(), i = n.packets.filterByTag(R.packet.literalData);
        if (1 !== i.length) throw Error("Can only verify message with one literal data packet.");
        o(n.packets.stream) && n.packets.push(...await C(n.packets.stream, (e)=>e || []));
        const s = n.packets.filterByTag(R.packet.onePassSignature).reverse(), a = n.packets.filterByTag(R.packet.signature);
        return s.length && !a.length && M.isStream(n.packets.stream) && !o(n.packets.stream) ? (await Promise.all(s.map(async (e)=>{
            e.correspondingSig = new Promise((t, r)=>{
                e.correspondingSigResolve = t, e.correspondingSigReject = r;
            }), e.signatureData = U(async ()=>(await e.correspondingSig).signatureData), e.hashed = C(await e.hash(e.signatureType, i[0], void 0, !1)), e.hashed.catch(()=>{});
        })), n.packets.stream = E(n.packets.stream, async (e, t)=>{
            const r = P(e), n = x(t);
            try {
                for(let e = 0; e < s.length; e++){
                    const { value: t } = await r.read();
                    s[e].correspondingSigResolve(t);
                }
                await r.readToEnd(), await n.ready, await n.close();
            } catch (e) {
                s.forEach((t)=>{
                    t.correspondingSigReject(e);
                }), await n.abort(e);
            }
        }), Go(s, i, e, t, !1, r)) : Go(a, i, e, t, !1, r);
    }
    verifyDetached(e, t, r = new Date, n = T) {
        const i = this.unwrapCompressed().packets.filterByTag(R.packet.literalData);
        if (1 !== i.length) throw Error("Can only verify message with one literal data packet.");
        return Go(e.packets.filterByTag(R.packet.signature), i, t, r, !0, n);
    }
    unwrapCompressed() {
        const e = this.packets.filterByTag(R.packet.compressedData);
        return e.length ? new Ho(e[0].packets) : this;
    }
    async appendSignature(e, t = T) {
        await this.packets.read(M.isUint8Array(e) ? e : (await $(e)).data, Oo, t);
    }
    write() {
        return this.packets.write();
    }
    armor(e = T) {
        const t = this.packets[this.packets.length - 1], r = t.constructor.tag === Fa.tag ? 2 !== t.version : this.packets.some((e)=>e.constructor.tag === Ba.tag && 6 !== e.version);
        return X(R.armor.message, this.write(), null, null, null, r, e);
    }
}
async function zo(e, t, r = [], n = null, i = [], s = new Date, a = [], o = [], c = [], h = !1, u = T) {
    const l = new Ua, y = null === e.text ? R.signature.binary : R.signature.text;
    if (await Promise.all(t.map(async (t, n)=>{
        const l = a[n];
        if (!t.isPrivate()) throw Error("Need private key for signing");
        const f = await t.getSigningKey(i[n], s, l, u);
        return fo(e, r.length ? r : [
            t
        ], f.keyPacket, {
            signatureType: y
        }, s, o, c, h, u);
    })).then((e)=>{
        l.push(...e);
    }), n) {
        const e = n.packets.filterByTag(R.packet.signature);
        l.push(...e);
    }
    return l;
}
async function Go(e, t, r, n = new Date, i = !1, s = T) {
    return Promise.all(e.filter(function(e) {
        return [
            "text",
            "binary"
        ].includes(R.read(R.signature, e.signatureType));
    }).map(async function(e) {
        return async function(e, t, r, n = new Date, i = !1, s = T) {
            let a, o;
            for (const t of r){
                const r = t.getKeys(e.issuerKeyID);
                if (r.length > 0) {
                    a = t, o = r[0];
                    break;
                }
            }
            const c = e instanceof Ca ? e.correspondingSig : e, h = {
                keyID: e.issuerKeyID,
                verified: (async ()=>{
                    if (!o) throw Error("Could not find signing key with key ID " + e.issuerKeyID.toHex());
                    await e.verify(o.keyPacket, e.signatureType, t[0], n, i, s);
                    const r = await c;
                    if (o.getCreationTime() > r.created) throw Error("Key is newer than the signature");
                    try {
                        await a.getSigningKey(o.getKeyID(), r.created, void 0, s);
                    } catch (e) {
                        if (!s.allowInsecureVerificationWithReformattedKeys || !e.message.match(/Signature creation time is in the future/)) throw e;
                        await a.getSigningKey(o.getKeyID(), n, void 0, s);
                    }
                    return !0;
                })(),
                signature: (async ()=>{
                    const e = await c, t = new Ua;
                    return e && t.push(e), new so(t);
                })()
            };
            return h.signature.catch(()=>{}), h.verified.catch(()=>{}), h;
        }(e, t, r, n, i, s);
    }));
}
async function _o({ armoredMessage: e, binaryMessage: t, config: r, ...n }) {
    r = {
        ...T,
        ...r
    };
    let i = e || t;
    if (!i) throw Error("readMessage: must pass options object containing `armoredMessage` or `binaryMessage`");
    if (e && !M.isString(e) && !M.isStream(e)) throw Error("readMessage: options.armoredMessage must be a string or stream");
    if (t && !M.isUint8Array(t) && !M.isStream(t)) throw Error("readMessage: options.binaryMessage must be a Uint8Array or stream");
    const s = Object.keys(n);
    if (s.length > 0) throw Error("Unknown option: " + s.join(", "));
    const a = M.isStream(i);
    if (e) {
        const { type: e, data: t } = await $(i);
        if (e !== R.armor.message) throw Error("Armored text not of type message");
        i = t;
    }
    const o = await Ua.fromBinary(i, No, r), c = new Ho(o);
    return c.fromStream = a, c;
}
async function jo({ text: e, binary: t, filename: r, date: n = new Date, format: i = void 0 !== e ? "utf8" : "binary", ...s }) {
    const a = void 0 !== e ? e : t;
    if (void 0 === a) throw Error("createMessage: must pass options object containing `text` or `binary`");
    if (e && !M.isString(e) && !M.isStream(e)) throw Error("createMessage: options.text must be a string or stream");
    if (t && !M.isUint8Array(t) && !M.isStream(t)) throw Error("createMessage: options.binary must be a Uint8Array or stream");
    const o = Object.keys(s);
    if (o.length > 0) throw Error("Unknown option: " + o.join(", "));
    const c = M.isStream(a), h = new ba(n);
    void 0 !== e ? h.setText(a, R.write(R.literal, i)) : h.setBytes(a, R.write(R.literal, i)), void 0 !== r && h.setFilename(r);
    const u = new Ua;
    u.push(h);
    const l = new Ho(u);
    return l.fromStream = c, l;
}
const qo = /*#__PURE__*/ M.constructAllowedPackets([
    Ba
]);
class Vo {
    constructor(e, t){
        if (this.text = M.removeTrailingSpaces(e).replace(/\r?\n/g, "\r\n"), t && !(t instanceof so)) throw Error("Invalid signature input");
        this.signature = t || new so(new Ua);
    }
    getSigningKeyIDs() {
        const e = [];
        return this.signature.packets.forEach(function(t) {
            e.push(t.issuerKeyID);
        }), e;
    }
    async sign(e, t = [], r = null, n = [], i = new Date, s = [], a = [], o = [], c = T) {
        const h = new ba;
        h.setText(this.text);
        const u = new so(await zo(h, e, t, r, n, i, s, a, o, !0, c));
        return new Vo(this.text, u);
    }
    verify(e, t = new Date, r = T) {
        const n = this.signature.packets.filterByTag(R.packet.signature), i = new ba;
        return i.setText(this.text), Go(n, [
            i
        ], e, t, !0, r);
    }
    getText() {
        return this.text.replace(/\r\n/g, "\n");
    }
    armor(e = T) {
        const t = this.signature.packets.some((e)=>6 !== e.version), r = {
            hash: t ? Array.from(new Set(this.signature.packets.map((e)=>R.read(R.hash, e.hashAlgorithm).toUpperCase()))).join() : null,
            text: this.text,
            data: this.signature.packets.write()
        };
        return X(R.armor.signed, r, void 0, void 0, void 0, t, e);
    }
}
async function Jo({ cleartextMessage: e, config: t, ...r }) {
    if (t = {
        ...T,
        ...t
    }, !e) throw Error("readCleartextMessage: must pass options object containing `cleartextMessage`");
    if (!M.isString(e)) throw Error("readCleartextMessage: options.cleartextMessage must be a string");
    const n = Object.keys(r);
    if (n.length > 0) throw Error("Unknown option: " + n.join(", "));
    const i = await $(e);
    if (i.type !== R.armor.signed) throw Error("No cleartext signed message.");
    const s = await Ua.fromBinary(i.data, qo, t);
    !function(e, t) {
        const r = function(e) {
            const r = (e)=>(t)=>e.hashAlgorithm === t;
            for(let n = 0; n < t.length; n++)if (t[n].constructor.tag === R.packet.signature && !e.some(r(t[n]))) return !1;
            return !0;
        }, n = [];
        if (e.forEach((e)=>{
            const t = e.match(/^Hash: (.+)$/);
            if (!t) throw Error('Only "Hash" header allowed in cleartext signed message');
            {
                const e = t[1].replace(/\s/g, "").split(",").map((e)=>{
                    try {
                        return R.write(R.hash, e.toLowerCase());
                    } catch (t) {
                        throw Error("Unknown hash algorithm in armor header: " + e.toLowerCase());
                    }
                });
                n.push(...e);
            }
        }), n.length && !r(n)) throw Error("Hash algorithm mismatch in armor header and signature");
    }(i.headers, s);
    const a = new so(s);
    return new Vo(i.text, a);
}
async function Yo({ text: e, ...t }) {
    if (!e) throw Error("createCleartextMessage: must pass options object containing `text`");
    if (!M.isString(e)) throw Error("createCleartextMessage: options.text must be a string");
    const r = Object.keys(t);
    if (r.length > 0) throw Error("Unknown option: " + r.join(", "));
    return new Vo(e);
}
async function Zo({ userIDs: e = [], passphrase: t, type: r, curve: n, rsaBits: i = 4096, keyExpirationTime: s = 0, date: a = new Date, subkeys: o = [
    {}
], format: c = "armored", config: h, ...u }) {
    yc(h = {
        ...T,
        ...h
    }), r || n ? (r = r || "ecc", n = n || "curve25519Legacy") : (r = h.v6Keys ? "curve25519" : "ecc", n = "curve25519Legacy"), e = fc(e);
    const l = Object.keys(u);
    if (l.length > 0) throw Error("Unknown option: " + l.join(", "));
    if (0 === e.length && !h.v6Keys) throw Error("UserIDs are required for V4 keys");
    if ("rsa" === r && i < h.minRSABits) throw Error(`rsaBits should be at least ${h.minRSABits}, got: ${i}`);
    const y = {
        userIDs: e,
        passphrase: t,
        type: r,
        rsaBits: i,
        curve: n,
        keyExpirationTime: s,
        date: a,
        subkeys: o
    };
    try {
        const { key: e, revocationCertificate: t } = await async function(e, t) {
            e.sign = !0, (e = wo(e)).subkeys = e.subkeys.map((t, r)=>wo(e.subkeys[r], e));
            let r = [
                co(e, t)
            ];
            r = r.concat(e.subkeys.map((e)=>oo(e, t)));
            const n = await Promise.all(r), i = await Qo(n[0], n.slice(1), e, t), s = await i.getRevocationCertificate(e.date, t);
            return i.revocationSignatures = [], {
                key: i,
                revocationCertificate: s
            };
        }(y, h);
        return e.getKeys().forEach(({ keyPacket: e })=>Eo(e, h)), {
            privateKey: dc(e, c, h),
            publicKey: dc(e.toPublic(), c, h),
            revocationCertificate: t
        };
    } catch (e) {
        throw M.wrapError("Error generating keypair", e);
    }
}
async function Wo({ privateKey: e, userIDs: t = [], passphrase: r, keyExpirationTime: n = 0, date: i, format: s = "armored", config: a, ...o }) {
    yc(a = {
        ...T,
        ...a
    }), t = fc(t);
    const c = Object.keys(o);
    if (c.length > 0) throw Error("Unknown option: " + c.join(", "));
    if (0 === t.length && 6 !== e.keyPacket.version) throw Error("UserIDs are required for V4 keys");
    const h = {
        privateKey: e,
        userIDs: t,
        passphrase: r,
        keyExpirationTime: n,
        date: i
    };
    try {
        const { key: e, revocationCertificate: t } = await async function(e, t) {
            e = o(e);
            const { privateKey: r } = e;
            if (!r.isPrivate()) throw Error("Cannot reformat a public key");
            if (r.keyPacket.isDummy()) throw Error("Cannot reformat a gnu-dummy primary key");
            if (!r.getKeys().every(({ keyPacket: e })=>e.isDecrypted())) throw Error("Key is not decrypted");
            const n = r.keyPacket;
            e.subkeys || (e.subkeys = await Promise.all(r.subkeys.map(async (e)=>{
                const r = e.keyPacket, i = {
                    key: n,
                    bind: r
                }, s = await ho(e.bindingSignatures, n, R.signature.subkeyBinding, i, null, t).catch(()=>({}));
                return {
                    sign: s.keyFlags && s.keyFlags[0] & R.keyFlags.signData
                };
            })));
            const i = r.subkeys.map((e)=>e.keyPacket);
            if (e.subkeys.length !== i.length) throw Error("Number of subkey options does not match number of subkeys");
            e.subkeys = e.subkeys.map((t)=>o(t, e));
            const s = await Qo(n, i, e, t), a = await s.getRevocationCertificate(e.date, t);
            return s.revocationSignatures = [], {
                key: s,
                revocationCertificate: a
            };
            function o(e, t = {}) {
                return e.keyExpirationTime = e.keyExpirationTime || t.keyExpirationTime, e.passphrase = M.isString(e.passphrase) ? e.passphrase : t.passphrase, e.date = e.date || t.date, e;
            }
        }(h, a);
        return {
            privateKey: dc(e, s, a),
            publicKey: dc(e.toPublic(), s, a),
            revocationCertificate: t
        };
    } catch (e) {
        throw M.wrapError("Error reformatting keypair", e);
    }
}
async function $o({ key: e, revocationCertificate: t, reasonForRevocation: r, date: n = new Date, format: i = "armored", config: s, ...a }) {
    yc(s = {
        ...T,
        ...s
    });
    const o = Object.keys(a);
    if (o.length > 0) throw Error("Unknown option: " + o.join(", "));
    try {
        const a = t ? await e.applyRevocationCertificate(t, n, s) : await e.revoke(r, n, s);
        return a.isPrivate() ? {
            privateKey: dc(a, i, s),
            publicKey: dc(a.toPublic(), i, s)
        } : {
            privateKey: null,
            publicKey: dc(a, i, s)
        };
    } catch (e) {
        throw M.wrapError("Error revoking key", e);
    }
}
async function Xo({ privateKey: e, passphrase: t, config: r, ...n }) {
    yc(r = {
        ...T,
        ...r
    });
    const i = Object.keys(n);
    if (i.length > 0) throw Error("Unknown option: " + i.join(", "));
    if (!e.isPrivate()) throw Error("Cannot decrypt a public key");
    const s = e.clone(!0), a = M.isArray(t) ? t : [
        t
    ];
    try {
        return await Promise.all(s.getKeys().map((e)=>M.anyPromise(a.map((t)=>e.keyPacket.decrypt(t))))), await s.validate(r), s;
    } catch (e) {
        throw s.clearPrivateParams(), M.wrapError("Error decrypting private key", e);
    }
}
async function ec({ privateKey: e, passphrase: t, config: r, ...n }) {
    yc(r = {
        ...T,
        ...r
    });
    const i = Object.keys(n);
    if (i.length > 0) throw Error("Unknown option: " + i.join(", "));
    if (!e.isPrivate()) throw Error("Cannot encrypt a public key");
    const s = e.clone(!0), a = s.getKeys(), o = M.isArray(t) ? t : Array(a.length).fill(t);
    if (o.length !== a.length) throw Error("Invalid number of passphrases given for key encryption");
    try {
        return await Promise.all(a.map(async (e, t)=>{
            const { keyPacket: n } = e;
            await n.encrypt(o[t], r), n.clearPrivateParams();
        })), s;
    } catch (e) {
        throw s.clearPrivateParams(), M.wrapError("Error encrypting private key", e);
    }
}
async function tc({ message: e, encryptionKeys: t, signingKeys: r, passwords: n, sessionKey: i, format: s = "armored", signature: a = null, wildcard: o = !1, signingKeyIDs: c = [], encryptionKeyIDs: h = [], date: u = new Date, signingUserIDs: l = [], encryptionUserIDs: y = [], signatureNotations: f = [], config: g, ...p }) {
    if (yc(g = {
        ...T,
        ...g
    }), cc(e), uc(s), t = fc(t), r = fc(r), n = fc(n), c = fc(c), h = fc(h), l = fc(l), y = fc(y), f = fc(f), p.detached) throw Error("The `detached` option has been removed from openpgp.encrypt, separately call openpgp.sign instead. Don't forget to remove the `privateKeys` option as well.");
    if (p.publicKeys) throw Error("The `publicKeys` option has been removed from openpgp.encrypt, pass `encryptionKeys` instead");
    if (p.privateKeys) throw Error("The `privateKeys` option has been removed from openpgp.encrypt, pass `signingKeys` instead");
    if (void 0 !== p.armor) throw Error("The `armor` option has been removed from openpgp.encrypt, pass `format` instead.");
    const d = Object.keys(p);
    if (d.length > 0) throw Error("Unknown option: " + d.join(", "));
    r || (r = []);
    try {
        if ((r.length || a) && (e = await e.sign(r, t, a, c, u, l, h, f, g)), e = e.compress(await async function(e = [], t = new Date, r = [], n = T) {
            const i = R.compression.uncompressed, s = n.preferredCompressionAlgorithm, a = await Promise.all(e.map(async function(e, i) {
                const a = (await e.getPrimarySelfSignature(t, r[i], n)).preferredCompressionAlgorithms;
                return !!a && a.indexOf(s) >= 0;
            }));
            return a.every(Boolean) ? s : i;
        }(t, u, y, g), g), e = await e.encrypt(t, n, i, o, h, u, y, g), "object" === s) return e;
        const p = "armored" === s ? e.armor(g) : e.write();
        return await gc(p);
    } catch (e) {
        throw M.wrapError("Error encrypting message", e);
    }
}
async function rc({ message: e, decryptionKeys: t, passwords: r, sessionKeys: n, verificationKeys: i, expectSigned: s = !1, format: a = "utf8", signature: o = null, date: c = new Date, config: h, ...u }) {
    if (yc(h = {
        ...T,
        ...h
    }), cc(e), i = fc(i), t = fc(t), r = fc(r), n = fc(n), u.privateKeys) throw Error("The `privateKeys` option has been removed from openpgp.decrypt, pass `decryptionKeys` instead");
    if (u.publicKeys) throw Error("The `publicKeys` option has been removed from openpgp.decrypt, pass `verificationKeys` instead");
    const l = Object.keys(u);
    if (l.length > 0) throw Error("Unknown option: " + l.join(", "));
    try {
        const u = await e.decrypt(t, r, n, c, h);
        i || (i = []);
        const l = {};
        if (l.signatures = o ? await u.verifyDetached(o, i, c, h) : await u.verify(i, c, h), l.data = "binary" === a ? u.getLiteralData() : u.getText(), l.filename = u.getFilename(), pc(l, e), s) {
            if (0 === i.length) throw Error("Verification keys are required to verify message signatures");
            if (0 === l.signatures.length) throw Error("Message is not signed");
            l.data = A([
                l.data,
                U(async ()=>(await M.anyPromise(l.signatures.map((e)=>e.verified)), "binary" === a ? new Uint8Array : ""))
            ]);
        }
        return l.data = await gc(l.data), l;
    } catch (e) {
        throw M.wrapError("Error decrypting message", e);
    }
}
async function nc({ message: e, signingKeys: t, recipientKeys: r = [], format: n = "armored", detached: i = !1, signingKeyIDs: s = [], date: a = new Date, signingUserIDs: o = [], recipientUserIDs: c = [], signatureNotations: h = [], config: u, ...l }) {
    if (yc(u = {
        ...T,
        ...u
    }), hc(e), uc(n), t = fc(t), s = fc(s), o = fc(o), r = fc(r), c = fc(c), h = fc(h), l.privateKeys) throw Error("The `privateKeys` option has been removed from openpgp.sign, pass `signingKeys` instead");
    if (void 0 !== l.armor) throw Error("The `armor` option has been removed from openpgp.sign, pass `format` instead.");
    const y = Object.keys(l);
    if (y.length > 0) throw Error("Unknown option: " + y.join(", "));
    if (e instanceof Vo && "binary" === n) throw Error("Cannot return signed cleartext message in binary format");
    if (e instanceof Vo && i) throw Error("Cannot detach-sign a cleartext message");
    if (!t || 0 === t.length) throw Error("No signing keys provided");
    try {
        let l;
        if (l = i ? await e.signDetached(t, r, void 0, s, a, o, c, h, u) : await e.sign(t, r, void 0, s, a, o, c, h, u), "object" === n) return l;
        return l = "armored" === n ? l.armor(u) : l.write(), i && (l = E(e.packets.write(), async (e, t)=>{
            await Promise.all([
                w(l, t),
                C(e).catch(()=>{})
            ]);
        })), await gc(l);
    } catch (e) {
        throw M.wrapError("Error signing message", e);
    }
}
async function ic({ message: e, verificationKeys: t, expectSigned: r = !1, format: n = "utf8", signature: i = null, date: s = new Date, config: a, ...o }) {
    if (yc(a = {
        ...T,
        ...a
    }), hc(e), t = fc(t), o.publicKeys) throw Error("The `publicKeys` option has been removed from openpgp.verify, pass `verificationKeys` instead");
    const c = Object.keys(o);
    if (c.length > 0) throw Error("Unknown option: " + c.join(", "));
    if (e instanceof Vo && "binary" === n) throw Error("Can't return cleartext message data as binary");
    if (e instanceof Vo && i) throw Error("Can't verify detached cleartext signature");
    try {
        const o = {};
        if (o.signatures = i ? await e.verifyDetached(i, t, s, a) : await e.verify(t, s, a), o.data = "binary" === n ? e.getLiteralData() : e.getText(), e.fromStream && !i && pc(o, e), r) {
            if (0 === o.signatures.length) throw Error("Message is not signed");
            o.data = A([
                o.data,
                U(async ()=>(await M.anyPromise(o.signatures.map((e)=>e.verified)), "binary" === n ? new Uint8Array : ""))
            ]);
        }
        return o.data = await gc(o.data), o;
    } catch (e) {
        throw M.wrapError("Error verifying signed message", e);
    }
}
async function sc({ encryptionKeys: e, date: t = new Date, encryptionUserIDs: r = [], config: n, ...i }) {
    if (yc(n = {
        ...T,
        ...n
    }), e = fc(e), r = fc(r), i.publicKeys) throw Error("The `publicKeys` option has been removed from openpgp.generateSessionKey, pass `encryptionKeys` instead");
    const s = Object.keys(i);
    if (s.length > 0) throw Error("Unknown option: " + s.join(", "));
    try {
        return await Ho.generateSessionKey(e, t, r, n);
    } catch (e) {
        throw M.wrapError("Error generating session key", e);
    }
}
async function ac({ data: e, algorithm: t, aeadAlgorithm: r, encryptionKeys: n, passwords: i, format: s = "armored", wildcard: a = !1, encryptionKeyIDs: o = [], date: c = new Date, encryptionUserIDs: h = [], config: u, ...l }) {
    if (yc(u = {
        ...T,
        ...u
    }), function(e) {
        if (!M.isUint8Array(e)) throw Error("Parameter [data] must be of type Uint8Array");
    }(e), function(e, t) {
        if (!M.isString(e)) throw Error("Parameter [" + t + "] must be of type String");
    }(t, "algorithm"), uc(s), n = fc(n), i = fc(i), o = fc(o), h = fc(h), l.publicKeys) throw Error("The `publicKeys` option has been removed from openpgp.encryptSessionKey, pass `encryptionKeys` instead");
    const y = Object.keys(l);
    if (y.length > 0) throw Error("Unknown option: " + y.join(", "));
    if (!(n && 0 !== n.length || i && 0 !== i.length)) throw Error("No encryption keys or passwords provided.");
    try {
        return dc(await Ho.encryptSessionKey(e, t, r, n, i, a, o, c, h, u), s, u);
    } catch (e) {
        throw M.wrapError("Error encrypting session key", e);
    }
}
async function oc({ message: e, decryptionKeys: t, passwords: r, date: n = new Date, config: i, ...s }) {
    if (yc(i = {
        ...T,
        ...i
    }), cc(e), t = fc(t), r = fc(r), s.privateKeys) throw Error("The `privateKeys` option has been removed from openpgp.decryptSessionKeys, pass `decryptionKeys` instead");
    const a = Object.keys(s);
    if (a.length > 0) throw Error("Unknown option: " + a.join(", "));
    try {
        return await e.decryptSessionKeys(t, r, void 0, n, i);
    } catch (e) {
        throw M.wrapError("Error decrypting session keys", e);
    }
}
function cc(e) {
    if (!(e instanceof Ho)) throw Error("Parameter [message] needs to be of type Message");
}
function hc(e) {
    if (!(e instanceof Vo || e instanceof Ho)) throw Error("Parameter [message] needs to be of type Message or CleartextMessage");
}
function uc(e) {
    if ("armored" !== e && "binary" !== e && "object" !== e) throw Error("Unsupported format " + e);
}
const lc = Object.keys(T).length;
function yc(e) {
    const t = Object.keys(e);
    if (t.length !== lc) {
        for (const e of t)if (void 0 === T[e]) throw Error("Unknown config property: " + e);
    }
}
function fc(e) {
    return e && !M.isArray(e) && (e = [
        e
    ]), e;
}
async function gc(e) {
    return "array" === M.isStream(e) ? C(e) : e;
}
function pc(e, t) {
    e.data = E(t.packets.stream, async (t, r)=>{
        await w(e.data, r, {
            preventClose: !0
        });
        const n = x(r);
        try {
            await C(t, (e)=>e), await n.close();
        } catch (e) {
            await n.abort(e);
        }
    });
}
function dc(e, t, r) {
    switch(t){
        case "object":
            return e;
        case "armored":
            return e.armor(r);
        case "binary":
            return e.write();
        default:
            throw Error("Unsupported format " + t);
    }
}
function Ac(e) {
    if (!Number.isSafeInteger(e) || e < 0) throw Error("positive integer expected, not " + e);
}
function wc(e, ...t) {
    if (!((r = e) instanceof Uint8Array || null != r && "object" == typeof r && "Uint8Array" === r.constructor.name)) throw Error("Uint8Array expected");
    var r;
    if (t.length > 0 && !t.includes(e.length)) throw Error(`Uint8Array expected of length ${t}, not of length=${e.length}`);
}
function mc(e, t = !0) {
    if (e.destroyed) throw Error("Hash instance has been destroyed");
    if (t && e.finished) throw Error("Hash#digest() has already been called");
}
function bc(e, t) {
    wc(e);
    const r = t.outputLen;
    if (e.length < r) throw Error("digestInto() expects output buffer of length at least " + r);
}
const kc = "object" == typeof e && "crypto" in e ? e.crypto : void 0, Ec = (e)=>new DataView(e.buffer, e.byteOffset, e.byteLength), vc = (e, t)=>e << 32 - t | e >>> t, Ic = (e, t)=>e << t | e >>> 32 - t >>> 0, Bc = 68 === new Uint8Array(new Uint32Array([
    287454020
]).buffer)[0];
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ function Sc(e) {
    for(let r = 0; r < e.length; r++)e[r] = (t = e[r]) << 24 & 4278190080 | t << 8 & 16711680 | t >>> 8 & 65280 | t >>> 24 & 255;
    var t;
}
function Kc(e) {
    if ("string" != typeof e) throw Error("utf8ToBytes expected string, got " + typeof e);
    return new Uint8Array((new TextEncoder).encode(e));
}
function Cc(e) {
    return "string" == typeof e && (e = Kc(e)), wc(e), e;
}
function Dc(...e) {
    let t = 0;
    for(let r = 0; r < e.length; r++){
        const n = e[r];
        wc(n), t += n.length;
    }
    const r = new Uint8Array(t);
    for(let t = 0, n = 0; t < e.length; t++){
        const i = e[t];
        r.set(i, n), n += i.length;
    }
    return r;
}
class Uc {
    clone() {
        return this._cloneInto();
    }
}
function Pc(e) {
    const t = (t)=>e().update(Cc(t)).digest(), r = e();
    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = ()=>e(), t;
}
function xc(e = 32) {
    if (kc && "function" == typeof kc.getRandomValues) return kc.getRandomValues(new Uint8Array(e));
    if (kc && "function" == typeof kc.randomBytes) return kc.randomBytes(e);
    throw Error("crypto.getRandomValues must be defined");
}
const Qc = (e, t, r)=>e & t ^ ~e & r, Rc = (e, t, r)=>e & t ^ e & r ^ t & r;
class Tc extends Uc {
    constructor(e, t, r, n){
        super(), this.blockLen = e, this.outputLen = t, this.padOffset = r, this.isLE = n, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = Ec(this.buffer);
    }
    update(e) {
        mc(this);
        const { view: t, buffer: r, blockLen: n } = this, i = (e = Cc(e)).length;
        for(let s = 0; s < i;){
            const a = Math.min(n - this.pos, i - s);
            if (a !== n) r.set(e.subarray(s, s + a), this.pos), this.pos += a, s += a, this.pos === n && (this.process(t, 0), this.pos = 0);
            else {
                const t = Ec(e);
                for(; n <= i - s; s += n)this.process(t, s);
            }
        }
        return this.length += e.length, this.roundClean(), this;
    }
    digestInto(e) {
        mc(this), bc(e, this), this.finished = !0;
        const { buffer: t, view: r, blockLen: n, isLE: i } = this;
        let { pos: s } = this;
        t[s++] = 128, this.buffer.subarray(s).fill(0), this.padOffset > n - s && (this.process(r, 0), s = 0);
        for(let e = s; e < n; e++)t[e] = 0;
        !function(e, t, r, n) {
            if ("function" == typeof e.setBigUint64) return e.setBigUint64(t, r, n);
            const i = BigInt(32), s = BigInt(4294967295), a = Number(r >> i & s), o = Number(r & s), c = n ? 4 : 0, h = n ? 0 : 4;
            e.setUint32(t + c, a, n), e.setUint32(t + h, o, n);
        }(r, n - 8, BigInt(8 * this.length), i), this.process(r, 0);
        const a = Ec(e), o = this.outputLen;
        if (o % 4) throw Error("_sha2: outputLen should be aligned to 32bit");
        const c = o / 4, h = this.get();
        if (c > h.length) throw Error("_sha2: outputLen bigger than state");
        for(let e = 0; e < c; e++)a.setUint32(4 * e, h[e], i);
    }
    digest() {
        const { buffer: e, outputLen: t } = this;
        this.digestInto(e);
        const r = e.slice(0, t);
        return this.destroy(), r;
    }
    _cloneInto(e) {
        e || (e = new this.constructor), e.set(...this.get());
        const { blockLen: t, buffer: r, length: n, finished: i, destroyed: s, pos: a } = this;
        return e.length = n, e.pos = a, e.finished = i, e.destroyed = s, n % t && e.buffer.set(r), e;
    }
}
const Lc = /* @__PURE__ */ new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
]), Mc = /* @__PURE__ */ new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
]), Nc = /* @__PURE__ */ new Uint32Array(64);
class Fc extends Tc {
    constructor(){
        super(64, 32, 8, !1), this.A = 0 | Mc[0], this.B = 0 | Mc[1], this.C = 0 | Mc[2], this.D = 0 | Mc[3], this.E = 0 | Mc[4], this.F = 0 | Mc[5], this.G = 0 | Mc[6], this.H = 0 | Mc[7];
    }
    get() {
        const { A: e, B: t, C: r, D: n, E: i, F: s, G: a, H: o } = this;
        return [
            e,
            t,
            r,
            n,
            i,
            s,
            a,
            o
        ];
    }
    set(e, t, r, n, i, s, a, o) {
        this.A = 0 | e, this.B = 0 | t, this.C = 0 | r, this.D = 0 | n, this.E = 0 | i, this.F = 0 | s, this.G = 0 | a, this.H = 0 | o;
    }
    process(e, t) {
        for(let r = 0; r < 16; r++, t += 4)Nc[r] = e.getUint32(t, !1);
        for(let e = 16; e < 64; e++){
            const t = Nc[e - 15], r = Nc[e - 2], n = vc(t, 7) ^ vc(t, 18) ^ t >>> 3, i = vc(r, 17) ^ vc(r, 19) ^ r >>> 10;
            Nc[e] = i + Nc[e - 7] + n + Nc[e - 16] | 0;
        }
        let { A: r, B: n, C: i, D: s, E: a, F: o, G: c, H: h } = this;
        for(let e = 0; e < 64; e++){
            const t = h + (vc(a, 6) ^ vc(a, 11) ^ vc(a, 25)) + Qc(a, o, c) + Lc[e] + Nc[e] | 0, u = (vc(r, 2) ^ vc(r, 13) ^ vc(r, 22)) + Rc(r, n, i) | 0;
            h = c, c = o, o = a, a = s + t | 0, s = i, i = n, n = r, r = t + u | 0;
        }
        r = r + this.A | 0, n = n + this.B | 0, i = i + this.C | 0, s = s + this.D | 0, a = a + this.E | 0, o = o + this.F | 0, c = c + this.G | 0, h = h + this.H | 0, this.set(r, n, i, s, a, o, c, h);
    }
    roundClean() {
        Nc.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
}
class Oc extends Fc {
    constructor(){
        super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
}
const Hc = /* @__PURE__ */ Pc(()=>new Fc), zc = /* @__PURE__ */ Pc(()=>new Oc);
class Gc extends Uc {
    constructor(e, t){
        super(), this.finished = !1, this.destroyed = !1, function(e) {
            if ("function" != typeof e || "function" != typeof e.create) throw Error("Hash should be wrapped by utils.wrapConstructor");
            Ac(e.outputLen), Ac(e.blockLen);
        }(e);
        const r = Cc(t);
        if (this.iHash = e.create(), "function" != typeof this.iHash.update) throw Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
        const n = this.blockLen, i = new Uint8Array(n);
        i.set(r.length > n ? e.create().update(r).digest() : r);
        for(let e = 0; e < i.length; e++)i[e] ^= 54;
        this.iHash.update(i), this.oHash = e.create();
        for(let e = 0; e < i.length; e++)i[e] ^= 106;
        this.oHash.update(i), i.fill(0);
    }
    update(e) {
        return mc(this), this.iHash.update(e), this;
    }
    digestInto(e) {
        mc(this), wc(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
    }
    digest() {
        const e = new Uint8Array(this.oHash.outputLen);
        return this.digestInto(e), e;
    }
    _cloneInto(e) {
        e || (e = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: t, iHash: r, finished: n, destroyed: i, blockLen: s, outputLen: a } = this;
        return e.finished = n, e.destroyed = i, e.blockLen = s, e.outputLen = a, e.oHash = t._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
    }
    destroy() {
        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
}
const _c = (e, t, r)=>new Gc(e, t).update(r).digest();
_c.create = (e, t)=>new Gc(e, t);
const jc = /* @__PURE__ */ BigInt(0), qc = /* @__PURE__ */ BigInt(1), Vc = /* @__PURE__ */ BigInt(2);
function Jc(e) {
    return e instanceof Uint8Array || null != e && "object" == typeof e && "Uint8Array" === e.constructor.name;
}
function Yc(e) {
    if (!Jc(e)) throw Error("Uint8Array expected");
}
function Zc(e, t) {
    if ("boolean" != typeof t) throw Error(`${e} must be valid boolean, got "${t}".`);
}
const Wc = /* @__PURE__ */ Array.from({
    length: 256
}, (e, t)=>t.toString(16).padStart(2, "0"));
function $c(e) {
    Yc(e);
    let t = "";
    for(let r = 0; r < e.length; r++)t += Wc[e[r]];
    return t;
}
function Xc(e) {
    const t = e.toString(16);
    return 1 & t.length ? "0" + t : t;
}
function eh(e) {
    if ("string" != typeof e) throw Error("hex string expected, got " + typeof e);
    return BigInt("" === e ? "0" : "0x" + e);
}
const th = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function rh(e) {
    return e >= th._0 && e <= th._9 ? e - th._0 : e >= th._A && e <= th._F ? e - (th._A - 10) : e >= th._a && e <= th._f ? e - (th._a - 10) : void 0;
}
function nh(e) {
    if ("string" != typeof e) throw Error("hex string expected, got " + typeof e);
    const t = e.length, r = t / 2;
    if (t % 2) throw Error("padded hex string expected, got unpadded hex of length " + t);
    const n = new Uint8Array(r);
    for(let t = 0, i = 0; t < r; t++, i += 2){
        const r = rh(e.charCodeAt(i)), s = rh(e.charCodeAt(i + 1));
        if (void 0 === r || void 0 === s) {
            const t = e[i] + e[i + 1];
            throw Error('hex string expected, got non-hex character "' + t + '" at index ' + i);
        }
        n[t] = 16 * r + s;
    }
    return n;
}
function ih(e) {
    return eh($c(e));
}
function sh(e) {
    return Yc(e), eh($c(Uint8Array.from(e).reverse()));
}
function ah(e, t) {
    return nh(e.toString(16).padStart(2 * t, "0"));
}
function oh(e, t) {
    return ah(e, t).reverse();
}
function ch(e, t, r) {
    let n;
    if ("string" == typeof t) try {
        n = nh(t);
    } catch (r) {
        throw Error(`${e} must be valid hex string, got "${t}". Cause: ${r}`);
    }
    else {
        if (!Jc(t)) throw Error(e + " must be hex string or Uint8Array");
        n = Uint8Array.from(t);
    }
    const i = n.length;
    if ("number" == typeof r && i !== r) throw Error(`${e} expected ${r} bytes, got ${i}`);
    return n;
}
function hh(...e) {
    let t = 0;
    for(let r = 0; r < e.length; r++){
        const n = e[r];
        Yc(n), t += n.length;
    }
    const r = new Uint8Array(t);
    for(let t = 0, n = 0; t < e.length; t++){
        const i = e[t];
        r.set(i, n), n += i.length;
    }
    return r;
}
const uh = (e)=>"bigint" == typeof e && jc <= e;
function lh(e, t, r) {
    return uh(e) && uh(t) && uh(r) && t <= e && e < r;
}
function yh(e, t, r, n) {
    if (!lh(t, r, n)) throw Error(`expected valid ${e}: ${r} <= n < ${n}, got ${typeof t} ${t}`);
}
function fh(e) {
    let t;
    for(t = 0; e > jc; e >>= qc, t += 1);
    return t;
}
const gh = (e)=>(Vc << BigInt(e - 1)) - qc, ph = (e)=>new Uint8Array(e), dh = (e)=>Uint8Array.from(e);
function Ah(e, t, r) {
    if ("number" != typeof e || e < 2) throw Error("hashLen must be a number");
    if ("number" != typeof t || t < 2) throw Error("qByteLen must be a number");
    if ("function" != typeof r) throw Error("hmacFn must be a function");
    let n = ph(e), i = ph(e), s = 0;
    const a = ()=>{
        n.fill(1), i.fill(0), s = 0;
    }, o = (...e)=>r(i, n, ...e), c = (e = ph())=>{
        i = o(dh([
            0
        ]), e), n = o(), 0 !== e.length && (i = o(dh([
            1
        ]), e), n = o());
    }, h = ()=>{
        if (s++ >= 1e3) throw Error("drbg: tried 1000 values");
        let e = 0;
        const r = [];
        for(; e < t;){
            n = o();
            const t = n.slice();
            r.push(t), e += n.length;
        }
        return hh(...r);
    };
    return (e, t)=>{
        let r;
        for(a(), c(e); !(r = t(h()));)c();
        return a(), r;
    };
}
const wh = {
    bigint: (e)=>"bigint" == typeof e,
    function: (e)=>"function" == typeof e,
    boolean: (e)=>"boolean" == typeof e,
    string: (e)=>"string" == typeof e,
    stringOrUint8Array: (e)=>"string" == typeof e || Jc(e),
    isSafeInteger: (e)=>Number.isSafeInteger(e),
    array: (e)=>Array.isArray(e),
    field: (e, t)=>t.Fp.isValid(e),
    hash: (e)=>"function" == typeof e && Number.isSafeInteger(e.outputLen)
};
function mh(e, t, r = {}) {
    const n = (t, r, n)=>{
        const i = wh[r];
        if ("function" != typeof i) throw Error(`Invalid validator "${r}", expected function`);
        const s = e[t];
        if (!(n && void 0 === s || i(s, e))) throw Error(`Invalid param ${t + ""}=${s} (${typeof s}), expected ${r}`);
    };
    for (const [e, r] of Object.entries(t))n(e, r, !1);
    for (const [e, t] of Object.entries(r))n(e, t, !0);
    return e;
}
function bh(e) {
    const t = new WeakMap;
    return (r, ...n)=>{
        const i = t.get(r);
        if (void 0 !== i) return i;
        const s = e(r, ...n);
        return t.set(r, s), s;
    };
}
var kh = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    aInRange: yh,
    abool: Zc,
    abytes: Yc,
    bitGet: function(e, t) {
        return e >> BigInt(t) & qc;
    },
    bitLen: fh,
    bitMask: gh,
    bitSet: function(e, t, r) {
        return e | (r ? qc : jc) << BigInt(t);
    },
    bytesToHex: $c,
    bytesToNumberBE: ih,
    bytesToNumberLE: sh,
    concatBytes: hh,
    createHmacDrbg: Ah,
    ensureBytes: ch,
    equalBytes: function(e, t) {
        if (e.length !== t.length) return !1;
        let r = 0;
        for(let n = 0; n < e.length; n++)r |= e[n] ^ t[n];
        return 0 === r;
    },
    hexToBytes: nh,
    hexToNumber: eh,
    inRange: lh,
    isBytes: Jc,
    memoized: bh,
    notImplemented: ()=>{
        throw Error("not implemented");
    },
    numberToBytesBE: ah,
    numberToBytesLE: oh,
    numberToHexUnpadded: Xc,
    numberToVarBytesBE: function(e) {
        return nh(Xc(e));
    },
    utf8ToBytes: function(e) {
        if ("string" != typeof e) throw Error("utf8ToBytes expected string, got " + typeof e);
        return new Uint8Array((new TextEncoder).encode(e));
    },
    validateObject: mh
});
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const Eh = BigInt(0), vh = BigInt(1), Ih = BigInt(2), Bh = BigInt(3), Sh = BigInt(4), Kh = BigInt(5), Ch = BigInt(8);
function Dh(e, t) {
    const r = e % t;
    return r >= Eh ? r : t + r;
}
function Uh(e, t, r) {
    if (r <= Eh || t < Eh) throw Error("Expected power/modulo > 0");
    if (r === vh) return Eh;
    let n = vh;
    for(; t > Eh;)t & vh && (n = n * e % r), e = e * e % r, t >>= vh;
    return n;
}
function Ph(e, t, r) {
    let n = e;
    for(; t-- > Eh;)n *= n, n %= r;
    return n;
}
function xh(e, t) {
    if (e === Eh || t <= Eh) throw Error(`invert: expected positive integers, got n=${e} mod=${t}`);
    let r = Dh(e, t), n = t, i = Eh, s = vh;
    for(; r !== Eh;){
        const e = n % r, t = i - s * (n / r);
        n = r, r = e, i = s, s = t;
    }
    if (n !== vh) throw Error("invert: does not exist");
    return Dh(i, t);
}
function Qh(e) {
    if (e % Sh === Bh) {
        const t = (e + vh) / Sh;
        return function(e, r) {
            const n = e.pow(r, t);
            if (!e.eql(e.sqr(n), r)) throw Error("Cannot find square root");
            return n;
        };
    }
    if (e % Ch === Kh) {
        const t = (e - Kh) / Ch;
        return function(e, r) {
            const n = e.mul(r, Ih), i = e.pow(n, t), s = e.mul(r, i), a = e.mul(e.mul(s, Ih), i), o = e.mul(s, e.sub(a, e.ONE));
            if (!e.eql(e.sqr(o), r)) throw Error("Cannot find square root");
            return o;
        };
    }
    return function(e) {
        const t = (e - vh) / Ih;
        let r, n, i;
        for(r = e - vh, n = 0; r % Ih === Eh; r /= Ih, n++);
        for(i = Ih; i < e && Uh(i, t, e) !== e - vh; i++);
        if (1 === n) {
            const t = (e + vh) / Sh;
            return function(e, r) {
                const n = e.pow(r, t);
                if (!e.eql(e.sqr(n), r)) throw Error("Cannot find square root");
                return n;
            };
        }
        const s = (r + vh) / Ih;
        return function(e, a) {
            if (e.pow(a, t) === e.neg(e.ONE)) throw Error("Cannot find square root");
            let o = n, c = e.pow(e.mul(e.ONE, i), r), h = e.pow(a, s), u = e.pow(a, r);
            for(; !e.eql(u, e.ONE);){
                if (e.eql(u, e.ZERO)) return e.ZERO;
                let t = 1;
                for(let r = e.sqr(u); t < o && !e.eql(r, e.ONE); t++)r = e.sqr(r);
                const r = e.pow(c, vh << BigInt(o - t - 1));
                c = e.sqr(r), h = e.mul(h, r), u = e.mul(u, c), o = t;
            }
            return h;
        };
    }(e);
}
BigInt(9), BigInt(16);
const Rh = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function Th(e, t) {
    const r = void 0 !== t ? t : e.toString(2).length;
    return {
        nBitLength: r,
        nByteLength: Math.ceil(r / 8)
    };
}
function Lh(e, t, r = !1, n = {}) {
    if (e <= Eh) throw Error("Expected Field ORDER > 0, got " + e);
    const { nBitLength: i, nByteLength: s } = Th(e, t);
    if (s > 2048) throw Error("Field lengths over 2048 bytes are not supported");
    const a = Qh(e), o = Object.freeze({
        ORDER: e,
        BITS: i,
        BYTES: s,
        MASK: gh(i),
        ZERO: Eh,
        ONE: vh,
        create: (t)=>Dh(t, e),
        isValid: (t)=>{
            if ("bigint" != typeof t) throw Error("Invalid field element: expected bigint, got " + typeof t);
            return Eh <= t && t < e;
        },
        is0: (e)=>e === Eh,
        isOdd: (e)=>(e & vh) === vh,
        neg: (t)=>Dh(-t, e),
        eql: (e, t)=>e === t,
        sqr: (t)=>Dh(t * t, e),
        add: (t, r)=>Dh(t + r, e),
        sub: (t, r)=>Dh(t - r, e),
        mul: (t, r)=>Dh(t * r, e),
        pow: (e, t)=>(function(e, t, r) {
                if (r < Eh) throw Error("Expected power > 0");
                if (r === Eh) return e.ONE;
                if (r === vh) return t;
                let n = e.ONE, i = t;
                for(; r > Eh;)r & vh && (n = e.mul(n, i)), i = e.sqr(i), r >>= vh;
                return n;
            })(o, e, t),
        div: (t, r)=>Dh(t * xh(r, e), e),
        sqrN: (e)=>e * e,
        addN: (e, t)=>e + t,
        subN: (e, t)=>e - t,
        mulN: (e, t)=>e * t,
        inv: (t)=>xh(t, e),
        sqrt: n.sqrt || ((e)=>a(o, e)),
        invertBatch: (e)=>(function(e, t) {
                const r = Array(t.length), n = t.reduce((t, n, i)=>e.is0(n) ? t : (r[i] = t, e.mul(t, n)), e.ONE), i = e.inv(n);
                return t.reduceRight((t, n, i)=>e.is0(n) ? t : (r[i] = e.mul(t, r[i]), e.mul(t, n)), i), r;
            })(o, e),
        cmov: (e, t, r)=>r ? t : e,
        toBytes: (e)=>r ? oh(e, s) : ah(e, s),
        fromBytes: (e)=>{
            if (e.length !== s) throw Error(`Fp.fromBytes: expected ${s}, got ${e.length}`);
            return r ? sh(e) : ih(e);
        }
    });
    return Object.freeze(o);
}
function Mh(e) {
    if ("bigint" != typeof e) throw Error("field order must be bigint");
    const t = e.toString(2).length;
    return Math.ceil(t / 8);
}
function Nh(e) {
    const t = Mh(e);
    return t + Math.ceil(t / 2);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const Fh = BigInt(0), Oh = BigInt(1), Hh = new WeakMap, zh = new WeakMap;
function Gh(e, t) {
    const r = (e, t)=>{
        const r = t.negate();
        return e ? r : t;
    }, n = (e)=>{
        if (!Number.isSafeInteger(e) || e <= 0 || e > t) throw Error(`Wrong window size=${e}, should be [1..${t}]`);
    }, i = (e)=>{
        n(e);
        return {
            windows: Math.ceil(t / e) + 1,
            windowSize: 2 ** (e - 1)
        };
    };
    return {
        constTimeNegate: r,
        unsafeLadder (t, r) {
            let n = e.ZERO, i = t;
            for(; r > Fh;)r & Oh && (n = n.add(i)), i = i.double(), r >>= Oh;
            return n;
        },
        precomputeWindow (e, t) {
            const { windows: r, windowSize: n } = i(t), s = [];
            let a = e, o = a;
            for(let e = 0; e < r; e++){
                o = a, s.push(o);
                for(let e = 1; e < n; e++)o = o.add(a), s.push(o);
                a = o.double();
            }
            return s;
        },
        wNAF (t, n, s) {
            const { windows: a, windowSize: o } = i(t);
            let c = e.ZERO, h = e.BASE;
            const u = BigInt(2 ** t - 1), l = 2 ** t, y = BigInt(t);
            for(let e = 0; e < a; e++){
                const t = e * o;
                let i = Number(s & u);
                s >>= y, i > o && (i -= l, s += Oh);
                const a = t, f = t + Math.abs(i) - 1, g = e % 2 != 0, p = i < 0;
                0 === i ? h = h.add(r(g, n[a])) : c = c.add(r(p, n[f]));
            }
            return {
                p: c,
                f: h
            };
        },
        wNAFCached (e, t, r) {
            const n = zh.get(e) || 1;
            let i = Hh.get(e);
            return i || (i = this.precomputeWindow(e, n), 1 !== n && Hh.set(e, r(i))), this.wNAF(n, i, t);
        },
        setWindowSize (e, t) {
            n(t), zh.set(e, t), Hh.delete(e);
        }
    };
}
function _h(e, t, r, n) {
    if (!Array.isArray(r) || !Array.isArray(n) || n.length !== r.length) throw Error("arrays of points and scalars must have equal length");
    n.forEach((e, r)=>{
        if (!t.isValid(e)) throw Error("wrong scalar at index " + r);
    }), r.forEach((t, r)=>{
        if (!(t instanceof e)) throw Error("wrong point at index " + r);
    });
    const i = fh(BigInt(r.length)), s = i > 12 ? i - 3 : i > 4 ? i - 2 : i ? 2 : 1, a = (1 << s) - 1, o = Array(a + 1).fill(e.ZERO), c = Math.floor((t.BITS - 1) / s) * s;
    let h = e.ZERO;
    for(let t = c; t >= 0; t -= s){
        o.fill(e.ZERO);
        for(let e = 0; e < n.length; e++){
            const i = n[e], s = Number(i >> BigInt(t) & BigInt(a));
            o[s] = o[s].add(r[e]);
        }
        let i = e.ZERO;
        for(let t = o.length - 1, r = e.ZERO; t > 0; t--)r = r.add(o[t]), i = i.add(r);
        if (h = h.add(i), 0 !== t) for(let e = 0; e < s; e++)h = h.double();
    }
    return h;
}
function jh(e) {
    return mh(e.Fp, Rh.reduce((e, t)=>(e[t] = "function", e), {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    })), mh(e, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    }), Object.freeze({
        ...Th(e.n, e.nBitLength),
        ...e,
        p: e.Fp.ORDER
    });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ function qh(e) {
    void 0 !== e.lowS && Zc("lowS", e.lowS), void 0 !== e.prehash && Zc("prehash", e.prehash);
}
const { bytesToNumberBE: Vh, hexToBytes: Jh } = kh, Yh = {
    Err: class extends Error {
        constructor(e = ""){
            super(e);
        }
    },
    _tlv: {
        encode: (e, t)=>{
            const { Err: r } = Yh;
            if (e < 0 || e > 256) throw new r("tlv.encode: wrong tag");
            if (1 & t.length) throw new r("tlv.encode: unpadded data");
            const n = t.length / 2, i = Xc(n);
            if (i.length / 2 & 128) throw new r("tlv.encode: long form length too big");
            const s = n > 127 ? Xc(i.length / 2 | 128) : "";
            return `${Xc(e)}${s}${i}${t}`;
        },
        decode (e, t) {
            const { Err: r } = Yh;
            let n = 0;
            if (e < 0 || e > 256) throw new r("tlv.encode: wrong tag");
            if (t.length < 2 || t[n++] !== e) throw new r("tlv.decode: wrong tlv");
            const i = t[n++];
            let s = 0;
            if (!!(128 & i)) {
                const e = 127 & i;
                if (!e) throw new r("tlv.decode(long): indefinite length not supported");
                if (e > 4) throw new r("tlv.decode(long): byte length is too big");
                const a = t.subarray(n, n + e);
                if (a.length !== e) throw new r("tlv.decode: length bytes not complete");
                if (0 === a[0]) throw new r("tlv.decode(long): zero leftmost byte");
                for (const e of a)s = s << 8 | e;
                if (n += e, s < 128) throw new r("tlv.decode(long): not minimal encoding");
            } else s = i;
            const a = t.subarray(n, n + s);
            if (a.length !== s) throw new r("tlv.decode: wrong value length");
            return {
                v: a,
                l: t.subarray(n + s)
            };
        }
    },
    _int: {
        encode (e) {
            const { Err: t } = Yh;
            if (e < Zh) throw new t("integer: negative integers are not allowed");
            let r = Xc(e);
            if (8 & Number.parseInt(r[0], 16) && (r = "00" + r), 1 & r.length) throw new t("unexpected assertion");
            return r;
        },
        decode (e) {
            const { Err: t } = Yh;
            if (128 & e[0]) throw new t("Invalid signature integer: negative");
            if (0 === e[0] && !(128 & e[1])) throw new t("Invalid signature integer: unnecessary leading zero");
            return Vh(e);
        }
    },
    toSig (e) {
        const { Err: t, _int: r, _tlv: n } = Yh, i = "string" == typeof e ? Jh(e) : e;
        Yc(i);
        const { v: s, l: a } = n.decode(48, i);
        if (a.length) throw new t("Invalid signature: left bytes after parsing");
        const { v: o, l: c } = n.decode(2, s), { v: h, l: u } = n.decode(2, c);
        if (u.length) throw new t("Invalid signature: left bytes after parsing");
        return {
            r: r.decode(o),
            s: r.decode(h)
        };
    },
    hexFromSig (e) {
        const { _tlv: t, _int: r } = Yh, n = `${t.encode(2, r.encode(e.r))}${t.encode(2, r.encode(e.s))}`;
        return t.encode(48, n);
    }
}, Zh = BigInt(0), Wh = BigInt(1);
BigInt(2);
const $h = BigInt(3);
function Xh(e) {
    const t = function(e) {
        const t = jh(e);
        mh(t, {
            a: "field",
            b: "field"
        }, {
            allowedPrivateKeyLengths: "array",
            wrapPrivateKey: "boolean",
            isTorsionFree: "function",
            clearCofactor: "function",
            allowInfinityPoint: "boolean",
            fromBytes: "function",
            toBytes: "function"
        });
        const { endo: r, Fp: n, a: i } = t;
        if (r) {
            if (!n.eql(i, n.ZERO)) throw Error("Endomorphism can only be defined for Koblitz curves that have a=0");
            if ("object" != typeof r || "bigint" != typeof r.beta || "function" != typeof r.splitScalar) throw Error("Expected endomorphism with beta: bigint and splitScalar: function");
        }
        return Object.freeze({
            ...t
        });
    }(e), { Fp: r } = t, n = Lh(t.n, t.nBitLength), i = t.toBytes || ((e, t, n)=>{
        const i = t.toAffine();
        return hh(Uint8Array.from([
            4
        ]), r.toBytes(i.x), r.toBytes(i.y));
    }), s = t.fromBytes || ((e)=>{
        const t = e.subarray(1);
        return {
            x: r.fromBytes(t.subarray(0, r.BYTES)),
            y: r.fromBytes(t.subarray(r.BYTES, 2 * r.BYTES))
        };
    });
    function a(e) {
        const { a: n, b: i } = t, s = r.sqr(e), a = r.mul(s, e);
        return r.add(r.add(a, r.mul(e, n)), i);
    }
    if (!r.eql(r.sqr(t.Gy), a(t.Gx))) throw Error("bad generator point: equation left != right");
    function o(e) {
        const { allowedPrivateKeyLengths: r, nByteLength: n, wrapPrivateKey: i, n: s } = t;
        if (r && "bigint" != typeof e) {
            if (Jc(e) && (e = $c(e)), "string" != typeof e || !r.includes(e.length)) throw Error("Invalid key");
            e = e.padStart(2 * n, "0");
        }
        let a;
        try {
            a = "bigint" == typeof e ? e : ih(ch("private key", e, n));
        } catch (t) {
            throw Error(`private key must be ${n} bytes, hex or bigint, not ${typeof e}`);
        }
        return i && (a = Dh(a, s)), yh("private key", a, Wh, s), a;
    }
    function c(e) {
        if (!(e instanceof l)) throw Error("ProjectivePoint expected");
    }
    const h = bh((e, t)=>{
        const { px: n, py: i, pz: s } = e;
        if (r.eql(s, r.ONE)) return {
            x: n,
            y: i
        };
        const a = e.is0();
        null == t && (t = a ? r.ONE : r.inv(s));
        const o = r.mul(n, t), c = r.mul(i, t), h = r.mul(s, t);
        if (a) return {
            x: r.ZERO,
            y: r.ZERO
        };
        if (!r.eql(h, r.ONE)) throw Error("invZ was invalid");
        return {
            x: o,
            y: c
        };
    }), u = bh((e)=>{
        if (e.is0()) {
            if (t.allowInfinityPoint && !r.is0(e.py)) return;
            throw Error("bad point: ZERO");
        }
        const { x: n, y: i } = e.toAffine();
        if (!r.isValid(n) || !r.isValid(i)) throw Error("bad point: x or y not FE");
        const s = r.sqr(i), o = a(n);
        if (!r.eql(s, o)) throw Error("bad point: equation left != right");
        if (!e.isTorsionFree()) throw Error("bad point: not in prime-order subgroup");
        return !0;
    });
    class l {
        constructor(e, t, n){
            if (this.px = e, this.py = t, this.pz = n, null == e || !r.isValid(e)) throw Error("x required");
            if (null == t || !r.isValid(t)) throw Error("y required");
            if (null == n || !r.isValid(n)) throw Error("z required");
            Object.freeze(this);
        }
        static fromAffine(e) {
            const { x: t, y: n } = e || {};
            if (!e || !r.isValid(t) || !r.isValid(n)) throw Error("invalid affine point");
            if (e instanceof l) throw Error("projective point not allowed");
            const i = (e)=>r.eql(e, r.ZERO);
            return i(t) && i(n) ? l.ZERO : new l(t, n, r.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static normalizeZ(e) {
            const t = r.invertBatch(e.map((e)=>e.pz));
            return e.map((e, r)=>e.toAffine(t[r])).map(l.fromAffine);
        }
        static fromHex(e) {
            const t = l.fromAffine(s(ch("pointHex", e)));
            return t.assertValidity(), t;
        }
        static fromPrivateKey(e) {
            return l.BASE.multiply(o(e));
        }
        static msm(e, t) {
            return _h(l, n, e, t);
        }
        _setWindowSize(e) {
            f.setWindowSize(this, e);
        }
        assertValidity() {
            u(this);
        }
        hasEvenY() {
            const { y: e } = this.toAffine();
            if (r.isOdd) return !r.isOdd(e);
            throw Error("Field doesn't support isOdd");
        }
        equals(e) {
            c(e);
            const { px: t, py: n, pz: i } = this, { px: s, py: a, pz: o } = e, h = r.eql(r.mul(t, o), r.mul(s, i)), u = r.eql(r.mul(n, o), r.mul(a, i));
            return h && u;
        }
        negate() {
            return new l(this.px, r.neg(this.py), this.pz);
        }
        double() {
            const { a: e, b: n } = t, i = r.mul(n, $h), { px: s, py: a, pz: o } = this;
            let c = r.ZERO, h = r.ZERO, u = r.ZERO, y = r.mul(s, s), f = r.mul(a, a), g = r.mul(o, o), p = r.mul(s, a);
            return p = r.add(p, p), u = r.mul(s, o), u = r.add(u, u), c = r.mul(e, u), h = r.mul(i, g), h = r.add(c, h), c = r.sub(f, h), h = r.add(f, h), h = r.mul(c, h), c = r.mul(p, c), u = r.mul(i, u), g = r.mul(e, g), p = r.sub(y, g), p = r.mul(e, p), p = r.add(p, u), u = r.add(y, y), y = r.add(u, y), y = r.add(y, g), y = r.mul(y, p), h = r.add(h, y), g = r.mul(a, o), g = r.add(g, g), y = r.mul(g, p), c = r.sub(c, y), u = r.mul(g, f), u = r.add(u, u), u = r.add(u, u), new l(c, h, u);
        }
        add(e) {
            c(e);
            const { px: n, py: i, pz: s } = this, { px: a, py: o, pz: h } = e;
            let u = r.ZERO, y = r.ZERO, f = r.ZERO;
            const g = t.a, p = r.mul(t.b, $h);
            let d = r.mul(n, a), A = r.mul(i, o), w = r.mul(s, h), m = r.add(n, i), b = r.add(a, o);
            m = r.mul(m, b), b = r.add(d, A), m = r.sub(m, b), b = r.add(n, s);
            let k = r.add(a, h);
            return b = r.mul(b, k), k = r.add(d, w), b = r.sub(b, k), k = r.add(i, s), u = r.add(o, h), k = r.mul(k, u), u = r.add(A, w), k = r.sub(k, u), f = r.mul(g, b), u = r.mul(p, w), f = r.add(u, f), u = r.sub(A, f), f = r.add(A, f), y = r.mul(u, f), A = r.add(d, d), A = r.add(A, d), w = r.mul(g, w), b = r.mul(p, b), A = r.add(A, w), w = r.sub(d, w), w = r.mul(g, w), b = r.add(b, w), d = r.mul(A, b), y = r.add(y, d), d = r.mul(k, b), u = r.mul(m, u), u = r.sub(u, d), d = r.mul(m, A), f = r.mul(k, f), f = r.add(f, d), new l(u, y, f);
        }
        subtract(e) {
            return this.add(e.negate());
        }
        is0() {
            return this.equals(l.ZERO);
        }
        wNAF(e) {
            return f.wNAFCached(this, e, l.normalizeZ);
        }
        multiplyUnsafe(e) {
            yh("scalar", e, Zh, t.n);
            const n = l.ZERO;
            if (e === Zh) return n;
            if (e === Wh) return this;
            const { endo: i } = t;
            if (!i) return f.unsafeLadder(this, e);
            let { k1neg: s, k1: a, k2neg: o, k2: c } = i.splitScalar(e), h = n, u = n, y = this;
            for(; a > Zh || c > Zh;)a & Wh && (h = h.add(y)), c & Wh && (u = u.add(y)), y = y.double(), a >>= Wh, c >>= Wh;
            return s && (h = h.negate()), o && (u = u.negate()), u = new l(r.mul(u.px, i.beta), u.py, u.pz), h.add(u);
        }
        multiply(e) {
            const { endo: n, n: i } = t;
            let s, a;
            if (yh("scalar", e, Wh, i), n) {
                const { k1neg: t, k1: i, k2neg: o, k2: c } = n.splitScalar(e);
                let { p: h, f: u } = this.wNAF(i), { p: y, f: g } = this.wNAF(c);
                h = f.constTimeNegate(t, h), y = f.constTimeNegate(o, y), y = new l(r.mul(y.px, n.beta), y.py, y.pz), s = h.add(y), a = u.add(g);
            } else {
                const { p: t, f: r } = this.wNAF(e);
                s = t, a = r;
            }
            return l.normalizeZ([
                s,
                a
            ])[0];
        }
        multiplyAndAddUnsafe(e, t, r) {
            const n = l.BASE, i = (e, t)=>t !== Zh && t !== Wh && e.equals(n) ? e.multiply(t) : e.multiplyUnsafe(t), s = i(this, t).add(i(e, r));
            return s.is0() ? void 0 : s;
        }
        toAffine(e) {
            return h(this, e);
        }
        isTorsionFree() {
            const { h: e, isTorsionFree: r } = t;
            if (e === Wh) return !0;
            if (r) return r(l, this);
            throw Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: e, clearCofactor: r } = t;
            return e === Wh ? this : r ? r(l, this) : this.multiplyUnsafe(t.h);
        }
        toRawBytes(e = !0) {
            return Zc("isCompressed", e), this.assertValidity(), i(l, this, e);
        }
        toHex(e = !0) {
            return Zc("isCompressed", e), $c(this.toRawBytes(e));
        }
    }
    l.BASE = new l(t.Gx, t.Gy, r.ONE), l.ZERO = new l(r.ZERO, r.ONE, r.ZERO);
    const y = t.nBitLength, f = Gh(l, t.endo ? Math.ceil(y / 2) : y);
    return {
        CURVE: t,
        ProjectivePoint: l,
        normPrivateKeyToScalar: o,
        weierstrassEquation: a,
        isWithinCurveOrder: function(e) {
            return lh(e, Wh, t.n);
        }
    };
}
function eu(e) {
    const t = function(e) {
        const t = jh(e);
        return mh(t, {
            hash: "hash",
            hmac: "function",
            randomBytes: "function"
        }, {
            bits2int: "function",
            bits2int_modN: "function",
            lowS: "boolean"
        }), Object.freeze({
            lowS: !0,
            ...t
        });
    }(e), { Fp: r, n } = t, i = r.BYTES + 1, s = 2 * r.BYTES + 1;
    function a(e) {
        return Dh(e, n);
    }
    function o(e) {
        return xh(e, n);
    }
    const { ProjectivePoint: c, normPrivateKeyToScalar: h, weierstrassEquation: u, isWithinCurveOrder: l } = Xh({
        ...t,
        toBytes (e, t, n) {
            const i = t.toAffine(), s = r.toBytes(i.x), a = hh;
            return Zc("isCompressed", n), n ? a(Uint8Array.from([
                t.hasEvenY() ? 2 : 3
            ]), s) : a(Uint8Array.from([
                4
            ]), s, r.toBytes(i.y));
        },
        fromBytes (e) {
            const t = e.length, n = e[0], a = e.subarray(1);
            if (t !== i || 2 !== n && 3 !== n) {
                if (t === s && 4 === n) return {
                    x: r.fromBytes(a.subarray(0, r.BYTES)),
                    y: r.fromBytes(a.subarray(r.BYTES, 2 * r.BYTES))
                };
                throw Error(`Point of length ${t} was invalid. Expected ${i} compressed bytes or ${s} uncompressed bytes`);
            }
            {
                const e = ih(a);
                if (!lh(e, Wh, r.ORDER)) throw Error("Point is not on curve");
                const t = u(e);
                let i;
                try {
                    i = r.sqrt(t);
                } catch (e) {
                    const t = e instanceof Error ? ": " + e.message : "";
                    throw Error("Point is not on curve" + t);
                }
                return !(1 & ~n) !== ((i & Wh) === Wh) && (i = r.neg(i)), {
                    x: e,
                    y: i
                };
            }
        }
    }), y = (e)=>$c(ah(e, t.nByteLength));
    function f(e) {
        return e > n >> Wh;
    }
    const g = (e, t, r)=>ih(e.slice(t, r));
    class p {
        constructor(e, t, r){
            this.r = e, this.s = t, this.recovery = r, this.assertValidity();
        }
        static fromCompact(e) {
            const r = t.nByteLength;
            return e = ch("compactSignature", e, 2 * r), new p(g(e, 0, r), g(e, r, 2 * r));
        }
        static fromDER(e) {
            const { r: t, s: r } = Yh.toSig(ch("DER", e));
            return new p(t, r);
        }
        assertValidity() {
            yh("r", this.r, Wh, n), yh("s", this.s, Wh, n);
        }
        addRecoveryBit(e) {
            return new p(this.r, this.s, e);
        }
        recoverPublicKey(e) {
            const { r: n, s: i, recovery: s } = this, h = m(ch("msgHash", e));
            if (null == s || ![
                0,
                1,
                2,
                3
            ].includes(s)) throw Error("recovery id invalid");
            const u = 2 === s || 3 === s ? n + t.n : n;
            if (u >= r.ORDER) throw Error("recovery id 2 or 3 invalid");
            const l = 1 & s ? "03" : "02", f = c.fromHex(l + y(u)), g = o(u), p = a(-h * g), d = a(i * g), A = c.BASE.multiplyAndAddUnsafe(f, p, d);
            if (!A) throw Error("point at infinify");
            return A.assertValidity(), A;
        }
        hasHighS() {
            return f(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new p(this.r, a(-this.s), this.recovery) : this;
        }
        toDERRawBytes() {
            return nh(this.toDERHex());
        }
        toDERHex() {
            return Yh.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        toCompactRawBytes() {
            return nh(this.toCompactHex());
        }
        toCompactHex() {
            return y(this.r) + y(this.s);
        }
    }
    const d = {
        isValidPrivateKey (e) {
            try {
                return h(e), !0;
            } catch (e) {
                return !1;
            }
        },
        normPrivateKeyToScalar: h,
        randomPrivateKey: ()=>{
            const e = Nh(t.n);
            return function(e, t, r = !1) {
                const n = e.length, i = Mh(t), s = Nh(t);
                if (n < 16 || n < s || n > 1024) throw Error(`expected ${s}-1024 bytes of input, got ${n}`);
                const a = Dh(r ? ih(e) : sh(e), t - vh) + vh;
                return r ? oh(a, i) : ah(a, i);
            }(t.randomBytes(e), t.n);
        },
        precompute: (e = 8, t = c.BASE)=>(t._setWindowSize(e), t.multiply(BigInt(3)), t)
    };
    function A(e) {
        const t = Jc(e), r = "string" == typeof e, n = (t || r) && e.length;
        return t ? n === i || n === s : r ? n === 2 * i || n === 2 * s : e instanceof c;
    }
    const w = t.bits2int || function(e) {
        const r = ih(e), n = 8 * e.length - t.nBitLength;
        return n > 0 ? r >> BigInt(n) : r;
    }, m = t.bits2int_modN || function(e) {
        return a(w(e));
    }, b = gh(t.nBitLength);
    function k(e) {
        return yh("num < 2^" + t.nBitLength, e, Zh, b), ah(e, t.nByteLength);
    }
    function E(e, n, i = v) {
        if ([
            "recovered",
            "canonical"
        ].some((e)=>e in i)) throw Error("sign() legacy options not supported");
        const { hash: s, randomBytes: u } = t;
        let { lowS: y, prehash: g, extraEntropy: d } = i;
        null == y && (y = !0), e = ch("msgHash", e), qh(i), g && (e = ch("prehashed msgHash", s(e)));
        const A = m(e), b = h(n), E1 = [
            k(b),
            k(A)
        ];
        if (null != d && !1 !== d) {
            const e = !0 === d ? u(r.BYTES) : d;
            E1.push(ch("extraEntropy", e));
        }
        const I = hh(...E1), B = A;
        return {
            seed: I,
            k2sig: function(e) {
                const t = w(e);
                if (!l(t)) return;
                const r = o(t), n = c.BASE.multiply(t).toAffine(), i = a(n.x);
                if (i === Zh) return;
                const s = a(r * a(B + i * b));
                if (s === Zh) return;
                let h = (n.x === i ? 0 : 2) | Number(n.y & Wh), u = s;
                return y && f(s) && (u = function(e) {
                    return f(e) ? a(-e) : e;
                }(s), h ^= 1), new p(i, u, h);
            }
        };
    }
    const v = {
        lowS: t.lowS,
        prehash: !1
    }, I = {
        lowS: t.lowS,
        prehash: !1
    };
    return c.BASE._setWindowSize(8), {
        CURVE: t,
        getPublicKey: function(e, t = !0) {
            return c.fromPrivateKey(e).toRawBytes(t);
        },
        getSharedSecret: function(e, t, r = !0) {
            if (A(e)) throw Error("first arg must be private key");
            if (!A(t)) throw Error("second arg must be public key");
            return c.fromHex(t).multiply(h(e)).toRawBytes(r);
        },
        sign: function(e, r, n = v) {
            const { seed: i, k2sig: s } = E(e, r, n), a = t;
            return Ah(a.hash.outputLen, a.nByteLength, a.hmac)(i, s);
        },
        verify: function(e, r, n, i = I) {
            const s = e;
            if (r = ch("msgHash", r), n = ch("publicKey", n), "strict" in i) throw Error("options.strict was renamed to lowS");
            qh(i);
            const { lowS: h, prehash: u } = i;
            let l, y;
            try {
                if ("string" == typeof s || Jc(s)) try {
                    l = p.fromDER(s);
                } catch (e) {
                    if (!(e instanceof Yh.Err)) throw e;
                    l = p.fromCompact(s);
                }
                else {
                    if ("object" != typeof s || "bigint" != typeof s.r || "bigint" != typeof s.s) throw Error("PARSE");
                    {
                        const { r: e, s: t } = s;
                        l = new p(e, t);
                    }
                }
                y = c.fromHex(n);
            } catch (e) {
                if ("PARSE" === e.message) throw Error("signature must be Signature instance, Uint8Array or hex string");
                return !1;
            }
            if (h && l.hasHighS()) return !1;
            u && (r = t.hash(r));
            const { r: f, s: g } = l, d = m(r), A = o(g), w = a(d * A), b = a(f * A), k = c.BASE.multiplyAndAddUnsafe(y, w, b)?.toAffine();
            return !!k && a(k.x) === f;
        },
        ProjectivePoint: c,
        Signature: p,
        utils: d
    };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ function tu(e) {
    return {
        hash: e,
        hmac: (t, ...r)=>_c(e, t, Dc(...r)),
        randomBytes: xc
    };
}
function ru(e, t) {
    const r = (t)=>eu({
            ...e,
            ...tu(t)
        });
    return Object.freeze({
        ...r(t),
        create: r
    });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ BigInt(4);
const nu = Lh(BigInt("0xffffffff00000001000000000000000000000000ffffffffffffffffffffffff")), iu = ru({
    a: nu.create(BigInt("-3")),
    b: BigInt("0x5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b"),
    Fp: nu,
    n: BigInt("0xffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551"),
    Gx: BigInt("0x6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296"),
    Gy: BigInt("0x4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5"),
    h: BigInt(1),
    lowS: !1
}, Hc), su = /* @__PURE__ */ BigInt(2 ** 32 - 1), au = /* @__PURE__ */ BigInt(32);
function ou(e, t = !1) {
    return t ? {
        h: Number(e & su),
        l: Number(e >> au & su)
    } : {
        h: 0 | Number(e >> au & su),
        l: 0 | Number(e & su)
    };
}
function cu(e, t = !1) {
    let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
    for(let i = 0; i < e.length; i++){
        const { h: s, l: a } = ou(e[i], t);
        [r[i], n[i]] = [
            s,
            a
        ];
    }
    return [
        r,
        n
    ];
}
const hu = (e, t, r)=>e << r | t >>> 32 - r, uu = (e, t, r)=>t << r | e >>> 32 - r, lu = (e, t, r)=>t << r - 32 | e >>> 64 - r, yu = (e, t, r)=>e << r - 32 | t >>> 64 - r;
const fu = {
    fromBig: ou,
    split: cu,
    toBig: (e, t)=>BigInt(e >>> 0) << au | BigInt(t >>> 0),
    shrSH: (e, t, r)=>e >>> r,
    shrSL: (e, t, r)=>e << 32 - r | t >>> r,
    rotrSH: (e, t, r)=>e >>> r | t << 32 - r,
    rotrSL: (e, t, r)=>e << 32 - r | t >>> r,
    rotrBH: (e, t, r)=>e << 64 - r | t >>> r - 32,
    rotrBL: (e, t, r)=>e >>> r - 32 | t << 64 - r,
    rotr32H: (e, t)=>t,
    rotr32L: (e, t)=>e,
    rotlSH: hu,
    rotlSL: uu,
    rotlBH: lu,
    rotlBL: yu,
    add: function(e, t, r, n) {
        const i = (t >>> 0) + (n >>> 0);
        return {
            h: e + r + (i / 2 ** 32 | 0) | 0,
            l: 0 | i
        };
    },
    add3L: (e, t, r)=>(e >>> 0) + (t >>> 0) + (r >>> 0),
    add3H: (e, t, r, n)=>t + r + n + (e / 2 ** 32 | 0) | 0,
    add4L: (e, t, r, n)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0),
    add4H: (e, t, r, n, i)=>t + r + n + i + (e / 2 ** 32 | 0) | 0,
    add5H: (e, t, r, n, i, s)=>t + r + n + i + s + (e / 2 ** 32 | 0) | 0,
    add5L: (e, t, r, n, i)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (i >>> 0)
}, [gu, pu] = /* @__PURE__ */ (()=>fu.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((e)=>BigInt(e))))(), du = /* @__PURE__ */ new Uint32Array(80), Au = /* @__PURE__ */ new Uint32Array(80);
class wu extends Tc {
    constructor(){
        super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
    }
    get() {
        const { Ah: e, Al: t, Bh: r, Bl: n, Ch: i, Cl: s, Dh: a, Dl: o, Eh: c, El: h, Fh: u, Fl: l, Gh: y, Gl: f, Hh: g, Hl: p } = this;
        return [
            e,
            t,
            r,
            n,
            i,
            s,
            a,
            o,
            c,
            h,
            u,
            l,
            y,
            f,
            g,
            p
        ];
    }
    set(e, t, r, n, i, s, a, o, c, h, u, l, y, f, g, p) {
        this.Ah = 0 | e, this.Al = 0 | t, this.Bh = 0 | r, this.Bl = 0 | n, this.Ch = 0 | i, this.Cl = 0 | s, this.Dh = 0 | a, this.Dl = 0 | o, this.Eh = 0 | c, this.El = 0 | h, this.Fh = 0 | u, this.Fl = 0 | l, this.Gh = 0 | y, this.Gl = 0 | f, this.Hh = 0 | g, this.Hl = 0 | p;
    }
    process(e, t) {
        for(let r = 0; r < 16; r++, t += 4)du[r] = e.getUint32(t), Au[r] = e.getUint32(t += 4);
        for(let e = 16; e < 80; e++){
            const t = 0 | du[e - 15], r = 0 | Au[e - 15], n = fu.rotrSH(t, r, 1) ^ fu.rotrSH(t, r, 8) ^ fu.shrSH(t, r, 7), i = fu.rotrSL(t, r, 1) ^ fu.rotrSL(t, r, 8) ^ fu.shrSL(t, r, 7), s = 0 | du[e - 2], a = 0 | Au[e - 2], o = fu.rotrSH(s, a, 19) ^ fu.rotrBH(s, a, 61) ^ fu.shrSH(s, a, 6), c = fu.rotrSL(s, a, 19) ^ fu.rotrBL(s, a, 61) ^ fu.shrSL(s, a, 6), h = fu.add4L(i, c, Au[e - 7], Au[e - 16]), u = fu.add4H(h, n, o, du[e - 7], du[e - 16]);
            du[e] = 0 | u, Au[e] = 0 | h;
        }
        let { Ah: r, Al: n, Bh: i, Bl: s, Ch: a, Cl: o, Dh: c, Dl: h, Eh: u, El: l, Fh: y, Fl: f, Gh: g, Gl: p, Hh: d, Hl: A } = this;
        for(let e = 0; e < 80; e++){
            const t = fu.rotrSH(u, l, 14) ^ fu.rotrSH(u, l, 18) ^ fu.rotrBH(u, l, 41), w = fu.rotrSL(u, l, 14) ^ fu.rotrSL(u, l, 18) ^ fu.rotrBL(u, l, 41), m = u & y ^ ~u & g, b = l & f ^ ~l & p, k = fu.add5L(A, w, b, pu[e], Au[e]), E = fu.add5H(k, d, t, m, gu[e], du[e]), v = 0 | k, I = fu.rotrSH(r, n, 28) ^ fu.rotrBH(r, n, 34) ^ fu.rotrBH(r, n, 39), B = fu.rotrSL(r, n, 28) ^ fu.rotrBL(r, n, 34) ^ fu.rotrBL(r, n, 39), S = r & i ^ r & a ^ i & a, K = n & s ^ n & o ^ s & o;
            d = 0 | g, A = 0 | p, g = 0 | y, p = 0 | f, y = 0 | u, f = 0 | l, ({ h: u, l } = fu.add(0 | c, 0 | h, 0 | E, 0 | v)), c = 0 | a, h = 0 | o, a = 0 | i, o = 0 | s, i = 0 | r, s = 0 | n;
            const C = fu.add3L(v, B, K);
            r = fu.add3H(C, E, I, S), n = 0 | C;
        }
        ({ h: r, l: n } = fu.add(0 | this.Ah, 0 | this.Al, 0 | r, 0 | n)), ({ h: i, l: s } = fu.add(0 | this.Bh, 0 | this.Bl, 0 | i, 0 | s)), ({ h: a, l: o } = fu.add(0 | this.Ch, 0 | this.Cl, 0 | a, 0 | o)), ({ h: c, l: h } = fu.add(0 | this.Dh, 0 | this.Dl, 0 | c, 0 | h)), ({ h: u, l } = fu.add(0 | this.Eh, 0 | this.El, 0 | u, 0 | l)), ({ h: y, l: f } = fu.add(0 | this.Fh, 0 | this.Fl, 0 | y, 0 | f)), ({ h: g, l: p } = fu.add(0 | this.Gh, 0 | this.Gl, 0 | g, 0 | p)), ({ h: d, l: A } = fu.add(0 | this.Hh, 0 | this.Hl, 0 | d, 0 | A)), this.set(r, n, i, s, a, o, c, h, u, l, y, f, g, p, d, A);
    }
    roundClean() {
        du.fill(0), Au.fill(0);
    }
    destroy() {
        this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class mu extends wu {
    constructor(){
        super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
    }
}
const bu = /* @__PURE__ */ Pc(()=>new wu), ku = /* @__PURE__ */ Pc(()=>new mu), Eu = Lh(BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffeffffffff0000000000000000ffffffff")), vu = ru({
    a: Eu.create(BigInt("-3")),
    b: BigInt("0xb3312fa7e23ee7e4988e056be3f82d19181d9c6efe8141120314088f5013875ac656398d8a2ed19d2a85c8edd3ec2aef"),
    Fp: Eu,
    n: BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffc7634d81f4372ddf581a0db248b0a77aecec196accc52973"),
    Gx: BigInt("0xaa87ca22be8b05378eb1c71ef320ad746e1d3b628ba79b9859f741e082542a385502f25dbf55296c3a545e3872760ab7"),
    Gy: BigInt("0x3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f"),
    h: BigInt(1),
    lowS: !1
}, ku), Iu = Lh(BigInt("0x1ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff")), Bu = {
    a: Iu.create(BigInt("-3")),
    b: BigInt("0x0051953eb9618e1c9a1f929a21a0b68540eea2da725b99b315f3b8b489918ef109e156193951ec7e937b1652c0bd3bb1bf073573df883d2c34f1ef451fd46b503f00"),
    Fp: Iu,
    n: BigInt("0x01fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffa51868783bf2f966b7fcc0148f709a5d03bb5c9b8899c47aebb6fb71e91386409"),
    Gx: BigInt("0x00c6858e06b70404e9cd9e3ecb662395b4429c648139053fb521f828af606b4d3dbaa14b5e77efe75928fe1dc127a2ffa8de3348b3c1856a429bf97e7e31c2e5bd66"),
    Gy: BigInt("0x011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650"),
    h: BigInt(1)
}, Su = ru({
    a: Bu.a,
    b: Bu.b,
    Fp: Iu,
    n: Bu.n,
    Gx: Bu.Gx,
    Gy: Bu.Gy,
    h: Bu.h,
    lowS: !1,
    allowedPrivateKeyLengths: [
        130,
        131,
        132
    ]
}, bu), Ku = [], Cu = [], Du = [], Uu = /* @__PURE__ */ BigInt(0), Pu = /* @__PURE__ */ BigInt(1), xu = /* @__PURE__ */ BigInt(2), Qu = /* @__PURE__ */ BigInt(7), Ru = /* @__PURE__ */ BigInt(256), Tu = /* @__PURE__ */ BigInt(113);
for(let e = 0, t = Pu, r = 1, n = 0; e < 24; e++){
    [r, n] = [
        n,
        (2 * r + 3 * n) % 5
    ], Ku.push(2 * (5 * n + r)), Cu.push((e + 1) * (e + 2) / 2 % 64);
    let i = Uu;
    for(let e = 0; e < 7; e++)t = (t << Pu ^ (t >> Qu) * Tu) % Ru, t & xu && (i ^= Pu << (Pu << /* @__PURE__ */ BigInt(e)) - Pu);
    Du.push(i);
}
const [Lu, Mu] = /* @__PURE__ */ cu(Du, !0), Nu = (e, t, r)=>r > 32 ? lu(e, t, r) : hu(e, t, r), Fu = (e, t, r)=>r > 32 ? yu(e, t, r) : uu(e, t, r);
class Ou extends Uc {
    constructor(e, t, r, n = !1, i = 24){
        if (super(), this.blockLen = e, this.suffix = t, this.outputLen = r, this.enableXOF = n, this.rounds = i, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, Ac(r), 0 >= this.blockLen || this.blockLen >= 200) throw Error("Sha3 supports only keccak-f1600 function");
        var s;
        this.state = new Uint8Array(200), this.state32 = (s = this.state, new Uint32Array(s.buffer, s.byteOffset, Math.floor(s.byteLength / 4)));
    }
    keccak() {
        Bc || Sc(this.state32), function(e, t = 24) {
            const r = new Uint32Array(10);
            for(let n = 24 - t; n < 24; n++){
                for(let t = 0; t < 10; t++)r[t] = e[t] ^ e[t + 10] ^ e[t + 20] ^ e[t + 30] ^ e[t + 40];
                for(let t = 0; t < 10; t += 2){
                    const n = (t + 8) % 10, i = (t + 2) % 10, s = r[i], a = r[i + 1], o = Nu(s, a, 1) ^ r[n], c = Fu(s, a, 1) ^ r[n + 1];
                    for(let r = 0; r < 50; r += 10)e[t + r] ^= o, e[t + r + 1] ^= c;
                }
                let t = e[2], i = e[3];
                for(let r = 0; r < 24; r++){
                    const n = Cu[r], s = Nu(t, i, n), a = Fu(t, i, n), o = Ku[r];
                    t = e[o], i = e[o + 1], e[o] = s, e[o + 1] = a;
                }
                for(let t = 0; t < 50; t += 10){
                    for(let n = 0; n < 10; n++)r[n] = e[t + n];
                    for(let n = 0; n < 10; n++)e[t + n] ^= ~r[(n + 2) % 10] & r[(n + 4) % 10];
                }
                e[0] ^= Lu[n], e[1] ^= Mu[n];
            }
            r.fill(0);
        }(this.state32, this.rounds), Bc || Sc(this.state32), this.posOut = 0, this.pos = 0;
    }
    update(e) {
        mc(this);
        const { blockLen: t, state: r } = this, n = (e = Cc(e)).length;
        for(let i = 0; i < n;){
            const s = Math.min(t - this.pos, n - i);
            for(let t = 0; t < s; t++)r[this.pos++] ^= e[i++];
            this.pos === t && this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = !0;
        const { state: e, suffix: t, pos: r, blockLen: n } = this;
        e[r] ^= t, 128 & t && r === n - 1 && this.keccak(), e[n - 1] ^= 128, this.keccak();
    }
    writeInto(e) {
        mc(this, !1), wc(e), this.finish();
        const t = this.state, { blockLen: r } = this;
        for(let n = 0, i = e.length; n < i;){
            this.posOut >= r && this.keccak();
            const s = Math.min(r - this.posOut, i - n);
            e.set(t.subarray(this.posOut, this.posOut + s), n), this.posOut += s, n += s;
        }
        return e;
    }
    xofInto(e) {
        if (!this.enableXOF) throw Error("XOF is not possible for this instance");
        return this.writeInto(e);
    }
    xof(e) {
        return Ac(e), this.xofInto(new Uint8Array(e));
    }
    digestInto(e) {
        if (bc(e, this), this.finished) throw Error("digest() was already called");
        return this.writeInto(e), this.destroy(), e;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = !0, this.state.fill(0);
    }
    _cloneInto(e) {
        const { blockLen: t, suffix: r, outputLen: n, rounds: i, enableXOF: s } = this;
        return e || (e = new Ou(t, r, n, s, i)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = i, e.suffix = r, e.outputLen = n, e.enableXOF = s, e.destroyed = this.destroyed, e;
    }
}
const Hu = (e, t, r)=>Pc(()=>new Ou(t, e, r)), zu = /* @__PURE__ */ Hu(6, 136, 32), Gu = /* @__PURE__ */ Hu(6, 72, 64), _u = /* @__PURE__ */ ((e, t, r)=>(function(e) {
        const t = (t, r)=>e(r).update(Cc(t)).digest(), r = e({});
        return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = (t)=>e(t), t;
    })((n = {})=>new Ou(t, e, void 0 === n.dkLen ? r : n.dkLen, !0)))(31, 136, 32), ju = BigInt(0), qu = BigInt(1), Vu = BigInt(2), Ju = BigInt(8), Yu = {
    zip215: !0
};
function Zu(e) {
    const t = function(e) {
        const t = jh(e);
        return mh(e, {
            hash: "function",
            a: "bigint",
            d: "bigint",
            randomBytes: "function"
        }, {
            adjustScalarBytes: "function",
            domain: "function",
            uvRatio: "function",
            mapToCurve: "function"
        }), Object.freeze({
            ...t
        });
    }(e), { Fp: r, n, prehash: i, hash: s, randomBytes: a, nByteLength: o, h: c } = t, h = Vu << BigInt(8 * o) - qu, u = r.create, l = Lh(t.n, t.nBitLength), y = t.uvRatio || ((e, t)=>{
        try {
            return {
                isValid: !0,
                value: r.sqrt(e * r.inv(t))
            };
        } catch (e) {
            return {
                isValid: !1,
                value: ju
            };
        }
    }), f = t.adjustScalarBytes || ((e)=>e), g = t.domain || ((e, t, r)=>{
        if (Zc("phflag", r), t.length || r) throw Error("Contexts/pre-hash are not supported");
        return e;
    });
    function p(e, t) {
        yh("coordinate " + e, t, ju, h);
    }
    function d(e) {
        if (!(e instanceof m)) throw Error("ExtendedPoint expected");
    }
    const A = bh((e, t)=>{
        const { ex: n, ey: i, ez: s } = e, a = e.is0();
        null == t && (t = a ? Ju : r.inv(s));
        const o = u(n * t), c = u(i * t), h = u(s * t);
        if (a) return {
            x: ju,
            y: qu
        };
        if (h !== qu) throw Error("invZ was invalid");
        return {
            x: o,
            y: c
        };
    }), w = bh((e)=>{
        const { a: r, d: n } = t;
        if (e.is0()) throw Error("bad point: ZERO");
        const { ex: i, ey: s, ez: a, et: o } = e, c = u(i * i), h = u(s * s), l = u(a * a), y = u(l * l), f = u(c * r);
        if (u(l * u(f + h)) !== u(y + u(n * u(c * h)))) throw Error("bad point: equation left != right (1)");
        if (u(i * s) !== u(a * o)) throw Error("bad point: equation left != right (2)");
        return !0;
    });
    class m {
        constructor(e, t, r, n){
            this.ex = e, this.ey = t, this.ez = r, this.et = n, p("x", e), p("y", t), p("z", r), p("t", n), Object.freeze(this);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(e) {
            if (e instanceof m) throw Error("extended point not allowed");
            const { x: t, y: r } = e || {};
            return p("x", t), p("y", r), new m(t, r, qu, u(t * r));
        }
        static normalizeZ(e) {
            const t = r.invertBatch(e.map((e)=>e.ez));
            return e.map((e, r)=>e.toAffine(t[r])).map(m.fromAffine);
        }
        static msm(e, t) {
            return _h(m, l, e, t);
        }
        _setWindowSize(e) {
            E.setWindowSize(this, e);
        }
        assertValidity() {
            w(this);
        }
        equals(e) {
            d(e);
            const { ex: t, ey: r, ez: n } = this, { ex: i, ey: s, ez: a } = e, o = u(t * a), c = u(i * n), h = u(r * a), l = u(s * n);
            return o === c && h === l;
        }
        is0() {
            return this.equals(m.ZERO);
        }
        negate() {
            return new m(u(-this.ex), this.ey, this.ez, u(-this.et));
        }
        double() {
            const { a: e } = t, { ex: r, ey: n, ez: i } = this, s = u(r * r), a = u(n * n), o = u(Vu * u(i * i)), c = u(e * s), h = r + n, l = u(u(h * h) - s - a), y = c + a, f = y - o, g = c - a, p = u(l * f), d = u(y * g), A = u(l * g), w = u(f * y);
            return new m(p, d, w, A);
        }
        add(e) {
            d(e);
            const { a: r, d: n } = t, { ex: i, ey: s, ez: a, et: o } = this, { ex: c, ey: h, ez: l, et: y } = e;
            if (r === BigInt(-1)) {
                const e = u((s - i) * (h + c)), t = u((s + i) * (h - c)), r = u(t - e);
                if (r === ju) return this.double();
                const n = u(a * Vu * y), f = u(o * Vu * l), g = f + n, p = t + e, d = f - n, A = u(g * r), w = u(p * d), b = u(g * d), k = u(r * p);
                return new m(A, w, k, b);
            }
            const f = u(i * c), g = u(s * h), p = u(o * n * y), A = u(a * l), w = u((i + s) * (c + h) - f - g), b = A - p, k = A + p, E = u(g - r * f), v = u(w * b), I = u(k * E), B = u(w * E), S = u(b * k);
            return new m(v, I, S, B);
        }
        subtract(e) {
            return this.add(e.negate());
        }
        wNAF(e) {
            return E.wNAFCached(this, e, m.normalizeZ);
        }
        multiply(e) {
            const t = e;
            yh("scalar", t, qu, n);
            const { p: r, f: i } = this.wNAF(t);
            return m.normalizeZ([
                r,
                i
            ])[0];
        }
        multiplyUnsafe(e) {
            const t = e;
            return yh("scalar", t, ju, n), t === ju ? k : this.equals(k) || t === qu ? this : this.equals(b) ? this.wNAF(t).p : E.unsafeLadder(this, t);
        }
        isSmallOrder() {
            return this.multiplyUnsafe(c).is0();
        }
        isTorsionFree() {
            return E.unsafeLadder(this, n).is0();
        }
        toAffine(e) {
            return A(this, e);
        }
        clearCofactor() {
            const { h: e } = t;
            return e === qu ? this : this.multiplyUnsafe(e);
        }
        static fromHex(e, n = !1) {
            const { d: i, a: s } = t, a = r.BYTES;
            e = ch("pointHex", e, a), Zc("zip215", n);
            const o = e.slice(), c = e[a - 1];
            o[a - 1] = -129 & c;
            const l = sh(o), f = n ? h : r.ORDER;
            yh("pointHex.y", l, ju, f);
            const g = u(l * l), p = u(g - qu), d = u(i * g - s);
            let { isValid: A, value: w } = y(p, d);
            if (!A) throw Error("Point.fromHex: invalid y coordinate");
            const b = (w & qu) === qu, k = !!(128 & c);
            if (!n && w === ju && k) throw Error("Point.fromHex: x=0 and x_0=1");
            return k !== b && (w = u(-w)), m.fromAffine({
                x: w,
                y: l
            });
        }
        static fromPrivateKey(e) {
            return B(e).point;
        }
        toRawBytes() {
            const { x: e, y: t } = this.toAffine(), n = oh(t, r.BYTES);
            return n[n.length - 1] |= e & qu ? 128 : 0, n;
        }
        toHex() {
            return $c(this.toRawBytes());
        }
    }
    m.BASE = new m(t.Gx, t.Gy, qu, u(t.Gx * t.Gy)), m.ZERO = new m(ju, qu, qu, ju);
    const { BASE: b, ZERO: k } = m, E = Gh(m, 8 * o);
    function v(e) {
        return Dh(e, n);
    }
    function I(e) {
        return v(sh(e));
    }
    function B(e) {
        const t = o;
        e = ch("private key", e, t);
        const r = ch("hashed private key", s(e), 2 * t), n = f(r.slice(0, t)), i = r.slice(t, 2 * t), a = I(n), c = b.multiply(a), h = c.toRawBytes();
        return {
            head: n,
            prefix: i,
            scalar: a,
            point: c,
            pointBytes: h
        };
    }
    function S(e = new Uint8Array, ...t) {
        const r = hh(...t);
        return I(s(g(r, ch("context", e), !!i)));
    }
    const K = Yu;
    b._setWindowSize(8);
    return {
        CURVE: t,
        getPublicKey: function(e) {
            return B(e).pointBytes;
        },
        sign: function(e, t, s = {}) {
            e = ch("message", e), i && (e = i(e));
            const { prefix: a, scalar: c, pointBytes: h } = B(t), u = S(s.context, a, e), l = b.multiply(u).toRawBytes(), y = v(u + S(s.context, l, h, e) * c);
            return yh("signature.s", y, ju, n), ch("result", hh(l, oh(y, r.BYTES)), 2 * o);
        },
        verify: function(e, t, n, s = K) {
            const { context: a, zip215: o } = s, c = r.BYTES;
            e = ch("signature", e, 2 * c), t = ch("message", t), void 0 !== o && Zc("zip215", o), i && (t = i(t));
            const h = sh(e.slice(c, 2 * c));
            let u, l, y;
            try {
                u = m.fromHex(n, o), l = m.fromHex(e.slice(0, c), o), y = b.multiplyUnsafe(h);
            } catch (e) {
                return !1;
            }
            if (!o && u.isSmallOrder()) return !1;
            const f = S(a, l.toRawBytes(), u.toRawBytes(), t);
            return l.add(u.multiplyUnsafe(f)).subtract(y).clearCofactor().equals(m.ZERO);
        },
        ExtendedPoint: m,
        utils: {
            getExtendedPublicKey: B,
            randomPrivateKey: ()=>a(r.BYTES),
            precompute: (e = 8, t = m.BASE)=>(t._setWindowSize(e), t.multiply(BigInt(3)), t)
        }
    };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const Wu = BigInt(0), $u = BigInt(1);
function Xu(e) {
    const t = (mh(r = e, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    }), Object.freeze({
        ...r
    }));
    var r;
    const { P: n } = t, i = (e)=>Dh(e, n), s = t.montgomeryBits, a = Math.ceil(s / 8), o = t.nByteLength, c = t.adjustScalarBytes || ((e)=>e), h = t.powPminus2 || ((e)=>Uh(e, n - BigInt(2), n));
    function u(e, t, r) {
        const n = i(e * (t - r));
        return [
            t = i(t - n),
            r = i(r + n)
        ];
    }
    const l = (t.a - BigInt(2)) / BigInt(4);
    function y(e) {
        return oh(i(e), a);
    }
    function f(e, t) {
        const r = function(e) {
            const t = ch("u coordinate", e, a);
            return 32 === o && (t[31] &= 127), sh(t);
        }(t), f = function(e) {
            const t = ch("scalar", e), r = t.length;
            if (r !== a && r !== o) throw Error(`Expected ${a} or ${o} bytes, got ${r}`);
            return sh(c(t));
        }(e), g = function(e, t) {
            yh("u", e, Wu, n), yh("scalar", t, Wu, n);
            const r = t, a = e;
            let o, c = $u, y = Wu, f = e, g = $u, p = Wu;
            for(let e = BigInt(s - 1); e >= Wu; e--){
                const t = r >> e & $u;
                p ^= t, o = u(p, c, f), c = o[0], f = o[1], o = u(p, y, g), y = o[0], g = o[1], p = t;
                const n = c + y, s = i(n * n), h = c - y, d = i(h * h), A = s - d, w = f + g, m = i((f - g) * n), b = i(w * h), k = m + b, E = m - b;
                f = i(k * k), g = i(a * i(E * E)), c = i(s * d), y = i(A * (s + i(l * A)));
            }
            o = u(p, c, f), c = o[0], f = o[1], o = u(p, y, g), y = o[0], g = o[1];
            const d = h(y);
            return i(c * d);
        }(r, f);
        if (g === Wu) throw Error("Invalid private or public key received");
        return y(g);
    }
    const g = y(t.Gu);
    function p(e) {
        return f(e, g);
    }
    return {
        scalarMult: f,
        scalarMultBase: p,
        getSharedSecret: (e, t)=>f(e, t),
        getPublicKey: (e)=>p(e),
        utils: {
            randomPrivateKey: ()=>t.randomBytes(t.nByteLength)
        },
        GuBytes: g
    };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const el = Pc(()=>_u.create({
        dkLen: 114
    })), tl = (Pc(()=>_u.create({
        dkLen: 64
    })), BigInt("726838724295606890549323807888004534353641360687318060281490199180612328166730772686396383698676545930088884461843637361053498018365439")), rl = BigInt(1), nl = BigInt(2), il = BigInt(3);
BigInt(4);
const sl = BigInt(11), al = BigInt(22), ol = BigInt(44), cl = BigInt(88), hl = BigInt(223);
function ul(e) {
    const t = tl, r = e * e * e % t, n = r * r * e % t, i = Ph(n, il, t) * n % t, s = Ph(i, il, t) * n % t, a = Ph(s, nl, t) * r % t, o = Ph(a, sl, t) * a % t, c = Ph(o, al, t) * o % t, h = Ph(c, ol, t) * c % t, u = Ph(h, cl, t) * h % t, l = Ph(u, ol, t) * c % t, y = Ph(l, nl, t) * r % t, f = Ph(y, rl, t) * e % t;
    return Ph(f, hl, t) * y % t;
}
function ll(e) {
    return e[0] &= 252, e[55] |= 128, e[56] = 0, e;
}
const yl = Lh(tl, 456, !0), fl = {
    a: BigInt(1),
    d: BigInt("726838724295606890549323807888004534353641360687318060281490199180612328166730772686396383698676545930088884461843637361053498018326358"),
    Fp: yl,
    n: BigInt("181709681073901722637330951972001133588410340171829515070372549795146003961539585716195755291692375963310293709091662304773755859649779"),
    nBitLength: 456,
    h: BigInt(4),
    Gx: BigInt("224580040295924300187604334099896036246789641632564134246125461686950415467406032909029192869357953282578032075146446173674602635247710"),
    Gy: BigInt("298819210078481492676017930443930673437544040154080242095928241372331506189835876003536878655418784733982303233503462500531545062832660"),
    hash: el,
    randomBytes: xc,
    adjustScalarBytes: ll,
    domain: (e, t, r)=>{
        if (t.length > 255) throw Error("Context is too big: " + t.length);
        return Dc(Kc("SigEd448"), new Uint8Array([
            r ? 1 : 0,
            t.length
        ]), t, e);
    },
    uvRatio: function(e, t) {
        const r = tl, n = Dh(e * e * t, r), i = Dh(n * e, r), s = Dh(i * n * t, r), a = Dh(i * ul(s), r), o = Dh(a * a, r);
        return {
            isValid: Dh(o * t, r) === e,
            value: a
        };
    }
}, gl = /* @__PURE__ */ Zu(fl), pl = /* @__PURE__ */ (()=>Xu({
        a: BigInt(156326),
        montgomeryBits: 448,
        nByteLength: 56,
        P: tl,
        Gu: BigInt(5),
        powPminus2: (e)=>{
            const t = tl;
            return Dh(Ph(ul(e), BigInt(2), t) * e, t);
        },
        adjustScalarBytes: ll,
        randomBytes: xc
    }))();
yl.ORDER, BigInt(3), BigInt(4), BigInt(156326), BigInt("39082"), BigInt("78163"), BigInt("98944233647732219769177004876929019128417576295529901074099889598043702116001257856802131563896515373927712232092845883226922417596214"), BigInt("315019913931389607337177038330951043522456072897266928557328499619017160722351061360252776265186336876723201881398623946864393857820716"), BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const dl = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), Al = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), wl = BigInt(1), ml = BigInt(2), bl = (e, t)=>(e + t / ml) / t;
const kl = Lh(dl, void 0, void 0, {
    sqrt: function(e) {
        const t = dl, r = BigInt(3), n = BigInt(6), i = BigInt(11), s = BigInt(22), a = BigInt(23), o = BigInt(44), c = BigInt(88), h = e * e * e % t, u = h * h * e % t, l = Ph(u, r, t) * u % t, y = Ph(l, r, t) * u % t, f = Ph(y, ml, t) * h % t, g = Ph(f, i, t) * f % t, p = Ph(g, s, t) * g % t, d = Ph(p, o, t) * p % t, A = Ph(d, c, t) * d % t, w = Ph(A, o, t) * p % t, m = Ph(w, r, t) * u % t, b = Ph(m, a, t) * g % t, k = Ph(b, n, t) * h % t, E = Ph(k, ml, t);
        if (!kl.eql(kl.sqr(E), e)) throw Error("Cannot find square root");
        return E;
    }
}), El = ru({
    a: BigInt(0),
    b: BigInt(7),
    Fp: kl,
    n: Al,
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: !0,
    endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (e)=>{
            const t = Al, r = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -wl * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), i = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), s = r, a = BigInt("0x100000000000000000000000000000000"), o = bl(s * e, t), c = bl(-n * e, t);
            let h = Dh(e - o * r - c * i, t), u = Dh(-o * n - c * s, t);
            const l = h > a, y = u > a;
            if (l && (h = t - h), y && (u = t - u), h > a || u > a) throw Error("splitScalar: Endomorphism failed, k=" + e);
            return {
                k1neg: l,
                k1: h,
                k2neg: y,
                k2: u
            };
        }
    }
}, Hc);
BigInt(0), El.ProjectivePoint;
const vl = Lh(BigInt("0xa9fb57dba1eea9bc3e660a909d838d726e3bf623d52620282013481d1f6e5377")), Il = ru({
    a: vl.create(BigInt("0x7d5a0975fc2c3057eef67530417affe7fb8055c126dc5c6ce94a4b44f330b5d9")),
    b: BigInt("0x26dc5c6ce94a4b44f330b5d9bbd77cbf958416295cf7e1ce6bccdc18ff8c07b6"),
    Fp: vl,
    n: BigInt("0xa9fb57dba1eea9bc3e660a909d838d718c397aa3b561a6f7901e0e82974856a7"),
    Gx: BigInt("0x8bd2aeb9cb7e57cb2c4b482ffc81b7afb9de27e1e3bd23c23a4453bd9ace3262"),
    Gy: BigInt("0x547ef835c3dac4fd97f8461a14611dc9c27745132ded8e545c1d54c72f046997"),
    h: BigInt(1),
    lowS: !1
}, Hc), Bl = Lh(BigInt("0x8cb91e82a3386d280f5d6f7e50e641df152f7109ed5456b412b1da197fb71123acd3a729901d1a71874700133107ec53")), Sl = ru({
    a: Bl.create(BigInt("0x7bc382c63d8c150c3c72080ace05afa0c2bea28e4fb22787139165efba91f90f8aa5814a503ad4eb04a8c7dd22ce2826")),
    b: BigInt("0x04a8c7dd22ce28268b39b55416f0447c2fb77de107dcd2a62e880ea53eeb62d57cb4390295dbc9943ab78696fa504c11"),
    Fp: Bl,
    n: BigInt("0x8cb91e82a3386d280f5d6f7e50e641df152f7109ed5456b31f166e6cac0425a7cf3ab6af6b7fc3103b883202e9046565"),
    Gx: BigInt("0x1d1c64f068cf45ffa2a63a81b7c13f6b8847a3e77ef14fe3db7fcafe0cbd10e8e826e03436d646aaef87b2e247d4af1e"),
    Gy: BigInt("0x8abe1d7520f9c2a45cb1eb8e95cfd55262b70b29feec5864e19c054ff99129280e4646217791811142820341263c5315"),
    h: BigInt(1),
    lowS: !1
}, ku), Kl = Lh(BigInt("0xaadd9db8dbe9c48b3fd4e6ae33c9fc07cb308db3b3c9d20ed6639cca703308717d4d9b009bc66842aecda12ae6a380e62881ff2f2d82c68528aa6056583a48f3")), Cl = ru({
    a: Kl.create(BigInt("0x7830a3318b603b89e2327145ac234cc594cbdd8d3df91610a83441caea9863bc2ded5d5aa8253aa10a2ef1c98b9ac8b57f1117a72bf2c7b9e7c1ac4d77fc94ca")),
    b: BigInt("0x3df91610a83441caea9863bc2ded5d5aa8253aa10a2ef1c98b9ac8b57f1117a72bf2c7b9e7c1ac4d77fc94cadc083e67984050b75ebae5dd2809bd638016f723"),
    Fp: Kl,
    n: BigInt("0xaadd9db8dbe9c48b3fd4e6ae33c9fc07cb308db3b3c9d20ed6639cca70330870553e5c414ca92619418661197fac10471db1d381085ddaddb58796829ca90069"),
    Gx: BigInt("0x81aee4bdd82ed9645a21322e9c4c6a9385ed9f70b5d916c1b43b62eef4d0098eff3b1f78e2d0d48d50d1687b93b97d5f7c6d5047406a5e688b352209bcb9f822"),
    Gy: BigInt("0x7dde385d566332ecc0eabfa9cf7822fdf209f70024a57b1aa000c55b881f8111b2dcde494a5f485e5bca4bd88a2763aed1ca2b2fa8f0540678cd1e0f3ad80892"),
    h: BigInt(1),
    lowS: !1
}, bu), Dl = new Map(Object.entries({
    nistP256: iu,
    nistP384: vu,
    nistP521: Su,
    brainpoolP256r1: Il,
    brainpoolP384r1: Sl,
    brainpoolP512r1: Cl,
    secp256k1: El,
    x448: pl,
    ed448: gl
}));
var Ul = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    nobleCurves: Dl
});
const Pl = /* @__PURE__ */ new Uint32Array([
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
]), xl = /* @__PURE__ */ new Uint32Array(80);
class Ql extends Tc {
    constructor(){
        super(64, 20, 8, !1), this.A = 0 | Pl[0], this.B = 0 | Pl[1], this.C = 0 | Pl[2], this.D = 0 | Pl[3], this.E = 0 | Pl[4];
    }
    get() {
        const { A: e, B: t, C: r, D: n, E: i } = this;
        return [
            e,
            t,
            r,
            n,
            i
        ];
    }
    set(e, t, r, n, i) {
        this.A = 0 | e, this.B = 0 | t, this.C = 0 | r, this.D = 0 | n, this.E = 0 | i;
    }
    process(e, t) {
        for(let r = 0; r < 16; r++, t += 4)xl[r] = e.getUint32(t, !1);
        for(let e = 16; e < 80; e++)xl[e] = Ic(xl[e - 3] ^ xl[e - 8] ^ xl[e - 14] ^ xl[e - 16], 1);
        let { A: r, B: n, C: i, D: s, E: a } = this;
        for(let e = 0; e < 80; e++){
            let t, o;
            e < 20 ? (t = Qc(n, i, s), o = 1518500249) : e < 40 ? (t = n ^ i ^ s, o = 1859775393) : e < 60 ? (t = Rc(n, i, s), o = 2400959708) : (t = n ^ i ^ s, o = 3395469782);
            const c = Ic(r, 5) + t + a + o + xl[e] | 0;
            a = s, s = i, i = Ic(n, 30), n = r, r = c;
        }
        r = r + this.A | 0, n = n + this.B | 0, i = i + this.C | 0, s = s + this.D | 0, a = a + this.E | 0, this.set(r, n, i, s, a);
    }
    roundClean() {
        xl.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0), this.buffer.fill(0);
    }
}
const Rl = /* @__PURE__ */ Pc(()=>new Ql), Tl = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]), Ll = /* @__PURE__ */ new Uint8Array(Array(16).fill(0).map((e, t)=>t)), Ml = /* @__PURE__ */ Ll.map((e)=>(9 * e + 5) % 16);
let Nl = [
    Ll
], Fl = [
    Ml
];
for(let e = 0; e < 4; e++)for (let t of [
    Nl,
    Fl
])t.push(t[e].map((e)=>Tl[e]));
const Ol = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((e)=>new Uint8Array(e)), Hl = /* @__PURE__ */ Nl.map((e, t)=>e.map((e)=>Ol[t][e])), zl = /* @__PURE__ */ Fl.map((e, t)=>e.map((e)=>Ol[t][e])), Gl = /* @__PURE__ */ new Uint32Array([
    0,
    1518500249,
    1859775393,
    2400959708,
    2840853838
]), _l = /* @__PURE__ */ new Uint32Array([
    1352829926,
    1548603684,
    1836072691,
    2053994217,
    0
]);
function jl(e, t, r, n) {
    return 0 === e ? t ^ r ^ n : 1 === e ? t & r | ~t & n : 2 === e ? (t | ~r) ^ n : 3 === e ? t & n | r & ~n : t ^ (r | ~n);
}
const ql = /* @__PURE__ */ new Uint32Array(16);
class Vl extends Tc {
    constructor(){
        super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
    }
    get() {
        const { h0: e, h1: t, h2: r, h3: n, h4: i } = this;
        return [
            e,
            t,
            r,
            n,
            i
        ];
    }
    set(e, t, r, n, i) {
        this.h0 = 0 | e, this.h1 = 0 | t, this.h2 = 0 | r, this.h3 = 0 | n, this.h4 = 0 | i;
    }
    process(e, t) {
        for(let r = 0; r < 16; r++, t += 4)ql[r] = e.getUint32(t, !0);
        let r = 0 | this.h0, n = r, i = 0 | this.h1, s = i, a = 0 | this.h2, o = a, c = 0 | this.h3, h = c, u = 0 | this.h4, l = u;
        for(let e = 0; e < 5; e++){
            const t = 4 - e, y = Gl[e], f = _l[e], g = Nl[e], p = Fl[e], d = Hl[e], A = zl[e];
            for(let t = 0; t < 16; t++){
                const n = Ic(r + jl(e, i, a, c) + ql[g[t]] + y, d[t]) + u | 0;
                r = u, u = c, c = 0 | Ic(a, 10), a = i, i = n;
            }
            for(let e = 0; e < 16; e++){
                const r = Ic(n + jl(t, s, o, h) + ql[p[e]] + f, A[e]) + l | 0;
                n = l, l = h, h = 0 | Ic(o, 10), o = s, s = r;
            }
        }
        this.set(this.h1 + a + h | 0, this.h2 + c + l | 0, this.h3 + u + n | 0, this.h4 + r + s | 0, this.h0 + i + o | 0);
    }
    roundClean() {
        ql.fill(0);
    }
    destroy() {
        this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
    }
}
const Jl = /* @__PURE__ */ Pc(()=>new Vl), Yl = Array.from({
    length: 64
}, (e, t)=>Math.floor(2 ** 32 * Math.abs(Math.sin(t + 1)))), Zl = (e, t, r)=>e & t ^ ~e & r, Wl = /* @__PURE__ */ new Uint32Array([
    1732584193,
    4023233417,
    2562383102,
    271733878
]), $l = /* @__PURE__ */ new Uint32Array(16);
class Xl extends Tc {
    constructor(){
        super(64, 16, 8, !0), this.A = 0 | Wl[0], this.B = 0 | Wl[1], this.C = 0 | Wl[2], this.D = 0 | Wl[3];
    }
    get() {
        const { A: e, B: t, C: r, D: n } = this;
        return [
            e,
            t,
            r,
            n
        ];
    }
    set(e, t, r, n) {
        this.A = 0 | e, this.B = 0 | t, this.C = 0 | r, this.D = 0 | n;
    }
    process(e, t) {
        for(let r = 0; r < 16; r++, t += 4)$l[r] = e.getUint32(t, !0);
        let { A: r, B: n, C: i, D: s } = this;
        for(let e = 0; e < 64; e++){
            let t, a, o;
            e < 16 ? (t = Zl(n, i, s), a = e, o = [
                7,
                12,
                17,
                22
            ]) : e < 32 ? (t = Zl(s, n, i), a = (5 * e + 1) % 16, o = [
                5,
                9,
                14,
                20
            ]) : e < 48 ? (t = n ^ i ^ s, a = (3 * e + 5) % 16, o = [
                4,
                11,
                16,
                23
            ]) : (t = i ^ (n | ~s), a = 7 * e % 16, o = [
                6,
                10,
                15,
                21
            ]), t = t + r + Yl[e] + $l[a], r = s, s = i, i = n, n += Ic(t, o[e % 4]);
        }
        r = r + this.A | 0, n = n + this.B | 0, i = i + this.C | 0, s = s + this.D | 0, this.set(r, n, i, s);
    }
    roundClean() {
        $l.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0), this.buffer.fill(0);
    }
}
const ey = new Map(Object.entries({
    md5: /* @__PURE__ */ Pc(()=>new Xl),
    sha1: Rl,
    sha224: zc,
    sha256: Hc,
    sha384: ku,
    sha512: bu,
    sha3_256: zu,
    sha3_512: Gu,
    ripemd160: Jl
}));
var ty = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    nobleHashes: ey
});
function ry(e, t, r, n, i, s) {
    const a = [
        16843776,
        0,
        65536,
        16843780,
        16842756,
        66564,
        4,
        65536,
        1024,
        16843776,
        16843780,
        1024,
        16778244,
        16842756,
        16777216,
        4,
        1028,
        16778240,
        16778240,
        66560,
        66560,
        16842752,
        16842752,
        16778244,
        65540,
        16777220,
        16777220,
        65540,
        0,
        1028,
        66564,
        16777216,
        65536,
        16843780,
        4,
        16842752,
        16843776,
        16777216,
        16777216,
        1024,
        16842756,
        65536,
        66560,
        16777220,
        1024,
        4,
        16778244,
        66564,
        16843780,
        65540,
        16842752,
        16778244,
        16777220,
        1028,
        66564,
        16843776,
        1028,
        16778240,
        16778240,
        0,
        65540,
        66560,
        0,
        16842756
    ], o = [
        -2146402272,
        -2147450880,
        32768,
        1081376,
        1048576,
        32,
        -2146435040,
        -2147450848,
        -2147483616,
        -2146402272,
        -2146402304,
        -2147483648,
        -2147450880,
        1048576,
        32,
        -2146435040,
        1081344,
        1048608,
        -2147450848,
        0,
        -2147483648,
        32768,
        1081376,
        -2146435072,
        1048608,
        -2147483616,
        0,
        1081344,
        32800,
        -2146402304,
        -2146435072,
        32800,
        0,
        1081376,
        -2146435040,
        1048576,
        -2147450848,
        -2146435072,
        -2146402304,
        32768,
        -2146435072,
        -2147450880,
        32,
        -2146402272,
        1081376,
        32,
        32768,
        -2147483648,
        32800,
        -2146402304,
        1048576,
        -2147483616,
        1048608,
        -2147450848,
        -2147483616,
        1048608,
        1081344,
        0,
        -2147450880,
        32800,
        -2147483648,
        -2146435040,
        -2146402272,
        1081344
    ], c = [
        520,
        134349312,
        0,
        134348808,
        134218240,
        0,
        131592,
        134218240,
        131080,
        134217736,
        134217736,
        131072,
        134349320,
        131080,
        134348800,
        520,
        134217728,
        8,
        134349312,
        512,
        131584,
        134348800,
        134348808,
        131592,
        134218248,
        131584,
        131072,
        134218248,
        8,
        134349320,
        512,
        134217728,
        134349312,
        134217728,
        131080,
        520,
        131072,
        134349312,
        134218240,
        0,
        512,
        131080,
        134349320,
        134218240,
        134217736,
        512,
        0,
        134348808,
        134218248,
        131072,
        134217728,
        134349320,
        8,
        131592,
        131584,
        134217736,
        134348800,
        134218248,
        520,
        134348800,
        131592,
        8,
        134348808,
        131584
    ], h = [
        8396801,
        8321,
        8321,
        128,
        8396928,
        8388737,
        8388609,
        8193,
        0,
        8396800,
        8396800,
        8396929,
        129,
        0,
        8388736,
        8388609,
        1,
        8192,
        8388608,
        8396801,
        128,
        8388608,
        8193,
        8320,
        8388737,
        1,
        8320,
        8388736,
        8192,
        8396928,
        8396929,
        129,
        8388736,
        8388609,
        8396800,
        8396929,
        129,
        0,
        0,
        8396800,
        8320,
        8388736,
        8388737,
        1,
        8396801,
        8321,
        8321,
        128,
        8396929,
        129,
        1,
        8192,
        8388609,
        8193,
        8396928,
        8388737,
        8193,
        8320,
        8388608,
        8396801,
        128,
        8388608,
        8192,
        8396928
    ], u = [
        256,
        34078976,
        34078720,
        1107296512,
        524288,
        256,
        1073741824,
        34078720,
        1074266368,
        524288,
        33554688,
        1074266368,
        1107296512,
        1107820544,
        524544,
        1073741824,
        33554432,
        1074266112,
        1074266112,
        0,
        1073742080,
        1107820800,
        1107820800,
        33554688,
        1107820544,
        1073742080,
        0,
        1107296256,
        34078976,
        33554432,
        1107296256,
        524544,
        524288,
        1107296512,
        256,
        33554432,
        1073741824,
        34078720,
        1107296512,
        1074266368,
        33554688,
        1073741824,
        1107820544,
        34078976,
        1074266368,
        256,
        33554432,
        1107820544,
        1107820800,
        524544,
        1107296256,
        1107820800,
        34078720,
        0,
        1074266112,
        1107296256,
        524544,
        33554688,
        1073742080,
        524288,
        0,
        1074266112,
        34078976,
        1073742080
    ], l = [
        536870928,
        541065216,
        16384,
        541081616,
        541065216,
        16,
        541081616,
        4194304,
        536887296,
        4210704,
        4194304,
        536870928,
        4194320,
        536887296,
        536870912,
        16400,
        0,
        4194320,
        536887312,
        16384,
        4210688,
        536887312,
        16,
        541065232,
        541065232,
        0,
        4210704,
        541081600,
        16400,
        4210688,
        541081600,
        536870912,
        536887296,
        16,
        541065232,
        4210688,
        541081616,
        4194304,
        16400,
        536870928,
        4194304,
        536887296,
        536870912,
        16400,
        536870928,
        541081616,
        4210688,
        541065216,
        4210704,
        541081600,
        0,
        541065232,
        16,
        16384,
        541065216,
        4210704,
        16384,
        4194320,
        536887312,
        0,
        541081600,
        536870912,
        4194320,
        536887312
    ], y = [
        2097152,
        69206018,
        67110914,
        0,
        2048,
        67110914,
        2099202,
        69208064,
        69208066,
        2097152,
        0,
        67108866,
        2,
        67108864,
        69206018,
        2050,
        67110912,
        2099202,
        2097154,
        67110912,
        67108866,
        69206016,
        69208064,
        2097154,
        69206016,
        2048,
        2050,
        69208066,
        2099200,
        2,
        67108864,
        2099200,
        67108864,
        2099200,
        2097152,
        67110914,
        67110914,
        69206018,
        69206018,
        2,
        2097154,
        67108864,
        67110912,
        2097152,
        69208064,
        2050,
        2099202,
        69208064,
        2050,
        67108866,
        69208066,
        69206016,
        2099200,
        0,
        2,
        69208066,
        0,
        2099202,
        69206016,
        2048,
        67108866,
        67110912,
        2048,
        2097154
    ], f = [
        268439616,
        4096,
        262144,
        268701760,
        268435456,
        268439616,
        64,
        268435456,
        262208,
        268697600,
        268701760,
        266240,
        268701696,
        266304,
        4096,
        64,
        268697600,
        268435520,
        268439552,
        4160,
        266240,
        262208,
        268697664,
        268701696,
        4160,
        0,
        0,
        268697664,
        268435520,
        268439552,
        266304,
        262144,
        266304,
        262144,
        268701696,
        4096,
        64,
        268697664,
        4096,
        266304,
        268439552,
        64,
        268435520,
        268697600,
        268697664,
        268435456,
        262144,
        268439616,
        0,
        268701760,
        262208,
        268435520,
        268697600,
        268439552,
        268439616,
        0,
        268701760,
        266240,
        266240,
        4160,
        4160,
        262208,
        268435456,
        268701696
    ];
    let g, p, d, A, w, m, b, k, E, v, I = 0, B = t.length;
    const S = 32 === e.length ? 3 : 9;
    k = 3 === S ? r ? [
        0,
        32,
        2
    ] : [
        30,
        -2,
        -2
    ] : r ? [
        0,
        32,
        2,
        62,
        30,
        -2,
        64,
        96,
        2
    ] : [
        94,
        62,
        -2,
        32,
        64,
        2,
        30,
        -2,
        -2
    ], r && (t = function(e) {
        const t = 8 - e.length % 8;
        let r;
        if (!(t < 8)) {
            if (8 === t) return e;
            throw Error("des: invalid padding");
        }
        r = 0;
        const n = new Uint8Array(e.length + t);
        for(let t = 0; t < e.length; t++)n[t] = e[t];
        for(let i = 0; i < t; i++)n[e.length + i] = r;
        return n;
    }(t), B = t.length);
    let K = new Uint8Array(B), C = 0;
    for(; I < B;){
        for(m = t[I++] << 24 | t[I++] << 16 | t[I++] << 8 | t[I++], b = t[I++] << 24 | t[I++] << 16 | t[I++] << 8 | t[I++], d = 252645135 & (m >>> 4 ^ b), b ^= d, m ^= d << 4, d = 65535 & (m >>> 16 ^ b), b ^= d, m ^= d << 16, d = 858993459 & (b >>> 2 ^ m), m ^= d, b ^= d << 2, d = 16711935 & (b >>> 8 ^ m), m ^= d, b ^= d << 8, d = 1431655765 & (m >>> 1 ^ b), b ^= d, m ^= d << 1, m = m << 1 | m >>> 31, b = b << 1 | b >>> 31, p = 0; p < S; p += 3){
            for(E = k[p + 1], v = k[p + 2], g = k[p]; g !== E; g += v)A = b ^ e[g], w = (b >>> 4 | b << 28) ^ e[g + 1], d = m, m = b, b = d ^ (o[A >>> 24 & 63] | h[A >>> 16 & 63] | l[A >>> 8 & 63] | f[63 & A] | a[w >>> 24 & 63] | c[w >>> 16 & 63] | u[w >>> 8 & 63] | y[63 & w]);
            d = m, m = b, b = d;
        }
        m = m >>> 1 | m << 31, b = b >>> 1 | b << 31, d = 1431655765 & (m >>> 1 ^ b), b ^= d, m ^= d << 1, d = 16711935 & (b >>> 8 ^ m), m ^= d, b ^= d << 8, d = 858993459 & (b >>> 2 ^ m), m ^= d, b ^= d << 2, d = 65535 & (m >>> 16 ^ b), b ^= d, m ^= d << 16, d = 252645135 & (m >>> 4 ^ b), b ^= d, m ^= d << 4, K[C++] = m >>> 24, K[C++] = m >>> 16 & 255, K[C++] = m >>> 8 & 255, K[C++] = 255 & m, K[C++] = b >>> 24, K[C++] = b >>> 16 & 255, K[C++] = b >>> 8 & 255, K[C++] = 255 & b;
    }
    return r || (K = function(e) {
        let t, r = null;
        if (t = 0, !r) {
            for(r = 1; e[e.length - r] === t;)r++;
            r--;
        }
        return e.subarray(0, e.length - r);
    }(K)), K;
}
function ny(e) {
    const t = [
        0,
        4,
        536870912,
        536870916,
        65536,
        65540,
        536936448,
        536936452,
        512,
        516,
        536871424,
        536871428,
        66048,
        66052,
        536936960,
        536936964
    ], r = [
        0,
        1,
        1048576,
        1048577,
        67108864,
        67108865,
        68157440,
        68157441,
        256,
        257,
        1048832,
        1048833,
        67109120,
        67109121,
        68157696,
        68157697
    ], n = [
        0,
        8,
        2048,
        2056,
        16777216,
        16777224,
        16779264,
        16779272,
        0,
        8,
        2048,
        2056,
        16777216,
        16777224,
        16779264,
        16779272
    ], i = [
        0,
        2097152,
        134217728,
        136314880,
        8192,
        2105344,
        134225920,
        136323072,
        131072,
        2228224,
        134348800,
        136445952,
        139264,
        2236416,
        134356992,
        136454144
    ], s = [
        0,
        262144,
        16,
        262160,
        0,
        262144,
        16,
        262160,
        4096,
        266240,
        4112,
        266256,
        4096,
        266240,
        4112,
        266256
    ], a = [
        0,
        1024,
        32,
        1056,
        0,
        1024,
        32,
        1056,
        33554432,
        33555456,
        33554464,
        33555488,
        33554432,
        33555456,
        33554464,
        33555488
    ], o = [
        0,
        268435456,
        524288,
        268959744,
        2,
        268435458,
        524290,
        268959746,
        0,
        268435456,
        524288,
        268959744,
        2,
        268435458,
        524290,
        268959746
    ], c = [
        0,
        65536,
        2048,
        67584,
        536870912,
        536936448,
        536872960,
        536938496,
        131072,
        196608,
        133120,
        198656,
        537001984,
        537067520,
        537004032,
        537069568
    ], h = [
        0,
        262144,
        0,
        262144,
        2,
        262146,
        2,
        262146,
        33554432,
        33816576,
        33554432,
        33816576,
        33554434,
        33816578,
        33554434,
        33816578
    ], u = [
        0,
        268435456,
        8,
        268435464,
        0,
        268435456,
        8,
        268435464,
        1024,
        268436480,
        1032,
        268436488,
        1024,
        268436480,
        1032,
        268436488
    ], l = [
        0,
        32,
        0,
        32,
        1048576,
        1048608,
        1048576,
        1048608,
        8192,
        8224,
        8192,
        8224,
        1056768,
        1056800,
        1056768,
        1056800
    ], y = [
        0,
        16777216,
        512,
        16777728,
        2097152,
        18874368,
        2097664,
        18874880,
        67108864,
        83886080,
        67109376,
        83886592,
        69206016,
        85983232,
        69206528,
        85983744
    ], f = [
        0,
        4096,
        134217728,
        134221824,
        524288,
        528384,
        134742016,
        134746112,
        16,
        4112,
        134217744,
        134221840,
        524304,
        528400,
        134742032,
        134746128
    ], g = [
        0,
        4,
        256,
        260,
        0,
        4,
        256,
        260,
        1,
        5,
        257,
        261,
        1,
        5,
        257,
        261
    ], p = e.length > 8 ? 3 : 1, d = Array(32 * p), A = [
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0
    ];
    let w, m, b, k = 0, E = 0;
    for(let v = 0; v < p; v++){
        let p = e[k++] << 24 | e[k++] << 16 | e[k++] << 8 | e[k++], v = e[k++] << 24 | e[k++] << 16 | e[k++] << 8 | e[k++];
        b = 252645135 & (p >>> 4 ^ v), v ^= b, p ^= b << 4, b = 65535 & (v >>> -16 ^ p), p ^= b, v ^= b << -16, b = 858993459 & (p >>> 2 ^ v), v ^= b, p ^= b << 2, b = 65535 & (v >>> -16 ^ p), p ^= b, v ^= b << -16, b = 1431655765 & (p >>> 1 ^ v), v ^= b, p ^= b << 1, b = 16711935 & (v >>> 8 ^ p), p ^= b, v ^= b << 8, b = 1431655765 & (p >>> 1 ^ v), v ^= b, p ^= b << 1, b = p << 8 | v >>> 20 & 240, p = v << 24 | v << 8 & 16711680 | v >>> 8 & 65280 | v >>> 24 & 240, v = b;
        for(let e = 0; e < 16; e++)A[e] ? (p = p << 2 | p >>> 26, v = v << 2 | v >>> 26) : (p = p << 1 | p >>> 27, v = v << 1 | v >>> 27), p &= -15, v &= -15, w = t[p >>> 28] | r[p >>> 24 & 15] | n[p >>> 20 & 15] | i[p >>> 16 & 15] | s[p >>> 12 & 15] | a[p >>> 8 & 15] | o[p >>> 4 & 15], m = c[v >>> 28] | h[v >>> 24 & 15] | u[v >>> 20 & 15] | l[v >>> 16 & 15] | y[v >>> 12 & 15] | f[v >>> 8 & 15] | g[v >>> 4 & 15], b = 65535 & (m >>> 16 ^ w), d[E++] = w ^ b, d[E++] = m ^ b << 16;
    }
    return d;
}
function iy(e) {
    this.key = [];
    for(let t = 0; t < 3; t++)this.key.push(new Uint8Array(e.subarray(8 * t, 8 * t + 8)));
    this.encrypt = function(e) {
        return ry(ny(this.key[2]), ry(ny(this.key[1]), ry(ny(this.key[0]), e, !0), !1), !0);
    };
}
function sy() {
    this.BlockSize = 8, this.KeySize = 16, this.setKey = function(e) {
        if (this.masking = Array(16), this.rotate = Array(16), this.reset(), e.length !== this.KeySize) throw Error("CAST-128: keys must be 16 bytes");
        return this.keySchedule(e), !0;
    }, this.reset = function() {
        for(let e = 0; e < 16; e++)this.masking[e] = 0, this.rotate[e] = 0;
    }, this.getBlockSize = function() {
        return this.BlockSize;
    }, this.encrypt = function(e) {
        const t = Array(e.length);
        for(let s = 0; s < e.length; s += 8){
            let a, o = e[s] << 24 | e[s + 1] << 16 | e[s + 2] << 8 | e[s + 3], c = e[s + 4] << 24 | e[s + 5] << 16 | e[s + 6] << 8 | e[s + 7];
            a = c, c = o ^ r(c, this.masking[0], this.rotate[0]), o = a, a = c, c = o ^ n(c, this.masking[1], this.rotate[1]), o = a, a = c, c = o ^ i(c, this.masking[2], this.rotate[2]), o = a, a = c, c = o ^ r(c, this.masking[3], this.rotate[3]), o = a, a = c, c = o ^ n(c, this.masking[4], this.rotate[4]), o = a, a = c, c = o ^ i(c, this.masking[5], this.rotate[5]), o = a, a = c, c = o ^ r(c, this.masking[6], this.rotate[6]), o = a, a = c, c = o ^ n(c, this.masking[7], this.rotate[7]), o = a, a = c, c = o ^ i(c, this.masking[8], this.rotate[8]), o = a, a = c, c = o ^ r(c, this.masking[9], this.rotate[9]), o = a, a = c, c = o ^ n(c, this.masking[10], this.rotate[10]), o = a, a = c, c = o ^ i(c, this.masking[11], this.rotate[11]), o = a, a = c, c = o ^ r(c, this.masking[12], this.rotate[12]), o = a, a = c, c = o ^ n(c, this.masking[13], this.rotate[13]), o = a, a = c, c = o ^ i(c, this.masking[14], this.rotate[14]), o = a, a = c, c = o ^ r(c, this.masking[15], this.rotate[15]), o = a, t[s] = c >>> 24 & 255, t[s + 1] = c >>> 16 & 255, t[s + 2] = c >>> 8 & 255, t[s + 3] = 255 & c, t[s + 4] = o >>> 24 & 255, t[s + 5] = o >>> 16 & 255, t[s + 6] = o >>> 8 & 255, t[s + 7] = 255 & o;
        }
        return t;
    }, this.decrypt = function(e) {
        const t = Array(e.length);
        for(let s = 0; s < e.length; s += 8){
            let a, o = e[s] << 24 | e[s + 1] << 16 | e[s + 2] << 8 | e[s + 3], c = e[s + 4] << 24 | e[s + 5] << 16 | e[s + 6] << 8 | e[s + 7];
            a = c, c = o ^ r(c, this.masking[15], this.rotate[15]), o = a, a = c, c = o ^ i(c, this.masking[14], this.rotate[14]), o = a, a = c, c = o ^ n(c, this.masking[13], this.rotate[13]), o = a, a = c, c = o ^ r(c, this.masking[12], this.rotate[12]), o = a, a = c, c = o ^ i(c, this.masking[11], this.rotate[11]), o = a, a = c, c = o ^ n(c, this.masking[10], this.rotate[10]), o = a, a = c, c = o ^ r(c, this.masking[9], this.rotate[9]), o = a, a = c, c = o ^ i(c, this.masking[8], this.rotate[8]), o = a, a = c, c = o ^ n(c, this.masking[7], this.rotate[7]), o = a, a = c, c = o ^ r(c, this.masking[6], this.rotate[6]), o = a, a = c, c = o ^ i(c, this.masking[5], this.rotate[5]), o = a, a = c, c = o ^ n(c, this.masking[4], this.rotate[4]), o = a, a = c, c = o ^ r(c, this.masking[3], this.rotate[3]), o = a, a = c, c = o ^ i(c, this.masking[2], this.rotate[2]), o = a, a = c, c = o ^ n(c, this.masking[1], this.rotate[1]), o = a, a = c, c = o ^ r(c, this.masking[0], this.rotate[0]), o = a, t[s] = c >>> 24 & 255, t[s + 1] = c >>> 16 & 255, t[s + 2] = c >>> 8 & 255, t[s + 3] = 255 & c, t[s + 4] = o >>> 24 & 255, t[s + 5] = o >> 16 & 255, t[s + 6] = o >> 8 & 255, t[s + 7] = 255 & o;
        }
        return t;
    };
    const e = [
        ,
        ,
        ,
        , 
    ];
    e[0] = [
        ,
        ,
        ,
        , 
    ], e[0][0] = [
        4,
        0,
        13,
        15,
        12,
        14,
        8
    ], e[0][1] = [
        5,
        2,
        16,
        18,
        17,
        19,
        10
    ], e[0][2] = [
        6,
        3,
        23,
        22,
        21,
        20,
        9
    ], e[0][3] = [
        7,
        1,
        26,
        25,
        27,
        24,
        11
    ], e[1] = [
        ,
        ,
        ,
        , 
    ], e[1][0] = [
        0,
        6,
        21,
        23,
        20,
        22,
        16
    ], e[1][1] = [
        1,
        4,
        0,
        2,
        1,
        3,
        18
    ], e[1][2] = [
        2,
        5,
        7,
        6,
        5,
        4,
        17
    ], e[1][3] = [
        3,
        7,
        10,
        9,
        11,
        8,
        19
    ], e[2] = [
        ,
        ,
        ,
        , 
    ], e[2][0] = [
        4,
        0,
        13,
        15,
        12,
        14,
        8
    ], e[2][1] = [
        5,
        2,
        16,
        18,
        17,
        19,
        10
    ], e[2][2] = [
        6,
        3,
        23,
        22,
        21,
        20,
        9
    ], e[2][3] = [
        7,
        1,
        26,
        25,
        27,
        24,
        11
    ], e[3] = [
        ,
        ,
        ,
        , 
    ], e[3][0] = [
        0,
        6,
        21,
        23,
        20,
        22,
        16
    ], e[3][1] = [
        1,
        4,
        0,
        2,
        1,
        3,
        18
    ], e[3][2] = [
        2,
        5,
        7,
        6,
        5,
        4,
        17
    ], e[3][3] = [
        3,
        7,
        10,
        9,
        11,
        8,
        19
    ];
    const t = [
        ,
        ,
        ,
        , 
    ];
    function r(e, t, r) {
        const n = t + e, i = n << r | n >>> 32 - r;
        return (s[0][i >>> 24] ^ s[1][i >>> 16 & 255]) - s[2][i >>> 8 & 255] + s[3][255 & i];
    }
    function n(e, t, r) {
        const n = t ^ e, i = n << r | n >>> 32 - r;
        return s[0][i >>> 24] - s[1][i >>> 16 & 255] + s[2][i >>> 8 & 255] ^ s[3][255 & i];
    }
    function i(e, t, r) {
        const n = t - e, i = n << r | n >>> 32 - r;
        return (s[0][i >>> 24] + s[1][i >>> 16 & 255] ^ s[2][i >>> 8 & 255]) - s[3][255 & i];
    }
    t[0] = [
        ,
        ,
        ,
        , 
    ], t[0][0] = [
        24,
        25,
        23,
        22,
        18
    ], t[0][1] = [
        26,
        27,
        21,
        20,
        22
    ], t[0][2] = [
        28,
        29,
        19,
        18,
        25
    ], t[0][3] = [
        30,
        31,
        17,
        16,
        28
    ], t[1] = [
        ,
        ,
        ,
        , 
    ], t[1][0] = [
        3,
        2,
        12,
        13,
        8
    ], t[1][1] = [
        1,
        0,
        14,
        15,
        13
    ], t[1][2] = [
        7,
        6,
        8,
        9,
        3
    ], t[1][3] = [
        5,
        4,
        10,
        11,
        7
    ], t[2] = [
        ,
        ,
        ,
        , 
    ], t[2][0] = [
        19,
        18,
        28,
        29,
        25
    ], t[2][1] = [
        17,
        16,
        30,
        31,
        28
    ], t[2][2] = [
        23,
        22,
        24,
        25,
        18
    ], t[2][3] = [
        21,
        20,
        26,
        27,
        22
    ], t[3] = [
        ,
        ,
        ,
        , 
    ], t[3][0] = [
        8,
        9,
        7,
        6,
        3
    ], t[3][1] = [
        10,
        11,
        5,
        4,
        7
    ], t[3][2] = [
        12,
        13,
        3,
        2,
        8
    ], t[3][3] = [
        14,
        15,
        1,
        0,
        13
    ], this.keySchedule = function(r) {
        const n = [
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            , 
        ], i = Array(32);
        let a;
        for(let e = 0; e < 4; e++)a = 4 * e, n[e] = r[a] << 24 | r[a + 1] << 16 | r[a + 2] << 8 | r[a + 3];
        const o = [
            6,
            7,
            4,
            5
        ];
        let c, h = 0;
        for(let r = 0; r < 2; r++)for(let r = 0; r < 4; r++){
            for(a = 0; a < 4; a++){
                const t = e[r][a];
                c = n[t[1]], c ^= s[4][n[t[2] >>> 2] >>> 24 - 8 * (3 & t[2]) & 255], c ^= s[5][n[t[3] >>> 2] >>> 24 - 8 * (3 & t[3]) & 255], c ^= s[6][n[t[4] >>> 2] >>> 24 - 8 * (3 & t[4]) & 255], c ^= s[7][n[t[5] >>> 2] >>> 24 - 8 * (3 & t[5]) & 255], c ^= s[o[a]][n[t[6] >>> 2] >>> 24 - 8 * (3 & t[6]) & 255], n[t[0]] = c;
            }
            for(a = 0; a < 4; a++){
                const e = t[r][a];
                c = s[4][n[e[0] >>> 2] >>> 24 - 8 * (3 & e[0]) & 255], c ^= s[5][n[e[1] >>> 2] >>> 24 - 8 * (3 & e[1]) & 255], c ^= s[6][n[e[2] >>> 2] >>> 24 - 8 * (3 & e[2]) & 255], c ^= s[7][n[e[3] >>> 2] >>> 24 - 8 * (3 & e[3]) & 255], c ^= s[4 + a][n[e[4] >>> 2] >>> 24 - 8 * (3 & e[4]) & 255], i[h] = c, h++;
            }
        }
        for(let e = 0; e < 16; e++)this.masking[e] = i[e], this.rotate[e] = 31 & i[16 + e];
    };
    const s = [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        , 
    ];
    s[0] = [
        821772500,
        2678128395,
        1810681135,
        1059425402,
        505495343,
        2617265619,
        1610868032,
        3483355465,
        3218386727,
        2294005173,
        3791863952,
        2563806837,
        1852023008,
        365126098,
        3269944861,
        584384398,
        677919599,
        3229601881,
        4280515016,
        2002735330,
        1136869587,
        3744433750,
        2289869850,
        2731719981,
        2714362070,
        879511577,
        1639411079,
        575934255,
        717107937,
        2857637483,
        576097850,
        2731753936,
        1725645e3,
        2810460463,
        5111599,
        767152862,
        2543075244,
        1251459544,
        1383482551,
        3052681127,
        3089939183,
        3612463449,
        1878520045,
        1510570527,
        2189125840,
        2431448366,
        582008916,
        3163445557,
        1265446783,
        1354458274,
        3529918736,
        3202711853,
        3073581712,
        3912963487,
        3029263377,
        1275016285,
        4249207360,
        2905708351,
        3304509486,
        1442611557,
        3585198765,
        2712415662,
        2731849581,
        3248163920,
        2283946226,
        208555832,
        2766454743,
        1331405426,
        1447828783,
        3315356441,
        3108627284,
        2957404670,
        2981538698,
        3339933917,
        1669711173,
        286233437,
        1465092821,
        1782121619,
        3862771680,
        710211251,
        980974943,
        1651941557,
        430374111,
        2051154026,
        704238805,
        4128970897,
        3144820574,
        2857402727,
        948965521,
        3333752299,
        2227686284,
        718756367,
        2269778983,
        2731643755,
        718440111,
        2857816721,
        3616097120,
        1113355533,
        2478022182,
        410092745,
        1811985197,
        1944238868,
        2696854588,
        1415722873,
        1682284203,
        1060277122,
        1998114690,
        1503841958,
        82706478,
        2315155686,
        1068173648,
        845149890,
        2167947013,
        1768146376,
        1993038550,
        3566826697,
        3390574031,
        940016341,
        3355073782,
        2328040721,
        904371731,
        1205506512,
        4094660742,
        2816623006,
        825647681,
        85914773,
        2857843460,
        1249926541,
        1417871568,
        3287612,
        3211054559,
        3126306446,
        1975924523,
        1353700161,
        2814456437,
        2438597621,
        1800716203,
        722146342,
        2873936343,
        1151126914,
        4160483941,
        2877670899,
        458611604,
        2866078500,
        3483680063,
        770352098,
        2652916994,
        3367839148,
        3940505011,
        3585973912,
        3809620402,
        718646636,
        2504206814,
        2914927912,
        3631288169,
        2857486607,
        2860018678,
        575749918,
        2857478043,
        718488780,
        2069512688,
        3548183469,
        453416197,
        1106044049,
        3032691430,
        52586708,
        3378514636,
        3459808877,
        3211506028,
        1785789304,
        218356169,
        3571399134,
        3759170522,
        1194783844,
        1523787992,
        3007827094,
        1975193539,
        2555452411,
        1341901877,
        3045838698,
        3776907964,
        3217423946,
        2802510864,
        2889438986,
        1057244207,
        1636348243,
        3761863214,
        1462225785,
        2632663439,
        481089165,
        718503062,
        24497053,
        3332243209,
        3344655856,
        3655024856,
        3960371065,
        1195698900,
        2971415156,
        3710176158,
        2115785917,
        4027663609,
        3525578417,
        2524296189,
        2745972565,
        3564906415,
        1372086093,
        1452307862,
        2780501478,
        1476592880,
        3389271281,
        18495466,
        2378148571,
        901398090,
        891748256,
        3279637769,
        3157290713,
        2560960102,
        1447622437,
        4284372637,
        216884176,
        2086908623,
        1879786977,
        3588903153,
        2242455666,
        2938092967,
        3559082096,
        2810645491,
        758861177,
        1121993112,
        215018983,
        642190776,
        4169236812,
        1196255959,
        2081185372,
        3508738393,
        941322904,
        4124243163,
        2877523539,
        1848581667,
        2205260958,
        3180453958,
        2589345134,
        3694731276,
        550028657,
        2519456284,
        3789985535,
        2973870856,
        2093648313,
        443148163,
        46942275,
        2734146937,
        1117713533,
        1115362972,
        1523183689,
        3717140224,
        1551984063
    ], s[1] = [
        522195092,
        4010518363,
        1776537470,
        960447360,
        4267822970,
        4005896314,
        1435016340,
        1929119313,
        2913464185,
        1310552629,
        3579470798,
        3724818106,
        2579771631,
        1594623892,
        417127293,
        2715217907,
        2696228731,
        1508390405,
        3994398868,
        3925858569,
        3695444102,
        4019471449,
        3129199795,
        3770928635,
        3520741761,
        990456497,
        4187484609,
        2783367035,
        21106139,
        3840405339,
        631373633,
        3783325702,
        532942976,
        396095098,
        3548038825,
        4267192484,
        2564721535,
        2011709262,
        2039648873,
        620404603,
        3776170075,
        2898526339,
        3612357925,
        4159332703,
        1645490516,
        223693667,
        1567101217,
        3362177881,
        1029951347,
        3470931136,
        3570957959,
        1550265121,
        119497089,
        972513919,
        907948164,
        3840628539,
        1613718692,
        3594177948,
        465323573,
        2659255085,
        654439692,
        2575596212,
        2699288441,
        3127702412,
        277098644,
        624404830,
        4100943870,
        2717858591,
        546110314,
        2403699828,
        3655377447,
        1321679412,
        4236791657,
        1045293279,
        4010672264,
        895050893,
        2319792268,
        494945126,
        1914543101,
        2777056443,
        3894764339,
        2219737618,
        311263384,
        4275257268,
        3458730721,
        669096869,
        3584475730,
        3835122877,
        3319158237,
        3949359204,
        2005142349,
        2713102337,
        2228954793,
        3769984788,
        569394103,
        3855636576,
        1425027204,
        108000370,
        2736431443,
        3671869269,
        3043122623,
        1750473702,
        2211081108,
        762237499,
        3972989403,
        2798899386,
        3061857628,
        2943854345,
        867476300,
        964413654,
        1591880597,
        1594774276,
        2179821409,
        552026980,
        3026064248,
        3726140315,
        2283577634,
        3110545105,
        2152310760,
        582474363,
        1582640421,
        1383256631,
        2043843868,
        3322775884,
        1217180674,
        463797851,
        2763038571,
        480777679,
        2718707717,
        2289164131,
        3118346187,
        214354409,
        200212307,
        3810608407,
        3025414197,
        2674075964,
        3997296425,
        1847405948,
        1342460550,
        510035443,
        4080271814,
        815934613,
        833030224,
        1620250387,
        1945732119,
        2703661145,
        3966000196,
        1388869545,
        3456054182,
        2687178561,
        2092620194,
        562037615,
        1356438536,
        3409922145,
        3261847397,
        1688467115,
        2150901366,
        631725691,
        3840332284,
        549916902,
        3455104640,
        394546491,
        837744717,
        2114462948,
        751520235,
        2221554606,
        2415360136,
        3999097078,
        2063029875,
        803036379,
        2702586305,
        821456707,
        3019566164,
        360699898,
        4018502092,
        3511869016,
        3677355358,
        2402471449,
        812317050,
        49299192,
        2570164949,
        3259169295,
        2816732080,
        3331213574,
        3101303564,
        2156015656,
        3705598920,
        3546263921,
        143268808,
        3200304480,
        1638124008,
        3165189453,
        3341807610,
        578956953,
        2193977524,
        3638120073,
        2333881532,
        807278310,
        658237817,
        2969561766,
        1641658566,
        11683945,
        3086995007,
        148645947,
        1138423386,
        4158756760,
        1981396783,
        2401016740,
        3699783584,
        380097457,
        2680394679,
        2803068651,
        3334260286,
        441530178,
        4016580796,
        1375954390,
        761952171,
        891809099,
        2183123478,
        157052462,
        3683840763,
        1592404427,
        341349109,
        2438483839,
        1417898363,
        644327628,
        2233032776,
        2353769706,
        2201510100,
        220455161,
        1815641738,
        182899273,
        2995019788,
        3627381533,
        3702638151,
        2890684138,
        1052606899,
        588164016,
        1681439879,
        4038439418,
        2405343923,
        4229449282,
        167996282,
        1336969661,
        1688053129,
        2739224926,
        1543734051,
        1046297529,
        1138201970,
        2121126012,
        115334942,
        1819067631,
        1902159161,
        1941945968,
        2206692869,
        1159982321
    ], s[2] = [
        2381300288,
        637164959,
        3952098751,
        3893414151,
        1197506559,
        916448331,
        2350892612,
        2932787856,
        3199334847,
        4009478890,
        3905886544,
        1373570990,
        2450425862,
        4037870920,
        3778841987,
        2456817877,
        286293407,
        124026297,
        3001279700,
        1028597854,
        3115296800,
        4208886496,
        2691114635,
        2188540206,
        1430237888,
        1218109995,
        3572471700,
        308166588,
        570424558,
        2187009021,
        2455094765,
        307733056,
        1310360322,
        3135275007,
        1384269543,
        2388071438,
        863238079,
        2359263624,
        2801553128,
        3380786597,
        2831162807,
        1470087780,
        1728663345,
        4072488799,
        1090516929,
        532123132,
        2389430977,
        1132193179,
        2578464191,
        3051079243,
        1670234342,
        1434557849,
        2711078940,
        1241591150,
        3314043432,
        3435360113,
        3091448339,
        1812415473,
        2198440252,
        267246943,
        796911696,
        3619716990,
        38830015,
        1526438404,
        2806502096,
        374413614,
        2943401790,
        1489179520,
        1603809326,
        1920779204,
        168801282,
        260042626,
        2358705581,
        1563175598,
        2397674057,
        1356499128,
        2217211040,
        514611088,
        2037363785,
        2186468373,
        4022173083,
        2792511869,
        2913485016,
        1173701892,
        4200428547,
        3896427269,
        1334932762,
        2455136706,
        602925377,
        2835607854,
        1613172210,
        41346230,
        2499634548,
        2457437618,
        2188827595,
        41386358,
        4172255629,
        1313404830,
        2405527007,
        3801973774,
        2217704835,
        873260488,
        2528884354,
        2478092616,
        4012915883,
        2555359016,
        2006953883,
        2463913485,
        575479328,
        2218240648,
        2099895446,
        660001756,
        2341502190,
        3038761536,
        3888151779,
        3848713377,
        3286851934,
        1022894237,
        1620365795,
        3449594689,
        1551255054,
        15374395,
        3570825345,
        4249311020,
        4151111129,
        3181912732,
        310226346,
        1133119310,
        530038928,
        136043402,
        2476768958,
        3107506709,
        2544909567,
        1036173560,
        2367337196,
        1681395281,
        1758231547,
        3641649032,
        306774401,
        1575354324,
        3716085866,
        1990386196,
        3114533736,
        2455606671,
        1262092282,
        3124342505,
        2768229131,
        4210529083,
        1833535011,
        423410938,
        660763973,
        2187129978,
        1639812e3,
        3508421329,
        3467445492,
        310289298,
        272797111,
        2188552562,
        2456863912,
        310240523,
        677093832,
        1013118031,
        901835429,
        3892695601,
        1116285435,
        3036471170,
        1337354835,
        243122523,
        520626091,
        277223598,
        4244441197,
        4194248841,
        1766575121,
        594173102,
        316590669,
        742362309,
        3536858622,
        4176435350,
        3838792410,
        2501204839,
        1229605004,
        3115755532,
        1552908988,
        2312334149,
        979407927,
        3959474601,
        1148277331,
        176638793,
        3614686272,
        2083809052,
        40992502,
        1340822838,
        2731552767,
        3535757508,
        3560899520,
        1354035053,
        122129617,
        7215240,
        2732932949,
        3118912700,
        2718203926,
        2539075635,
        3609230695,
        3725561661,
        1928887091,
        2882293555,
        1988674909,
        2063640240,
        2491088897,
        1459647954,
        4189817080,
        2302804382,
        1113892351,
        2237858528,
        1927010603,
        4002880361,
        1856122846,
        1594404395,
        2944033133,
        3855189863,
        3474975698,
        1643104450,
        4054590833,
        3431086530,
        1730235576,
        2984608721,
        3084664418,
        2131803598,
        4178205752,
        267404349,
        1617849798,
        1616132681,
        1462223176,
        736725533,
        2327058232,
        551665188,
        2945899023,
        1749386277,
        2575514597,
        1611482493,
        674206544,
        2201269090,
        3642560800,
        728599968,
        1680547377,
        2620414464,
        1388111496,
        453204106,
        4156223445,
        1094905244,
        2754698257,
        2201108165,
        3757000246,
        2704524545,
        3922940700,
        3996465027
    ], s[3] = [
        2645754912,
        532081118,
        2814278639,
        3530793624,
        1246723035,
        1689095255,
        2236679235,
        4194438865,
        2116582143,
        3859789411,
        157234593,
        2045505824,
        4245003587,
        1687664561,
        4083425123,
        605965023,
        672431967,
        1336064205,
        3376611392,
        214114848,
        4258466608,
        3232053071,
        489488601,
        605322005,
        3998028058,
        264917351,
        1912574028,
        756637694,
        436560991,
        202637054,
        135989450,
        85393697,
        2152923392,
        3896401662,
        2895836408,
        2145855233,
        3535335007,
        115294817,
        3147733898,
        1922296357,
        3464822751,
        4117858305,
        1037454084,
        2725193275,
        2127856640,
        1417604070,
        1148013728,
        1827919605,
        642362335,
        2929772533,
        909348033,
        1346338451,
        3547799649,
        297154785,
        1917849091,
        4161712827,
        2883604526,
        3968694238,
        1469521537,
        3780077382,
        3375584256,
        1763717519,
        136166297,
        4290970789,
        1295325189,
        2134727907,
        2798151366,
        1566297257,
        3672928234,
        2677174161,
        2672173615,
        965822077,
        2780786062,
        289653839,
        1133871874,
        3491843819,
        35685304,
        1068898316,
        418943774,
        672553190,
        642281022,
        2346158704,
        1954014401,
        3037126780,
        4079815205,
        2030668546,
        3840588673,
        672283427,
        1776201016,
        359975446,
        3750173538,
        555499703,
        2769985273,
        1324923,
        69110472,
        152125443,
        3176785106,
        3822147285,
        1340634837,
        798073664,
        1434183902,
        15393959,
        216384236,
        1303690150,
        3881221631,
        3711134124,
        3960975413,
        106373927,
        2578434224,
        1455997841,
        1801814300,
        1578393881,
        1854262133,
        3188178946,
        3258078583,
        2302670060,
        1539295533,
        3505142565,
        3078625975,
        2372746020,
        549938159,
        3278284284,
        2620926080,
        181285381,
        2865321098,
        3970029511,
        68876850,
        488006234,
        1728155692,
        2608167508,
        836007927,
        2435231793,
        919367643,
        3339422534,
        3655756360,
        1457871481,
        40520939,
        1380155135,
        797931188,
        234455205,
        2255801827,
        3990488299,
        397000196,
        739833055,
        3077865373,
        2871719860,
        4022553888,
        772369276,
        390177364,
        3853951029,
        557662966,
        740064294,
        1640166671,
        1699928825,
        3535942136,
        622006121,
        3625353122,
        68743880,
        1742502,
        219489963,
        1664179233,
        1577743084,
        1236991741,
        410585305,
        2366487942,
        823226535,
        1050371084,
        3426619607,
        3586839478,
        212779912,
        4147118561,
        1819446015,
        1911218849,
        530248558,
        3486241071,
        3252585495,
        2886188651,
        3410272728,
        2342195030,
        20547779,
        2982490058,
        3032363469,
        3631753222,
        312714466,
        1870521650,
        1493008054,
        3491686656,
        615382978,
        4103671749,
        2534517445,
        1932181,
        2196105170,
        278426614,
        6369430,
        3274544417,
        2913018367,
        697336853,
        2143000447,
        2946413531,
        701099306,
        1558357093,
        2805003052,
        3500818408,
        2321334417,
        3567135975,
        216290473,
        3591032198,
        23009561,
        1996984579,
        3735042806,
        2024298078,
        3739440863,
        569400510,
        2339758983,
        3016033873,
        3097871343,
        3639523026,
        3844324983,
        3256173865,
        795471839,
        2951117563,
        4101031090,
        4091603803,
        3603732598,
        971261452,
        534414648,
        428311343,
        3389027175,
        2844869880,
        694888862,
        1227866773,
        2456207019,
        3043454569,
        2614353370,
        3749578031,
        3676663836,
        459166190,
        4132644070,
        1794958188,
        51825668,
        2252611902,
        3084671440,
        2036672799,
        3436641603,
        1099053433,
        2469121526,
        3059204941,
        1323291266,
        2061838604,
        1018778475,
        2233344254,
        2553501054,
        334295216,
        3556750194,
        1065731521,
        183467730
    ], s[4] = [
        2127105028,
        745436345,
        2601412319,
        2788391185,
        3093987327,
        500390133,
        1155374404,
        389092991,
        150729210,
        3891597772,
        3523549952,
        1935325696,
        716645080,
        946045387,
        2901812282,
        1774124410,
        3869435775,
        4039581901,
        3293136918,
        3438657920,
        948246080,
        363898952,
        3867875531,
        1286266623,
        1598556673,
        68334250,
        630723836,
        1104211938,
        1312863373,
        613332731,
        2377784574,
        1101634306,
        441780740,
        3129959883,
        1917973735,
        2510624549,
        3238456535,
        2544211978,
        3308894634,
        1299840618,
        4076074851,
        1756332096,
        3977027158,
        297047435,
        3790297736,
        2265573040,
        3621810518,
        1311375015,
        1667687725,
        47300608,
        3299642885,
        2474112369,
        201668394,
        1468347890,
        576830978,
        3594690761,
        3742605952,
        1958042578,
        1747032512,
        3558991340,
        1408974056,
        3366841779,
        682131401,
        1033214337,
        1545599232,
        4265137049,
        206503691,
        103024618,
        2855227313,
        1337551222,
        2428998917,
        2963842932,
        4015366655,
        3852247746,
        2796956967,
        3865723491,
        3747938335,
        247794022,
        3755824572,
        702416469,
        2434691994,
        397379957,
        851939612,
        2314769512,
        218229120,
        1380406772,
        62274761,
        214451378,
        3170103466,
        2276210409,
        3845813286,
        28563499,
        446592073,
        1693330814,
        3453727194,
        29968656,
        3093872512,
        220656637,
        2470637031,
        77972100,
        1667708854,
        1358280214,
        4064765667,
        2395616961,
        325977563,
        4277240721,
        4220025399,
        3605526484,
        3355147721,
        811859167,
        3069544926,
        3962126810,
        652502677,
        3075892249,
        4132761541,
        3498924215,
        1217549313,
        3250244479,
        3858715919,
        3053989961,
        1538642152,
        2279026266,
        2875879137,
        574252750,
        3324769229,
        2651358713,
        1758150215,
        141295887,
        2719868960,
        3515574750,
        4093007735,
        4194485238,
        1082055363,
        3417560400,
        395511885,
        2966884026,
        179534037,
        3646028556,
        3738688086,
        1092926436,
        2496269142,
        257381841,
        3772900718,
        1636087230,
        1477059743,
        2499234752,
        3811018894,
        2675660129,
        3285975680,
        90732309,
        1684827095,
        1150307763,
        1723134115,
        3237045386,
        1769919919,
        1240018934,
        815675215,
        750138730,
        2239792499,
        1234303040,
        1995484674,
        138143821,
        675421338,
        1145607174,
        1936608440,
        3238603024,
        2345230278,
        2105974004,
        323969391,
        779555213,
        3004902369,
        2861610098,
        1017501463,
        2098600890,
        2628620304,
        2940611490,
        2682542546,
        1171473753,
        3656571411,
        3687208071,
        4091869518,
        393037935,
        159126506,
        1662887367,
        1147106178,
        391545844,
        3452332695,
        1891500680,
        3016609650,
        1851642611,
        546529401,
        1167818917,
        3194020571,
        2848076033,
        3953471836,
        575554290,
        475796850,
        4134673196,
        450035699,
        2351251534,
        844027695,
        1080539133,
        86184846,
        1554234488,
        3692025454,
        1972511363,
        2018339607,
        1491841390,
        1141460869,
        1061690759,
        4244549243,
        2008416118,
        2351104703,
        2868147542,
        1598468138,
        722020353,
        1027143159,
        212344630,
        1387219594,
        1725294528,
        3745187956,
        2500153616,
        458938280,
        4129215917,
        1828119673,
        544571780,
        3503225445,
        2297937496,
        1241802790,
        267843827,
        2694610800,
        1397140384,
        1558801448,
        3782667683,
        1806446719,
        929573330,
        2234912681,
        400817706,
        616011623,
        4121520928,
        3603768725,
        1761550015,
        1968522284,
        4053731006,
        4192232858,
        4005120285,
        872482584,
        3140537016,
        3894607381,
        2287405443,
        1963876937,
        3663887957,
        1584857e3,
        2975024454,
        1833426440,
        4025083860
    ], s[5] = [
        4143615901,
        749497569,
        1285769319,
        3795025788,
        2514159847,
        23610292,
        3974978748,
        844452780,
        3214870880,
        3751928557,
        2213566365,
        1676510905,
        448177848,
        3730751033,
        4086298418,
        2307502392,
        871450977,
        3222878141,
        4110862042,
        3831651966,
        2735270553,
        1310974780,
        2043402188,
        1218528103,
        2736035353,
        4274605013,
        2702448458,
        3936360550,
        2693061421,
        162023535,
        2827510090,
        687910808,
        23484817,
        3784910947,
        3371371616,
        779677500,
        3503626546,
        3473927188,
        4157212626,
        3500679282,
        4248902014,
        2466621104,
        3899384794,
        1958663117,
        925738300,
        1283408968,
        3669349440,
        1840910019,
        137959847,
        2679828185,
        1239142320,
        1315376211,
        1547541505,
        1690155329,
        739140458,
        3128809933,
        3933172616,
        3876308834,
        905091803,
        1548541325,
        4040461708,
        3095483362,
        144808038,
        451078856,
        676114313,
        2861728291,
        2469707347,
        993665471,
        373509091,
        2599041286,
        4025009006,
        4170239449,
        2149739950,
        3275793571,
        3749616649,
        2794760199,
        1534877388,
        572371878,
        2590613551,
        1753320020,
        3467782511,
        1405125690,
        4270405205,
        633333386,
        3026356924,
        3475123903,
        632057672,
        2846462855,
        1404951397,
        3882875879,
        3915906424,
        195638627,
        2385783745,
        3902872553,
        1233155085,
        3355999740,
        2380578713,
        2702246304,
        2144565621,
        3663341248,
        3894384975,
        2502479241,
        4248018925,
        3094885567,
        1594115437,
        572884632,
        3385116731,
        767645374,
        1331858858,
        1475698373,
        3793881790,
        3532746431,
        1321687957,
        619889600,
        1121017241,
        3440213920,
        2070816767,
        2833025776,
        1933951238,
        4095615791,
        890643334,
        3874130214,
        859025556,
        360630002,
        925594799,
        1764062180,
        3920222280,
        4078305929,
        979562269,
        2810700344,
        4087740022,
        1949714515,
        546639971,
        1165388173,
        3069891591,
        1495988560,
        922170659,
        1291546247,
        2107952832,
        1813327274,
        3406010024,
        3306028637,
        4241950635,
        153207855,
        2313154747,
        1608695416,
        1150242611,
        1967526857,
        721801357,
        1220138373,
        3691287617,
        3356069787,
        2112743302,
        3281662835,
        1111556101,
        1778980689,
        250857638,
        2298507990,
        673216130,
        2846488510,
        3207751581,
        3562756981,
        3008625920,
        3417367384,
        2198807050,
        529510932,
        3547516680,
        3426503187,
        2364944742,
        102533054,
        2294910856,
        1617093527,
        1204784762,
        3066581635,
        1019391227,
        1069574518,
        1317995090,
        1691889997,
        3661132003,
        510022745,
        3238594800,
        1362108837,
        1817929911,
        2184153760,
        805817662,
        1953603311,
        3699844737,
        120799444,
        2118332377,
        207536705,
        2282301548,
        4120041617,
        145305846,
        2508124933,
        3086745533,
        3261524335,
        1877257368,
        2977164480,
        3160454186,
        2503252186,
        4221677074,
        759945014,
        254147243,
        2767453419,
        3801518371,
        629083197,
        2471014217,
        907280572,
        3900796746,
        940896768,
        2751021123,
        2625262786,
        3161476951,
        3661752313,
        3260732218,
        1425318020,
        2977912069,
        1496677566,
        3988592072,
        2140652971,
        3126511541,
        3069632175,
        977771578,
        1392695845,
        1698528874,
        1411812681,
        1369733098,
        1343739227,
        3620887944,
        1142123638,
        67414216,
        3102056737,
        3088749194,
        1626167401,
        2546293654,
        3941374235,
        697522451,
        33404913,
        143560186,
        2595682037,
        994885535,
        1247667115,
        3859094837,
        2699155541,
        3547024625,
        4114935275,
        2968073508,
        3199963069,
        2732024527,
        1237921620,
        951448369,
        1898488916,
        1211705605,
        2790989240,
        2233243581,
        3598044975
    ], s[6] = [
        2246066201,
        858518887,
        1714274303,
        3485882003,
        713916271,
        2879113490,
        3730835617,
        539548191,
        36158695,
        1298409750,
        419087104,
        1358007170,
        749914897,
        2989680476,
        1261868530,
        2995193822,
        2690628854,
        3443622377,
        3780124940,
        3796824509,
        2976433025,
        4259637129,
        1551479e3,
        512490819,
        1296650241,
        951993153,
        2436689437,
        2460458047,
        144139966,
        3136204276,
        310820559,
        3068840729,
        643875328,
        1969602020,
        1680088954,
        2185813161,
        3283332454,
        672358534,
        198762408,
        896343282,
        276269502,
        3014846926,
        84060815,
        197145886,
        376173866,
        3943890818,
        3813173521,
        3545068822,
        1316698879,
        1598252827,
        2633424951,
        1233235075,
        859989710,
        2358460855,
        3503838400,
        3409603720,
        1203513385,
        1193654839,
        2792018475,
        2060853022,
        207403770,
        1144516871,
        3068631394,
        1121114134,
        177607304,
        3785736302,
        326409831,
        1929119770,
        2983279095,
        4183308101,
        3474579288,
        3200513878,
        3228482096,
        119610148,
        1170376745,
        3378393471,
        3163473169,
        951863017,
        3337026068,
        3135789130,
        2907618374,
        1183797387,
        2015970143,
        4045674555,
        2182986399,
        2952138740,
        3928772205,
        384012900,
        2454997643,
        10178499,
        2879818989,
        2596892536,
        111523738,
        2995089006,
        451689641,
        3196290696,
        235406569,
        1441906262,
        3890558523,
        3013735005,
        4158569349,
        1644036924,
        376726067,
        1006849064,
        3664579700,
        2041234796,
        1021632941,
        1374734338,
        2566452058,
        371631263,
        4007144233,
        490221539,
        206551450,
        3140638584,
        1053219195,
        1853335209,
        3412429660,
        3562156231,
        735133835,
        1623211703,
        3104214392,
        2738312436,
        4096837757,
        3366392578,
        3110964274,
        3956598718,
        3196820781,
        2038037254,
        3877786376,
        2339753847,
        300912036,
        3766732888,
        2372630639,
        1516443558,
        4200396704,
        1574567987,
        4069441456,
        4122592016,
        2699739776,
        146372218,
        2748961456,
        2043888151,
        35287437,
        2596680554,
        655490400,
        1132482787,
        110692520,
        1031794116,
        2188192751,
        1324057718,
        1217253157,
        919197030,
        686247489,
        3261139658,
        1028237775,
        3135486431,
        3059715558,
        2460921700,
        986174950,
        2661811465,
        4062904701,
        2752986992,
        3709736643,
        367056889,
        1353824391,
        731860949,
        1650113154,
        1778481506,
        784341916,
        357075625,
        3608602432,
        1074092588,
        2480052770,
        3811426202,
        92751289,
        877911070,
        3600361838,
        1231880047,
        480201094,
        3756190983,
        3094495953,
        434011822,
        87971354,
        363687820,
        1717726236,
        1901380172,
        3926403882,
        2481662265,
        400339184,
        1490350766,
        2661455099,
        1389319756,
        2558787174,
        784598401,
        1983468483,
        30828846,
        3550527752,
        2716276238,
        3841122214,
        1765724805,
        1955612312,
        1277890269,
        1333098070,
        1564029816,
        2704417615,
        1026694237,
        3287671188,
        1260819201,
        3349086767,
        1016692350,
        1582273796,
        1073413053,
        1995943182,
        694588404,
        1025494639,
        3323872702,
        3551898420,
        4146854327,
        453260480,
        1316140391,
        1435673405,
        3038941953,
        3486689407,
        1622062951,
        403978347,
        817677117,
        950059133,
        4246079218,
        3278066075,
        1486738320,
        1417279718,
        481875527,
        2549965225,
        3933690356,
        760697757,
        1452955855,
        3897451437,
        1177426808,
        1702951038,
        4085348628,
        2447005172,
        1084371187,
        3516436277,
        3068336338,
        1073369276,
        1027665953,
        3284188590,
        1230553676,
        1368340146,
        2226246512,
        267243139,
        2274220762,
        4070734279,
        2497715176,
        2423353163,
        2504755875
    ], s[7] = [
        3793104909,
        3151888380,
        2817252029,
        895778965,
        2005530807,
        3871412763,
        237245952,
        86829237,
        296341424,
        3851759377,
        3974600970,
        2475086196,
        709006108,
        1994621201,
        2972577594,
        937287164,
        3734691505,
        168608556,
        3189338153,
        2225080640,
        3139713551,
        3033610191,
        3025041904,
        77524477,
        185966941,
        1208824168,
        2344345178,
        1721625922,
        3354191921,
        1066374631,
        1927223579,
        1971335949,
        2483503697,
        1551748602,
        2881383779,
        2856329572,
        3003241482,
        48746954,
        1398218158,
        2050065058,
        313056748,
        4255789917,
        393167848,
        1912293076,
        940740642,
        3465845460,
        3091687853,
        2522601570,
        2197016661,
        1727764327,
        364383054,
        492521376,
        1291706479,
        3264136376,
        1474851438,
        1685747964,
        2575719748,
        1619776915,
        1814040067,
        970743798,
        1561002147,
        2925768690,
        2123093554,
        1880132620,
        3151188041,
        697884420,
        2550985770,
        2607674513,
        2659114323,
        110200136,
        1489731079,
        997519150,
        1378877361,
        3527870668,
        478029773,
        2766872923,
        1022481122,
        431258168,
        1112503832,
        897933369,
        2635587303,
        669726182,
        3383752315,
        918222264,
        163866573,
        3246985393,
        3776823163,
        114105080,
        1903216136,
        761148244,
        3571337562,
        1690750982,
        3166750252,
        1037045171,
        1888456500,
        2010454850,
        642736655,
        616092351,
        365016990,
        1185228132,
        4174898510,
        1043824992,
        2023083429,
        2241598885,
        3863320456,
        3279669087,
        3674716684,
        108438443,
        2132974366,
        830746235,
        606445527,
        4173263986,
        2204105912,
        1844756978,
        2532684181,
        4245352700,
        2969441100,
        3796921661,
        1335562986,
        4061524517,
        2720232303,
        2679424040,
        634407289,
        885462008,
        3294724487,
        3933892248,
        2094100220,
        339117932,
        4048830727,
        3202280980,
        1458155303,
        2689246273,
        1022871705,
        2464987878,
        3714515309,
        353796843,
        2822958815,
        4256850100,
        4052777845,
        551748367,
        618185374,
        3778635579,
        4020649912,
        1904685140,
        3069366075,
        2670879810,
        3407193292,
        2954511620,
        4058283405,
        2219449317,
        3135758300,
        1120655984,
        3447565834,
        1474845562,
        3577699062,
        550456716,
        3466908712,
        2043752612,
        881257467,
        869518812,
        2005220179,
        938474677,
        3305539448,
        3850417126,
        1315485940,
        3318264702,
        226533026,
        965733244,
        321539988,
        1136104718,
        804158748,
        573969341,
        3708209826,
        937399083,
        3290727049,
        2901666755,
        1461057207,
        4013193437,
        4066861423,
        3242773476,
        2421326174,
        1581322155,
        3028952165,
        786071460,
        3900391652,
        3918438532,
        1485433313,
        4023619836,
        3708277595,
        3678951060,
        953673138,
        1467089153,
        1930354364,
        1533292819,
        2492563023,
        1346121658,
        1685000834,
        1965281866,
        3765933717,
        4190206607,
        2052792609,
        3515332758,
        690371149,
        3125873887,
        2180283551,
        2903598061,
        3933952357,
        436236910,
        289419410,
        14314871,
        1242357089,
        2904507907,
        1616633776,
        2666382180,
        585885352,
        3471299210,
        2699507360,
        1432659641,
        277164553,
        3354103607,
        770115018,
        2303809295,
        3741942315,
        3177781868,
        2853364978,
        2269453327,
        3774259834,
        987383833,
        1290892879,
        225909803,
        1741533526,
        890078084,
        1496906255,
        1111072499,
        916028167,
        243534141,
        1252605537,
        2204162171,
        531204876,
        290011180,
        3916834213,
        102027703,
        237315147,
        209093447,
        1486785922,
        220223953,
        2758195998,
        4175039106,
        82940208,
        3127791296,
        2569425252,
        518464269,
        1353887104,
        3941492737,
        2377294467,
        3935040926
    ];
}
function ay(e) {
    this.cast5 = new sy, this.cast5.setKey(e), this.encrypt = function(e) {
        return this.cast5.encrypt(e);
    };
}
iy.keySize = iy.prototype.keySize = 24, iy.blockSize = iy.prototype.blockSize = 8, ay.blockSize = ay.prototype.blockSize = 8, ay.keySize = ay.prototype.keySize = 16;
const oy = 4294967295;
function cy(e, t) {
    return (e << t | e >>> 32 - t) & oy;
}
function hy(e, t) {
    return e[t] | e[t + 1] << 8 | e[t + 2] << 16 | e[t + 3] << 24;
}
function uy(e, t, r) {
    e.splice(t, 4, 255 & r, r >>> 8 & 255, r >>> 16 & 255, r >>> 24 & 255);
}
function ly(e, t) {
    return e >>> 8 * t & 255;
}
function yy(e) {
    this.tf = function() {
        let e = null, t = null, r = -1, n = [], i = [
            [],
            [],
            [],
            []
        ];
        function s(e) {
            return i[0][ly(e, 0)] ^ i[1][ly(e, 1)] ^ i[2][ly(e, 2)] ^ i[3][ly(e, 3)];
        }
        function a(e) {
            return i[0][ly(e, 3)] ^ i[1][ly(e, 0)] ^ i[2][ly(e, 1)] ^ i[3][ly(e, 2)];
        }
        function o(e, t) {
            let r = s(t[0]), i = a(t[1]);
            t[2] = cy(t[2] ^ r + i + n[4 * e + 8] & oy, 31), t[3] = cy(t[3], 1) ^ r + 2 * i + n[4 * e + 9] & oy, r = s(t[2]), i = a(t[3]), t[0] = cy(t[0] ^ r + i + n[4 * e + 10] & oy, 31), t[1] = cy(t[1], 1) ^ r + 2 * i + n[4 * e + 11] & oy;
        }
        function c(e, t) {
            let r = s(t[0]), i = a(t[1]);
            t[2] = cy(t[2], 1) ^ r + i + n[4 * e + 10] & oy, t[3] = cy(t[3] ^ r + 2 * i + n[4 * e + 11] & oy, 31), r = s(t[2]), i = a(t[3]), t[0] = cy(t[0], 1) ^ r + i + n[4 * e + 8] & oy, t[1] = cy(t[1] ^ r + 2 * i + n[4 * e + 9] & oy, 31);
        }
        return {
            name: "twofish",
            blocksize: 16,
            open: function(t) {
                let r, s, a, o, c;
                e = t;
                const h = [], u = [], l = [];
                let y;
                const f = [];
                let g, p, d;
                const A = [
                    [
                        8,
                        1,
                        7,
                        13,
                        6,
                        15,
                        3,
                        2,
                        0,
                        11,
                        5,
                        9,
                        14,
                        12,
                        10,
                        4
                    ],
                    [
                        2,
                        8,
                        11,
                        13,
                        15,
                        7,
                        6,
                        14,
                        3,
                        1,
                        9,
                        4,
                        0,
                        10,
                        12,
                        5
                    ]
                ], w = [
                    [
                        14,
                        12,
                        11,
                        8,
                        1,
                        2,
                        3,
                        5,
                        15,
                        4,
                        10,
                        6,
                        7,
                        0,
                        9,
                        13
                    ],
                    [
                        1,
                        14,
                        2,
                        11,
                        4,
                        12,
                        3,
                        7,
                        6,
                        13,
                        10,
                        5,
                        15,
                        9,
                        0,
                        8
                    ]
                ], m = [
                    [
                        11,
                        10,
                        5,
                        14,
                        6,
                        13,
                        9,
                        0,
                        12,
                        8,
                        15,
                        3,
                        2,
                        4,
                        7,
                        1
                    ],
                    [
                        4,
                        12,
                        7,
                        5,
                        1,
                        6,
                        9,
                        10,
                        0,
                        14,
                        13,
                        8,
                        2,
                        11,
                        3,
                        15
                    ]
                ], b = [
                    [
                        13,
                        7,
                        15,
                        4,
                        1,
                        2,
                        6,
                        14,
                        9,
                        11,
                        3,
                        0,
                        8,
                        5,
                        12,
                        10
                    ],
                    [
                        11,
                        9,
                        5,
                        1,
                        12,
                        3,
                        13,
                        14,
                        6,
                        4,
                        7,
                        15,
                        2,
                        0,
                        8,
                        10
                    ]
                ], k = [
                    0,
                    8,
                    1,
                    9,
                    2,
                    10,
                    3,
                    11,
                    4,
                    12,
                    5,
                    13,
                    6,
                    14,
                    7,
                    15
                ], E = [
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    5,
                    14,
                    7
                ], v = [
                    [],
                    []
                ], I = [
                    [],
                    [],
                    [],
                    []
                ];
                function B(e) {
                    return e ^ e >> 2 ^ [
                        0,
                        90,
                        180,
                        238
                    ][3 & e];
                }
                function S(e) {
                    return e ^ e >> 1 ^ e >> 2 ^ [
                        0,
                        238,
                        180,
                        90
                    ][3 & e];
                }
                function K(e, t) {
                    let r, n, i;
                    for(r = 0; r < 8; r++)n = t >>> 24, t = t << 8 & oy | e >>> 24, e = e << 8 & oy, i = n << 1, 128 & n && (i ^= 333), t ^= n ^ i << 16, i ^= n >>> 1, 1 & n && (i ^= 166), t ^= i << 24 | i << 8;
                    return t;
                }
                function C(e, t) {
                    const r = t >> 4, n = 15 & t, i = A[e][r ^ n], s = w[e][k[n] ^ E[r]];
                    return b[e][k[s] ^ E[i]] << 4 | m[e][i ^ s];
                }
                function D(e, t) {
                    let r = ly(e, 0), n = ly(e, 1), i = ly(e, 2), s = ly(e, 3);
                    switch(y){
                        case 4:
                            r = v[1][r] ^ ly(t[3], 0), n = v[0][n] ^ ly(t[3], 1), i = v[0][i] ^ ly(t[3], 2), s = v[1][s] ^ ly(t[3], 3);
                        case 3:
                            r = v[1][r] ^ ly(t[2], 0), n = v[1][n] ^ ly(t[2], 1), i = v[0][i] ^ ly(t[2], 2), s = v[0][s] ^ ly(t[2], 3);
                        case 2:
                            r = v[0][v[0][r] ^ ly(t[1], 0)] ^ ly(t[0], 0), n = v[0][v[1][n] ^ ly(t[1], 1)] ^ ly(t[0], 1), i = v[1][v[0][i] ^ ly(t[1], 2)] ^ ly(t[0], 2), s = v[1][v[1][s] ^ ly(t[1], 3)] ^ ly(t[0], 3);
                    }
                    return I[0][r] ^ I[1][n] ^ I[2][i] ^ I[3][s];
                }
                for(e = e.slice(0, 32), r = e.length; 16 !== r && 24 !== r && 32 !== r;)e[r++] = 0;
                for(r = 0; r < e.length; r += 4)l[r >> 2] = hy(e, r);
                for(r = 0; r < 256; r++)v[0][r] = C(0, r), v[1][r] = C(1, r);
                for(r = 0; r < 256; r++)g = v[1][r], p = B(g), d = S(g), I[0][r] = g + (p << 8) + (d << 16) + (d << 24), I[2][r] = p + (d << 8) + (g << 16) + (d << 24), g = v[0][r], p = B(g), d = S(g), I[1][r] = d + (d << 8) + (p << 16) + (g << 24), I[3][r] = p + (g << 8) + (d << 16) + (p << 24);
                for(y = l.length / 2, r = 0; r < y; r++)s = l[r + r], h[r] = s, a = l[r + r + 1], u[r] = a, f[y - r - 1] = K(s, a);
                for(r = 0; r < 40; r += 2)s = 16843009 * r, a = s + 16843009, s = D(s, h), a = cy(D(a, u), 8), n[r] = s + a & oy, n[r + 1] = cy(s + 2 * a, 9);
                for(r = 0; r < 256; r++)switch(s = a = o = c = r, y){
                    case 4:
                        s = v[1][s] ^ ly(f[3], 0), a = v[0][a] ^ ly(f[3], 1), o = v[0][o] ^ ly(f[3], 2), c = v[1][c] ^ ly(f[3], 3);
                    case 3:
                        s = v[1][s] ^ ly(f[2], 0), a = v[1][a] ^ ly(f[2], 1), o = v[0][o] ^ ly(f[2], 2), c = v[0][c] ^ ly(f[2], 3);
                    case 2:
                        i[0][r] = I[0][v[0][v[0][s] ^ ly(f[1], 0)] ^ ly(f[0], 0)], i[1][r] = I[1][v[0][v[1][a] ^ ly(f[1], 1)] ^ ly(f[0], 1)], i[2][r] = I[2][v[1][v[0][o] ^ ly(f[1], 2)] ^ ly(f[0], 2)], i[3][r] = I[3][v[1][v[1][c] ^ ly(f[1], 3)] ^ ly(f[0], 3)];
                }
            },
            close: function() {
                n = [], i = [
                    [],
                    [],
                    [],
                    []
                ];
            },
            encrypt: function(e, i) {
                t = e, r = i;
                const s = [
                    hy(t, r) ^ n[0],
                    hy(t, r + 4) ^ n[1],
                    hy(t, r + 8) ^ n[2],
                    hy(t, r + 12) ^ n[3]
                ];
                for(let e = 0; e < 8; e++)o(e, s);
                return uy(t, r, s[2] ^ n[4]), uy(t, r + 4, s[3] ^ n[5]), uy(t, r + 8, s[0] ^ n[6]), uy(t, r + 12, s[1] ^ n[7]), r += 16, t;
            },
            decrypt: function(e, i) {
                t = e, r = i;
                const s = [
                    hy(t, r) ^ n[4],
                    hy(t, r + 4) ^ n[5],
                    hy(t, r + 8) ^ n[6],
                    hy(t, r + 12) ^ n[7]
                ];
                for(let e = 7; e >= 0; e--)c(e, s);
                uy(t, r, s[2] ^ n[0]), uy(t, r + 4, s[3] ^ n[1]), uy(t, r + 8, s[0] ^ n[2]), uy(t, r + 12, s[1] ^ n[3]), r += 16;
            },
            finalize: function() {
                return t;
            }
        };
    }(), this.tf.open(Array.from(e), 0), this.encrypt = function(e) {
        return this.tf.encrypt(Array.from(e), 0);
    };
}
function fy() {}
function gy(e) {
    this.bf = new fy, this.bf.init(e), this.encrypt = function(e) {
        return this.bf.encryptBlock(e);
    };
}
yy.keySize = yy.prototype.keySize = 32, yy.blockSize = yy.prototype.blockSize = 16, fy.prototype.BLOCKSIZE = 8, fy.prototype.SBOXES = [
    [
        3509652390,
        2564797868,
        805139163,
        3491422135,
        3101798381,
        1780907670,
        3128725573,
        4046225305,
        614570311,
        3012652279,
        134345442,
        2240740374,
        1667834072,
        1901547113,
        2757295779,
        4103290238,
        227898511,
        1921955416,
        1904987480,
        2182433518,
        2069144605,
        3260701109,
        2620446009,
        720527379,
        3318853667,
        677414384,
        3393288472,
        3101374703,
        2390351024,
        1614419982,
        1822297739,
        2954791486,
        3608508353,
        3174124327,
        2024746970,
        1432378464,
        3864339955,
        2857741204,
        1464375394,
        1676153920,
        1439316330,
        715854006,
        3033291828,
        289532110,
        2706671279,
        2087905683,
        3018724369,
        1668267050,
        732546397,
        1947742710,
        3462151702,
        2609353502,
        2950085171,
        1814351708,
        2050118529,
        680887927,
        999245976,
        1800124847,
        3300911131,
        1713906067,
        1641548236,
        4213287313,
        1216130144,
        1575780402,
        4018429277,
        3917837745,
        3693486850,
        3949271944,
        596196993,
        3549867205,
        258830323,
        2213823033,
        772490370,
        2760122372,
        1774776394,
        2652871518,
        566650946,
        4142492826,
        1728879713,
        2882767088,
        1783734482,
        3629395816,
        2517608232,
        2874225571,
        1861159788,
        326777828,
        3124490320,
        2130389656,
        2716951837,
        967770486,
        1724537150,
        2185432712,
        2364442137,
        1164943284,
        2105845187,
        998989502,
        3765401048,
        2244026483,
        1075463327,
        1455516326,
        1322494562,
        910128902,
        469688178,
        1117454909,
        936433444,
        3490320968,
        3675253459,
        1240580251,
        122909385,
        2157517691,
        634681816,
        4142456567,
        3825094682,
        3061402683,
        2540495037,
        79693498,
        3249098678,
        1084186820,
        1583128258,
        426386531,
        1761308591,
        1047286709,
        322548459,
        995290223,
        1845252383,
        2603652396,
        3431023940,
        2942221577,
        3202600964,
        3727903485,
        1712269319,
        422464435,
        3234572375,
        1170764815,
        3523960633,
        3117677531,
        1434042557,
        442511882,
        3600875718,
        1076654713,
        1738483198,
        4213154764,
        2393238008,
        3677496056,
        1014306527,
        4251020053,
        793779912,
        2902807211,
        842905082,
        4246964064,
        1395751752,
        1040244610,
        2656851899,
        3396308128,
        445077038,
        3742853595,
        3577915638,
        679411651,
        2892444358,
        2354009459,
        1767581616,
        3150600392,
        3791627101,
        3102740896,
        284835224,
        4246832056,
        1258075500,
        768725851,
        2589189241,
        3069724005,
        3532540348,
        1274779536,
        3789419226,
        2764799539,
        1660621633,
        3471099624,
        4011903706,
        913787905,
        3497959166,
        737222580,
        2514213453,
        2928710040,
        3937242737,
        1804850592,
        3499020752,
        2949064160,
        2386320175,
        2390070455,
        2415321851,
        4061277028,
        2290661394,
        2416832540,
        1336762016,
        1754252060,
        3520065937,
        3014181293,
        791618072,
        3188594551,
        3933548030,
        2332172193,
        3852520463,
        3043980520,
        413987798,
        3465142937,
        3030929376,
        4245938359,
        2093235073,
        3534596313,
        375366246,
        2157278981,
        2479649556,
        555357303,
        3870105701,
        2008414854,
        3344188149,
        4221384143,
        3956125452,
        2067696032,
        3594591187,
        2921233993,
        2428461,
        544322398,
        577241275,
        1471733935,
        610547355,
        4027169054,
        1432588573,
        1507829418,
        2025931657,
        3646575487,
        545086370,
        48609733,
        2200306550,
        1653985193,
        298326376,
        1316178497,
        3007786442,
        2064951626,
        458293330,
        2589141269,
        3591329599,
        3164325604,
        727753846,
        2179363840,
        146436021,
        1461446943,
        4069977195,
        705550613,
        3059967265,
        3887724982,
        4281599278,
        3313849956,
        1404054877,
        2845806497,
        146425753,
        1854211946
    ],
    [
        1266315497,
        3048417604,
        3681880366,
        3289982499,
        290971e4,
        1235738493,
        2632868024,
        2414719590,
        3970600049,
        1771706367,
        1449415276,
        3266420449,
        422970021,
        1963543593,
        2690192192,
        3826793022,
        1062508698,
        1531092325,
        1804592342,
        2583117782,
        2714934279,
        4024971509,
        1294809318,
        4028980673,
        1289560198,
        2221992742,
        1669523910,
        35572830,
        157838143,
        1052438473,
        1016535060,
        1802137761,
        1753167236,
        1386275462,
        3080475397,
        2857371447,
        1040679964,
        2145300060,
        2390574316,
        1461121720,
        2956646967,
        4031777805,
        4028374788,
        33600511,
        2920084762,
        1018524850,
        629373528,
        3691585981,
        3515945977,
        2091462646,
        2486323059,
        586499841,
        988145025,
        935516892,
        3367335476,
        2599673255,
        2839830854,
        265290510,
        3972581182,
        2759138881,
        3795373465,
        1005194799,
        847297441,
        406762289,
        1314163512,
        1332590856,
        1866599683,
        4127851711,
        750260880,
        613907577,
        1450815602,
        3165620655,
        3734664991,
        3650291728,
        3012275730,
        3704569646,
        1427272223,
        778793252,
        1343938022,
        2676280711,
        2052605720,
        1946737175,
        3164576444,
        3914038668,
        3967478842,
        3682934266,
        1661551462,
        3294938066,
        4011595847,
        840292616,
        3712170807,
        616741398,
        312560963,
        711312465,
        1351876610,
        322626781,
        1910503582,
        271666773,
        2175563734,
        1594956187,
        70604529,
        3617834859,
        1007753275,
        1495573769,
        4069517037,
        2549218298,
        2663038764,
        504708206,
        2263041392,
        3941167025,
        2249088522,
        1514023603,
        1998579484,
        1312622330,
        694541497,
        2582060303,
        2151582166,
        1382467621,
        776784248,
        2618340202,
        3323268794,
        2497899128,
        2784771155,
        503983604,
        4076293799,
        907881277,
        423175695,
        432175456,
        1378068232,
        4145222326,
        3954048622,
        3938656102,
        3820766613,
        2793130115,
        2977904593,
        26017576,
        3274890735,
        3194772133,
        1700274565,
        1756076034,
        4006520079,
        3677328699,
        720338349,
        1533947780,
        354530856,
        688349552,
        3973924725,
        1637815568,
        332179504,
        3949051286,
        53804574,
        2852348879,
        3044236432,
        1282449977,
        3583942155,
        3416972820,
        4006381244,
        1617046695,
        2628476075,
        3002303598,
        1686838959,
        431878346,
        2686675385,
        1700445008,
        1080580658,
        1009431731,
        832498133,
        3223435511,
        2605976345,
        2271191193,
        2516031870,
        1648197032,
        4164389018,
        2548247927,
        300782431,
        375919233,
        238389289,
        3353747414,
        2531188641,
        2019080857,
        1475708069,
        455242339,
        2609103871,
        448939670,
        3451063019,
        1395535956,
        2413381860,
        1841049896,
        1491858159,
        885456874,
        4264095073,
        4001119347,
        1565136089,
        3898914787,
        1108368660,
        540939232,
        1173283510,
        2745871338,
        3681308437,
        4207628240,
        3343053890,
        4016749493,
        1699691293,
        1103962373,
        3625875870,
        2256883143,
        3830138730,
        1031889488,
        3479347698,
        1535977030,
        4236805024,
        3251091107,
        2132092099,
        1774941330,
        1199868427,
        1452454533,
        157007616,
        2904115357,
        342012276,
        595725824,
        1480756522,
        206960106,
        497939518,
        591360097,
        863170706,
        2375253569,
        3596610801,
        1814182875,
        2094937945,
        3421402208,
        1082520231,
        3463918190,
        2785509508,
        435703966,
        3908032597,
        1641649973,
        2842273706,
        3305899714,
        1510255612,
        2148256476,
        2655287854,
        3276092548,
        4258621189,
        236887753,
        3681803219,
        274041037,
        1734335097,
        3815195456,
        3317970021,
        1899903192,
        1026095262,
        4050517792,
        356393447,
        2410691914,
        3873677099,
        3682840055
    ],
    [
        3913112168,
        2491498743,
        4132185628,
        2489919796,
        1091903735,
        1979897079,
        3170134830,
        3567386728,
        3557303409,
        857797738,
        1136121015,
        1342202287,
        507115054,
        2535736646,
        337727348,
        3213592640,
        1301675037,
        2528481711,
        1895095763,
        1721773893,
        3216771564,
        62756741,
        2142006736,
        835421444,
        2531993523,
        1442658625,
        3659876326,
        2882144922,
        676362277,
        1392781812,
        170690266,
        3921047035,
        1759253602,
        3611846912,
        1745797284,
        664899054,
        1329594018,
        3901205900,
        3045908486,
        2062866102,
        2865634940,
        3543621612,
        3464012697,
        1080764994,
        553557557,
        3656615353,
        3996768171,
        991055499,
        499776247,
        1265440854,
        648242737,
        3940784050,
        980351604,
        3713745714,
        1749149687,
        3396870395,
        4211799374,
        3640570775,
        1161844396,
        3125318951,
        1431517754,
        545492359,
        4268468663,
        3499529547,
        1437099964,
        2702547544,
        3433638243,
        2581715763,
        2787789398,
        1060185593,
        1593081372,
        2418618748,
        4260947970,
        69676912,
        2159744348,
        86519011,
        2512459080,
        3838209314,
        1220612927,
        3339683548,
        133810670,
        1090789135,
        1078426020,
        1569222167,
        845107691,
        3583754449,
        4072456591,
        1091646820,
        628848692,
        1613405280,
        3757631651,
        526609435,
        236106946,
        48312990,
        2942717905,
        3402727701,
        1797494240,
        859738849,
        992217954,
        4005476642,
        2243076622,
        3870952857,
        3732016268,
        765654824,
        3490871365,
        2511836413,
        1685915746,
        3888969200,
        1414112111,
        2273134842,
        3281911079,
        4080962846,
        172450625,
        2569994100,
        980381355,
        4109958455,
        2819808352,
        2716589560,
        2568741196,
        3681446669,
        3329971472,
        1835478071,
        660984891,
        3704678404,
        4045999559,
        3422617507,
        3040415634,
        1762651403,
        1719377915,
        3470491036,
        2693910283,
        3642056355,
        3138596744,
        1364962596,
        2073328063,
        1983633131,
        926494387,
        3423689081,
        2150032023,
        4096667949,
        1749200295,
        3328846651,
        309677260,
        2016342300,
        1779581495,
        3079819751,
        111262694,
        1274766160,
        443224088,
        298511866,
        1025883608,
        3806446537,
        1145181785,
        168956806,
        3641502830,
        3584813610,
        1689216846,
        3666258015,
        3200248200,
        1692713982,
        2646376535,
        4042768518,
        1618508792,
        1610833997,
        3523052358,
        4130873264,
        2001055236,
        3610705100,
        2202168115,
        4028541809,
        2961195399,
        1006657119,
        2006996926,
        3186142756,
        1430667929,
        3210227297,
        1314452623,
        4074634658,
        4101304120,
        2273951170,
        1399257539,
        3367210612,
        3027628629,
        1190975929,
        2062231137,
        2333990788,
        2221543033,
        2438960610,
        1181637006,
        548689776,
        2362791313,
        3372408396,
        3104550113,
        3145860560,
        296247880,
        1970579870,
        3078560182,
        3769228297,
        1714227617,
        3291629107,
        3898220290,
        166772364,
        1251581989,
        493813264,
        448347421,
        195405023,
        2709975567,
        677966185,
        3703036547,
        1463355134,
        2715995803,
        1338867538,
        1343315457,
        2802222074,
        2684532164,
        233230375,
        2599980071,
        2000651841,
        3277868038,
        1638401717,
        4028070440,
        3237316320,
        6314154,
        819756386,
        300326615,
        590932579,
        1405279636,
        3267499572,
        3150704214,
        2428286686,
        3959192993,
        3461946742,
        1862657033,
        1266418056,
        963775037,
        2089974820,
        2263052895,
        1917689273,
        448879540,
        3550394620,
        3981727096,
        150775221,
        3627908307,
        1303187396,
        508620638,
        2975983352,
        2726630617,
        1817252668,
        1876281319,
        1457606340,
        908771278,
        3720792119,
        3617206836,
        2455994898,
        1729034894,
        1080033504
    ],
    [
        976866871,
        3556439503,
        2881648439,
        1522871579,
        1555064734,
        1336096578,
        3548522304,
        2579274686,
        3574697629,
        3205460757,
        3593280638,
        3338716283,
        3079412587,
        564236357,
        2993598910,
        1781952180,
        1464380207,
        3163844217,
        3332601554,
        1699332808,
        1393555694,
        1183702653,
        3581086237,
        1288719814,
        691649499,
        2847557200,
        2895455976,
        3193889540,
        2717570544,
        1781354906,
        1676643554,
        2592534050,
        3230253752,
        1126444790,
        2770207658,
        2633158820,
        2210423226,
        2615765581,
        2414155088,
        3127139286,
        673620729,
        2805611233,
        1269405062,
        4015350505,
        3341807571,
        4149409754,
        1057255273,
        2012875353,
        2162469141,
        2276492801,
        2601117357,
        993977747,
        3918593370,
        2654263191,
        753973209,
        36408145,
        2530585658,
        25011837,
        3520020182,
        2088578344,
        530523599,
        2918365339,
        1524020338,
        1518925132,
        3760827505,
        3759777254,
        1202760957,
        3985898139,
        3906192525,
        674977740,
        4174734889,
        2031300136,
        2019492241,
        3983892565,
        4153806404,
        3822280332,
        352677332,
        2297720250,
        60907813,
        90501309,
        3286998549,
        1016092578,
        2535922412,
        2839152426,
        457141659,
        509813237,
        4120667899,
        652014361,
        1966332200,
        2975202805,
        55981186,
        2327461051,
        676427537,
        3255491064,
        2882294119,
        3433927263,
        1307055953,
        942726286,
        933058658,
        2468411793,
        3933900994,
        4215176142,
        1361170020,
        2001714738,
        2830558078,
        3274259782,
        1222529897,
        1679025792,
        2729314320,
        3714953764,
        1770335741,
        151462246,
        3013232138,
        1682292957,
        1483529935,
        471910574,
        1539241949,
        458788160,
        3436315007,
        1807016891,
        3718408830,
        978976581,
        1043663428,
        3165965781,
        1927990952,
        4200891579,
        2372276910,
        3208408903,
        3533431907,
        1412390302,
        2931980059,
        4132332400,
        1947078029,
        3881505623,
        4168226417,
        2941484381,
        1077988104,
        1320477388,
        886195818,
        18198404,
        3786409e3,
        2509781533,
        112762804,
        3463356488,
        1866414978,
        891333506,
        18488651,
        661792760,
        1628790961,
        3885187036,
        3141171499,
        876946877,
        2693282273,
        1372485963,
        791857591,
        2686433993,
        3759982718,
        3167212022,
        3472953795,
        2716379847,
        445679433,
        3561995674,
        3504004811,
        3574258232,
        54117162,
        3331405415,
        2381918588,
        3769707343,
        4154350007,
        1140177722,
        4074052095,
        668550556,
        3214352940,
        367459370,
        261225585,
        2610173221,
        4209349473,
        3468074219,
        3265815641,
        314222801,
        3066103646,
        3808782860,
        282218597,
        3406013506,
        3773591054,
        379116347,
        1285071038,
        846784868,
        2669647154,
        3771962079,
        3550491691,
        2305946142,
        453669953,
        1268987020,
        3317592352,
        3279303384,
        3744833421,
        2610507566,
        3859509063,
        266596637,
        3847019092,
        517658769,
        3462560207,
        3443424879,
        370717030,
        4247526661,
        2224018117,
        4143653529,
        4112773975,
        2788324899,
        2477274417,
        1456262402,
        2901442914,
        1517677493,
        1846949527,
        2295493580,
        3734397586,
        2176403920,
        1280348187,
        1908823572,
        3871786941,
        846861322,
        1172426758,
        3287448474,
        3383383037,
        1655181056,
        3139813346,
        901632758,
        1897031941,
        2986607138,
        3066810236,
        3447102507,
        1393639104,
        373351379,
        950779232,
        625454576,
        3124240540,
        4148612726,
        2007998917,
        544563296,
        2244738638,
        2330496472,
        2058025392,
        1291430526,
        424198748,
        50039436,
        29584100,
        3605783033,
        2429876329,
        2791104160,
        1057563949,
        3255363231,
        3075367218,
        3463963227,
        1469046755,
        985887462
    ]
], fy.prototype.PARRAY = [
    608135816,
    2242054355,
    320440878,
    57701188,
    2752067618,
    698298832,
    137296536,
    3964562569,
    1160258022,
    953160567,
    3193202383,
    887688300,
    3232508343,
    3380367581,
    1065670069,
    3041331479,
    2450970073,
    2306472731
], fy.prototype.NN = 16, fy.prototype._clean = function(e) {
    if (e < 0) e = (2147483647 & e) + 2147483648;
    return e;
}, fy.prototype._F = function(e) {
    let t;
    const r = 255 & e, n = 255 & (e >>>= 8), i = 255 & (e >>>= 8), s = 255 & (e >>>= 8);
    return t = this.sboxes[0][s] + this.sboxes[1][i], t ^= this.sboxes[2][n], t += this.sboxes[3][r], t;
}, fy.prototype._encryptBlock = function(e) {
    let t, r = e[0], n = e[1];
    for(t = 0; t < this.NN; ++t){
        r ^= this.parray[t], n = this._F(r) ^ n;
        const e = r;
        r = n, n = e;
    }
    r ^= this.parray[this.NN + 0], n ^= this.parray[this.NN + 1], e[0] = this._clean(n), e[1] = this._clean(r);
}, fy.prototype.encryptBlock = function(e) {
    let t;
    const r = [
        0,
        0
    ], n = this.BLOCKSIZE / 2;
    for(t = 0; t < this.BLOCKSIZE / 2; ++t)r[0] = r[0] << 8 | 255 & e[t + 0], r[1] = r[1] << 8 | 255 & e[t + n];
    this._encryptBlock(r);
    const i = [];
    for(t = 0; t < this.BLOCKSIZE / 2; ++t)i[t + 0] = r[0] >>> 24 - 8 * t & 255, i[t + n] = r[1] >>> 24 - 8 * t & 255;
    return i;
}, fy.prototype._decryptBlock = function(e) {
    let t, r = e[0], n = e[1];
    for(t = this.NN + 1; t > 1; --t){
        r ^= this.parray[t], n = this._F(r) ^ n;
        const e = r;
        r = n, n = e;
    }
    r ^= this.parray[1], n ^= this.parray[0], e[0] = this._clean(n), e[1] = this._clean(r);
}, fy.prototype.init = function(e) {
    let t, r = 0;
    for(this.parray = [], t = 0; t < this.NN + 2; ++t){
        let n = 0;
        for(let t = 0; t < 4; ++t)n = n << 8 | 255 & e[r], ++r >= e.length && (r = 0);
        this.parray[t] = this.PARRAY[t] ^ n;
    }
    for(this.sboxes = [], t = 0; t < 4; ++t)for(this.sboxes[t] = [], r = 0; r < 256; ++r)this.sboxes[t][r] = this.SBOXES[t][r];
    const n = [
        0,
        0
    ];
    for(t = 0; t < this.NN + 2; t += 2)this._encryptBlock(n), this.parray[t + 0] = n[0], this.parray[t + 1] = n[1];
    for(t = 0; t < 4; ++t)for(r = 0; r < 256; r += 2)this._encryptBlock(n), this.sboxes[t][r + 0] = n[0], this.sboxes[t][r + 1] = n[1];
}, gy.keySize = gy.prototype.keySize = 16, gy.blockSize = gy.prototype.blockSize = 8;
const py = new Map(Object.entries({
    tripledes: iy,
    cast5: ay,
    twofish: yy,
    blowfish: gy
}));
var dy = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    legacyCiphers: py
});
function Ay(e, t, r, n) {
    e[t] += r[n], e[t + 1] += r[n + 1] + (e[t] < r[n]);
}
function wy(e, t) {
    e[0] += t, e[1] += e[0] < t;
}
function my(e, t, r, n, i, s, a, o) {
    Ay(e, r, e, n), Ay(e, r, t, a);
    let c = e[s] ^ e[r], h = e[s + 1] ^ e[r + 1];
    e[s] = h, e[s + 1] = c, Ay(e, i, e, s), c = e[n] ^ e[i], h = e[n + 1] ^ e[i + 1], e[n] = c >>> 24 ^ h << 8, e[n + 1] = h >>> 24 ^ c << 8, Ay(e, r, e, n), Ay(e, r, t, o), c = e[s] ^ e[r], h = e[s + 1] ^ e[r + 1], e[s] = c >>> 16 ^ h << 16, e[s + 1] = h >>> 16 ^ c << 16, Ay(e, i, e, s), c = e[n] ^ e[i], h = e[n + 1] ^ e[i + 1], e[n] = h >>> 31 ^ c << 1, e[n + 1] = c >>> 31 ^ h << 1;
}
const by = new Uint32Array([
    4089235720,
    1779033703,
    2227873595,
    3144134277,
    4271175723,
    1013904242,
    1595750129,
    2773480762,
    2917565137,
    1359893119,
    725511199,
    2600822924,
    4215389547,
    528734635,
    327033209,
    1541459225
]), ky = new Uint8Array([
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3
].map((e)=>2 * e));
function Ey(e, t) {
    const r = new Uint32Array(32), n = new Uint32Array(e.b.buffer, e.b.byteOffset, 32);
    for(let t = 0; t < 16; t++)r[t] = e.h[t], r[t + 16] = by[t];
    r[24] ^= e.t0[0], r[25] ^= e.t0[1];
    const i = t ? 4294967295 : 0;
    r[28] ^= i, r[29] ^= i;
    for(let e = 0; e < 12; e++){
        const t = e << 4;
        my(r, n, 0, 8, 16, 24, ky[t + 0], ky[t + 1]), my(r, n, 2, 10, 18, 26, ky[t + 2], ky[t + 3]), my(r, n, 4, 12, 20, 28, ky[t + 4], ky[t + 5]), my(r, n, 6, 14, 22, 30, ky[t + 6], ky[t + 7]), my(r, n, 0, 10, 20, 30, ky[t + 8], ky[t + 9]), my(r, n, 2, 12, 22, 24, ky[t + 10], ky[t + 11]), my(r, n, 4, 14, 16, 26, ky[t + 12], ky[t + 13]), my(r, n, 6, 8, 18, 28, ky[t + 14], ky[t + 15]);
    }
    for(let t = 0; t < 16; t++)e.h[t] ^= r[t] ^ r[t + 16];
}
class vy {
    constructor(e, t, r, n){
        const i = new Uint8Array(64);
        this.S = {
            b: new Uint8Array(Sy),
            h: new Uint32Array(By / 4),
            t0: new Uint32Array(2),
            c: 0,
            outlen: e
        }, i[0] = e, t && (i[1] = t.length), i[2] = 1, i[3] = 1, r && i.set(r, 32), n && i.set(n, 48);
        const s = new Uint32Array(i.buffer, i.byteOffset, i.length / Uint32Array.BYTES_PER_ELEMENT);
        for(let e = 0; e < 16; e++)this.S.h[e] = by[e] ^ s[e];
        if (t) {
            const e = new Uint8Array(Sy);
            e.set(t), this.update(e);
        }
    }
    update(e) {
        if (!(e instanceof Uint8Array)) throw Error("Input must be Uint8Array or Buffer");
        let t = 0;
        for(; t < e.length;){
            this.S.c === Sy && (wy(this.S.t0, this.S.c), Ey(this.S, !1), this.S.c = 0);
            let r = Sy - this.S.c;
            this.S.b.set(e.subarray(t, t + r), this.S.c);
            const n = Math.min(r, e.length - t);
            this.S.c += n, t += n;
        }
        return this;
    }
    digest(e) {
        wy(this.S.t0, this.S.c), this.S.b.fill(0, this.S.c), this.S.c = Sy, Ey(this.S, !0);
        const t = e || new Uint8Array(this.S.outlen);
        for(let e = 0; e < this.S.outlen; e++)t[e] = this.S.h[e >> 2] >> 8 * (3 & e);
        return this.S.h = null, t.buffer;
    }
}
function Iy(e, t, r, n) {
    if (e > By) throw Error(`outlen must be at most ${By} (given: ${e})`);
    return new vy(e, t, r, n);
}
const By = 64, Sy = 128, Ky = 2, Cy = 19, Dy = 4294967295, Uy = 4, Py = 4294967295, xy = 8, Qy = 4294967295, Ry = 8, Ty = 4294967295, Ly = 4294967295, My = 32, Ny = 1024, Fy = 64, Oy = 205 === new Uint8Array(new Uint16Array([
    43981
]).buffer)[0];
function Hy(e, t, r) {
    return e[r + 0] = t, e[r + 1] = t >> 8, e[r + 2] = t >> 16, e[r + 3] = t >> 24, e;
}
function zy(e, t, r) {
    if (t > Number.MAX_SAFE_INTEGER) throw Error("LE64: large numbers unsupported");
    let n = t;
    for(let t = r; t < r + 7; t++)e[t] = n, n = (n - e[t]) / 256;
    return e;
}
function Gy(e, t, r) {
    const n = new Uint8Array(64), i = new Uint8Array(4 + t.length);
    if (Hy(i, e, 0), i.set(t, 4), e <= 64) return Iy(e).update(i).digest(r), r;
    const s = Math.ceil(e / 32) - 2;
    for(let e = 0; e < s; e++)Iy(64).update(0 === e ? i : n).digest(n), r.set(n.subarray(0, 32), 32 * e);
    const a = new Uint8Array(Iy(e - 32 * s).update(n).digest());
    return r.set(a, 32 * s), r;
}
function _y(e, t, r, n) {
    return e.fn.XOR(t.byteOffset, r.byteOffset, n.byteOffset), t;
}
function jy(e, t, r, n) {
    return e.fn.G(t.byteOffset, r.byteOffset, n.byteOffset, e.refs.gZ.byteOffset), n;
}
function qy(e, t, r, n) {
    return e.fn.G2(t.byteOffset, r.byteOffset, n.byteOffset, e.refs.gZ.byteOffset), n;
}
function* Vy(e, t, r, n, i, s, a, o) {
    e.refs.prngTmp.fill(0);
    const c = e.refs.prngTmp.subarray(0, 48);
    zy(c, t, 0), zy(c, r, 8), zy(c, n, 16), zy(c, i, 24), zy(c, s, 32), zy(c, Ky, 40);
    for(let t = 1; t <= a; t++){
        zy(e.refs.prngTmp, t, c.length);
        const r = qy(e, e.refs.ZERO1024, e.refs.prngTmp, e.refs.prngR);
        for(let e = 1 === t ? 8 * o : 0; e < r.length; e += 8)yield r.subarray(e, e + 8);
    }
    return [];
}
const Jy = 1024, Yy = 64 * Jy;
function Zy(e, { memory: t, instance: r }) {
    if (!Oy) throw Error("BigEndian system not supported");
    const n = function({ type: e, version: t, tagLength: r, password: n, salt: i, ad: s, secret: a, parallelism: o, memorySize: c, passes: h }) {
        const u = (e, t, r, n)=>{
            if (t < r || t > n) throw Error(`${e} size should be between ${r} and ${n} bytes`);
        };
        if (e !== Ky || t !== Cy) throw Error("Unsupported type or version");
        return u("password", n, Ry, Qy), u("salt", i, xy, Py), u("tag", r, Uy, Dy), u("memory", c, 8 * o, Ty), s && u("associated data", s, 0, Ly), a && u("secret", a, 0, My), {
            type: e,
            version: t,
            tagLength: r,
            password: n,
            salt: i,
            ad: s,
            secret: a,
            lanes: o,
            memorySize: c,
            passes: h
        };
    }({
        type: Ky,
        version: Cy,
        ...e
    }), { G: i, G2: s, xor: a, getLZ: o } = r.exports, c = {}, h = {};
    h.G = i, h.G2 = s, h.XOR = a;
    const u = 4 * n.lanes * Math.floor(n.memorySize / (4 * n.lanes)), l = u * Ny + 10 * Jy;
    if (t.buffer.byteLength < l) {
        const e = Math.ceil((l - t.buffer.byteLength) / Yy);
        t.grow(e);
    }
    let y = 0;
    c.gZ = new Uint8Array(t.buffer, y, Ny), y += c.gZ.length, c.prngR = new Uint8Array(t.buffer, y, Ny), y += c.prngR.length, c.prngTmp = new Uint8Array(t.buffer, y, Ny), y += c.prngTmp.length, c.ZERO1024 = new Uint8Array(t.buffer, y, 1024), y += c.ZERO1024.length;
    const f = new Uint32Array(t.buffer, y, 2);
    y += f.length * Uint32Array.BYTES_PER_ELEMENT;
    const g = {
        fn: h,
        refs: c
    }, p = new Uint8Array(t.buffer, y, Ny);
    y += p.length;
    const d = new Uint8Array(t.buffer, y, n.memorySize * Ny), A = new Uint8Array(t.buffer, 0, y), w = function(e) {
        const t = Iy(Fy), r = new Uint8Array(4), n = new Uint8Array(24);
        Hy(n, e.lanes, 0), Hy(n, e.tagLength, 4), Hy(n, e.memorySize, 8), Hy(n, e.passes, 12), Hy(n, e.version, 16), Hy(n, e.type, 20);
        const i = [
            n
        ];
        e.password ? (i.push(Hy(new Uint8Array(4), e.password.length, 0)), i.push(e.password)) : i.push(r);
        e.salt ? (i.push(Hy(new Uint8Array(4), e.salt.length, 0)), i.push(e.salt)) : i.push(r);
        e.secret ? (i.push(Hy(new Uint8Array(4), e.secret.length, 0)), i.push(e.secret)) : i.push(r);
        e.ad ? (i.push(Hy(new Uint8Array(4), e.ad.length, 0)), i.push(e.ad)) : i.push(r);
        t.update(function(e) {
            if (1 === e.length) return e[0];
            let t = 0;
            for(let r = 0; r < e.length; r++){
                if (!(e[r] instanceof Uint8Array)) throw Error("concatArrays: Data must be in the form of a Uint8Array");
                t += e[r].length;
            }
            const r = new Uint8Array(t);
            let n = 0;
            return e.forEach((e)=>{
                r.set(e, n), n += e.length;
            }), r;
        }(i));
        const s = t.digest();
        return new Uint8Array(s);
    }(n), m = u / n.lanes, b = Array(n.lanes).fill(null).map(()=>Array(m)), k = (e, t)=>(b[e][t] = d.subarray(e * m * 1024 + 1024 * t, e * m * 1024 + 1024 * t + Ny), b[e][t]);
    for(let e = 0; e < n.lanes; e++){
        const t = new Uint8Array(w.length + 8);
        t.set(w), Hy(t, 0, w.length), Hy(t, e, w.length + 4), Gy(Ny, t, k(e, 0)), Hy(t, 1, w.length), Gy(Ny, t, k(e, 1));
    }
    const E = m / 4;
    for(let e = 0; e < n.passes; e++)for(let t = 0; t < 4; t++){
        const r = 0 === e && t <= 1;
        for(let i = 0; i < n.lanes; i++){
            let s = 0 === t && 0 === e ? 2 : 0;
            const a = r ? Vy(g, e, i, t, u, n.passes, E, s) : null;
            for(; s < E; s++){
                const c = t * E + s, h = c > 0 ? b[i][c - 1] : b[i][m - 1], u = r ? a.next().value : h;
                o(f.byteOffset, u.byteOffset, i, n.lanes, e, t, s, 4, E);
                const l = f[0], y = f[1];
                0 === e && k(i, c), jy(g, h, b[l][y], e > 0 ? p : b[i][c]), e > 0 && _y(g, b[i][c], p, b[i][c]);
            }
        }
    }
    const v = b[0][m - 1];
    for(let e = 1; e < n.lanes; e++)_y(g, v, v, b[e][m - 1]);
    const I = Gy(n.tagLength, v, new Uint8Array(n.tagLength));
    return A.fill(0), t.grow(0), I;
}
let Wy;
async function $y(e, t) {
    const r = new WebAssembly.Memory({
        initial: 1040,
        maximum: 65536
    }), n = await async function(e, t, r) {
        const n = {
            env: {
                memory: e
            }
        };
        if (void 0 === Wy) try {
            const e = await t(n);
            return Wy = !0, e;
        } catch (e) {
            Wy = !1;
        }
        return (Wy ? t : r)(n);
    }(r, e, t);
    return (e)=>Zy(e, {
            instance: n.instance,
            memory: r
        });
}
function Xy(t, r, n, i) {
    var s = null, a = e.atob(n), o = a.length;
    s = new Uint8Array(new ArrayBuffer(o));
    for(var c = 0; c < o; c++)s[c] = a.charCodeAt(c);
    return function(e, t) {
        var r = WebAssembly.instantiate, n = WebAssembly.compile;
        return t ? r(e, t) : n(e);
    }(s, i);
}
var ef = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    default: async ()=>$y((e)=>Xy(0, 0, "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", e), (e)=>Xy(0, 0, "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", e))
}), tf = [
    0,
    1,
    3,
    7,
    15,
    31,
    63,
    127,
    255
], rf = function(e) {
    this.stream = e, this.bitOffset = 0, this.curByte = 0, this.hasByte = !1;
};
rf.prototype._ensureByte = function() {
    this.hasByte || (this.curByte = this.stream.readByte(), this.hasByte = !0);
}, rf.prototype.read = function(e) {
    for(var t = 0; e > 0;){
        this._ensureByte();
        var r = 8 - this.bitOffset;
        if (e >= r) t <<= r, t |= tf[r] & this.curByte, this.hasByte = !1, this.bitOffset = 0, e -= r;
        else {
            t <<= e;
            var n = r - e;
            t |= (this.curByte & tf[e] << n) >> n, this.bitOffset += e, e = 0;
        }
    }
    return t;
}, rf.prototype.seek = function(e) {
    var t = e % 8, r = (e - t) / 8;
    this.bitOffset = t, this.stream.seek(r), this.hasByte = !1;
}, rf.prototype.pi = function() {
    var e, t = new Uint8Array(6);
    for(e = 0; e < t.length; e++)t[e] = this.read(8);
    return function(e) {
        return Array.prototype.map.call(e, (e)=>("00" + e.toString(16)).slice(-2)).join("");
    }(t);
};
var nf = rf, sf = function() {};
sf.prototype.readByte = function() {
    throw Error("abstract method readByte() not implemented");
}, sf.prototype.read = function(e, t, r) {
    for(var n = 0; n < r;){
        var i = this.readByte();
        if (i < 0) return 0 === n ? -1 : n;
        e[t++] = i, n++;
    }
    return n;
}, sf.prototype.seek = function(e) {
    throw Error("abstract method seek() not implemented");
}, sf.prototype.writeByte = function(e) {
    throw Error("abstract method readByte() not implemented");
}, sf.prototype.write = function(e, t, r) {
    var n;
    for(n = 0; n < r; n++)this.writeByte(e[t++]);
    return r;
}, sf.prototype.flush = function() {};
var af, of = sf, cf = (af = new Uint32Array([
    0,
    79764919,
    159529838,
    222504665,
    319059676,
    398814059,
    445009330,
    507990021,
    638119352,
    583659535,
    797628118,
    726387553,
    890018660,
    835552979,
    1015980042,
    944750013,
    1276238704,
    1221641927,
    1167319070,
    1095957929,
    1595256236,
    1540665371,
    1452775106,
    1381403509,
    1780037320,
    1859660671,
    1671105958,
    1733955601,
    2031960084,
    2111593891,
    1889500026,
    1952343757,
    2552477408,
    2632100695,
    2443283854,
    2506133561,
    2334638140,
    2414271883,
    2191915858,
    2254759653,
    3190512472,
    3135915759,
    3081330742,
    3009969537,
    2905550212,
    2850959411,
    2762807018,
    2691435357,
    3560074640,
    3505614887,
    3719321342,
    3648080713,
    3342211916,
    3287746299,
    3467911202,
    3396681109,
    4063920168,
    4143685023,
    4223187782,
    4286162673,
    3779000052,
    3858754371,
    3904687514,
    3967668269,
    881225847,
    809987520,
    1023691545,
    969234094,
    662832811,
    591600412,
    771767749,
    717299826,
    311336399,
    374308984,
    453813921,
    533576470,
    25881363,
    88864420,
    134795389,
    214552010,
    2023205639,
    2086057648,
    1897238633,
    1976864222,
    1804852699,
    1867694188,
    1645340341,
    1724971778,
    1587496639,
    1516133128,
    1461550545,
    1406951526,
    1302016099,
    1230646740,
    1142491917,
    1087903418,
    2896545431,
    2825181984,
    2770861561,
    2716262478,
    3215044683,
    3143675388,
    3055782693,
    3001194130,
    2326604591,
    2389456536,
    2200899649,
    2280525302,
    2578013683,
    2640855108,
    2418763421,
    2498394922,
    3769900519,
    3832873040,
    3912640137,
    3992402750,
    4088425275,
    4151408268,
    4197601365,
    4277358050,
    3334271071,
    3263032808,
    3476998961,
    3422541446,
    3585640067,
    3514407732,
    3694837229,
    3640369242,
    1762451694,
    1842216281,
    1619975040,
    1682949687,
    2047383090,
    2127137669,
    1938468188,
    2001449195,
    1325665622,
    1271206113,
    1183200824,
    1111960463,
    1543535498,
    1489069629,
    1434599652,
    1363369299,
    622672798,
    568075817,
    748617968,
    677256519,
    907627842,
    853037301,
    1067152940,
    995781531,
    51762726,
    131386257,
    177728840,
    240578815,
    269590778,
    349224269,
    429104020,
    491947555,
    4046411278,
    4126034873,
    4172115296,
    4234965207,
    3794477266,
    3874110821,
    3953728444,
    4016571915,
    3609705398,
    3555108353,
    3735388376,
    3664026991,
    3290680682,
    3236090077,
    3449943556,
    3378572211,
    3174993278,
    3120533705,
    3032266256,
    2961025959,
    2923101090,
    2868635157,
    2813903052,
    2742672763,
    2604032198,
    2683796849,
    2461293480,
    2524268063,
    2284983834,
    2364738477,
    2175806836,
    2238787779,
    1569362073,
    1498123566,
    1409854455,
    1355396672,
    1317987909,
    1246755826,
    1192025387,
    1137557660,
    2072149281,
    2135122070,
    1912620623,
    1992383480,
    1753615357,
    1816598090,
    1627664531,
    1707420964,
    295390185,
    358241886,
    404320391,
    483945776,
    43990325,
    106832002,
    186451547,
    266083308,
    932423249,
    861060070,
    1041341759,
    986742920,
    613929101,
    542559546,
    756411363,
    701822548,
    3316196985,
    3244833742,
    3425377559,
    3370778784,
    3601682597,
    3530312978,
    3744426955,
    3689838204,
    3819031489,
    3881883254,
    3928223919,
    4007849240,
    4037393693,
    4100235434,
    4180117107,
    4259748804,
    2310601993,
    2373574846,
    2151335527,
    2231098320,
    2596047829,
    2659030626,
    2470359227,
    2550115596,
    2947551409,
    2876312838,
    2788305887,
    2733848168,
    3165939309,
    3094707162,
    3040238851,
    2985771188
]), function() {
    var e = 4294967295;
    this.getCRC = function() {
        return ~e >>> 0;
    }, this.updateCRC = function(t) {
        e = e << 8 ^ af[255 & (e >>> 24 ^ t)];
    }, this.updateCRCRun = function(t, r) {
        for(; r-- > 0;)e = e << 8 ^ af[255 & (e >>> 24 ^ t)];
    };
}), hf = nf, uf = of, lf = cf, yf = function(e, t) {
    var r, n = e[t];
    for(r = t; r > 0; r--)e[r] = e[r - 1];
    return e[0] = n, n;
}, ff = {
    OK: 0,
    LAST_BLOCK: -1,
    NOT_BZIP_DATA: -2,
    UNEXPECTED_INPUT_EOF: -3,
    UNEXPECTED_OUTPUT_EOF: -4,
    DATA_ERROR: -5,
    OUT_OF_MEMORY: -6,
    OBSOLETE_INPUT: -7,
    END_OF_BLOCK: -8
}, gf = {};
gf[ff.LAST_BLOCK] = "Bad file checksum", gf[ff.NOT_BZIP_DATA] = "Not bzip data", gf[ff.UNEXPECTED_INPUT_EOF] = "Unexpected input EOF", gf[ff.UNEXPECTED_OUTPUT_EOF] = "Unexpected output EOF", gf[ff.DATA_ERROR] = "Data error", gf[ff.OUT_OF_MEMORY] = "Out of memory", gf[ff.OBSOLETE_INPUT] = "Obsolete (pre 0.9.5) bzip format not supported.";
var pf = function(e, t) {
    var r = gf[e] || "unknown error";
    t && (r += ": " + t);
    var n = new TypeError(r);
    throw n.errorCode = e, n;
}, df = function(e, t) {
    this.writePos = this.writeCurrent = this.writeCount = 0, this._start_bunzip(e, t);
};
df.prototype._init_block = function() {
    return this._get_next_block() ? (this.blockCRC = new lf, !0) : (this.writeCount = -1, !1);
}, df.prototype._start_bunzip = function(e, t) {
    var r = new Uint8Array(4);
    4 === e.read(r, 0, 4) && "BZh" === String.fromCharCode(r[0], r[1], r[2]) || pf(ff.NOT_BZIP_DATA, "bad magic");
    var n = r[3] - 48;
    (n < 1 || n > 9) && pf(ff.NOT_BZIP_DATA, "level out of range"), this.reader = new hf(e), this.dbufSize = 1e5 * n, this.nextoutput = 0, this.outputStream = t, this.streamCRC = 0;
}, df.prototype._get_next_block = function() {
    var e, t, r, n = this.reader, i = n.pi();
    if ("177245385090" === i) return !1;
    "314159265359" !== i && pf(ff.NOT_BZIP_DATA), this.targetBlockCRC = n.read(32) >>> 0, this.streamCRC = (this.targetBlockCRC ^ (this.streamCRC << 1 | this.streamCRC >>> 31)) >>> 0, n.read(1) && pf(ff.OBSOLETE_INPUT);
    var s = n.read(24);
    s > this.dbufSize && pf(ff.DATA_ERROR, "initial position out of bounds");
    var a = n.read(16), o = new Uint8Array(256), c = 0;
    for(e = 0; e < 16; e++)if (a & 1 << 15 - e) {
        var h = 16 * e;
        for(r = n.read(16), t = 0; t < 16; t++)r & 1 << 15 - t && (o[c++] = h + t);
    }
    var u = n.read(3);
    (u < 2 || u > 6) && pf(ff.DATA_ERROR);
    var l = n.read(15);
    0 === l && pf(ff.DATA_ERROR);
    var y = new Uint8Array(256);
    for(e = 0; e < u; e++)y[e] = e;
    var f = new Uint8Array(l);
    for(e = 0; e < l; e++){
        for(t = 0; n.read(1); t++)t >= u && pf(ff.DATA_ERROR);
        f[e] = yf(y, t);
    }
    var g, p = c + 2, d = [];
    for(t = 0; t < u; t++){
        var A, w, m = new Uint8Array(p), b = new Uint16Array(21);
        for(a = n.read(5), e = 0; e < p; e++){
            for(; (a < 1 || a > 20) && pf(ff.DATA_ERROR), n.read(1);)n.read(1) ? a-- : a++;
            m[e] = a;
        }
        for(A = w = m[0], e = 1; e < p; e++)m[e] > w ? w = m[e] : m[e] < A && (A = m[e]);
        g = {}, d.push(g), g.permute = new Uint16Array(258), g.limit = new Uint32Array(22), g.base = new Uint32Array(21), g.minLen = A, g.maxLen = w;
        var k = 0;
        for(e = A; e <= w; e++)for(b[e] = g.limit[e] = 0, a = 0; a < p; a++)m[a] === e && (g.permute[k++] = a);
        for(e = 0; e < p; e++)b[m[e]]++;
        for(k = a = 0, e = A; e < w; e++)k += b[e], g.limit[e] = k - 1, k <<= 1, a += b[e], g.base[e + 1] = k - a;
        g.limit[w + 1] = Number.MAX_VALUE, g.limit[w] = k + b[w] - 1, g.base[A] = 0;
    }
    var E = new Uint32Array(256);
    for(e = 0; e < 256; e++)y[e] = e;
    var v, I = 0, B = 0, S = 0, K = this.dbuf = new Uint32Array(this.dbufSize);
    for(p = 0;;){
        for(p-- || (p = 49, S >= l && pf(ff.DATA_ERROR), g = d[f[S++]]), e = g.minLen, t = n.read(e); e > g.maxLen && pf(ff.DATA_ERROR), !(t <= g.limit[e]); e++)t = t << 1 | n.read(1);
        ((t -= g.base[e]) < 0 || t >= 258) && pf(ff.DATA_ERROR);
        var C = g.permute[t];
        if (0 !== C && 1 !== C) {
            if (I) for(I = 0, B + a > this.dbufSize && pf(ff.DATA_ERROR), E[v = o[y[0]]] += a; a--;)K[B++] = v;
            if (C > c) break;
            B >= this.dbufSize && pf(ff.DATA_ERROR), E[v = o[v = yf(y, e = C - 1)]]++, K[B++] = v;
        } else I || (I = 1, a = 0), a += 0 === C ? I : 2 * I, I <<= 1;
    }
    for((s < 0 || s >= B) && pf(ff.DATA_ERROR), t = 0, e = 0; e < 256; e++)r = t + E[e], E[e] = t, t = r;
    for(e = 0; e < B; e++)K[E[v = 255 & K[e]]] |= e << 8, E[v]++;
    var D = 0, U = 0, P = 0;
    return B && (U = 255 & (D = K[s]), D >>= 8, P = -1), this.writePos = D, this.writeCurrent = U, this.writeCount = B, this.writeRun = P, !0;
}, df.prototype._read_bunzip = function(e, t) {
    var r, n, i;
    if (this.writeCount < 0) return 0;
    var s = this.dbuf, a = this.writePos, o = this.writeCurrent, c = this.writeCount;
    this.outputsize;
    for(var h = this.writeRun; c;){
        for(c--, n = o, o = 255 & (a = s[a]), a >>= 8, 3 == h++ ? (r = o, i = n, o = -1) : (r = 1, i = o), this.blockCRC.updateCRCRun(i, r); r--;)this.outputStream.writeByte(i), this.nextoutput++;
        o != n && (h = 0);
    }
    return this.writeCount = c, this.blockCRC.getCRC() !== this.targetBlockCRC && pf(ff.DATA_ERROR, "Bad block CRC (got " + this.blockCRC.getCRC().toString(16) + " expected " + this.targetBlockCRC.toString(16) + ")"), this.nextoutput;
};
var Af = function(e) {
    if ("readByte" in e) return e;
    var t = new uf;
    return t.pos = 0, t.readByte = function() {
        return e[this.pos++];
    }, t.seek = function(e) {
        this.pos = e;
    }, t.eof = function() {
        return this.pos >= e.length;
    }, t;
}, wf = function(e) {
    var t = new uf, r = !0;
    if (e) {
        if ("number" == typeof e) t.buffer = new Uint8Array(e), r = !1;
        else {
            if ("writeByte" in e) return e;
            t.buffer = e, r = !1;
        }
    } else t.buffer = new Uint8Array(16384);
    return t.pos = 0, t.writeByte = function(e) {
        if (r && this.pos >= this.buffer.length) {
            var t = new Uint8Array(2 * this.buffer.length);
            t.set(this.buffer), this.buffer = t;
        }
        this.buffer[this.pos++] = e;
    }, t.getBuffer = function() {
        if (this.pos !== this.buffer.length) {
            if (!r) throw new TypeError("outputsize does not match decoded input");
            var e = new Uint8Array(this.pos);
            e.set(this.buffer.subarray(0, this.pos)), this.buffer = e;
        }
        return this.buffer;
    }, t._coerced = !0, t;
};
var mf = {
    Bunzip: df,
    Stream: uf,
    Err: ff,
    decode: function(e, t, r) {
        for(var n = Af(e), i = wf(t), s = new df(n, i); !("eof" in n) || !n.eof();)if (s._init_block()) s._read_bunzip();
        else {
            var a = s.reader.read(32) >>> 0;
            if (a !== s.streamCRC && pf(ff.DATA_ERROR, "Bad stream CRC (got " + s.streamCRC.toString(16) + " expected " + a.toString(16) + ")"), !r || !("eof" in n) || n.eof()) break;
            s._start_bunzip(n, i);
        }
        if ("getBuffer" in i) return i.getBuffer();
    },
    decodeBlock: function(e, t, r) {
        var n = Af(e), i = wf(r), s = new df(n, i);
        if (s.reader.seek(t), s._get_next_block() && (s.blockCRC = new lf, s.writeCopies = 0, s._read_bunzip()), "getBuffer" in i) return i.getBuffer();
    },
    table: function(e, t, r) {
        var n = new uf;
        n.delegate = Af(e), n.pos = 0, n.readByte = function() {
            return this.pos++, this.delegate.readByte();
        }, n.delegate.eof && (n.eof = n.delegate.eof.bind(n.delegate));
        var i = new uf;
        i.pos = 0, i.writeByte = function() {
            this.pos++;
        };
        for(var s = new df(n, i), a = s.dbufSize; !("eof" in n) || !n.eof();){
            var o = 8 * n.pos + s.reader.bitOffset;
            if (s.reader.hasByte && (o -= 8), s._init_block()) {
                var c = i.pos;
                s._read_bunzip(), t(o, i.pos - c);
            } else {
                if (s.reader.read(32), !r || !("eof" in n) || n.eof()) break;
                s._start_bunzip(n, i), console.assert(s.dbufSize === a, "shouldn't change block size within multistream file");
            }
        }
    }
}, bf = /*#__PURE__*/ t({
    __proto__: null
}, [
    mf
]);

});

const $d99b315d6ecdde76$var$plugins = [];
let $d99b315d6ecdde76$var$allConfig = {};
const $d99b315d6ecdde76$var$supportsConfig = {
    position: {
        groupPosition: {
            type: 'group',
            title: 'Position',
            items: {
                horizontal: {
                    title: 'Horizontal',
                    type: 'select',
                    options: [
                        'left',
                        'right'
                    ],
                    defaultValue: 'left'
                },
                horizontalSpace: {
                    title: 'Space',
                    type: 'number',
                    defaultValue: 30
                },
                vertical: {
                    title: 'Vertical',
                    type: 'select',
                    options: [
                        'top',
                        'bottom'
                    ],
                    defaultValue: 'bottom'
                },
                verticalSpace: {
                    title: 'Space',
                    type: 'number',
                    defaultValue: 153
                }
            }
        }
    }
};
const $d99b315d6ecdde76$export$7612db19fb8beb1e = (name, title, init)=>{
    init.settings = {
        enabled: {
            title: 'enabled',
            type: 'check',
            defaultValue: true
        },
        ...init.settings
    };
    if (typeof init.supports !== 'undefined') for (const key of init.supports)init.settings = {
        ...init.settings,
        ...$d99b315d6ecdde76$var$supportsConfig[key]
    };
    $d99b315d6ecdde76$var$plugins.push({
        name: name,
        title: title,
        ...init,
        config: Object.keys(init.settings).reduce((res, key)=>{
            res[key] = init.settings.defaultValue;
            return res;
        }, {}),
        testAction: init.testAction,
        debugAction: init.debugAction
    });
};
const $d99b315d6ecdde76$export$d117388934d9aaf6 = (enabledPlugins)=>{
    const instances = [];
    for (const enabledPlugin of Object.values(enabledPlugins))instances.push($d99b315d6ecdde76$export$43bcedd5d395f034(enabledPlugin));
    return instances;
};
const $d99b315d6ecdde76$export$43bcedd5d395f034 = (enabledPlugin, parentNode = null)=>{
    if (!parentNode) parentNode = document.body;
    const registeredPlugin = $d99b315d6ecdde76$var$plugins.find((p)=>p.name === enabledPlugin.plugin);
    if (!registeredPlugin) {
        console.error('failed to initialize missing plugin', enabledPlugin.plugin, $d99b315d6ecdde76$var$plugins);
        return;
    }
    const instance = {
        id: enabledPlugin.id,
        ...registeredPlugin,
        config: enabledPlugin.config
    };
    console.log('trigger init', enabledPlugin.plugin, enabledPlugin.id, parentNode);
    instance.initialize(enabledPlugin.id, enabledPlugin.config, parentNode);
    return instance;
};
const $d99b315d6ecdde76$export$964cce64f30a66b4 = (name)=>{
    const plugin = $d99b315d6ecdde76$var$plugins.find((p)=>p.name === name);
    if (!plugin) return {};
    let defaultConfig = {};
    if (typeof plugin.supports !== 'undefined') for (const key of plugin.supports)defaultConfig = {
        ...defaultConfig,
        ...$d99b315d6ecdde76$var$supportsConfig[key]
    };
    const overrides = typeof $d99b315d6ecdde76$var$allConfig[plugin.name] !== 'undefined' ? $d99b315d6ecdde76$var$allConfig[plugin.name] : {};
    return Object.keys({
        ...defaultConfig,
        ...plugin.settings
    }).reduce((res, key)=>{
        res[key] = typeof overrides[key] !== 'undefined' ? overrides[key] : $d99b315d6ecdde76$export$3df98d1b0a8e938f(plugin.name, key);
        return res;
    }, {});
};
const $d99b315d6ecdde76$export$355b3712ebacfec7 = (name, overrides = {})=>{
    const plugin = $d99b315d6ecdde76$var$plugins.find((p)=>p.name === name);
    if (!plugin) return {};
    let defaultConfig = {};
    if (typeof plugin.supports !== 'undefined') for (const key of plugin.supports)defaultConfig = {
        ...defaultConfig,
        ...$d99b315d6ecdde76$var$supportsConfig[key]
    };
    let res = defaultConfig;
    for (const key of Object.keys(plugin.settings)){
        if (plugin.settings[key].type !== 'group') res[key] = typeof overrides[key] !== 'undefined' ? overrides[key] : plugin.settings[key].defaultValue;
        else for (const key2 of Object.keys(plugin.settings[key].items))res[key2] = typeof overrides[key2] !== 'undefined' ? overrides[key2] : plugin.settings[key].items[key2].defaultValue;
    }
    return res;
};
const $d99b315d6ecdde76$export$3df98d1b0a8e938f = (name, key)=>{
    const plugin = $d99b315d6ecdde76$var$plugins.find((p)=>p.name === name);
    if (!plugin) return null;
    if (plugin.settings[key].type === 'group') return null;
    let res = typeof plugin.settings[key] !== 'undefined' ? plugin.settings[key].defaultValue : null;
    if (!res) {
        console.log('searching default value for', key, 'in', plugin.settings);
        for (const key2 of Object.keys(plugin.settings))if (plugin.settings[key2].type === 'group') {
            if (typeof plugin.settings[key2].items[key] !== 'undefined') return plugin.settings[key2].items[key].defaultValue;
            else console.log('not found in', plugin.settings[key2].items);
        }
    }
    return res;
};
const $d99b315d6ecdde76$export$afc29371fe9f4c2c = ()=>{
    return $d99b315d6ecdde76$var$plugins;
};
const $d99b315d6ecdde76$export$e29bb2b8877582e3 = ()=>{
    return $d99b315d6ecdde76$export$afc29371fe9f4c2c().map((p)=>({
            ...p,
            config: $d99b315d6ecdde76$export$964cce64f30a66b4(p.name)
        }));
};



const $ed1aed194b9dae94$var$spritesheet = '/plugins/res/heart-spritesheet.png';
(0, $d99b315d6ecdde76$export$7612db19fb8beb1e)('hearts', 'Hearts for tipping', {
    defaultSettings: [
        "location",
        "horizontalPercent",
        "duration"
    ],
    settings: {
        location: {
            title: 'Location',
            type: 'select',
            options: [
                'left',
                'right'
            ],
            defaultValue: 'right'
        },
        horizontalPercent: {
            title: 'Width',
            help: 'Used portion of screen width in %',
            type: 'number',
            defaultValue: 20
        },
        duration: {
            title: 'Duration',
            help: 'Duration to move a heart from top to bottom (in seconds)',
            type: 'number',
            defaultValue: 2.5
        },
        minSize: {
            title: 'Min. size',
            help: 'Minimum size of one heart',
            type: 'number',
            defaultValue: 20
        },
        maxSize: {
            title: 'Max. size',
            help: 'Maximum size of one heart',
            type: 'number',
            defaultValue: 30
        },
        volume: {
            title: 'Sound volume',
            help: "Volume of the ping sound (0\u2013100)",
            type: 'number',
            defaultValue: 10
        }
    },
    testAction: {
        tip: {
            title: 'Test Tipping',
            config: {
                username: {
                    title: 'Username',
                    type: 'string',
                    defaultValue: 'Test'
                },
                amount: {
                    title: 'Amount',
                    type: 'number',
                    defaultValue: 10
                }
            },
            run: (data, config)=>{
                $ed1aed194b9dae94$var$addHearts(data.amount, config);
            }
        }
    },
    initialize: (id, config)=>{
        console.log('hearts plugin init', id, config);
        if (!document.getElementById('hearts-style')) {
            const style = document.createElement('style');
            style.id = 'hearts-style';
            style.innerHTML = `
                @keyframes heart-spritesheet {
                    from { background-position: 0 0; }
                    to { background-position: -14400px 0; }
                }
            `;
            document.head.appendChild(style);
        }
    },
    onConfig: (id, config)=>{
        console.log('hearts plugin config', id, config);
    },
    onWsAction: (id, action, data, config)=>{
        if ([
            'tip',
            'hearts'
        ].includes(action)) {
            console.log('adding hearts with config', id, config);
            $ed1aed194b9dae94$var$addHearts(data.amount, config);
            return true;
        }
        return false;
    }
});
function $ed1aed194b9dae94$var$randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
const $ed1aed194b9dae94$var$SPRITE_FRAMES = 240;
const $ed1aed194b9dae94$var$SPRITE_LOOP_MS = 2000;
class $ed1aed194b9dae94$var$Heart {
    constructor(onFinished, config = {}){
        this.config = {
            location: 'right',
            duration: 2.5,
            minSize: 20,
            maxSize: 30,
            horizontalPercent: 20,
            ...config
        };
        this.config.duration = parseInt('' + this.config.duration) * 1000;
        this.config.minSize = parseInt('' + this.config.minSize);
        this.config.maxSize = parseInt('' + this.config.maxSize);
        const speedMultiplier = $ed1aed194b9dae94$var$randomInteger(95, 115) / 100;
        this.config.duration = this.config.duration * speedMultiplier;
        this.onFinished = onFinished;
        this.container = null;
        this.wrapper = null;
        this.spriteInterval = null;
    }
    attach() {
        const availableWidth = window.innerWidth * (this.config.horizontalPercent / 100);
        const size = Math.floor(Math.random() * this.config.maxSize) + this.config.minSize;
        const position = Math.floor(Math.random() * availableWidth);
        const fallDuration = this.config.duration;
        // Outer wrapper handles horizontal sway
        const swayAmplitude = $ed1aed194b9dae94$var$randomInteger(20, 50);
        const swayDir = Math.random() > 0.5 ? 1 : -1;
        this.wrapper = document.createElement('div');
        this.wrapper.classList.add('heart-wrapper');
        this.wrapper.style.setProperty('--sway-a', `${swayAmplitude * swayDir}px`);
        this.wrapper.style.setProperty('--sway-b', `${swayAmplitude * -swayDir * 0.7}px`);
        this.wrapper.style.setProperty('--sway-c', `${swayAmplitude * swayDir * 0.4}px`);
        this.wrapper.style.animation = `heart-sway ${fallDuration}ms ease-in-out`;
        if (this.config.location === 'right') this.wrapper.style.right = `${position}px`;
        else this.wrapper.style.left = `${position}px`;
        // Inner span handles vertical fall with gravity (ease-in)
        this.container = document.createElement('span');
        this.container.classList.add('heart');
        this.container.style.visibility = 'hidden';
        this.container.style.width = `${size}px`;
        this.container.style.height = `${size}px`;
        this.container.style.backgroundImage = `url(${$ed1aed194b9dae94$var$spritesheet})`;
        this.container.style.backgroundSize = `${size * $ed1aed194b9dae94$var$SPRITE_FRAMES}px ${size}px`;
        this.container.style.backgroundPosition = '0 0';
        this.container.style.animation = `heart-fall ${fallDuration}ms ease-in`;
        this.wrapper.appendChild(this.container);
        document.body.appendChild(this.wrapper);
        this.container.style.visibility = 'visible';
        let frame = 0;
        this.spriteInterval = setInterval(()=>{
            frame = (frame + 1) % $ed1aed194b9dae94$var$SPRITE_FRAMES;
            if (this.container) this.container.style.backgroundPosition = `${-frame * size}px 0`;
        }, $ed1aed194b9dae94$var$SPRITE_LOOP_MS / $ed1aed194b9dae94$var$SPRITE_FRAMES);
        setTimeout(()=>{
            clearInterval(this.spriteInterval);
            this.wrapper.parentNode.removeChild(this.wrapper);
            this.onFinished(this);
        }, fallDuration * 1.1);
    }
}
let $ed1aed194b9dae94$var$hearts = [];
const $ed1aed194b9dae94$var$addHearts = async (num = 1, config = {
    placementTimeout: 0
})=>{
    const pings = Math.max(1, Math.floor(num / 10));
    const volume = Math.min(100, Math.max(0, Number(config.volume ?? 80))) / 100;
    for(let i = 0; i < pings; i++)setTimeout(()=>{
        const audio = new Audio('/plugins/res/universfield-happy-message-ping-351298.mp3');
        audio.volume = volume;
        audio.play();
    }, i * 100);
    const durationMs = parseInt('' + (config.duration ?? 2.5)) * 1000;
    const placementTimeout = config.placementTimeout || Math.round(durationMs / 60);
    for(let i = 0; i < num; i++){
        const heart = new $ed1aed194b9dae94$var$Heart((h)=>{
            $ed1aed194b9dae94$var$hearts = $ed1aed194b9dae94$var$hearts.filter((h2)=>h2 !== h);
        }, config);
        $ed1aed194b9dae94$var$hearts.push(heart);
        await new Promise((resolve)=>setTimeout(()=>{
                heart.attach();
                resolve(null);
            }, placementTimeout));
    }
};



const $1747ea0f4a3b6994$var$render = (id, config, parentNode = null)=>{
    if (!parentNode) parentNode = document.body;
    if (typeof document === 'undefined') return;
    if (!config.image) return;
    // @ts-ignore
    let field = document.getElementById('plugin--image--' + id);
    if (field) field.parentNode.removeChild(field);
    if (!config.image.trim()) return;
    if (!config.enabled) return;
    field = document.createElement('img');
    field.src = '/file/' + config.image;
    field.id = 'plugin--image--' + id;
    field.style.position = 'absolute';
    field.style.width = `${config.width}px`;
    if (config.horizontal === 'left') field.style.left = `${config.horizontalSpace}px`;
    else field.style.right = `${config.horizontalSpace}px`;
    if (config.vertical === 'top') field.style.top = `${config.verticalSpace}px`;
    else field.style.bottom = `${config.verticalSpace}px`;
    parentNode.appendChild(field);
};
(0, $d99b315d6ecdde76$export$7612db19fb8beb1e)('image', 'Image', {
    defaultSettings: [
        "enabled",
        "image",
        "horizontal",
        "vertical",
        "horizontalSpace",
        "verticalSpace"
    ],
    supports: [
        'position'
    ],
    settings: {
        enabled: {
            title: 'enabled',
            type: 'check',
            defaultValue: true
        },
        image: {
            title: 'image',
            type: 'image',
            defaultValue: ''
        },
        width: {
            title: 'Width',
            type: 'number',
            defaultValue: 300
        }
    },
    initialize: (id, config, parentNode = null)=>{
        console.log('image plugin init', id, config, parentNode);
        $1747ea0f4a3b6994$var$render(id, config, parentNode);
    },
    onConfig: (id, config)=>{
        console.log('image plugin config', id, config);
        $1747ea0f4a3b6994$var$render(id, config);
    },
    onRemove: (id)=>{
        console.log('removing image plugin', id);
        let field = document.getElementById('plugin--image--' + id);
        if (field) field.parentNode.removeChild(field);
    },
    onWsAction: ()=>false
});



const $ccf26cb5233254dc$var$render = (id, config, parentNode = null)=>{
    if (!parentNode) parentNode = document.body;
    if (typeof document === 'undefined') return;
    let field = document.getElementById('plugin--name--' + id);
    if (field) {
        parentNode = field.parentNode;
        field.parentNode.removeChild(field);
    }
    console.log('RENDER TEXT', config, parentNode);
    if (!config.enabled) return;
    if (!config.name.trim()) return;
    field = document.createElement('div');
    field.id = 'plugin--name--' + id;
    if (parentNode === document.body) field.style.position = 'absolute';
    field.style.fontSize = `${config.size}px`;
    field.style.fontFamily = config.family;
    field.style.fontWeight = config.weight;
    field.style.color = config.color;
    field.style.textAlign = config.align;
    if (config.horizontal === 'left') field.style.left = `${config.horizontalSpace}px`;
    else field.style.right = `${config.horizontalSpace}px`;
    if (config.vertical === 'top') field.style.top = `${config.verticalSpace}px`;
    else field.style.bottom = `${config.verticalSpace}px`;
    field.innerHTML = config.name;
    parentNode.appendChild(field);
};
(0, $d99b315d6ecdde76$export$7612db19fb8beb1e)('text', 'Text', {
    defaultSettings: [
        "enabled",
        "name",
        "align",
        "horizontal",
        "vertical",
        "horizontalSpace",
        "verticalSpace"
    ],
    supports: [
        "position"
    ],
    settings: {
        enabled: {
            title: 'enabled',
            type: 'check',
            defaultValue: true
        },
        name: {
            title: 'text',
            type: 'string',
            defaultValue: 'My Tip-Menu'
        },
        align: {
            title: 'Alignment',
            type: 'select',
            options: [
                'left',
                'center',
                'right'
            ],
            defaultValue: 'left'
        },
        size: {
            title: 'Size',
            type: 'number',
            defaultValue: 26
        },
        family: {
            title: 'Font-Family',
            type: 'select',
            options: [
                'serif',
                'sans-serif'
            ],
            defaultValue: 'sans-serif'
        },
        weight: {
            title: 'Font weight',
            type: 'select',
            options: [
                'normal',
                'bold'
            ],
            defaultValue: 'bold'
        },
        color: {
            title: 'Color',
            type: 'color',
            defaultValue: '#b11b71'
        }
    },
    initialize: (id, config, parentNode)=>{
        console.log('name plugin init', id, config, parentNode);
        $ccf26cb5233254dc$var$render(id, config, parentNode);
    },
    onConfig: (id, config)=>{
        console.log('name plugin config', id, config);
        $ccf26cb5233254dc$var$render(id, config);
    },
    onRemove: (id)=>{
        console.log('removing name plugin', id);
        let field = document.getElementById('plugin--name--' + id);
        if (field) field.parentNode.removeChild(field);
    },
    onWsAction: ()=>false
});



const $7fd63db4c9ff3206$var$render = (id, config, parentNode = null)=>{
    if (!parentNode) parentNode = document.body;
    if (typeof document === 'undefined') return;
    let field = document.getElementById('plugin--tipmenu--' + id);
    if (field) {
        parentNode = field.parentNode;
        field.parentNode.removeChild(field);
    }
    let styleTag = document.getElementById('plugin--tipmenu--' + id + '--style');
    if (styleTag) styleTag.parentNode.removeChild(styleTag);
    let stylesheet = '';
    const items = config.items.split("\n").map((line)=>{
        line = line.trim();
        if (!line || !line.includes('|')) return null;
        const [key, value] = line.split('|');
        return {
            title: key.trim(),
            token: value.trim()
        };
    }).filter((item)=>!!item);
    if (!config.enabled) return;
    if (!items.length) return;
    field = document.createElement('div');
    field.id = 'plugin--tipmenu--' + id;
    if (parentNode === document.body) field.style.position = 'absolute';
    if (config.horizontal === 'left') field.style.left = `${config.horizontalSpace}px`;
    else field.style.right = `${config.horizontalSpace}px`;
    if (config.vertical === 'top') field.style.top = `${config.verticalSpace}px`;
    else field.style.bottom = `${config.verticalSpace}px`;
    const tableWrap = document.createElement('div');
    tableWrap.classList.add('table-wrap');
    tableWrap.style.borderStyle = 'solid';
    tableWrap.style.position = 'relative';
    tableWrap.style.borderColor = config.tableBorderColor;
    tableWrap.style.borderWidth = config.tableBorderWidth;
    tableWrap.style.borderRadius = `${config.tableBorderRadius}px`;
    tableWrap.style.padding = `${config.outerPaddingVertical}px ${config.outerPaddingHorizontal}px`;
    const table = document.createElement('table');
    table.style.borderCollapse = 'collapse';
    table.style.fontSize = `${config.size}px`;
    table.style.fontFamily = config.family;
    table.style.fontWeight = config.weight;
    table.style.color = config.color;
    for (const item of items){
        const tr = document.createElement('tr');
        const tdTitle = document.createElement('td');
        tdTitle.innerText = item.title;
        tdTitle.style.borderStyle = 'solid';
        tdTitle.style.borderColor = config.tableBorderInnerColor;
        tdTitle.style.borderWidth = config.tableBorderInnerWidth;
        tdTitle.style.padding = `${config.innerPaddingVertical}px ${config.innerPaddingHorizontal / 2}px ${config.innerPaddingVertical}px ${config.innerPaddingHorizontal}px`;
        const tdToken = document.createElement('td');
        tdToken.innerText = `${item.token} Token`;
        tdToken.style.borderStyle = 'solid';
        tdToken.style.borderColor = config.tableBorderInnerColor;
        tdToken.style.borderWidth = config.tableBorderInnerWidth;
        tdToken.style.padding = `${config.innerPaddingVertical}px ${config.innerPaddingHorizontal}px ${config.innerPaddingVertical}px ${config.innerPaddingHorizontal / 2}px`;
        tr.appendChild(tdTitle);
        tr.appendChild(tdToken);
        table.appendChild(tr);
    }
    tableWrap.appendChild(table);
    field.appendChild(tableWrap);
    parentNode.appendChild(field);
    if (config.tableBackgroundTransparent < 100) stylesheet += `
#plugin--tipmenu--${id} .table-wrap::before {
    content: '';
    display: block;
    background: ${config.tableBackground};
    opacity: ${1 - config.tableBackgroundTransparent / 100};
    border-radius: ${config.tableBorderRadius}px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
}
        `;
    if (stylesheet) {
        styleTag = document.createElement('style');
        styleTag.id = 'plugin--tipmenu--' + id + '--style';
        styleTag.innerText = stylesheet.replaceAll("\n", ' ');
        console.log('appending stylesheet', styleTag, parentNode);
        parentNode.appendChild(styleTag);
    } else console.log('no stylesheet');
};
(0, $d99b315d6ecdde76$export$7612db19fb8beb1e)('tipmenu', 'Tip-Menu', {
    defaultSettings: [
        "enabled",
        "items",
        "horizontal",
        "vertical"
    ],
    supports: [
        'position'
    ],
    settings: {
        items: {
            title: 'Items',
            type: 'textarea',
            help: 'Each item per line - description and token amount separated by "|"',
            rows: 6,
            defaultValue: `
Item 1: | 10
Item 2: | 20
Item 3: | 30
            `.trim()
        },
        groupTable: {
            type: 'group',
            title: 'Table',
            items: {
                size: {
                    title: 'Size',
                    type: 'number',
                    defaultValue: 22
                },
                family: {
                    title: 'Font-Family',
                    type: 'select',
                    options: [
                        'serif',
                        'sans-serif'
                    ],
                    defaultValue: 'sans-serif'
                },
                weight: {
                    title: 'Font weight',
                    type: 'select',
                    options: [
                        'normal',
                        'bold'
                    ],
                    defaultValue: 'normal'
                },
                color: {
                    title: 'Color',
                    type: 'color',
                    defaultValue: '#000000'
                },
                tableBorderColor: {
                    title: 'Border color',
                    type: 'color',
                    defaultValue: '#000000'
                },
                tableBorderWidth: {
                    title: 'Border outer width',
                    type: 'number',
                    defaultValue: 0
                },
                tableBorderInnerColor: {
                    title: 'Border inner color',
                    type: 'color',
                    defaultValue: '#efefef'
                },
                tableBorderInnerWidth: {
                    title: 'Border inner width',
                    type: 'number',
                    defaultValue: 0
                },
                tableBorderRadius: {
                    title: 'Rounded corners',
                    type: 'number',
                    defaultValue: 10
                },
                tableBackgroundTransparent: {
                    title: 'Background transparency',
                    type: 'number',
                    min: 0,
                    max: 100,
                    defaultValue: 40
                },
                tableBackground: {
                    title: 'Background color',
                    type: 'color',
                    defaultValue: '#fff'
                }
            }
        },
        groupOuterSpace: {
            type: 'group',
            title: 'Outer Space',
            items: {
                outerPaddingHorizontal: {
                    title: 'Horizontal',
                    type: 'number',
                    defaultValue: 5
                },
                outerPaddingVertical: {
                    title: 'Vertical',
                    type: 'number',
                    defaultValue: 5
                }
            }
        },
        groupInnerSpace: {
            type: 'group',
            title: 'Inner Space',
            items: {
                innerPaddingHorizontal: {
                    title: 'Horizontal',
                    type: 'number',
                    defaultValue: 13
                },
                innerPaddingVertical: {
                    title: 'Vertical',
                    type: 'number',
                    defaultValue: 8
                }
            }
        }
    },
    initialize: (id, config, parentNode)=>{
        console.log('tipmenu plugin init', id, config, parentNode);
        $7fd63db4c9ff3206$var$render(id, config, parentNode);
    },
    onConfig: (id, config)=>{
        console.log('tipmenu plugin config', id, config);
        $7fd63db4c9ff3206$var$render(id, config);
    },
    onRemove: (id)=>{
        console.log('removing name plugin', id);
        let field = document.getElementById('plugin--tipmenu--' + id);
        if (field) field.parentNode.removeChild(field);
        let stylesheet = document.getElementById('plugin--tipmenu--' + id + '--style');
        if (field) field.parentNode.removeChild(stylesheet);
    },
    onWsAction: ()=>false
});



const $2f372d8f85c030da$var$cubeIntervals = {};
const $2f372d8f85c030da$var$render = (id, config)=>{
    if (!config.enabled) return;
    // @ts-ignore
    let field = document.getElementById('plugin--cube--' + id);
    if (field) field.parentNode.removeChild(field);
    if (typeof $2f372d8f85c030da$var$cubeIntervals[id] !== 'undefined') {
        clearInterval($2f372d8f85c030da$var$cubeIntervals[id]);
        delete $2f372d8f85c030da$var$cubeIntervals[id];
    }
    console.log('render cube', id, config);
    field = document.createElement('div');
    field.id = 'plugin--cube--' + id;
    field.style.position = 'absolute';
    if (config.horizontal === 'left') field.style.left = `${config.horizontalSpace}px`;
    else field.style.right = `${config.horizontalSpace}px`;
    if (config.vertical === 'top') field.style.top = `${config.verticalSpace}px`;
    else field.style.bottom = `${config.verticalSpace}px`;
    const cube = document.createElement('div');
    cube.classList.add('plugin--cube__cube');
    let numOfFaces = 0;
    for (const side of config.faces){
        const face = document.createElement('div');
        face.classList.add('face');
        face.classList.add('face-' + numOfFaces);
        face.style.background = side.background;
        cube.appendChild(face);
        (0, $d99b315d6ecdde76$export$43bcedd5d395f034)(side.plugin, face);
        numOfFaces++;
    }
    const singleSideRotation = 360 / numOfFaces;
    field.appendChild(cube);
    let translateZ = Math.floor(config.width / 3) * .864;
    field.innerHTML += `
<style>
#plugin--cube--${id} {
    width: ${config.width}px;
    height: ${config.height}px;
}
#plugin--cube--${id} .plugin--cube__cube {
    position: relative;
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    transition: transform .5s;
}
#plugin--cube--${id} .plugin--cube__cube .face {
    width: 100%;
    height: 100%;
    position: absolute;
}
#plugin--cube--${id} .plugin--cube__cube .face:not(.current) {
    visibility: hidden;
}
#plugin--cube--${id} .plugin--cube__cube.show-next .face.prev {
    visibility: visible;
}
#plugin--cube--${id} .plugin--cube__cube .face > * {
    width: 100%;
}
${numOfFaces === 3 ? `
    #plugin--cube--${id} .face-0 {
        transform: rotateY(0deg) translateZ(${translateZ}px);
    }
    #plugin--cube--${id} .face-1 {
        transform:  rotateY(${singleSideRotation}deg) translateZ(${translateZ}px);
    }
    #plugin--cube--${id} .face-2 {
        transform: rotateY(${2 * singleSideRotation}deg) translateZ(${translateZ}px);
    }
` : ''}
${numOfFaces === 4 ? `
    #plugin--cube--${id} .face-0 {
        transform: translateZ(${config.width / 2}px) rotateY(0deg);
    }
    #plugin--cube--${id} .face-1 {
        transform: translateX(${config.width / 2}px) rotateY(${singleSideRotation}deg);
    }
    #plugin--cube--${id} .face-2 {
        transform: translateZ(-${config.width / 2}px) rotateY(${2 * singleSideRotation}deg);
    }
    #plugin--cube--${id} .face-3 {
        transform: translateX(-${config.width / 2}px) rotateY(${3 * singleSideRotation}deg);
    }
` : ''}
</style>
    `;
    document.body.appendChild(field);
    field.querySelector(`.plugin--cube__cube .face-0`).classList.add('current');
    field.querySelector(`.plugin--cube__cube .face-1`).classList.add('next');
    let rotation = 0;
    let current = 0;
    $2f372d8f85c030da$var$cubeIntervals[id] = setInterval(()=>{
        const cube = field.querySelector('.plugin--cube__cube');
        cube.classList.remove(`show-${cube.getAttribute('data-current')}`);
        rotation += singleSideRotation;
        console.log('rotate', rotation + 'deg');
        field.querySelector(`.plugin--cube__cube`).classList.add('show-next');
        cube.style.transform = `rotate3d(0, 1, 0, -${rotation}deg)`;
        setTimeout(()=>{
            field.querySelector(`.plugin--cube__cube`).classList.remove('show-next');
            field.querySelector(`.plugin--cube__cube .face.prev`).classList.remove('prev');
        }, 800);
        let prev = current;
        current++;
        if (current === numOfFaces) current = 0;
        let next = current + 1;
        if (next === numOfFaces) next = 0;
        field.querySelectorAll(`.plugin--cube__cube .face`).forEach((el)=>el.classList.remove('prev', 'current', 'next'));
        field.querySelector(`.plugin--cube__cube .face-${prev}`).classList.add('prev');
        field.querySelector(`.plugin--cube__cube .face-${current}`).classList.add('current');
        field.querySelector(`.plugin--cube__cube .face-${next}`).classList.add('next');
    }, config.delay * 1000);
};
(0, $d99b315d6ecdde76$export$7612db19fb8beb1e)('cube', 'Cube', {
    defaultSettings: [
        "horizontal",
        "vertical",
        "horizontalSpace",
        "verticalSpace"
    ],
    settings: {
        enabled: {
            title: 'enabled',
            type: 'check',
            defaultValue: true
        },
        width: {
            title: 'Width',
            type: 'number',
            defaultValue: 300
        },
        height: {
            title: 'Height',
            type: 'number',
            defaultValue: 400
        },
        delay: {
            title: 'Delay',
            help: 'Delay between switching to next side in seconds',
            type: 'number',
            defaultValue: 5
        },
        horizontal: {
            title: 'Horizontal',
            type: 'select',
            options: [
                'left',
                'right'
            ],
            defaultValue: 'left'
        },
        horizontalSpace: {
            title: 'Space',
            type: 'number',
            defaultValue: 30
        },
        vertical: {
            title: 'Vertical',
            type: 'select',
            options: [
                'top',
                'bottom'
            ],
            defaultValue: 'top'
        },
        verticalSpace: {
            title: 'Space',
            type: 'number',
            defaultValue: 30
        }
    },
    initialize: (id, config)=>{
        console.log('cube plugin init', id, config);
        config = {
            width: 300,
            height: 400,
            delay: 3,
            ...config
        };
        config.faces = [
            {
                plugin: {
                    id: 'foo-tipmenu',
                    plugin: 'tipmenu',
                    config: {
                        enabled: true,
                        "items": "Item 1: | 10\nItem 2: | 20\nItem 3: | 30",
                        "size": 22,
                        "family": "sans-serif",
                        "weight": "normal",
                        "color": "#000000",
                        "tableBorderColor": "#000000",
                        "tableBorderWidth": 0,
                        "tableBorderInnerColor": "#efefef",
                        "tableBorderInnerWidth": 0,
                        "tableBackgroundTransparent": 100,
                        "tableBackground": "#fff",
                        "outerPaddingHorizontal": 20,
                        "outerPaddingVertical": 20,
                        "innerPaddingHorizontal": 13,
                        "innerPaddingVertical": 8,
                        "horizontal": "left",
                        "horizontalSpace": 15,
                        "vertical": "bottom",
                        "verticalSpace": 10
                    }
                }
            },
            {
                plugin: {
                    id: 'foo-text2',
                    plugin: 'text',
                    config: {
                        enabled: true,
                        name: '2',
                        align: 'center'
                    }
                }
            },
            {
                plugin: {
                    id: 'foo-text3',
                    plugin: 'text',
                    config: {
                        enabled: true,
                        name: '3'
                    }
                }
            },
            {
                plugin: {
                    id: 'foo-text4',
                    plugin: 'text',
                    config: {
                        enabled: true,
                        name: '4'
                    }
                }
            }
        ];
        $2f372d8f85c030da$var$render(id, config);
    },
    onConfig: (id, config)=>{
        console.log('cube plugin config', id, config);
        $2f372d8f85c030da$var$render(id, config);
    },
    onRemove: (id)=>{
        console.log('cube image plugin', id);
        let field = document.getElementById('plugin--cube--' + id);
        if (field) field.parentNode.removeChild(field);
    },
    onWsAction: ()=>false
});





var $TMgVJ = parcelRequire("TMgVJ");
const $69b5969bc9d2ade0$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $69b5969bc9d2ade0$export$2e2bcd8739ae039 = {
    randomUUID: $69b5969bc9d2ade0$var$randomUUID
};


let $a0330e7af1026ed7$var$getRandomValues;
const $a0330e7af1026ed7$var$rnds8 = new Uint8Array(16);
function $a0330e7af1026ed7$export$2e2bcd8739ae039() {
    if (!$a0330e7af1026ed7$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $a0330e7af1026ed7$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $a0330e7af1026ed7$var$getRandomValues($a0330e7af1026ed7$var$rnds8);
}


var $c8c8d45f36fa5396$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $2bd74bc62b9b3b84$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $c8c8d45f36fa5396$export$2e2bcd8739ae039).test(uuid);
}
var $2bd74bc62b9b3b84$export$2e2bcd8739ae039 = $2bd74bc62b9b3b84$var$validate;


const $3e09efef036ecd6d$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$3e09efef036ecd6d$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $3e09efef036ecd6d$export$8fb373d660548968(arr, offset = 0) {
    return ($3e09efef036ecd6d$var$byteToHex[arr[offset + 0]] + $3e09efef036ecd6d$var$byteToHex[arr[offset + 1]] + $3e09efef036ecd6d$var$byteToHex[arr[offset + 2]] + $3e09efef036ecd6d$var$byteToHex[arr[offset + 3]] + '-' + $3e09efef036ecd6d$var$byteToHex[arr[offset + 4]] + $3e09efef036ecd6d$var$byteToHex[arr[offset + 5]] + '-' + $3e09efef036ecd6d$var$byteToHex[arr[offset + 6]] + $3e09efef036ecd6d$var$byteToHex[arr[offset + 7]] + '-' + $3e09efef036ecd6d$var$byteToHex[arr[offset + 8]] + $3e09efef036ecd6d$var$byteToHex[arr[offset + 9]] + '-' + $3e09efef036ecd6d$var$byteToHex[arr[offset + 10]] + $3e09efef036ecd6d$var$byteToHex[arr[offset + 11]] + $3e09efef036ecd6d$var$byteToHex[arr[offset + 12]] + $3e09efef036ecd6d$var$byteToHex[arr[offset + 13]] + $3e09efef036ecd6d$var$byteToHex[arr[offset + 14]] + $3e09efef036ecd6d$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $3e09efef036ecd6d$var$stringify(arr, offset = 0) {
    const uuid = $3e09efef036ecd6d$export$8fb373d660548968(arr, offset);
    if (!(0, $2bd74bc62b9b3b84$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $3e09efef036ecd6d$export$2e2bcd8739ae039 = $3e09efef036ecd6d$var$stringify;


function $e64ccffe1ae6e005$var$v4(options, buf, offset) {
    if ((0, $69b5969bc9d2ade0$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $69b5969bc9d2ade0$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $a0330e7af1026ed7$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $3e09efef036ecd6d$export$8fb373d660548968)(rnds);
}
var $e64ccffe1ae6e005$export$2e2bcd8739ae039 = $e64ccffe1ae6e005$var$v4;


let $5f71f6bc5dfeb1f3$var$ws = null;
let $5f71f6bc5dfeb1f3$var$encryptionEnabled = false;
let $5f71f6bc5dfeb1f3$var$callbacks = {
    connected: [],
    loggedIn: [],
    onMessage: [],
    swRequest: []
};
let $5f71f6bc5dfeb1f3$var$keys;
let $5f71f6bc5dfeb1f3$var$privateKeyObj;
let $5f71f6bc5dfeb1f3$var$serverPublicKey;
// @ts-ignore
let $5f71f6bc5dfeb1f3$var$pendingSwReplies = {};
const $5f71f6bc5dfeb1f3$export$a62d19561b71a7c1 = (clientType, autoLogin = true)=>{
    const wsSend = async (action, data = {})=>{
        if ($5f71f6bc5dfeb1f3$var$ws) {
            let payload = JSON.stringify({
                action: action,
                ...data
            });
            if (action !== 'login' && $5f71f6bc5dfeb1f3$var$encryptionEnabled && $5f71f6bc5dfeb1f3$var$serverPublicKey) payload = await $TMgVJ.encrypt({
                message: await $TMgVJ.createMessage({
                    text: payload
                }),
                encryptionKeys: $5f71f6bc5dfeb1f3$var$serverPublicKey
            });
            $5f71f6bc5dfeb1f3$var$ws.send(payload);
        }
    };
    const requestFromSW = (requestId, room, requestAction, data = {}, onReply)=>{
        $5f71f6bc5dfeb1f3$var$pendingSwReplies[requestId] = onReply;
        wsSend('request-from-sw', {
            requestId: requestId,
            room: room,
            requestAction: requestAction,
            data: data
        });
    };
    const wsConnect = async (token)=>{
        if (!$5f71f6bc5dfeb1f3$var$keys) {
            const passphrase = (0, $e64ccffe1ae6e005$export$2e2bcd8739ae039)();
            const { publicKey: publicKey, privateKey: privateKey } = await $TMgVJ.generateKey({
                userIDs: [
                    {
                        name: token,
                        email: `${token}@${location.hostname}`
                    }
                ],
                // @ts-ignore
                curve: 'ed25519',
                passphrase: passphrase
            });
            $5f71f6bc5dfeb1f3$var$keys = {
                publicKey: publicKey,
                privateKey: privateKey
            };
            $5f71f6bc5dfeb1f3$var$privateKeyObj = await $TMgVJ.decryptKey({
                privateKey: await $TMgVJ.readPrivateKey({
                    armoredKey: $5f71f6bc5dfeb1f3$var$keys.privateKey
                }),
                passphrase: passphrase
            });
        }
        console.log('WS CLIENT', 'connect', token);
        return new Promise((resolve)=>{
            // @ts-ignore
            $5f71f6bc5dfeb1f3$var$ws = new WebSocket("wss://cb-hearts.sftest.at");
            $5f71f6bc5dfeb1f3$var$ws.onopen = ()=>{
                if (autoLogin) {
                    console.log('reconnected', 'logging in');
                    wsSend(`login`, {
                        type: clientType,
                        url: location.href,
                        token: token,
                        pubKey: $5f71f6bc5dfeb1f3$var$keys.publicKey
                    });
                } else console.log('reconnected', 'auto-login disabled');
                $5f71f6bc5dfeb1f3$var$callbacks.connected.forEach((cb)=>cb());
            };
            $5f71f6bc5dfeb1f3$var$ws.onclose = ()=>{
                setTimeout(()=>wsConnect(token), 2000);
            };
            $5f71f6bc5dfeb1f3$var$ws.onerror = (error)=>{
                console.error('connection error', error, ' reconnect');
            // connect()
            };
            $5f71f6bc5dfeb1f3$var$ws.onmessage = async (message)=>{
                let payload = message.data;
                if (payload.substring(0, 27) === '-----BEGIN PGP MESSAGE-----') {
                    $5f71f6bc5dfeb1f3$var$encryptionEnabled = true;
                    try {
                        const { data: decrypted } = await $TMgVJ.decrypt({
                            message: await $TMgVJ.readMessage({
                                armoredMessage: payload
                            }),
                            format: 'utf8',
                            decryptionKeys: $5f71f6bc5dfeb1f3$var$privateKeyObj
                        });
                        payload = decrypted;
                    } catch (e) {
                        console.log('decrypt error', e);
                    }
                } else $5f71f6bc5dfeb1f3$var$encryptionEnabled = false;
                const data = JSON.parse(payload);
                if (typeof data.action === 'undefined') {
                    console.error('got invalid message', message);
                    return;
                }
                if (data.action === 'logged-in') {
                    if (typeof data.publicKey !== 'undefined') {
                        $5f71f6bc5dfeb1f3$var$serverPublicKey = await $TMgVJ.readKey({
                            armoredKey: data.publicKey
                        });
                        delete data.publicKey;
                    }
                    $5f71f6bc5dfeb1f3$var$callbacks.loggedIn.forEach((cb)=>cb(data));
                    resolve(null);
                } else if (data.action === 'admin-request') $5f71f6bc5dfeb1f3$var$callbacks.swRequest.forEach((cb)=>{
                    cb(data.requestAction, data.data, (reply)=>{
                        wsSend('admin-reply', {
                            requestId: data.requestId,
                            reply: reply
                        });
                    });
                });
                else if (data.action === 'reply-from-sw') {
                    if (typeof $5f71f6bc5dfeb1f3$var$pendingSwReplies[data.requestId] !== 'undefined') {
                        $5f71f6bc5dfeb1f3$var$pendingSwReplies[data.requestId](data.reply);
                        delete $5f71f6bc5dfeb1f3$var$pendingSwReplies[data.requestId];
                    }
                } else {
                    const action = data.action || 'unknown';
                    if (typeof data.action !== 'undefined') delete data.action;
                    $5f71f6bc5dfeb1f3$var$callbacks.onMessage.forEach((cb)=>cb(action, data));
                }
            };
        });
    };
    const wsActions = {
        pluginUpdate: (id, config)=>wsSend('plugin-update', {
                id: id,
                config: config
            }),
        pluginAdd: (name)=>wsSend('plugin-add', {
                name: name
            }),
        pluginRemove: (id)=>wsSend('plugin-remove', {
                id: id
            }),
        pluginTestAction: (plugin, id, actionKey, button, data)=>wsSend('plugin-test-action', {
                plugin: plugin,
                id: id,
                actionKey: actionKey,
                button: button,
                data: data
            })
    };
    return {
        wsConnect: wsConnect,
        wsSend: wsSend,
        requestFromSW: requestFromSW,
        onConnected: (callback)=>$5f71f6bc5dfeb1f3$var$callbacks.connected.push(callback),
        onLoggedIn: (callback)=>$5f71f6bc5dfeb1f3$var$callbacks.loggedIn.push(callback),
        onMessage: (callback)=>$5f71f6bc5dfeb1f3$var$callbacks.onMessage.push(callback),
        onAdminRequest: (callback)=>$5f71f6bc5dfeb1f3$var$callbacks.swRequest.push(callback),
        wsActions: wsActions
    };
};


const $d572c1f0ee734b0e$var$config = {
    token: null,
    room: 'little_amyka',
    ws: 'wss://' + location.hostname,
    hearts: {
        enabled: true,
        duration: 2500,
        minSize: 20,
        maxSize: 30,
        horizontalPercent: 20,
        placementTimeout: 50,
        location: 'right'
    }
};
const $d572c1f0ee734b0e$var$originalConsole = console;
// @ts-ignore
console = {};
for (const method of Object.keys($d572c1f0ee734b0e$var$originalConsole))console[method] = (...args)=>{
    return;
};
let $d572c1f0ee734b0e$var$plugins = [];
const $d572c1f0ee734b0e$var$query = location.href.split('?')[1] || '';
if ($d572c1f0ee734b0e$var$query) {
    const queryData = $d572c1f0ee734b0e$var$query.split('&').reduce((res, val)=>{
        const [key, value] = val.split('=');
        res[key] = value;
        return res;
    }, {});
    if (typeof queryData['token'] !== 'undefined') $d572c1f0ee734b0e$var$config.token = queryData['token'];
    if (typeof queryData['ws'] !== 'undefined') $d572c1f0ee734b0e$var$config.ws = queryData['ws'];
}
const $d572c1f0ee734b0e$var$ws = (0, $5f71f6bc5dfeb1f3$export$a62d19561b71a7c1)('client');
$d572c1f0ee734b0e$var$ws.onLoggedIn((data)=>{
    data.enabledPlugins = data.enabledPlugins || {};
    // console.log('adding foo')
    // data.enabledPlugins['foo'] = {
    //     id: 'foobar',
    //     plugin: 'cube',
    //     config: {
    //         enabled: true,
    //         horizontal: 'right',
    //         horizontalSpace: 30,
    //         vertical: 'bottom',
    //         verticalSpace: 0,
    //     }
    // }
    $d572c1f0ee734b0e$var$plugins = (0, $d99b315d6ecdde76$export$d117388934d9aaf6)(data.enabledPlugins);
});
$d572c1f0ee734b0e$var$ws.onMessage((action, data)=>{
    switch(action){
        case 'plugin-update':
            {
                const plugin = $d572c1f0ee734b0e$var$plugins.find((p)=>p.id === data.id);
                if (!plugin) {
                    console.error('got config update for unknown plugin', data);
                    break;
                }
                plugin.config = data.config;
                plugin.onConfig(data.id, data.config);
                console.log('update plugin', plugin);
                break;
            }
        case 'plugin-remove':
            {
                const plugin = $d572c1f0ee734b0e$var$plugins.find((p)=>p.id === data.id);
                if (!plugin) {
                    console.error('got config update for unknown plugin', data);
                    break;
                }
                if (typeof plugin.onRemove !== 'undefined') plugin.onRemove(data.id);
                $d572c1f0ee734b0e$var$plugins = $d572c1f0ee734b0e$var$plugins.filter((p)=>p.id !== data.id);
                console.log('removed plugin', plugin);
                break;
            }
        case 'plugin-added':
            $d572c1f0ee734b0e$var$plugins.push((0, $d99b315d6ecdde76$export$43bcedd5d395f034)(data.plugin));
            console.log('added plugin', data.plugin);
            break;
        case 'plugin-test-action':
            {
                const plugin = $d572c1f0ee734b0e$var$plugins.find((p)=>p.id === data.id);
                if (plugin && typeof plugin.testAction[data.actionKey] !== 'undefined') plugin.testAction[data.actionKey].run(data.data, plugin.config);
                break;
            }
        default:
            for (const plugin of $d572c1f0ee734b0e$var$plugins){
                console.log('forwarding ws actiion to plugin', plugin.name, data.action, data);
                if (plugin.onWsAction(data.id, action, data, plugin.config)) console.log(`action "${data.action} handled by plugin "${plugin.name}"`);
            }
            break;
    }
});
$d572c1f0ee734b0e$var$ws.wsConnect($d572c1f0ee734b0e$var$config.token);


//# sourceMappingURL=public.4f756633.js.map
